(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('ractive')) :
	typeof define === 'function' && define.amd ? define(['ractive'], factory) :
	(global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.app = factory(global.Ractive));
})(this, (function (ractive) { 'use strict';

	function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

	var ractive__default = /*#__PURE__*/_interopDefaultLegacy(ractive);

	var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}

	function getCjsExportFromNamespace (n) {
		return n && n['default'] || n;
	}

	var check = function (it) {
	  return it && it.Math === Math && it;
	};

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var globalThis_1 =
	// eslint-disable-next-line es/no-global-this -- safe
	check(typeof globalThis == 'object' && globalThis) || check(typeof window == 'object' && window) ||
	// eslint-disable-next-line no-restricted-globals -- safe
	check(typeof self == 'object' && self) || check(typeof commonjsGlobal == 'object' && commonjsGlobal) || check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
	// eslint-disable-next-line no-new-func -- fallback
	function () {
	  return this;
	}() || Function('return this')();

	var fails = function (exec) {
	  try {
	    return !!exec();
	  } catch (error) {
	    return true;
	  }
	};

	// Detect IE8's incomplete defineProperty implementation
	var descriptors = !fails(function () {
	  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
	  return Object.defineProperty({}, 1, {
	    get: function () {
	      return 7;
	    }
	  })[1] !== 7;
	});

	var functionBindNative = !fails(function () {
	  // eslint-disable-next-line es/no-function-prototype-bind -- safe
	  var test = function () {/* empty */}.bind();
	  // eslint-disable-next-line no-prototype-builtins -- safe
	  return typeof test != 'function' || test.hasOwnProperty('prototype');
	});

	var call$1 = Function.prototype.call;
	var functionCall = functionBindNative ? call$1.bind(call$1) : function () {
	  return call$1.apply(call$1, arguments);
	};

	var $propertyIsEnumerable = {}.propertyIsEnumerable;
	// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	var getOwnPropertyDescriptor$2 = Object.getOwnPropertyDescriptor;

	// Nashorn ~ JDK8 bug
	var NASHORN_BUG = getOwnPropertyDescriptor$2 && !$propertyIsEnumerable.call({
	  1: 2
	}, 1);

	// `Object.prototype.propertyIsEnumerable` method implementation
	// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
	var f$5 = NASHORN_BUG ? function propertyIsEnumerable(V) {
	  var descriptor = getOwnPropertyDescriptor$2(this, V);
	  return !!descriptor && descriptor.enumerable;
	} : $propertyIsEnumerable;
	var objectPropertyIsEnumerable = {
	  f: f$5
	};

	var createPropertyDescriptor = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};

	var FunctionPrototype$1 = Function.prototype;
	var call = FunctionPrototype$1.call;
	var uncurryThisWithBind = functionBindNative && FunctionPrototype$1.bind.bind(call, call);
	var functionUncurryThis = functionBindNative ? uncurryThisWithBind : function (fn) {
	  return function () {
	    return call.apply(fn, arguments);
	  };
	};

	var toString$1 = functionUncurryThis({}.toString);
	var stringSlice = functionUncurryThis(''.slice);
	var classofRaw = function (it) {
	  return stringSlice(toString$1(it), 8, -1);
	};

	var $Object$4 = Object;
	var split = functionUncurryThis(''.split);

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var indexedObject = fails(function () {
	  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
	  // eslint-disable-next-line no-prototype-builtins -- safe
	  return !$Object$4('z').propertyIsEnumerable(0);
	}) ? function (it) {
	  return classofRaw(it) === 'String' ? split(it, '') : $Object$4(it);
	} : $Object$4;

	// we can't use just `it == null` since of `document.all` special case
	// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
	var isNullOrUndefined = function (it) {
	  return it === null || it === undefined;
	};

	var $TypeError$g = TypeError;

	// `RequireObjectCoercible` abstract operation
	// https://tc39.es/ecma262/#sec-requireobjectcoercible
	var requireObjectCoercible = function (it) {
	  if (isNullOrUndefined(it)) throw new $TypeError$g("Can't call method on " + it);
	  return it;
	};

	// toObject with fallback for non-array-like ES3 strings

	var toIndexedObject = function (it) {
	  return indexedObject(requireObjectCoercible(it));
	};

	// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
	var documentAll = typeof document == 'object' && document.all;

	// `IsCallable` abstract operation
	// https://tc39.es/ecma262/#sec-iscallable
	// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
	var isCallable = typeof documentAll == 'undefined' && documentAll !== undefined ? function (argument) {
	  return typeof argument == 'function' || argument === documentAll;
	} : function (argument) {
	  return typeof argument == 'function';
	};

	var isObject = function (it) {
	  return typeof it == 'object' ? it !== null : isCallable(it);
	};

	var aFunction = function (argument) {
	  return isCallable(argument) ? argument : undefined;
	};
	var getBuiltIn = function (namespace, method) {
	  return arguments.length < 2 ? aFunction(globalThis_1[namespace]) : globalThis_1[namespace] && globalThis_1[namespace][method];
	};

	var objectIsPrototypeOf = functionUncurryThis({}.isPrototypeOf);

	var navigator = globalThis_1.navigator;
	var userAgent = navigator && navigator.userAgent;
	var environmentUserAgent = userAgent ? String(userAgent) : '';

	var process = globalThis_1.process;
	var Deno = globalThis_1.Deno;
	var versions = process && process.versions || Deno && Deno.version;
	var v8 = versions && versions.v8;
	var match, version;
	if (v8) {
	  match = v8.split('.');
	  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
	  // but their correct versions are not interesting for us
	  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
	}

	// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
	// so check `userAgent` even if `.v8` exists, but 0
	if (!version && environmentUserAgent) {
	  match = environmentUserAgent.match(/Edge\/(\d+)/);
	  if (!match || match[1] >= 74) {
	    match = environmentUserAgent.match(/Chrome\/(\d+)/);
	    if (match) version = +match[1];
	  }
	}
	var environmentV8Version = version;

	/* eslint-disable es/no-symbol -- required for testing */

	var $String$4 = globalThis_1.String;

	// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
	var symbolConstructorDetection = !!Object.getOwnPropertySymbols && !fails(function () {
	  var symbol = Symbol('symbol detection');
	  // Chrome 38 Symbol has incorrect toString conversion
	  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
	  // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
	  // of course, fail.
	  return !$String$4(symbol) || !(Object(symbol) instanceof Symbol) ||
	  // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
	  !Symbol.sham && environmentV8Version && environmentV8Version < 41;
	});

	/* eslint-disable es/no-symbol -- required for testing */

	var useSymbolAsUid = symbolConstructorDetection && !Symbol.sham && typeof Symbol.iterator == 'symbol';

	var $Object$3 = Object;
	var isSymbol = useSymbolAsUid ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  var $Symbol = getBuiltIn('Symbol');
	  return isCallable($Symbol) && objectIsPrototypeOf($Symbol.prototype, $Object$3(it));
	};

	var $String$3 = String;
	var tryToString = function (argument) {
	  try {
	    return $String$3(argument);
	  } catch (error) {
	    return 'Object';
	  }
	};

	var $TypeError$f = TypeError;

	// `Assert: IsCallable(argument) is true`
	var aCallable = function (argument) {
	  if (isCallable(argument)) return argument;
	  throw new $TypeError$f(tryToString(argument) + ' is not a function');
	};

	// `GetMethod` abstract operation
	// https://tc39.es/ecma262/#sec-getmethod
	var getMethod = function (V, P) {
	  var func = V[P];
	  return isNullOrUndefined(func) ? undefined : aCallable(func);
	};

	var $TypeError$e = TypeError;

	// `OrdinaryToPrimitive` abstract operation
	// https://tc39.es/ecma262/#sec-ordinarytoprimitive
	var ordinaryToPrimitive = function (input, pref) {
	  var fn, val;
	  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = functionCall(fn, input))) return val;
	  if (isCallable(fn = input.valueOf) && !isObject(val = functionCall(fn, input))) return val;
	  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = functionCall(fn, input))) return val;
	  throw new $TypeError$e("Can't convert object to primitive value");
	};

	var isPure = false;

	// eslint-disable-next-line es/no-object-defineproperty -- safe
	var defineProperty$1 = Object.defineProperty;
	var defineGlobalProperty = function (key, value) {
	  try {
	    defineProperty$1(globalThis_1, key, {
	      value: value,
	      configurable: true,
	      writable: true
	    });
	  } catch (error) {
	    globalThis_1[key] = value;
	  }
	  return value;
	};

	var sharedStore = createCommonjsModule(function (module) {

	  var SHARED = '__core-js_shared__';
	  var store = module.exports = globalThis_1[SHARED] || defineGlobalProperty(SHARED, {});
	  (store.versions || (store.versions = [])).push({
	    version: '3.39.0',
	    mode: 'global',
	    copyright: '© 2014-2024 Denis Pushkarev (zloirock.ru)',
	    license: 'https://github.com/zloirock/core-js/blob/v3.39.0/LICENSE',
	    source: 'https://github.com/zloirock/core-js'
	  });
	});

	var shared = function (key, value) {
	  return sharedStore[key] || (sharedStore[key] = value || {});
	};

	var $Object$2 = Object;

	// `ToObject` abstract operation
	// https://tc39.es/ecma262/#sec-toobject
	var toObject = function (argument) {
	  return $Object$2(requireObjectCoercible(argument));
	};

	var hasOwnProperty = functionUncurryThis({}.hasOwnProperty);

	// `HasOwnProperty` abstract operation
	// https://tc39.es/ecma262/#sec-hasownproperty
	// eslint-disable-next-line es/no-object-hasown -- safe
	var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
	  return hasOwnProperty(toObject(it), key);
	};

	var id = 0;
	var postfix = Math.random();
	var toString = functionUncurryThis(1.0.toString);
	var uid = function (key) {
	  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
	};

	var Symbol$1 = globalThis_1.Symbol;
	var WellKnownSymbolsStore = shared('wks');
	var createWellKnownSymbol = useSymbolAsUid ? Symbol$1['for'] || Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid;
	var wellKnownSymbol = function (name) {
	  if (!hasOwnProperty_1(WellKnownSymbolsStore, name)) {
	    WellKnownSymbolsStore[name] = symbolConstructorDetection && hasOwnProperty_1(Symbol$1, name) ? Symbol$1[name] : createWellKnownSymbol('Symbol.' + name);
	  }
	  return WellKnownSymbolsStore[name];
	};

	var $TypeError$d = TypeError;
	var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

	// `ToPrimitive` abstract operation
	// https://tc39.es/ecma262/#sec-toprimitive
	var toPrimitive = function (input, pref) {
	  if (!isObject(input) || isSymbol(input)) return input;
	  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
	  var result;
	  if (exoticToPrim) {
	    if (pref === undefined) pref = 'default';
	    result = functionCall(exoticToPrim, input, pref);
	    if (!isObject(result) || isSymbol(result)) return result;
	    throw new $TypeError$d("Can't convert object to primitive value");
	  }
	  if (pref === undefined) pref = 'number';
	  return ordinaryToPrimitive(input, pref);
	};

	// `ToPropertyKey` abstract operation
	// https://tc39.es/ecma262/#sec-topropertykey
	var toPropertyKey = function (argument) {
	  var key = toPrimitive(argument, 'string');
	  return isSymbol(key) ? key : key + '';
	};

	var document$1 = globalThis_1.document;
	// typeof document.createElement is 'object' in old IE
	var EXISTS$1 = isObject(document$1) && isObject(document$1.createElement);
	var documentCreateElement = function (it) {
	  return EXISTS$1 ? document$1.createElement(it) : {};
	};

	// Thanks to IE8 for its funny defineProperty
	var ie8DomDefine = !descriptors && !fails(function () {
	  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
	  return Object.defineProperty(documentCreateElement('div'), 'a', {
	    get: function () {
	      return 7;
	    }
	  }).a !== 7;
	});

	// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

	// `Object.getOwnPropertyDescriptor` method
	// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
	var f$4 = descriptors ? $getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
	  O = toIndexedObject(O);
	  P = toPropertyKey(P);
	  if (ie8DomDefine) try {
	    return $getOwnPropertyDescriptor$1(O, P);
	  } catch (error) {/* empty */}
	  if (hasOwnProperty_1(O, P)) return createPropertyDescriptor(!functionCall(objectPropertyIsEnumerable.f, O, P), O[P]);
	};
	var objectGetOwnPropertyDescriptor = {
	  f: f$4
	};

	// V8 ~ Chrome 36-
	// https://bugs.chromium.org/p/v8/issues/detail?id=3334
	var v8PrototypeDefineBug = descriptors && fails(function () {
	  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
	  return Object.defineProperty(function () {/* empty */}, 'prototype', {
	    value: 42,
	    writable: false
	  }).prototype !== 42;
	});

	var $String$2 = String;
	var $TypeError$c = TypeError;

	// `Assert: Type(argument) is Object`
	var anObject = function (argument) {
	  if (isObject(argument)) return argument;
	  throw new $TypeError$c($String$2(argument) + ' is not an object');
	};

	var $TypeError$b = TypeError;
	// eslint-disable-next-line es/no-object-defineproperty -- safe
	var $defineProperty = Object.defineProperty;
	// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var ENUMERABLE = 'enumerable';
	var CONFIGURABLE$1 = 'configurable';
	var WRITABLE = 'writable';

	// `Object.defineProperty` method
	// https://tc39.es/ecma262/#sec-object.defineproperty
	var f$3 = descriptors ? v8PrototypeDefineBug ? function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPropertyKey(P);
	  anObject(Attributes);
	  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
	    var current = $getOwnPropertyDescriptor(O, P);
	    if (current && current[WRITABLE]) {
	      O[P] = Attributes.value;
	      Attributes = {
	        configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
	        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
	        writable: false
	      };
	    }
	  }
	  return $defineProperty(O, P, Attributes);
	} : $defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPropertyKey(P);
	  anObject(Attributes);
	  if (ie8DomDefine) try {
	    return $defineProperty(O, P, Attributes);
	  } catch (error) {/* empty */}
	  if ('get' in Attributes || 'set' in Attributes) throw new $TypeError$b('Accessors not supported');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};
	var objectDefineProperty = {
	  f: f$3
	};

	var createNonEnumerableProperty = descriptors ? function (object, key, value) {
	  return objectDefineProperty.f(object, key, createPropertyDescriptor(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};

	var FunctionPrototype = Function.prototype;
	// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	var getDescriptor = descriptors && Object.getOwnPropertyDescriptor;
	var EXISTS = hasOwnProperty_1(FunctionPrototype, 'name');
	// additional protection from minified / mangled / dropped function names
	var PROPER = EXISTS && function something() {/* empty */}.name === 'something';
	var CONFIGURABLE = EXISTS && (!descriptors || descriptors && getDescriptor(FunctionPrototype, 'name').configurable);
	var functionName = {
	  EXISTS: EXISTS,
	  PROPER: PROPER,
	  CONFIGURABLE: CONFIGURABLE
	};

	var functionToString = functionUncurryThis(Function.toString);

	// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
	if (!isCallable(sharedStore.inspectSource)) {
	  sharedStore.inspectSource = function (it) {
	    return functionToString(it);
	  };
	}
	var inspectSource = sharedStore.inspectSource;

	var WeakMap$1 = globalThis_1.WeakMap;
	var weakMapBasicDetection = isCallable(WeakMap$1) && /native code/.test(String(WeakMap$1));

	var keys$1 = shared('keys');
	var sharedKey = function (key) {
	  return keys$1[key] || (keys$1[key] = uid(key));
	};

	var hiddenKeys$1 = {};

	var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
	var TypeError$1 = globalThis_1.TypeError;
	var WeakMap = globalThis_1.WeakMap;
	var set, get, has$7;
	var enforce = function (it) {
	  return has$7(it) ? get(it) : set(it, {});
	};
	var getterFor = function (TYPE) {
	  return function (it) {
	    var state;
	    if (!isObject(it) || (state = get(it)).type !== TYPE) {
	      throw new TypeError$1('Incompatible receiver, ' + TYPE + ' required');
	    }
	    return state;
	  };
	};
	if (weakMapBasicDetection || sharedStore.state) {
	  var store = sharedStore.state || (sharedStore.state = new WeakMap());
	  /* eslint-disable no-self-assign -- prototype methods protection */
	  store.get = store.get;
	  store.has = store.has;
	  store.set = store.set;
	  /* eslint-enable no-self-assign -- prototype methods protection */
	  set = function (it, metadata) {
	    if (store.has(it)) throw new TypeError$1(OBJECT_ALREADY_INITIALIZED);
	    metadata.facade = it;
	    store.set(it, metadata);
	    return metadata;
	  };
	  get = function (it) {
	    return store.get(it) || {};
	  };
	  has$7 = function (it) {
	    return store.has(it);
	  };
	} else {
	  var STATE = sharedKey('state');
	  hiddenKeys$1[STATE] = true;
	  set = function (it, metadata) {
	    if (hasOwnProperty_1(it, STATE)) throw new TypeError$1(OBJECT_ALREADY_INITIALIZED);
	    metadata.facade = it;
	    createNonEnumerableProperty(it, STATE, metadata);
	    return metadata;
	  };
	  get = function (it) {
	    return hasOwnProperty_1(it, STATE) ? it[STATE] : {};
	  };
	  has$7 = function (it) {
	    return hasOwnProperty_1(it, STATE);
	  };
	}
	var internalState = {
	  set: set,
	  get: get,
	  has: has$7,
	  enforce: enforce,
	  getterFor: getterFor
	};

	var makeBuiltIn_1 = createCommonjsModule(function (module) {

	  var CONFIGURABLE_FUNCTION_NAME = functionName.CONFIGURABLE;
	  var enforceInternalState = internalState.enforce;
	  var getInternalState = internalState.get;
	  var $String = String;
	  // eslint-disable-next-line es/no-object-defineproperty -- safe
	  var defineProperty = Object.defineProperty;
	  var stringSlice = functionUncurryThis(''.slice);
	  var replace = functionUncurryThis(''.replace);
	  var join = functionUncurryThis([].join);
	  var CONFIGURABLE_LENGTH = descriptors && !fails(function () {
	    return defineProperty(function () {/* empty */}, 'length', {
	      value: 8
	    }).length !== 8;
	  });
	  var TEMPLATE = String(String).split('String');
	  var makeBuiltIn = module.exports = function (value, name, options) {
	    if (stringSlice($String(name), 0, 7) === 'Symbol(') {
	      name = '[' + replace($String(name), /^Symbol\(([^)]*)\).*$/, '$1') + ']';
	    }
	    if (options && options.getter) name = 'get ' + name;
	    if (options && options.setter) name = 'set ' + name;
	    if (!hasOwnProperty_1(value, 'name') || CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
	      if (descriptors) defineProperty(value, 'name', {
	        value: name,
	        configurable: true
	      });else value.name = name;
	    }
	    if (CONFIGURABLE_LENGTH && options && hasOwnProperty_1(options, 'arity') && value.length !== options.arity) {
	      defineProperty(value, 'length', {
	        value: options.arity
	      });
	    }
	    try {
	      if (options && hasOwnProperty_1(options, 'constructor') && options.constructor) {
	        if (descriptors) defineProperty(value, 'prototype', {
	          writable: false
	        });
	        // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
	      } else if (value.prototype) value.prototype = undefined;
	    } catch (error) {/* empty */}
	    var state = enforceInternalState(value);
	    if (!hasOwnProperty_1(state, 'source')) {
	      state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
	    }
	    return value;
	  };

	  // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	  // eslint-disable-next-line no-extend-native -- required
	  Function.prototype.toString = makeBuiltIn(function toString() {
	    return isCallable(this) && getInternalState(this).source || inspectSource(this);
	  }, 'toString');
	});

	var defineBuiltIn = function (O, key, value, options) {
	  if (!options) options = {};
	  var simple = options.enumerable;
	  var name = options.name !== undefined ? options.name : key;
	  if (isCallable(value)) makeBuiltIn_1(value, name, options);
	  if (options.global) {
	    if (simple) O[key] = value;else defineGlobalProperty(key, value);
	  } else {
	    try {
	      if (!options.unsafe) delete O[key];else if (O[key]) simple = true;
	    } catch (error) {/* empty */}
	    if (simple) O[key] = value;else objectDefineProperty.f(O, key, {
	      value: value,
	      enumerable: false,
	      configurable: !options.nonConfigurable,
	      writable: !options.nonWritable
	    });
	  }
	  return O;
	};

	var ceil = Math.ceil;
	var floor = Math.floor;

	// `Math.trunc` method
	// https://tc39.es/ecma262/#sec-math.trunc
	// eslint-disable-next-line es/no-math-trunc -- safe
	var mathTrunc = Math.trunc || function trunc(x) {
	  var n = +x;
	  return (n > 0 ? floor : ceil)(n);
	};

	// `ToIntegerOrInfinity` abstract operation
	// https://tc39.es/ecma262/#sec-tointegerorinfinity
	var toIntegerOrInfinity = function (argument) {
	  var number = +argument;
	  // eslint-disable-next-line no-self-compare -- NaN check
	  return number !== number || number === 0 ? 0 : mathTrunc(number);
	};

	var max$1 = Math.max;
	var min$1 = Math.min;

	// Helper for a popular repeating case of the spec:
	// Let integer be ? ToInteger(index).
	// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
	var toAbsoluteIndex = function (index, length) {
	  var integer = toIntegerOrInfinity(index);
	  return integer < 0 ? max$1(integer + length, 0) : min$1(integer, length);
	};

	var min = Math.min;

	// `ToLength` abstract operation
	// https://tc39.es/ecma262/#sec-tolength
	var toLength = function (argument) {
	  var len = toIntegerOrInfinity(argument);
	  return len > 0 ? min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
	};

	// `LengthOfArrayLike` abstract operation
	// https://tc39.es/ecma262/#sec-lengthofarraylike
	var lengthOfArrayLike = function (obj) {
	  return toLength(obj.length);
	};

	// `Array.prototype.{ indexOf, includes }` methods implementation
	var createMethod = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIndexedObject($this);
	    var length = lengthOfArrayLike(O);
	    if (length === 0) return !IS_INCLUDES && -1;
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare -- NaN check
	    if (IS_INCLUDES && el !== el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare -- NaN check
	      if (value !== value) return true;
	      // Array#indexOf ignores holes, Array#includes - not
	    } else for (; length > index; index++) {
	      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
	    }
	    return !IS_INCLUDES && -1;
	  };
	};
	var arrayIncludes = {
	  // `Array.prototype.includes` method
	  // https://tc39.es/ecma262/#sec-array.prototype.includes
	  includes: createMethod(true),
	  // `Array.prototype.indexOf` method
	  // https://tc39.es/ecma262/#sec-array.prototype.indexof
	  indexOf: createMethod(false)
	};

	var indexOf = arrayIncludes.indexOf;
	var push$1 = functionUncurryThis([].push);
	var objectKeysInternal = function (object, names) {
	  var O = toIndexedObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) !hasOwnProperty_1(hiddenKeys$1, key) && hasOwnProperty_1(O, key) && push$1(result, key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (hasOwnProperty_1(O, key = names[i++])) {
	    ~indexOf(result, key) || push$1(result, key);
	  }
	  return result;
	};

	// IE8- don't enum bug keys
	var enumBugKeys = ['constructor', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable', 'toLocaleString', 'toString', 'valueOf'];

	var hiddenKeys = enumBugKeys.concat('length', 'prototype');

	// `Object.getOwnPropertyNames` method
	// https://tc39.es/ecma262/#sec-object.getownpropertynames
	// eslint-disable-next-line es/no-object-getownpropertynames -- safe
	var f$2 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return objectKeysInternal(O, hiddenKeys);
	};
	var objectGetOwnPropertyNames = {
	  f: f$2
	};

	// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
	var f$1 = Object.getOwnPropertySymbols;
	var objectGetOwnPropertySymbols = {
	  f: f$1
	};

	var concat = functionUncurryThis([].concat);

	// all object keys, includes non-enumerable and symbols
	var ownKeys = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
	  var keys = objectGetOwnPropertyNames.f(anObject(it));
	  var getOwnPropertySymbols = objectGetOwnPropertySymbols.f;
	  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
	};

	var copyConstructorProperties = function (target, source, exceptions) {
	  var keys = ownKeys(source);
	  var defineProperty = objectDefineProperty.f;
	  var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    if (!hasOwnProperty_1(target, key) && !(exceptions && hasOwnProperty_1(exceptions, key))) {
	      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
	    }
	  }
	};

	var replacement = /#|\.prototype\./;
	var isForced = function (feature, detection) {
	  var value = data[normalize(feature)];
	  return value === POLYFILL ? true : value === NATIVE ? false : isCallable(detection) ? fails(detection) : !!detection;
	};
	var normalize = isForced.normalize = function (string) {
	  return String(string).replace(replacement, '.').toLowerCase();
	};
	var data = isForced.data = {};
	var NATIVE = isForced.NATIVE = 'N';
	var POLYFILL = isForced.POLYFILL = 'P';
	var isForced_1 = isForced;

	var getOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;

	/*
	  options.target         - name of the target object
	  options.global         - target is the global object
	  options.stat           - export as static methods of target
	  options.proto          - export as prototype methods of target
	  options.real           - real prototype method for the `pure` version
	  options.forced         - export even if the native feature is available
	  options.bind           - bind methods to the target, required for the `pure` version
	  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
	  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
	  options.sham           - add a flag to not completely full polyfills
	  options.enumerable     - export as enumerable property
	  options.dontCallGetSet - prevent calling a getter on target
	  options.name           - the .name of the function if it does not match the key
	*/
	var _export = function (options, source) {
	  var TARGET = options.target;
	  var GLOBAL = options.global;
	  var STATIC = options.stat;
	  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
	  if (GLOBAL) {
	    target = globalThis_1;
	  } else if (STATIC) {
	    target = globalThis_1[TARGET] || defineGlobalProperty(TARGET, {});
	  } else {
	    target = globalThis_1[TARGET] && globalThis_1[TARGET].prototype;
	  }
	  if (target) for (key in source) {
	    sourceProperty = source[key];
	    if (options.dontCallGetSet) {
	      descriptor = getOwnPropertyDescriptor$1(target, key);
	      targetProperty = descriptor && descriptor.value;
	    } else targetProperty = target[key];
	    FORCED = isForced_1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
	    // contained in target
	    if (!FORCED && targetProperty !== undefined) {
	      if (typeof sourceProperty == typeof targetProperty) continue;
	      copyConstructorProperties(sourceProperty, targetProperty);
	    }
	    // add a flag to not completely full polyfills
	    if (options.sham || targetProperty && targetProperty.sham) {
	      createNonEnumerableProperty(sourceProperty, 'sham', true);
	    }
	    defineBuiltIn(target, key, sourceProperty, options);
	  }
	};

	var $TypeError$a = TypeError;
	var anInstance = function (it, Prototype) {
	  if (objectIsPrototypeOf(Prototype, it)) return it;
	  throw new $TypeError$a('Incorrect invocation');
	};

	var correctPrototypeGetter = !fails(function () {
	  function F() {/* empty */}
	  F.prototype.constructor = null;
	  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
	  return Object.getPrototypeOf(new F()) !== F.prototype;
	});

	var IE_PROTO$1 = sharedKey('IE_PROTO');
	var $Object$1 = Object;
	var ObjectPrototype = $Object$1.prototype;

	// `Object.getPrototypeOf` method
	// https://tc39.es/ecma262/#sec-object.getprototypeof
	// eslint-disable-next-line es/no-object-getprototypeof -- safe
	var objectGetPrototypeOf = correctPrototypeGetter ? $Object$1.getPrototypeOf : function (O) {
	  var object = toObject(O);
	  if (hasOwnProperty_1(object, IE_PROTO$1)) return object[IE_PROTO$1];
	  var constructor = object.constructor;
	  if (isCallable(constructor) && object instanceof constructor) {
	    return constructor.prototype;
	  }
	  return object instanceof $Object$1 ? ObjectPrototype : null;
	};

	var defineBuiltInAccessor = function (target, name, descriptor) {
	  if (descriptor.get) makeBuiltIn_1(descriptor.get, name, {
	    getter: true
	  });
	  if (descriptor.set) makeBuiltIn_1(descriptor.set, name, {
	    setter: true
	  });
	  return objectDefineProperty.f(target, name, descriptor);
	};

	var createProperty = function (object, key, value) {
	  if (descriptors) objectDefineProperty.f(object, key, createPropertyDescriptor(0, value));else object[key] = value;
	};

	// `Object.keys` method
	// https://tc39.es/ecma262/#sec-object.keys
	// eslint-disable-next-line es/no-object-keys -- safe
	var objectKeys = Object.keys || function keys(O) {
	  return objectKeysInternal(O, enumBugKeys);
	};

	// `Object.defineProperties` method
	// https://tc39.es/ecma262/#sec-object.defineproperties
	// eslint-disable-next-line es/no-object-defineproperties -- safe
	var f = descriptors && !v8PrototypeDefineBug ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var props = toIndexedObject(Properties);
	  var keys = objectKeys(Properties);
	  var length = keys.length;
	  var index = 0;
	  var key;
	  while (length > index) objectDefineProperty.f(O, key = keys[index++], props[key]);
	  return O;
	};
	var objectDefineProperties = {
	  f: f
	};

	var html$1 = getBuiltIn('document', 'documentElement');

	/* global ActiveXObject -- old IE, WSH */

	var GT = '>';
	var LT = '<';
	var PROTOTYPE = 'prototype';
	var SCRIPT = 'script';
	var IE_PROTO = sharedKey('IE_PROTO');
	var EmptyConstructor = function () {/* empty */};
	var scriptTag = function (content) {
	  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
	};

	// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
	var NullProtoObjectViaActiveX = function (activeXDocument) {
	  activeXDocument.write(scriptTag(''));
	  activeXDocument.close();
	  var temp = activeXDocument.parentWindow.Object;
	  // eslint-disable-next-line no-useless-assignment -- avoid memory leak
	  activeXDocument = null;
	  return temp;
	};

	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var NullProtoObjectViaIFrame = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = documentCreateElement('iframe');
	  var JS = 'java' + SCRIPT + ':';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  html$1.appendChild(iframe);
	  // https://github.com/zloirock/core-js/issues/475
	  iframe.src = String(JS);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(scriptTag('document.F=Object'));
	  iframeDocument.close();
	  return iframeDocument.F;
	};

	// Check for document.domain and active x support
	// No need to use active x approach when document.domain is not set
	// see https://github.com/es-shims/es5-shim/issues/150
	// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
	// avoid IE GC bug
	var activeXDocument;
	var NullProtoObject = function () {
	  try {
	    activeXDocument = new ActiveXObject('htmlfile');
	  } catch (error) {/* ignore */}
	  NullProtoObject = typeof document != 'undefined' ? document.domain && activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) // old IE
	  : NullProtoObjectViaIFrame() : NullProtoObjectViaActiveX(activeXDocument); // WSH
	  var length = enumBugKeys.length;
	  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
	  return NullProtoObject();
	};
	hiddenKeys$1[IE_PROTO] = true;

	// `Object.create` method
	// https://tc39.es/ecma262/#sec-object.create
	// eslint-disable-next-line es/no-object-create -- safe
	var objectCreate = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    EmptyConstructor[PROTOTYPE] = anObject(O);
	    result = new EmptyConstructor();
	    EmptyConstructor[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = NullProtoObject();
	  return Properties === undefined ? result : objectDefineProperties.f(result, Properties);
	};

	var ITERATOR$3 = wellKnownSymbol('iterator');
	var BUGGY_SAFARI_ITERATORS = false;

	// `%IteratorPrototype%` object
	// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
	var IteratorPrototype$2, PrototypeOfArrayIteratorPrototype, arrayIterator;

	/* eslint-disable es/no-array-prototype-keys -- safe */
	if ([].keys) {
	  arrayIterator = [].keys();
	  // Safari 8 has buggy iterators w/o `next`
	  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;else {
	    PrototypeOfArrayIteratorPrototype = objectGetPrototypeOf(objectGetPrototypeOf(arrayIterator));
	    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$2 = PrototypeOfArrayIteratorPrototype;
	  }
	}
	var NEW_ITERATOR_PROTOTYPE = !isObject(IteratorPrototype$2) || fails(function () {
	  var test = {};
	  // FF44- legacy iterators case
	  return IteratorPrototype$2[ITERATOR$3].call(test) !== test;
	});
	if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype$2 = {};

	// `%IteratorPrototype%[@@iterator]()` method
	// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
	if (!isCallable(IteratorPrototype$2[ITERATOR$3])) {
	  defineBuiltIn(IteratorPrototype$2, ITERATOR$3, function () {
	    return this;
	  });
	}
	var iteratorsCore = {
	  IteratorPrototype: IteratorPrototype$2,
	  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
	};

	var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;
	var CONSTRUCTOR = 'constructor';
	var ITERATOR$2 = 'Iterator';
	var TO_STRING_TAG$3 = wellKnownSymbol('toStringTag');
	var $TypeError$9 = TypeError;
	var NativeIterator = globalThis_1[ITERATOR$2];

	// FF56- have non-standard global helper `Iterator`
	var FORCED$2 = !isCallable(NativeIterator) || NativeIterator.prototype !== IteratorPrototype$1
	// FF44- non-standard `Iterator` passes previous tests
	|| !fails(function () {
	  NativeIterator({});
	});
	var IteratorConstructor = function Iterator() {
	  anInstance(this, IteratorPrototype$1);
	  if (objectGetPrototypeOf(this) === IteratorPrototype$1) throw new $TypeError$9('Abstract class Iterator not directly constructable');
	};
	var defineIteratorPrototypeAccessor = function (key, value) {
	  if (descriptors) {
	    defineBuiltInAccessor(IteratorPrototype$1, key, {
	      configurable: true,
	      get: function () {
	        return value;
	      },
	      set: function (replacement) {
	        anObject(this);
	        if (this === IteratorPrototype$1) throw new $TypeError$9("You can't redefine this property");
	        if (hasOwnProperty_1(this, key)) this[key] = replacement;else createProperty(this, key, replacement);
	      }
	    });
	  } else IteratorPrototype$1[key] = value;
	};
	if (!hasOwnProperty_1(IteratorPrototype$1, TO_STRING_TAG$3)) defineIteratorPrototypeAccessor(TO_STRING_TAG$3, ITERATOR$2);
	if (FORCED$2 || !hasOwnProperty_1(IteratorPrototype$1, CONSTRUCTOR) || IteratorPrototype$1[CONSTRUCTOR] === Object) {
	  defineIteratorPrototypeAccessor(CONSTRUCTOR, IteratorConstructor);
	}
	IteratorConstructor.prototype = IteratorPrototype$1;

	// `Iterator` constructor
	// https://tc39.es/ecma262/#sec-iterator
	_export({
	  global: true,
	  constructor: true,
	  forced: FORCED$2
	}, {
	  Iterator: IteratorConstructor
	});

	var functionUncurryThisClause = function (fn) {
	  // Nashorn bug:
	  //   https://github.com/zloirock/core-js/issues/1128
	  //   https://github.com/zloirock/core-js/issues/1130
	  if (classofRaw(fn) === 'Function') return functionUncurryThis(fn);
	};

	var bind = functionUncurryThisClause(functionUncurryThisClause.bind);

	// optional / simple context binding
	var functionBindContext = function (fn, that) {
	  aCallable(fn);
	  return that === undefined ? fn : functionBindNative ? bind(fn, that) : function /* ...args */
	  () {
	    return fn.apply(that, arguments);
	  };
	};

	var iterators = {};

	var ITERATOR$1 = wellKnownSymbol('iterator');
	var ArrayPrototype = Array.prototype;

	// check on default Array iterator
	var isArrayIteratorMethod = function (it) {
	  return it !== undefined && (iterators.Array === it || ArrayPrototype[ITERATOR$1] === it);
	};

	var TO_STRING_TAG$2 = wellKnownSymbol('toStringTag');
	var test = {};
	test[TO_STRING_TAG$2] = 'z';
	var toStringTagSupport = String(test) === '[object z]';

	var TO_STRING_TAG$1 = wellKnownSymbol('toStringTag');
	var $Object = Object;

	// ES3 wrong here
	var CORRECT_ARGUMENTS = classofRaw(function () {
	  return arguments;
	}()) === 'Arguments';

	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (error) {/* empty */}
	};

	// getting tag from ES6+ `Object.prototype.toString`
	var classof = toStringTagSupport ? classofRaw : function (it) {
	  var O, tag, result;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	  // @@toStringTag case
	  : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG$1)) == 'string' ? tag
	  // builtinTag case
	  : CORRECT_ARGUMENTS ? classofRaw(O)
	  // ES3 arguments fallback
	  : (result = classofRaw(O)) === 'Object' && isCallable(O.callee) ? 'Arguments' : result;
	};

	var ITERATOR = wellKnownSymbol('iterator');
	var getIteratorMethod = function (it) {
	  if (!isNullOrUndefined(it)) return getMethod(it, ITERATOR) || getMethod(it, '@@iterator') || iterators[classof(it)];
	};

	var $TypeError$8 = TypeError;
	var getIterator = function (argument, usingIterator) {
	  var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
	  if (aCallable(iteratorMethod)) return anObject(functionCall(iteratorMethod, argument));
	  throw new $TypeError$8(tryToString(argument) + ' is not iterable');
	};

	var iteratorClose = function (iterator, kind, value) {
	  var innerResult, innerError;
	  anObject(iterator);
	  try {
	    innerResult = getMethod(iterator, 'return');
	    if (!innerResult) {
	      if (kind === 'throw') throw value;
	      return value;
	    }
	    innerResult = functionCall(innerResult, iterator);
	  } catch (error) {
	    innerError = true;
	    innerResult = error;
	  }
	  if (kind === 'throw') throw value;
	  if (innerError) throw innerResult;
	  anObject(innerResult);
	  return value;
	};

	var $TypeError$7 = TypeError;
	var Result = function (stopped, result) {
	  this.stopped = stopped;
	  this.result = result;
	};
	var ResultPrototype = Result.prototype;
	var iterate = function (iterable, unboundFunction, options) {
	  var that = options && options.that;
	  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
	  var IS_RECORD = !!(options && options.IS_RECORD);
	  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
	  var INTERRUPTED = !!(options && options.INTERRUPTED);
	  var fn = functionBindContext(unboundFunction, that);
	  var iterator, iterFn, index, length, result, next, step;
	  var stop = function (condition) {
	    if (iterator) iteratorClose(iterator, 'normal', condition);
	    return new Result(true, condition);
	  };
	  var callFn = function (value) {
	    if (AS_ENTRIES) {
	      anObject(value);
	      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
	    }
	    return INTERRUPTED ? fn(value, stop) : fn(value);
	  };
	  if (IS_RECORD) {
	    iterator = iterable.iterator;
	  } else if (IS_ITERATOR) {
	    iterator = iterable;
	  } else {
	    iterFn = getIteratorMethod(iterable);
	    if (!iterFn) throw new $TypeError$7(tryToString(iterable) + ' is not iterable');
	    // optimisation for array iterators
	    if (isArrayIteratorMethod(iterFn)) {
	      for (index = 0, length = lengthOfArrayLike(iterable); length > index; index++) {
	        result = callFn(iterable[index]);
	        if (result && objectIsPrototypeOf(ResultPrototype, result)) return result;
	      }
	      return new Result(false);
	    }
	    iterator = getIterator(iterable, iterFn);
	  }
	  next = IS_RECORD ? iterable.next : iterator.next;
	  while (!(step = functionCall(next, iterator)).done) {
	    try {
	      result = callFn(step.value);
	    } catch (error) {
	      iteratorClose(iterator, 'throw', error);
	    }
	    if (typeof result == 'object' && result && objectIsPrototypeOf(ResultPrototype, result)) return result;
	  }
	  return new Result(false);
	};

	// `GetIteratorDirect(obj)` abstract operation
	// https://tc39.es/proposal-iterator-helpers/#sec-getiteratordirect
	var getIteratorDirect = function (obj) {
	  return {
	    iterator: obj,
	    next: obj.next,
	    done: false
	  };
	};

	// `Iterator.prototype.forEach` method
	// https://tc39.es/ecma262/#sec-iterator.prototype.foreach
	_export({
	  target: 'Iterator',
	  proto: true,
	  real: true
	}, {
	  forEach: function forEach(fn) {
	    anObject(this);
	    aCallable(fn);
	    var record = getIteratorDirect(this);
	    var counter = 0;
	    iterate(record, function (value) {
	      fn(value, counter++);
	    }, {
	      IS_RECORD: true
	    });
	  }
	});

	Math.log10 = Math.log10 || function (x) {
	  return Math.log(x) * Math.LOG10E;
	};

	// `IsArray` abstract operation
	// https://tc39.es/ecma262/#sec-isarray
	// eslint-disable-next-line es/no-array-isarray -- safe
	var isArray = Array.isArray || function isArray(argument) {
	  return classofRaw(argument) === 'Array';
	};

	var $TypeError$6 = TypeError;
	// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

	// Safari < 13 does not throw an error in this case
	var SILENT_ON_NON_WRITABLE_LENGTH_SET = descriptors && !function () {
	  // makes no sense without proper strict mode support
	  if (this !== undefined) return true;
	  try {
	    // eslint-disable-next-line es/no-object-defineproperty -- safe
	    Object.defineProperty([], 'length', {
	      writable: false
	    }).length = 1;
	  } catch (error) {
	    return error instanceof TypeError;
	  }
	}();
	var arraySetLength = SILENT_ON_NON_WRITABLE_LENGTH_SET ? function (O, length) {
	  if (isArray(O) && !getOwnPropertyDescriptor(O, 'length').writable) {
	    throw new $TypeError$6('Cannot set read only .length');
	  }
	  return O.length = length;
	} : function (O, length) {
	  return O.length = length;
	};

	var $TypeError$5 = TypeError;
	var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991

	var doesNotExceedSafeInteger = function (it) {
	  if (it > MAX_SAFE_INTEGER) throw $TypeError$5('Maximum allowed index exceeded');
	  return it;
	};

	var INCORRECT_TO_LENGTH = fails(function () {
	  return [].push.call({
	    length: 0x100000000
	  }, 1) !== 4294967297;
	});

	// V8 <= 121 and Safari <= 15.4; FF < 23 throws InternalError
	// https://bugs.chromium.org/p/v8/issues/detail?id=12681
	var properErrorOnNonWritableLength$1 = function () {
	  try {
	    // eslint-disable-next-line es/no-object-defineproperty -- safe
	    Object.defineProperty([], 'length', {
	      writable: false
	    }).push();
	  } catch (error) {
	    return error instanceof TypeError;
	  }
	};
	var FORCED$1 = INCORRECT_TO_LENGTH || !properErrorOnNonWritableLength$1();

	// `Array.prototype.push` method
	// https://tc39.es/ecma262/#sec-array.prototype.push
	_export({
	  target: 'Array',
	  proto: true,
	  arity: 1,
	  forced: FORCED$1
	}, {
	  // eslint-disable-next-line no-unused-vars -- required for `.length`
	  push: function push(item) {
	    var O = toObject(this);
	    var len = lengthOfArrayLike(O);
	    var argCount = arguments.length;
	    doesNotExceedSafeInteger(len + argCount);
	    for (var i = 0; i < argCount; i++) {
	      O[len] = arguments[i];
	      len++;
	    }
	    arraySetLength(O, len);
	    return len;
	  }
	});

	var $TypeError$4 = TypeError;

	// `Iterator.prototype.reduce` method
	// https://tc39.es/ecma262/#sec-iterator.prototype.reduce
	_export({
	  target: 'Iterator',
	  proto: true,
	  real: true
	}, {
	  reduce: function reduce(reducer /* , initialValue */) {
	    anObject(this);
	    aCallable(reducer);
	    var record = getIteratorDirect(this);
	    var noInitial = arguments.length < 2;
	    var accumulator = noInitial ? undefined : arguments[1];
	    var counter = 0;
	    iterate(record, function (value) {
	      if (noInitial) {
	        noInitial = false;
	        accumulator = value;
	      } else {
	        accumulator = reducer(accumulator, value, counter);
	      }
	      counter++;
	    }, {
	      IS_RECORD: true
	    });
	    if (noInitial) throw new $TypeError$4('Reduce of empty iterator with no initial value');
	    return accumulator;
	  }
	});

	var defineBuiltIns = function (target, src, options) {
	  for (var key in src) defineBuiltIn(target, key, src[key], options);
	  return target;
	};

	// `CreateIterResultObject` abstract operation
	// https://tc39.es/ecma262/#sec-createiterresultobject
	var createIterResultObject = function (value, done) {
	  return {
	    value: value,
	    done: done
	  };
	};

	var IteratorPrototype = iteratorsCore.IteratorPrototype;
	var TO_STRING_TAG = wellKnownSymbol('toStringTag');
	var ITERATOR_HELPER = 'IteratorHelper';
	var WRAP_FOR_VALID_ITERATOR = 'WrapForValidIterator';
	var setInternalState = internalState.set;
	var createIteratorProxyPrototype = function (IS_ITERATOR) {
	  var getInternalState = internalState.getterFor(IS_ITERATOR ? WRAP_FOR_VALID_ITERATOR : ITERATOR_HELPER);
	  return defineBuiltIns(objectCreate(IteratorPrototype), {
	    next: function next() {
	      var state = getInternalState(this);
	      // for simplification:
	      //   for `%WrapForValidIteratorPrototype%.next` our `nextHandler` returns `IterResultObject`
	      //   for `%IteratorHelperPrototype%.next` - just a value
	      if (IS_ITERATOR) return state.nextHandler();
	      try {
	        var result = state.done ? undefined : state.nextHandler();
	        return createIterResultObject(result, state.done);
	      } catch (error) {
	        state.done = true;
	        throw error;
	      }
	    },
	    'return': function () {
	      var state = getInternalState(this);
	      var iterator = state.iterator;
	      state.done = true;
	      if (IS_ITERATOR) {
	        var returnMethod = getMethod(iterator, 'return');
	        return returnMethod ? functionCall(returnMethod, iterator) : createIterResultObject(undefined, true);
	      }
	      if (state.inner) try {
	        iteratorClose(state.inner.iterator, 'normal');
	      } catch (error) {
	        return iteratorClose(iterator, 'throw', error);
	      }
	      if (iterator) iteratorClose(iterator, 'normal');
	      return createIterResultObject(undefined, true);
	    }
	  });
	};
	var WrapForValidIteratorPrototype = createIteratorProxyPrototype(true);
	var IteratorHelperPrototype = createIteratorProxyPrototype(false);
	createNonEnumerableProperty(IteratorHelperPrototype, TO_STRING_TAG, 'Iterator Helper');
	var iteratorCreateProxy = function (nextHandler, IS_ITERATOR) {
	  var IteratorProxy = function Iterator(record, state) {
	    if (state) {
	      state.iterator = record.iterator;
	      state.next = record.next;
	    } else state = record;
	    state.type = IS_ITERATOR ? WRAP_FOR_VALID_ITERATOR : ITERATOR_HELPER;
	    state.nextHandler = nextHandler;
	    state.counter = 0;
	    state.done = false;
	    setInternalState(this, state);
	  };
	  IteratorProxy.prototype = IS_ITERATOR ? WrapForValidIteratorPrototype : IteratorHelperPrototype;
	  return IteratorProxy;
	};

	// call something on iterator step with safe closing on error
	var callWithSafeIterationClosing = function (iterator, fn, value, ENTRIES) {
	  try {
	    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
	  } catch (error) {
	    iteratorClose(iterator, 'throw', error);
	  }
	};

	var IteratorProxy$2 = iteratorCreateProxy(function () {
	  var iterator = this.iterator;
	  var predicate = this.predicate;
	  var next = this.next;
	  var result, done, value;
	  while (true) {
	    result = anObject(functionCall(next, iterator));
	    done = this.done = !!result.done;
	    if (done) return;
	    value = result.value;
	    if (callWithSafeIterationClosing(iterator, predicate, [value, this.counter++], true)) return value;
	  }
	});

	// `Iterator.prototype.filter` method
	// https://tc39.es/ecma262/#sec-iterator.prototype.filter
	_export({
	  target: 'Iterator',
	  proto: true,
	  real: true,
	  forced: isPure
	}, {
	  filter: function filter(predicate) {
	    anObject(this);
	    aCallable(predicate);
	    return new IteratorProxy$2(getIteratorDirect(this), {
	      predicate: predicate
	    });
	  }
	});

	// `Iterator.prototype.find` method
	// https://tc39.es/ecma262/#sec-iterator.prototype.find
	_export({
	  target: 'Iterator',
	  proto: true,
	  real: true
	}, {
	  find: function find(predicate) {
	    anObject(this);
	    aCallable(predicate);
	    var record = getIteratorDirect(this);
	    var counter = 0;
	    return iterate(record, function (value, stop) {
	      if (predicate(value, counter++)) return stop(value);
	    }, {
	      IS_RECORD: true,
	      INTERRUPTED: true
	    }).result;
	  }
	});

	var IteratorProxy$1 = iteratorCreateProxy(function () {
	  var iterator = this.iterator;
	  var result = anObject(functionCall(this.next, iterator));
	  var done = this.done = !!result.done;
	  if (!done) return callWithSafeIterationClosing(iterator, this.mapper, [result.value, this.counter++], true);
	});

	// `Iterator.prototype.map` method
	// https://github.com/tc39/proposal-iterator-helpers
	var iteratorMap = function map(mapper) {
	  anObject(this);
	  aCallable(mapper);
	  return new IteratorProxy$1(getIteratorDirect(this), {
	    mapper: mapper
	  });
	};

	// `Iterator.prototype.map` method
	// https://tc39.es/ecma262/#sec-iterator.prototype.map
	_export({
	  target: 'Iterator',
	  proto: true,
	  real: true,
	  forced: isPure
	}, {
	  map: iteratorMap
	});

	var $String$1 = String;
	var toString_1 = function (argument) {
	  if (classof(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
	  return $String$1(argument);
	};

	var $TypeError$3 = TypeError;
	var validateArgumentsLength = function (passed, required) {
	  if (passed < required) throw new $TypeError$3('Not enough arguments');
	  return passed;
	};

	var $URLSearchParams$1 = URLSearchParams;
	var URLSearchParamsPrototype$2 = $URLSearchParams$1.prototype;
	var append = functionUncurryThis(URLSearchParamsPrototype$2.append);
	var $delete = functionUncurryThis(URLSearchParamsPrototype$2['delete']);
	var forEach$2 = functionUncurryThis(URLSearchParamsPrototype$2.forEach);
	var push = functionUncurryThis([].push);
	var params$1 = new $URLSearchParams$1('a=1&a=2&b=3');
	params$1['delete']('a', 1);
	// `undefined` case is a Chromium 117 bug
	// https://bugs.chromium.org/p/v8/issues/detail?id=14222
	params$1['delete']('b', undefined);
	if (params$1 + '' !== 'a=2') {
	  defineBuiltIn(URLSearchParamsPrototype$2, 'delete', function (name /* , value */) {
	    var length = arguments.length;
	    var $value = length < 2 ? undefined : arguments[1];
	    if (length && $value === undefined) return $delete(this, name);
	    var entries = [];
	    forEach$2(this, function (v, k) {
	      // also validates `this`
	      push(entries, {
	        key: k,
	        value: v
	      });
	    });
	    validateArgumentsLength(length, 1);
	    var key = toString_1(name);
	    var value = toString_1($value);
	    var index = 0;
	    var dindex = 0;
	    var found = false;
	    var entriesLength = entries.length;
	    var entry;
	    while (index < entriesLength) {
	      entry = entries[index++];
	      if (found || entry.key === key) {
	        found = true;
	        $delete(this, entry.key);
	      } else dindex++;
	    }
	    while (dindex < entriesLength) {
	      entry = entries[dindex++];
	      if (!(entry.key === key && entry.value === value)) append(this, entry.key, entry.value);
	    }
	  }, {
	    enumerable: true,
	    unsafe: true
	  });
	}

	var $URLSearchParams = URLSearchParams;
	var URLSearchParamsPrototype$1 = $URLSearchParams.prototype;
	var getAll = functionUncurryThis(URLSearchParamsPrototype$1.getAll);
	var $has = functionUncurryThis(URLSearchParamsPrototype$1.has);
	var params = new $URLSearchParams('a=1');

	// `undefined` case is a Chromium 117 bug
	// https://bugs.chromium.org/p/v8/issues/detail?id=14222
	if (params.has('a', 2) || !params.has('a', undefined)) {
	  defineBuiltIn(URLSearchParamsPrototype$1, 'has', function has(name /* , value */) {
	    var length = arguments.length;
	    var $value = length < 2 ? undefined : arguments[1];
	    if (length && $value === undefined) return $has(this, name);
	    var values = getAll(this, name); // also validates `this`
	    validateArgumentsLength(length, 1);
	    var value = toString_1($value);
	    var index = 0;
	    while (index < values.length) {
	      if (values[index++] === value) return true;
	    }
	    return false;
	  }, {
	    enumerable: true,
	    unsafe: true
	  });
	}

	var URLSearchParamsPrototype = URLSearchParams.prototype;
	var forEach$1 = functionUncurryThis(URLSearchParamsPrototype.forEach);

	// `URLSearchParams.prototype.size` getter
	// https://github.com/whatwg/url/pull/734
	if (descriptors && !('size' in URLSearchParamsPrototype)) {
	  defineBuiltInAccessor(URLSearchParamsPrototype, 'size', {
	    get: function size() {
	      var count = 0;
	      forEach$1(this, function () {
	        count++;
	      });
	      return count;
	    },
	    configurable: true,
	    enumerable: true
	  });
	}

	var BN = {
		name: "Bunny",
		imgPath: "/img/statistics/bunny.svg",
		cacheHitRate: 99.61,
		color: "#3370EB",
		enabled: true
	};
	var CF = {
		name: "Cloudflare",
		imgPath: "/img/statistics/cloudflare.svg",
		cacheHitRate: 99.49,
		color: "#F6821F",
		enabled: true
	};
	var FY = {
		name: "Fastly",
		imgPath: "/img/statistics/fastly.svg",
		cacheHitRate: 99.43,
		color: "#FF282D",
		enabled: true
	};
	var GC = {
		name: "GCore",
		imgPath: "/img/statistics/g-core.svg",
		cacheHitRate: 98.93,
		color: "#A234D2",
		enabled: true
	};
	var MX = {
		name: "StackPath",
		cacheHitRate: 99.24,
		imgPath: "/img/statistics/stackpath.svg",
		color: "#106534",
		enabled: false
	};
	var QT = {
		name: "Quantil",
		imgPath: "/img/statistics/quantil.ico",
		cacheHitRate: 99.18,
		color: "#961C1F",
		enabled: false
	};
	var combinedProviders = {
		name: "Combined Providers",
		imgPath: "/img/statistics/stackpath.ico",
		color: "#F65128",
		enabled: false
	};
	var netProviders = {
		BN: BN,
		CF: CF,
		FY: FY,
		GC: GC,
		MX: MX,
		QT: QT,
		combinedProviders: combinedProviders
	};

	var netProviders$1 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		BN: BN,
		CF: CF,
		FY: FY,
		GC: GC,
		MX: MX,
		QT: QT,
		combinedProviders: combinedProviders,
		'default': netProviders
	});

	var newHost = "img.jsdelivr.com";
	var hosts = [
		"cloud.githubusercontent.com",
		"img.shields.io",
		"img.badgesize.io",
		"raw.githubusercontent.com",
		"github.com",
		"upload.wikimedia.org",
		"opencollective.com",
		"flat.badgen.net",
		"images.opencollective.com",
		"avatars.githubusercontent.com",
		"badgen.net"
	];
	var optimizedHosts$1 = {
		newHost: newHost,
		hosts: hosts
	};

	var optimizedHosts$2 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		newHost: newHost,
		hosts: hosts,
		'default': optimizedHosts$1
	});

	var providersJson = getCjsExportFromNamespace(netProviders$1);

	var optimizedHosts = getCjsExportFromNamespace(optimizedHosts$2);

	var _ = createCommonjsModule(function (module) {
	  const MONTHS_SHORT_NAMES_LIST = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	  const MONTHS_FULL_NAMES_LIST = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
	  const DAY_NAME_NUMBER_MAP = {
	    Mon: 0,
	    Tue: 1,
	    Wed: 2,
	    Thu: 3,
	    Fri: 4,
	    Sat: 5,
	    Sun: 6
	  };
	  const MONTH_FULL_OF_DAYS = '31';
	  const MONTH_SHORT_OF_DAYS = '30';
	  const MONTH_FEB_DAYS = '28';
	  const MONTH_LEAP_FEB_DAYS = '29';
	  const screenType = {
	    mobile: 480,
	    tablet: 768,
	    mdDesktop: 992,
	    lgDesktop: 1200,
	    xlDesktop: 1400
	  };
	  const PROBE_NO_TIMING_VALUE = 'time out';
	  const PROBE_STATUS_FAILED = 'failed';
	  const PROBE_STATUS_OFFLINE = 'offline';
	  module.exports = {
	    screenType,
	    isTabletScreen() {
	      return screen.width > screenType.mobile && screen.width <= screenType.tablet;
	    },
	    isMobileScreen() {
	      return screen.width <= screenType.mobile;
	    },
	    calculateGrowth(curr, prev) {
	      if (!prev) {
	        return 0;
	      }
	      return curr / prev * 100 - 100;
	    },
	    getValueFormatter(isBandwidth, values) {
	      if (!isBandwidth) {
	        return module.exports.formatNumber;
	      }
	      let unit = module.exports.findUnitFromArray(values);
	      return value => module.exports.formatBytesWithUnit(value, unit);
	    },
	    flattenFiles: function flattenFiles(tree) {
	      let path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '/';
	      let files = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	      tree.forEach(item => {
	        if (item.type === 'file') {
	          files.push(path + item.name);
	        } else {
	          flattenFiles(item.files, path + item.name + '/', files);
	        }
	      });
	      return files;
	    },
	    formatDate(date) {
	      let format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'long';
	      if (!date) {
	        return '';
	      }
	      if (typeof date === 'string') {
	        date = new Date(date);
	      }
	      if (format === 'short') {
	        return date.toLocaleDateString('en-US', {
	          day: 'numeric',
	          month: 'short'
	        });
	      }
	      return date.toLocaleDateString('en-US', {
	        day: 'numeric',
	        month: 'short',
	        year: 'numeric'
	      });
	    },
	    formatDateTime(date) {
	      if (!date) {
	        return '';
	      }
	      if (typeof date === 'string') {
	        date = new Date(date);
	      }
	      return date.toLocaleDateString('en-US', {
	        day: 'numeric',
	        month: 'short',
	        year: 'numeric',
	        hour: 'numeric',
	        minute: 'numeric',
	        second: 'numeric',
	        hour12: false
	      });
	    },
	    formatHits(hits) {
	      if (hits < 1e9) {
	        return 1;
	      }
	      return Math.round(hits / 1e9);
	    },
	    formatNumber(number) {
	      return Math.floor(number).toString().replace(/\d(?=(?:\d{3})+$)/g, '$& ');
	    },
	    formatNumberWithSpace(val) {
	      // remove sign if negative
	      let sign = 1;
	      if (val < 0) {
	        sign = -1;
	        val = -val;
	      }
	      let num = val.toString().includes('.') ? val.toString().split('.')[0] : val.toString();
	      while (/(\d+)(\d{3})/.test(num.toString())) {
	        num = num.toString().replace(/(\d+)(\d{3})/, '$1 $2');
	      }
	      if (val.toString().includes('.')) {
	        num = num + '.' + val.toString().split('.')[1];
	      }
	      return sign < 0 ? '-' + num : num;
	    },
	    getMinifiedName(name) {
	      return name.replace(/\.(js|css)$/i, '.min.$1');
	    },
	    getNonMinifiedName(name) {
	      return name.replace(/\.min\.(js|css)$/i, '.$1');
	    },
	    listFiles: function listFiles() {
	      let files = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	      let path = arguments.length > 1 ? arguments[1] : undefined;
	      if (!path.length) {
	        return files;
	      }
	      let p = path.slice();
	      let n = p.shift();
	      let d = files.filter(f => f.name === n)[0];
	      return d && d.files ? listFiles(d.files, p) : null;
	    },
	    linRange(max, number) {
	      let array = [];
	      for (let i = 1; i <= number; i++) {
	        array.push(max * i / number);
	      }
	      return array;
	    },
	    logRange(min, max) {
	      let array = [];
	      for (let i = min; i <= max; i *= 10) {
	        array.push(i);
	      }
	      return array;
	    },
	    multiplyDeep: function multiplyDeep(data, n) {
	      if (typeof data !== 'object') {
	        return data;
	      }
	      Object.keys(data).forEach(key => {
	        if (key !== 'rank' && typeof data[key] === 'number') {
	          data[key] *= n;
	        } else if (data[key] && typeof data[key] === 'object') {
	          multiplyDeep(data[key], n);
	        }
	      });
	      return data;
	    },
	    nth(n) {
	      n = Math.floor(n);
	      let m = n % 10;
	      if (n === 1) {
	        return '';
	      } else if (n > 20 && m === 1) {
	        return `${n}st`;
	      } else if (n === 2 || n > 20 && m === 2) {
	        return `${n}nd`;
	      } else if (n === 3 || n > 20 && m === 3) {
	        return `${n}rd`;
	      }
	      return `${n}th`;
	    },
	    getChartXAxisData(periodDates) {
	      let period = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'month';
	      let periodGroupBy = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'day';
	      let chartXData = [];
	      let dataPerMonths = periodDates.reduce((dataPerMonths, date) => {
	        let splittedDate = date.split('-');
	        let dateYear = splittedDate[0];
	        let dateMonth = splittedDate.slice(0, 2).join('-');
	        let periodMonthFormatted = MONTHS_SHORT_NAMES_LIST[new Date(dateMonth).getUTCMonth()];
	        if (!dataPerMonths[`${dateYear} ${periodMonthFormatted}`]) {
	          dataPerMonths[`${dateYear} ${periodMonthFormatted}`] = [];
	        }
	        dataPerMonths[`${dateYear} ${periodMonthFormatted}`].push(date);
	        return dataPerMonths;
	      }, []);
	      let labelArea = 0;
	      Object.keys(dataPerMonths).forEach(yearMonthKey => {
	        // let middleLength = Math.round(dataPerMonths[yearMonthKey].length / 2);

	        dataPerMonths[yearMonthKey].forEach((day, idx) => {
	          // for every case except we set month in the start of the days
	          // if period is year we should return month for every day since it will be filtered on ticks callback as needed
	          let year = yearMonthKey.split(' ')[0];
	          let month = yearMonthKey.split(' ')[1];
	          labelArea++;
	          if (period === 'year') {
	            if (idx === 0) {
	              if (periodGroupBy === 'day' && dataPerMonths[yearMonthKey].length > 15 && labelArea < 359) {
	                chartXData.push([day, month, year]);
	                return;
	              } else if (periodGroupBy === 'week' && labelArea > 0 && labelArea < 54) {
	                chartXData.push([day, month, year]);
	                return;
	              } else if (periodGroupBy === 'month' && labelArea < 12) {
	                chartXData.push([day, month, year]);
	                return;
	              }
	            }
	            if (periodGroupBy !== 'month') {
	              chartXData.push([day, '', '']);
	            }
	          } else if (idx === 0) {
	            if (periodGroupBy === 'month') {
	              chartXData.push(['', month]);
	            } else if (dataPerMonths[yearMonthKey].length > 1) {
	              chartXData.push([day, month]);
	            }
	          } else {
	            chartXData.push([day, '']);
	          }
	        });
	      });
	      return chartXData;
	    },
	    // escaping code: https://github.com/component/escape-html/blob/master/index.js
	    unescapeHtml(text) {
	      return text.replace(/&quot;/g, '"').replace(/&amp;/g, '&').replace(/&#39;/g, '\'').replace(/&lt;/g, '<').replace(/&gt;/g, '>');
	    },
	    // ignoreExtremlySmallValue: true when you need to find min value for the axis min e.g.
	    getValueByMagnitude(value) {
	      let rounding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'round';
	      let magnitudeCorrection = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	      let ignoreExtremlySmallValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
	      let magnitude = Math.floor(Math.log10(value) === -Infinity ? 0 : Math.log10(value)) - magnitudeCorrection;
	      if (ignoreExtremlySmallValue && value < 10) {
	        return rounding === 'ceil' ? 10 : 0;
	      }
	      switch (rounding) {
	        case 'round':
	          return Math.round(value / Math.pow(10, magnitude)) * Math.pow(10, magnitude);
	        case 'ceil':
	          return Math.ceil(value / Math.pow(10, magnitude)) * Math.pow(10, magnitude);
	        case 'floor':
	          return Math.floor(value / Math.pow(10, magnitude)) * Math.pow(10, magnitude);
	      }
	    },
	    convertBytesToUnits(bytesAmount) {
	      let units = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GB';
	      let unitsBase = null;
	      switch (units) {
	        case 'kB':
	          unitsBase = 1e3;
	          break;
	        case 'MB':
	          unitsBase = 1e6;
	          break;
	        case 'GB':
	          unitsBase = 1e9;
	          break;
	        case 'TB':
	          unitsBase = 1e12;
	          break;
	        case 'PB':
	          unitsBase = 1e15;
	          break;
	        case 'EB':
	          unitsBase = 1e18;
	          break;
	        default:
	          unitsBase = 1;
	      }
	      return Math.round(bytesAmount / unitsBase);
	    },
	    findUnitFromArray(numbers) {
	      let lookup = [{
	        value: 1,
	        symbol: 'B'
	      }, {
	        value: 1e4,
	        symbol: 'kB'
	      }, {
	        value: 1e7,
	        symbol: 'MB'
	      }, {
	        value: 1e10,
	        symbol: 'GB'
	      }, {
	        value: 1e13,
	        symbol: 'TB'
	      }, {
	        value: 1e16,
	        symbol: 'PB'
	      }, {
	        value: 1e19,
	        symbol: 'EB'
	      }];
	      return numbers.map(num => {
	        return lookup.slice().reverse().find(item => {
	          return num >= item.value;
	        });
	      }).sort((a, b) => a.value - b.value)[0].symbol;
	    },
	    findUnitFromNumber(num) {
	      let lookup = [{
	        value: 1e4,
	        symbol: 'kB'
	      }, {
	        value: 1e7,
	        symbol: 'MB'
	      }, {
	        value: 1e10,
	        symbol: 'GB'
	      }, {
	        value: 1e13,
	        symbol: 'TB'
	      }, {
	        value: 1e16,
	        symbol: 'PB'
	      }, {
	        value: 1e19,
	        symbol: 'EB'
	      }];
	      let unit = lookup.slice().reverse().find(item => {
	        return num >= item.value;
	      });
	      if (!unit) {
	        return 'B';
	      }
	      return unit.symbol;
	    },
	    formatBytesWithUnit(num, unit) {
	      let lookup = [{
	        value: 1,
	        symbol: 'B'
	      }, {
	        value: 1e3,
	        symbol: 'kB'
	      }, {
	        value: 1e6,
	        symbol: 'MB'
	      }, {
	        value: 1e9,
	        symbol: 'GB'
	      }, {
	        value: 1e12,
	        symbol: 'TB'
	      }, {
	        value: 1e15,
	        symbol: 'PB'
	      }, {
	        value: 1e18,
	        symbol: 'EB'
	      }];
	      let item = lookup.find(l => l.symbol === unit) || lookup.slice().reverse().find(item => {
	        return num >= item.value;
	      });
	      return item ? module.exports.formatNumber(num / item.value) + ' ' + item.symbol : '0';
	    },
	    formatGrowth(num) {
	      let fixed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	      if (num === 0 || num.toFixed(fixed) === '0') {
	        return `+0%`;
	      }
	      return `${num >= 0 ? '+' : ''}${num.toFixed(fixed)}%`;
	    },
	    formatShare(num) {
	      let fixed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	      if (num === 0 || num.toFixed(fixed) === '0') {
	        return `0%`;
	      }
	      return `${num.toFixed(fixed)}%`;
	    },
	    formatToShortNumber(num) {
	      let delimiter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	      let unit = arguments.length > 2 ? arguments[2] : undefined;
	      let lookup = [{
	        value: 1,
	        symbol: ''
	      }, {
	        value: 1e3,
	        symbol: 'K'
	      }, {
	        value: 1e6,
	        symbol: 'M'
	      }, {
	        value: 1e9,
	        symbol: 'B'
	      }, {
	        value: 1e12,
	        symbol: 'T'
	      }, {
	        value: 1e15,
	        symbol: 'P'
	      }, {
	        value: 1e18,
	        symbol: 'E'
	      }];
	      let rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
	      let item = lookup.find(l => l.symbol === unit) || lookup.slice().reverse().find(item => {
	        return num >= item.value;
	      });
	      return item ? (num / item.value).toFixed(1).replace(rx, '$1') + delimiter + item.symbol : '0';
	    },
	    makeHTTPRequest(obj) {
	      let {
	        method = 'GET',
	        rawResponse = false,
	        body,
	        url,
	        headers,
	        responseHeadersToGet = null,
	        withCredentials = false
	      } = obj;
	      return new Promise((resolve, reject) => {
	        let xhr = new XMLHttpRequest();
	        xhr.open(method || 'GET', method === 'GET' && body ? url + this.createQueryString(body) : url);
	        if (method === 'POST') {
	          xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        }
	        if (headers) {
	          Object.keys(headers).forEach(key => xhr.setRequestHeader(key, headers[key]));
	        }
	        if (withCredentials) {
	          xhr.withCredentials = true;
	        }
	        xhr.onerror = xhr.onload = () => {
	          let response = xhr.response;
	          if (!rawResponse) {
	            try {
	              response = JSON.parse(response);
	            } catch (e) {
	              console.error(e);
	            }
	          }
	          let responseHeaders = responseHeadersToGet ? responseHeadersToGet.reduce((headerValuePairs, headerName) => {
	            headerValuePairs[headerName] = xhr.getResponseHeader(headerName);
	            return headerValuePairs;
	          }, {}) : null;
	          if (xhr.status >= 200 && xhr.status < 300) {
	            let resolveData;
	            if (responseHeaders && Object.keys(responseHeaders).length) {
	              resolveData = {
	                response,
	                responseHeaders
	              };
	            } else {
	              resolveData = response;
	            }
	            resolve(resolveData);
	          } else {
	            let rejectData = {
	              ...response,
	              responseStatusCode: xhr.status
	            };
	            if (responseHeaders && Object.keys(responseHeaders).length) {
	              rejectData = {
	                ...rejectData,
	                responseHeaders
	              };
	            }

	            // eslint-disable-next-line prefer-promise-reject-errors
	            reject(rejectData);
	          }
	        };
	        if (method === 'GET') {
	          xhr.send();
	        } else if (method === 'POST') {
	          xhr.send(JSON.stringify(body));
	        }
	      });
	    },
	    createQueryString(params) {
	      let keys = Object.keys(params);
	      if (!keys.length) {
	        return '';
	      }
	      return '?' + keys.filter(key => params[key]).map(key => `${key}=${encodeURIComponent(params[key])}`).join('&');
	    },
	    deepExtend() {
	      let out = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      for (let i = 0; i < (arguments.length <= 1 ? 0 : arguments.length - 1); i++) {
	        let obj = i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1];
	        if (!obj) {
	          continue;
	        }
	        for (let key in obj) {
	          if (Object.hasOwn(obj, key)) {
	            if (typeof obj[key] === 'object' && obj[key] !== null) {
	              if (obj[key] instanceof Array) {
	                out[key] = obj[key].slice(0);
	              } else {
	                out[key] = this.deepExtend(out[key], obj[key]);
	              }
	            } else {
	              out[key] = obj[key];
	            }
	          }
	        }
	      }
	      return out;
	    },
	    onDocumentReady(fn) {
	      if (document.readyState !== 'loading') {
	        fn();
	      } else {
	        document.addEventListener('DOMContentLoaded', fn);
	      }
	    },
	    checkIfYearIsLeap(year) {
	      if (isNaN(Number(year)) || String(year).length !== 4) {
	        console.warn('Func isLeapYear expected a year as a String or a Number with 4 signs');
	        return false;
	      }
	      if (year % 4 === 0) {
	        if (year % 100 === 0) {
	          if (year % 400 === 0) {
	            return true;
	          }
	          return false;
	        }
	        return true;
	      }
	      return false;
	    },
	    getAmountOfDaysByMonth(month, year) {
	      switch (month) {
	        case '01':
	        case '03':
	        case '05':
	        case '07':
	        case '08':
	        case '10':
	        case '12':
	          return MONTH_FULL_OF_DAYS;
	        case '04':
	        case '06':
	        case '09':
	        case '11':
	          return MONTH_SHORT_OF_DAYS;
	        case '02':
	          return this.checkIfYearIsLeap(year) ? MONTH_LEAP_FEB_DAYS : MONTH_FEB_DAYS;
	      }
	    },
	    getDateFormats(date) {
	      let splittedDate = date.split('-');
	      let dateYear = splittedDate[0];
	      let dateMonth = splittedDate[1];
	      let dateDay = splittedDate[2];
	      let parsedDateDay = parseInt(splittedDate[2]);
	      let dateDayName = new Date(Date.UTC(Number(dateYear), Number(dateMonth) - 1, Number(dateDay))).toLocaleDateString('en-US', {
	        weekday: 'short'
	      });
	      let periodMonthShort = MONTHS_SHORT_NAMES_LIST[new Date(`${dateYear}-${dateMonth}`).getUTCMonth()];
	      let periodMonthFull = MONTHS_FULL_NAMES_LIST[new Date(`${dateYear}-${dateMonth}`).getUTCMonth()];
	      return {
	        dateYear,
	        dateMonth,
	        dateDay,
	        dateDayName,
	        periodMonthShort,
	        periodMonthFull,
	        parsedDateDay
	      };
	    },
	    prepareDataForChartGroupedBy(rawData, groupBy) {
	      let valueByDatePropName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	      let rawDataDatesKeys = Object.keys(rawData.dates);
	      let rawDataDatesData = rawData.dates;
	      return rawDataDatesKeys.reduce((resData, date) => {
	        let {
	          dateYear,
	          dateMonth,
	          dateDay,
	          dateDayName,
	          periodMonthShort,
	          periodMonthFull,
	          parsedDateDay
	        } = this.getDateFormats(date);
	        let valueByDateConverted = valueByDatePropName ? rawDataDatesData[date][valueByDatePropName] : rawDataDatesData[date];
	        switch (groupBy) {
	          case 'month':
	            if (!resData.preparedData[dateMonth]) {
	              resData.preparedData[dateMonth] = {
	                isFull: false,
	                value: valueByDateConverted,
	                day: dateDay,
	                month: periodMonthShort,
	                year: dateYear,
	                periodStart: `${periodMonthFull} ${parsedDateDay}, ${dateYear}`,
	                periodEnd: null
	              };
	            } else {
	              let lastDayNum = this.getAmountOfDaysByMonth(dateMonth, dateYear);
	              resData.preparedData[dateMonth].value += valueByDateConverted;
	              if (dateDay === lastDayNum) {
	                resData.preparedData[dateMonth].periodEnd = `${periodMonthFull} ${parsedDateDay}, ${dateYear}`;
	                if (resData.preparedData[dateMonth].day === `01`) {
	                  resData.preparedData[dateMonth].isFull = true;
	                }
	              }
	            }
	            return resData;
	          case 'week':
	            if (!resData.preparedData[resData.weekNumber]) {
	              resData.preparedData[resData.weekNumber] = {
	                isFull: false,
	                value: valueByDateConverted,
	                day: dateDay,
	                month: periodMonthShort,
	                year: dateYear,
	                periodStart: `${periodMonthFull} ${parsedDateDay}, ${dateYear}`,
	                periodEnd: null
	              };
	              resData.weekDayCnt = 1;
	            } else {
	              resData.preparedData[resData.weekNumber].value += valueByDateConverted;
	              resData.weekDayCnt++;
	              if (resData.weekDayCnt === 7) {
	                resData.preparedData[resData.weekNumber].isFull = true;
	                resData.preparedData[resData.weekNumber].periodEnd = `${periodMonthFull} ${parsedDateDay}, ${dateYear}`;
	              }
	            }
	            if (DAY_NAME_NUMBER_MAP[dateDayName] === 6) {
	              resData.weekNumber++;
	            }
	            return resData;
	          case 'day':
	            if (!resData.preparedData.days) {
	              resData.preparedData.days = [];
	            }
	            resData.preparedData.days.push({
	              value: valueByDateConverted,
	              day: dateDay,
	              month: periodMonthShort,
	              year: dateYear,
	              periodStart: `${periodMonthFull} ${parsedDateDay}, ${dateYear}`,
	              periodEnd: `${periodMonthFull} ${parsedDateDay}, ${dateYear}`
	            });
	            return resData;
	        }
	        return resData;
	      }, {
	        weekNumber: 0,
	        weekDayCnt: 0,
	        preparedData: {}
	      });
	    },
	    createWeekPeriodChartLabels(labels) {
	      // for both Mobile and Desktop we will show Day and Month per each tick
	      // no matter what resolution is
	      return labels.map(label => {
	        return label.slice(0, 2);
	      });
	    },
	    createMonthPeriodChartLabels(labels, groupBy) {
	      let formattedLabels = [];
	      if (groupBy === 'day') {
	        formattedLabels = labels.map((label, idx) => {
	          switch (true) {
	            case screen.width >= 992:
	              if (idx === 0 || label[0] === '01') {
	                return label.slice(0, 2);
	              }
	              return label.slice(0, 1);
	            case idx === Math.round(labels.length / 2):
	            case idx === 0:
	              return label.slice(0, 2);
	            default:
	              return [];
	          }
	        });
	      }
	      if (groupBy === 'week') {
	        formattedLabels = labels;
	      }
	      return formattedLabels;
	    },
	    createYearPeriodChartLabels(labels, groupBy) {
	      let formattedLabels = [...labels];
	      if (groupBy === 'day') {
	        let tempCurrMonth = labels[0][1];
	        let currAxisYear = labels[0][2];
	        formattedLabels = labels.map((label, idx) => {
	          switch (true) {
	            case screen.width >= 992:
	              if (idx === 0) {
	                return label.slice(1, 3);
	              } else if (label[2] !== currAxisYear && label[1] !== tempCurrMonth) {
	                currAxisYear = label[2];
	                tempCurrMonth = label[1];
	                return label.slice(1, 3);
	              } else if (label[1] !== tempCurrMonth && label[2] === currAxisYear) {
	                tempCurrMonth = label[1];
	                return label.slice(1, 2);
	              }
	              return [];
	            case idx === 0 || idx === labels.length - 1:
	              return label.slice(1, 3);
	          }
	          return [];
	        });
	      }
	      if (groupBy === 'week') {
	        let tempCurrMonth = labels[0][1];
	        let lastPeriodMonth = labels[labels.length - 1][1];
	        let currAxisYear = labels[0][2];
	        formattedLabels = labels.map((label, idx) => {
	          switch (true) {
	            case screen.width >= 768:
	              if (idx === 0 || idx === labels.length - 1 || label[2] !== currAxisYear) {
	                currAxisYear = label[2];
	                tempCurrMonth = label[1];
	                return label.slice(1, 3);
	              } else if (label[1] !== tempCurrMonth && label[1] !== lastPeriodMonth) {
	                tempCurrMonth = label[1];
	                return label.slice(1, 2);
	              }
	              return [];
	            case idx === 0 || idx === labels.length - 1:
	              return label.slice(1, 3);
	          }
	          return [];
	        });
	      }
	      if (groupBy === 'month') {
	        let currAxisYear = labels[0][2];
	        formattedLabels = labels.map((label, idx) => {
	          if (idx === 0 || idx === labels.length - 1 || label[2] !== currAxisYear) {
	            currAxisYear = label[2];
	            return label.slice(1, 3);
	          }
	          if (screen.width < 768) {
	            return [];
	          }
	          return label.slice(1, 2);
	        });
	      }
	      return formattedLabels;
	    },
	    // take preparedData for charts and then group it by day/week/month, calc magnitude, create labels for x-axis
	    getPreparedDataForBarChart(rawData, groupBy, chartPeriod, showChartBandwidth) {
	      let onlyFullPeriods = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
	      let {
	        preparedData
	      } = this.prepareDataForChartGroupedBy(rawData, groupBy);
	      let results = {
	        values: [],
	        labels: [],
	        labelsStartEndPeriods: [],
	        minRangeValue: 0,
	        maxRangeValue: 0,
	        valueUnits: ''
	      };
	      let dataToIteract = groupBy === 'day' ? preparedData.days : Object.values(preparedData);

	      // collect data for chart depending on groupBy
	      results = dataToIteract.reduce((res, period) => {
	        if (onlyFullPeriods && period.isFull === false) {
	          return res;
	        }
	        res.values.push(period.value);
	        res.labels.push([period.day, period.month, period.year]);
	        res.labelsStartEndPeriods.push([period.periodStart, period.periodEnd, period.value]);
	        return res;
	      }, results);
	      if (showChartBandwidth) {
	        let unit = module.exports.findUnitFromArray(results.values);
	        results.values = results.values.map(v => module.exports.convertBytesToUnits(v, unit));
	        results.valueUnits = ` ${unit}`;
	      }

	      // get min/max magnitude for y-axis
	      results.minRangeValue = this.getValueByMagnitude(Math.min(...results.values), 'floor');
	      results.maxRangeValue = this.getValueByMagnitude(Math.max(...results.values), 'ceil', 1);

	      // create labels depending on chartPeriod, Screen size, groupBy
	      switch (chartPeriod) {
	        case 's-week':
	          results.labels = this.createWeekPeriodChartLabels(results.labels);
	          break;
	        case 's-month':
	          results.labels = this.createMonthPeriodChartLabels(results.labels, groupBy);
	          break;
	        case 's-quarter':
	        case 's-year':
	          results.labels = this.createYearPeriodChartLabels(results.labels, groupBy);
	          break;
	      }
	      return results;
	    },
	    calcChartBarThicknessByResolution() {
	      let chartPeriod = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'month';
	      let usageChartGroupBy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'day';
	      let sreenWidth = screen.width;
	      let schema = {
	        thinnestBar: 1,
	        thinBar: 2,
	        regularBar: 4,
	        wideBar: 10
	      };
	      switch (chartPeriod) {
	        case 's-week':
	          return schema.wideBar;
	        case 's-month':
	          switch (usageChartGroupBy) {
	            case 'day':
	              if (sreenWidth >= 576) {
	                return schema.wideBar;
	              }
	              return schema.regularBar;
	            case 'week':
	              return schema.wideBar;
	          }
	          break;
	        case 's-quarter':
	          switch (usageChartGroupBy) {
	            case 'day':
	              if (sreenWidth >= 768) {
	                return schema.regularBar;
	              }
	              return schema.thinBar;
	            case 'week':
	              return schema.regularBar;
	            case 'month':
	              return schema.wideBar;
	          }
	          break;
	        case 's-year':
	          switch (usageChartGroupBy) {
	            case 'day':
	              return schema.thinnestBar;
	            case 'week':
	              if (sreenWidth >= 768) {
	                return schema.regularBar;
	              }
	              return schema.thinBar;
	            case 'month':
	              return schema.wideBar;
	          }
	          break;
	        default:
	          return schema.regularBar;
	      }
	    },
	    // prepare data for Providers Line Chart
	    getPreparedProvidersDataForLineChart(rawData, groupBy, chartPeriod, showChartBandwidth) {
	      let onlyFullPeriods = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
	      let dataType = showChartBandwidth ? 'bandwidth' : 'hits';
	      let valueUnits = '',
	        unit;
	      let sortedProviders = rawData[dataType].providers.sort((a, b) => b.total - a.total);
	      let topProviderData = sortedProviders[0] || {};
	      let {
	        preparedData: topProviderPrepData
	      } = this.prepareDataForChartGroupedBy(topProviderData, groupBy, 'total');
	      let labelsData = {
	        labels: [],
	        labelsStartEndPeriods: []
	      };
	      let dataToIteract = groupBy === 'day' ? topProviderPrepData.days : Object.values(topProviderPrepData);

	      // collect labels, period starts/ends data for chart
	      labelsData = dataToIteract.reduce((labelsData, period) => {
	        if (onlyFullPeriods && period.isFull === false) {
	          return labelsData;
	        }
	        labelsData.labels.push([period.day, period.month, period.year]);
	        labelsData.labelsStartEndPeriods.push([period.periodStart, period.periodEnd, period.value]);
	        return labelsData;
	      }, labelsData);

	      // create labels depending on chartPeriod, Screen size, groupBy
	      switch (chartPeriod) {
	        case 's-week':
	          labelsData.labels = this.createWeekPeriodChartLabels(labelsData.labels);
	          break;
	        case 's-month':
	          labelsData.labels = this.createMonthPeriodChartLabels(labelsData.labels, groupBy);
	          break;
	        case 's-quarter':
	        case 's-year':
	          labelsData.labels = this.createYearPeriodChartLabels(labelsData.labels, groupBy);
	          break;
	      }
	      let {
	        allGroupedByValues,
	        datasets
	      } = rawData[dataType].providers.reduce((res, providerData) => {
	        let {
	          preparedData
	        } = this.prepareDataForChartGroupedBy(providerData, groupBy, 'total');
	        let dataToIteract = groupBy === 'day' ? preparedData.days : Object.values(preparedData);
	        let groupedByValues = dataToIteract.reduce((values, period) => {
	          if (onlyFullPeriods && period.isFull === false) {
	            return values;
	          }
	          values.push(period.value);
	          return values;
	        }, []);
	        if (showChartBandwidth) {
	          if (!unit) {
	            unit = module.exports.findUnitFromArray(groupedByValues);
	            valueUnits = ` ${unit}`;
	          }
	          groupedByValues = groupedByValues.map(v => module.exports.convertBytesToUnits(v, unit));
	        }
	        let dataset = {
	          label: providersJson[providerData.code].name,
	          data: groupedByValues,
	          borderColor: providersJson[providerData.code].color,
	          backgroundColor: providersJson[providerData.code].color
	        };
	        res.datasets.push(dataset);
	        res.allGroupedByValues = [...res.allGroupedByValues, ...groupedByValues];
	        return res;
	      }, {
	        allGroupedByValues: [],
	        datasets: []
	      });

	      // get min/max magnitude for y-axis
	      let maxRangeValue = this.getValueByMagnitude(Math.max(...allGroupedByValues), 'ceil', 1);
	      return {
	        ...labelsData,
	        maxRangeValue,
	        valueUnits,
	        datasets
	      };
	    },
	    // prepare data for LineChart
	    getPreparedDataForLineChart(rawData, groupBy, chartPeriod, showChartBandwidth) {
	      let numberOfDatasets = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 5;
	      let onlyFullPeriods = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;
	      let colorsArray = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
	      let dataType = showChartBandwidth ? 'bandwidth' : 'hits';
	      let rawDataFiltered = rawData.sort((a, b) => b[dataType].hits - a[dataType].hits).slice(0, numberOfDatasets);
	      let valueUnits = '',
	        unit;
	      // get top by stats version of package to get from it values for y-axis, and labels to x-axis
	      let topVersionData = rawDataFiltered[0][dataType];
	      let {
	        preparedData: topVersionPrepData
	      } = this.prepareDataForChartGroupedBy(topVersionData, groupBy);
	      let labelsData = {
	        labels: [],
	        labelsStartEndPeriods: []
	      };
	      let dataToIteract = groupBy === 'day' ? topVersionPrepData.days : Object.values(topVersionPrepData);

	      // collect labels, period starts/ends adta for chart
	      labelsData = dataToIteract.reduce((labelsData, period) => {
	        if (onlyFullPeriods && period.isFull === false) {
	          return labelsData;
	        }
	        labelsData.labels.push([period.day, period.month, period.year]);
	        labelsData.labelsStartEndPeriods.push([period.periodStart, period.periodEnd, period.value]);
	        return labelsData;
	      }, labelsData);

	      // create labels depending on chartPeriod, Screen size, groupBy
	      switch (chartPeriod) {
	        case 's-week':
	          labelsData.labels = this.createWeekPeriodChartLabels(labelsData.labels);
	          break;
	        case 's-month':
	          labelsData.labels = this.createMonthPeriodChartLabels(labelsData.labels, groupBy);
	          break;
	        case 's-quarter':
	        case 's-year':
	          labelsData.labels = this.createYearPeriodChartLabels(labelsData.labels, groupBy);
	          break;
	      }
	      let {
	        allGroupedByValues,
	        datasets
	      } = rawDataFiltered.reduce((res, versionData, idx) => {
	        let {
	          preparedData
	        } = this.prepareDataForChartGroupedBy(versionData[dataType], groupBy);
	        let dataToIteract = groupBy === 'day' ? preparedData.days : Object.values(preparedData);
	        let groupedByValues = dataToIteract.reduce((values, period) => {
	          if (onlyFullPeriods && period.isFull === false) {
	            return values;
	          }
	          values.push(period.value);
	          return values;
	        }, []);
	        if (showChartBandwidth) {
	          if (!unit) {
	            unit = module.exports.findUnitFromArray(groupedByValues);
	            valueUnits = ` ${unit}`;
	          }
	          groupedByValues = groupedByValues.map(v => module.exports.convertBytesToUnits(v, unit));
	        }
	        let dataset = {
	          label: this.truncate(versionData.version, 20),
	          data: groupedByValues,
	          borderColor: colorsArray[idx],
	          backgroundColor: colorsArray[idx]
	        };
	        res.datasets.push(dataset);
	        res.allGroupedByValues = [...res.allGroupedByValues, ...groupedByValues];
	        return res;
	      }, {
	        allGroupedByValues: [],
	        datasets: []
	      });

	      // get min/max magnitude for y-axis
	      let maxRangeValue = this.getValueByMagnitude(Math.max(...allGroupedByValues), 'ceil', 1);
	      return {
	        ...labelsData,
	        maxRangeValue,
	        valueUnits,
	        datasets
	      };
	    },
	    // create barChart, lineChart improved tooltip title
	    createImprovedExternalTooltipTitle(periodStart, periodEnd, groupedBy) {
	      if (groupedBy === 'month') {
	        let [monthName,, year] = periodStart.split(' ');
	        return `${monthName}, ${year}`;
	      }
	      return periodStart === periodEnd ? `${periodStart}` : `${periodStart} - ${periodEnd}`;
	    },
	    getLineColorsFromMask(key) {
	      let mask = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	      let customColorsArr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	      let defaultColorsArr = ['#5C667A', '#BC5090', '#FFA600', '#FF6361', '#69C4F7'];
	      let colorsArr = customColorsArr ? customColorsArr : defaultColorsArr;
	      let lineColors = {
	        borderColor: mask ? mask[key] : colorsArr[key],
	        backgroundColor: mask ? mask[key] : colorsArr[key]
	      };
	      return lineColors;
	    },
	    translatePeriodsToSNotation(periodValue) {
	      switch (periodValue) {
	        case 'month':
	          return 's-month';
	        case 'quarter':
	          return 's-quarter';
	        case 'year':
	          return 's-year';
	        default:
	          return periodValue;
	      }
	    },
	    optimizeSrc(url, github) {
	      let {
	        newHost,
	        hosts
	      } = optimizedHosts;
	      let base = github ? `https://cdn.jsdelivr.net/gh/${github.user}/${github.project}@${github.head}/` : typeof location !== 'undefined' ? location.href : undefined;
	      let parsed = new URL(url.replace(/^\/+/, ''), base);
	      if (hosts.includes(parsed.hostname)) {
	        parsed.pathname = parsed.hostname + parsed.pathname;
	        parsed.hostname = newHost;
	      }
	      return parsed.toString();
	    },
	    normalizeHref(url, idPrefix) {
	      try {
	        let parsed = new URL(url.replace(/^\/+/, ''), location.href);
	        if (parsed.origin === location.origin && parsed.pathname === location.pathname) {
	          if (parsed.hash) {
	            parsed.hash = `#${idPrefix}${parsed.hash.substr(1)}`;
	          }
	        }
	        return parsed.toString();
	      } catch (e) {
	        return url;
	      }
	    },
	    isExternalLink(url) {
	      try {
	        let parsed = new URL(url.replace(/^\/+/, ''), location.href);
	        return parsed.hostname !== location.hostname;
	      } catch (e) {
	        return false;
	      }
	    },
	    packageToImportName(name) {
	      name = name.split(/[ ._-]/g).reduce((acc, value) => {
	        return acc + value.substr(0, 1).toUpperCase() + value.substr(1);
	      }).replace(/[^a-zA-Z0-9_$]/g, '');
	      if (/^\d/.test(name)) {
	        return `_${name}`;
	      }
	      return name || 'm';
	    },
	    filterListStatPeriods(rawListStatPeriods, filterFor) {
	      if (!filterFor) {
	        return rawListStatPeriods;
	      }
	      return rawListStatPeriods.reduce((res, item) => {
	        if (Object.hasOwn(item.links, 'filterFor')) {
	          res.push(item);
	        }
	        return res;
	      }, []);
	    },
	    prepareFilteredStatPeriods(rawPeriods) {
	      let {
	        prepPeriods
	      } = rawPeriods.reduce((res, rawItem, rawItemIdx) => {
	        let monthQuarterText = '';
	        let {
	          period,
	          periodType
	        } = rawItem;
	        let [year, monthOrQuarter] = period.split('-');
	        if (monthOrQuarter) {
	          monthQuarterText = isNaN(Number(monthOrQuarter)) ? monthOrQuarter : MONTHS_FULL_NAMES_LIST[Number(monthOrQuarter) - 1];
	        }
	        res.prepPeriods.push({
	          periodType,
	          periodText: `${monthQuarterText} ${year}`.trim(),
	          periodValue: period
	        });
	        if (res.yearPointer !== year) {
	          res.yearPointer = year;
	        }

	        // check if next item has different year form current, if so - add separator
	        if (rawPeriods[rawItemIdx + 1] && rawPeriods[rawItemIdx + 1].period.split('-')[0] !== year) {
	          res.prepPeriods.push({
	            periodType: 'separator'
	          });
	        }
	        return res;
	      }, {
	        prepPeriods: [],
	        yearPointer: null
	      });
	      let defaultPeriods = [{
	        periodType: 's-month',
	        periodText: 'month',
	        periodValue: 'month'
	      }, {
	        periodType: 's-quarter',
	        periodText: 'quarter',
	        periodValue: 'quarter'
	      }, {
	        periodType: 's-year',
	        periodText: 'year',
	        periodValue: 'year'
	      }, {
	        periodType: 'separator'
	      }];
	      return defaultPeriods.concat(prepPeriods);
	    },
	    getPreparedListStatPeriods(rawListStatPeriods, filterFor) {
	      let filteredStatPeriods = this.filterListStatPeriods(rawListStatPeriods, filterFor);
	      return this.prepareFilteredStatPeriods(filteredStatPeriods);
	    },
	    truncate(text, length) {
	      if (text.length <= length) {
	        return text;
	      }
	      return `${text.substr(0, length - 3)}...`;
	    },
	    getGpProbeLastTiming(testType, result) {
	      let lastTiming;
	      let {
	        timings = []
	      } = result;
	      if (testType === 'ping') {
	        lastTiming = timings[timings.length - 1] ? timings[timings.length - 1].rtt : PROBE_NO_TIMING_VALUE;
	      }
	      return lastTiming;
	    },
	    calcGpTestResTiming(testType, testResData) {
	      let dnsTraceEnabled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	      let units = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ' ms';
	      let resTiming;
	      let lastTiming;
	      let extraValues = {};
	      let lowCaseTestName = testType.toLowerCase();
	      lastTiming = this.getGpProbeLastTiming(testType, testResData.result);
	      if (testResData.result?.status === PROBE_STATUS_FAILED) {
	        return {
	          value: PROBE_STATUS_FAILED,
	          extraValues,
	          fullText: PROBE_STATUS_FAILED,
	          isFailed: true
	        };
	      } else if (testResData.result?.status === PROBE_STATUS_OFFLINE) {
	        return {
	          value: PROBE_STATUS_OFFLINE,
	          extraValues,
	          fullText: PROBE_STATUS_OFFLINE,
	          isFailed: false
	        };
	      }
	      if (lowCaseTestName === 'ping') {
	        resTiming = testResData.result?.stats?.avg;
	        if (typeof testResData.result?.stats?.loss === 'number') {
	          extraValues.loss = {
	            text: 'Loss',
	            value: testResData.result?.stats?.loss,
	            units: '%'
	          };
	        }
	      } else if (lowCaseTestName === 'traceroute') {
	        let {
	          timings
	        } = testResData.result.hops ? testResData.result.hops[testResData.result.hops.length - 1] : {};
	        if (timings && timings.length) {
	          let timingsCalc = timings.reduce((res, timing) => {
	            if (typeof timing.rtt === 'number') {
	              return {
	                sum: res.sum + Number(timing.rtt),
	                cnt: res.cnt + 1
	              };
	            }
	            return res;
	          }, {
	            sum: 0,
	            cnt: 0
	          });
	          if (timingsCalc.cnt) {
	            resTiming = Number((timingsCalc.sum / timingsCalc.cnt).toFixed(3));
	          }
	        }
	      } else if (lowCaseTestName === 'dns') {
	        if (dnsTraceEnabled) {
	          let lastHop = testResData.result.hops ? testResData.result.hops[testResData.result.hops.length - 1] : {};
	          if (lastHop) {
	            resTiming = lastHop.timings.total;
	          }
	        } else {
	          resTiming = testResData.result.timings.total;
	        }
	      } else if (lowCaseTestName === 'mtr') {
	        let lastHop = testResData.result.hops ? testResData.result.hops[testResData.result.hops.length - 1] : {};
	        if (lastHop) {
	          resTiming = lastHop.stats.avg;
	        }
	      } else if (lowCaseTestName === 'http') {
	        if (testResData.result.statusCode !== null) {
	          resTiming = testResData.result?.timings?.total;
	          if (typeof testResData.result?.timings?.dns === 'number') {
	            extraValues.dns = {
	              text: 'DNS',
	              value: testResData.result.timings.dns,
	              units: ' ms'
	            };
	          }
	          if (typeof testResData.result?.timings?.tcp === 'number') {
	            extraValues.tcp = {
	              text: 'TCP',
	              value: testResData.result.timings.tcp,
	              units: ' ms'
	            };
	          }
	          if (typeof testResData.result?.timings?.tls === 'number') {
	            extraValues.tls = {
	              text: 'TLS',
	              value: testResData.result.timings.tls,
	              units: ' ms'
	            };
	          }
	          if (typeof testResData.result?.timings?.firstByte === 'number') {
	            extraValues.firstByte = {
	              text: 'TTFB',
	              value: testResData.result.timings.firstByte,
	              units: ' ms'
	            };
	          }
	          if (typeof testResData.result?.timings?.download === 'number') {
	            extraValues.download = {
	              text: 'Download',
	              value: testResData.result.timings.download,
	              units: ' ms'
	            };
	          }
	        }
	      }
	      if (typeof resTiming === 'number') {
	        let note = '';
	        switch (lowCaseTestName) {
	          case 'traceroute':
	          case 'mtr':
	            note = '(average)';
	            break;
	          case 'dns':
	          case 'http':
	            note = '(total)';
	            break;
	        }
	        return {
	          value: resTiming,
	          extraValues,
	          units,
	          note,
	          fullText: note ? `${Math.round(resTiming)}${units} ${note}` : `${Math.round(resTiming)}${units}`,
	          lastTiming
	        };
	      }
	      return {
	        value: PROBE_NO_TIMING_VALUE,
	        extraValues,
	        fullText: PROBE_NO_TIMING_VALUE,
	        isFailed: testResData.result?.status === PROBE_STATUS_FAILED,
	        lastTiming: PROBE_NO_TIMING_VALUE
	      };
	    },
	    getProbeTimeOutValue() {
	      return PROBE_NO_TIMING_VALUE;
	    },
	    getProbeStatusFailedValue() {
	      return PROBE_STATUS_FAILED;
	    },
	    getProbeStatusOfflineValue() {
	      return PROBE_STATUS_OFFLINE;
	    },
	    capitalizeFirstLetter(word) {
	      return word ? word[0].toUpperCase() + word.slice(1) : '';
	    },
	    capitalizeStrEveryFirstLetter(string) {
	      let exclude = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	      return string.split(' ').reduce((res, w) => {
	        if (exclude.includes(w)) {
	          res.push(w);
	        } else {
	          res.push(this.capitalizeFirstLetter(w));
	        }
	        return res;
	      }, []).join(' ');
	    },
	    getElementOffset(el) {
	      let box = el.getBoundingClientRect();
	      let docElem = document.documentElement;
	      return {
	        top: box.top + window.scrollY - docElem.clientTop,
	        left: box.left + window.scrollX - docElem.clientLeft
	      };
	    },
	    removeDuplicatedTargets(arr) {
	      return arr.reduce((uniquesArr, item) => {
	        if (uniquesArr.indexOf(item) < 0) {
	          uniquesArr.push(item);
	        }
	        return uniquesArr;
	      }, []);
	    },
	    parseGpRawOutputForTimings(raw) {
	      let packets = [];
	      let timeMatch, noAnswerMatch;
	      let timeRegex = /icmp_seq=(\d+).*time=(\d+(\.\d+)?)/;
	      let noAnswerRegex = /no answer yet for icmp_seq=(\d+)/;
	      let lines = raw.split('\n').filter(l => l);
	      for (let i = 0; i < lines.length; i++) {
	        if (i === 0) {
	          continue;
	        }
	        if (lines[i].includes('---')) {
	          break;
	        }
	        timeMatch = timeRegex.exec(lines[i]);
	        noAnswerMatch = noAnswerRegex.exec(lines[i]);
	        if (timeMatch) {
	          packets[timeMatch[1] - 1] = parseFloat(timeMatch[2]);
	        } else if (noAnswerMatch) {
	          if (!packets[noAnswerMatch[1] - 1]) {
	            packets[noAnswerMatch[1] - 1] = PROBE_NO_TIMING_VALUE;
	          }
	        } else ;
	      }
	      return {
	        packetsRtt: packets,
	        packetsDrop: packets.filter(p => p === PROBE_NO_TIMING_VALUE).length,
	        packetsTotal: packets.length
	      };
	    },
	    memoize(func) {
	      let cache = new Map();
	      return function () {
	        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	        let key = JSON.stringify(args);
	        if (!cache.has(key)) {
	          cache.set(key, func.apply(this, args));
	        }
	        return cache.get(key);
	      };
	    },
	    getGpProbeStatusColor(timing) {
	      let probesMaxTiming = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
	      let probesMinTiming = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5;
	      // return default GREY color while probe has no timing yet
	      if (!timing) {
	        return '#c0c0c0';
	      }

	      // return default color for timed out probe
	      if (timing === PROBE_NO_TIMING_VALUE || timing === PROBE_STATUS_FAILED || timing === PROBE_STATUS_OFFLINE) {
	        return '#17233A';
	      }
	      function getColorFromGradient(quotient, start, middle, end) {
	        return quotient >= 0.5 ? linear(middle, end, (quotient - 0.5) * 2) : linear(start, middle, quotient * 2);
	      }
	      function linear(startColor, endColor, quotient) {
	        let redColor = byteLinear(startColor[1] + startColor[2], endColor[1] + endColor[2], quotient);
	        let greenColor = byteLinear(startColor[3] + startColor[4], endColor[3] + endColor[4], quotient);
	        let blueColor = byteLinear(startColor[5] + startColor[6], endColor[5] + endColor[6], quotient);
	        return `#${redColor}${greenColor}${blueColor}`;
	      }
	      function byteLinear(partOne, partTwo, quotient) {
	        let color = Math.floor(('0x' + partOne) * (1 - quotient) + ('0x' + partTwo) * quotient);
	        return color.toString(16).padStart(2, '0');
	      }
	      let pureTimingValue = parseInt(timing);

	      // '#17d4a7', '#ffb800', '#e64e3d' - colors are used for timings scale on the map
	      if (pureTimingValue <= probesMinTiming) {
	        return '#17d4a7';
	      }
	      if (pureTimingValue >= probesMaxTiming) {
	        return '#e64e3d';
	      }
	      return getColorFromGradient(pureTimingValue / probesMaxTiming, '#17d4a7', '#ffb800', '#e64e3d');
	    },
	    pluralize(singular, countOrPlural, countOrUndefined) {
	      let count = countOrUndefined ?? countOrPlural;
	      let plural = countOrUndefined ? countOrPlural : singular + 's';
	      return count === 1 ? singular : plural;
	    }
	  };
	});
	_.screenType;
	_.isTabletScreen;
	_.isMobileScreen;
	_.calculateGrowth;
	_.getValueFormatter;
	_.flattenFiles;
	_.formatDate;
	_.formatDateTime;
	_.formatHits;
	_.formatNumber;
	_.formatNumberWithSpace;
	_.getMinifiedName;
	_.getNonMinifiedName;
	_.listFiles;
	_.linRange;
	_.logRange;
	_.multiplyDeep;
	_.nth;
	_.getChartXAxisData;
	_.unescapeHtml;
	_.getValueByMagnitude;
	_.convertBytesToUnits;
	_.findUnitFromArray;
	_.findUnitFromNumber;
	_.formatBytesWithUnit;
	_.formatGrowth;
	_.formatShare;
	_.formatToShortNumber;
	_.makeHTTPRequest;
	_.createQueryString;
	_.deepExtend;
	_.onDocumentReady;
	_.checkIfYearIsLeap;
	_.getAmountOfDaysByMonth;
	_.getDateFormats;
	_.prepareDataForChartGroupedBy;
	_.createWeekPeriodChartLabels;
	_.createMonthPeriodChartLabels;
	_.createYearPeriodChartLabels;
	_.getPreparedDataForBarChart;
	_.calcChartBarThicknessByResolution;
	_.getPreparedProvidersDataForLineChart;
	_.getPreparedDataForLineChart;
	_.createImprovedExternalTooltipTitle;
	_.getLineColorsFromMask;
	_.translatePeriodsToSNotation;
	_.optimizeSrc;
	_.normalizeHref;
	_.isExternalLink;
	_.packageToImportName;
	_.filterListStatPeriods;
	_.prepareFilteredStatPeriods;
	_.getPreparedListStatPeriods;
	_.truncate;
	_.getGpProbeLastTiming;
	_.calcGpTestResTiming;
	_.getProbeTimeOutValue;
	_.getProbeStatusFailedValue;
	_.getProbeStatusOfflineValue;
	_.capitalizeFirstLetter;
	_.capitalizeStrEveryFirstLetter;
	_.getElementOffset;
	_.removeDuplicatedTargets;
	_.parseGpRawOutputForTimings;
	_.memoize;
	_.getGpProbeStatusColor;
	_.pluralize;

	const API_HOST = 'https://data.jsdelivr.com';
	const GITHUB_API_HOST = 'https://api.github.com';
	const SNYK_API_HOST = 'https://snyk-widget.herokuapp.com';
	const RAW_GH_USER_CONTENT_HOST = 'https://raw.githubusercontent.com';
	const GLOBALPING_HOST = 'https://api.globalping.io';
	const GLOBALPING_DASH_HOST = 'https://dash-directus.globalping.io';
	const HTTP_CACHE = new Map();
	const getWithCache = function (url) {
	  let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  let responseHeadersToGet = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	  url += _.createQueryString(params);
	  if (HTTP_CACHE.has(url)) {
	    return HTTP_CACHE.get(url);
	  }
	  let request;
	  if (responseHeadersToGet) {
	    request = _.makeHTTPRequest({
	      url,
	      responseHeadersToGet
	    });
	  } else {
	    request = _.makeHTTPRequest({
	      url
	    });
	  }
	  HTTP_CACHE.set(url, request);
	  return request;
	};
	var fetchPackageReadme = (type, name, version) => {
	  return _.makeHTTPRequest({
	    url: `/readme/${type}/${name}${version ? `/${version}` : ''}`,
	    rawResponse: true
	  });
	};
	var fetchNetworkStats = function () {
	  let period = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'month';
	  return getWithCache(`${API_HOST}/v1/stats/network/content?period=${period}`);
	};
	var fetchPackageFiles = (type, name, version) => {
	  return getWithCache(`${API_HOST}/v1/packages/${type}/${name}@${encodeURIComponent(version)}`);
	};
	var fetchPackageFilesFlat = (type, name, version) => {
	  let flatten = items => {
	    return items.reduce((acc, item) => {
	      if (item.type === 'file') {
	        acc.push({
	          ...item,
	          name: `/${item.name}`
	        });
	        return acc;
	      }
	      return flatten(item.files).reduce((acc, file) => {
	        acc.push({
	          ...file,
	          name: `/${item.name}${file.name}`
	        });
	        return acc;
	      }, acc);
	    }, []);
	  };
	  return getWithCache(`${API_HOST}/v1/packages/${type}/${name}@${encodeURIComponent(version)}`).then(response => {
	    return {
	      ...response,
	      files: flatten(response.files)
	    };
	  });
	};
	var fetchPackageFileStats = function (type, name, version) {
	  let period = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'month';
	  let by = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'hits';
	  let limit = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
	  return getWithCache(`${API_HOST}/v1/stats/packages/${type}/${name}@${encodeURIComponent(version)}/files`, {
	    period,
	    by,
	    limit
	  });
	};
	var fetchPackageFileStatsWithHeaders = function (type, name, version) {
	  let period = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'month';
	  let by = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'hits';
	  let limit = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 5;
	  let page = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 1;
	  let responseHeadersToGet = ['x-total-count', 'x-total-pages'];
	  return getWithCache(`${API_HOST}/v1/stats/packages/${type}/${name}@${encodeURIComponent(version)}/files`, {
	    period,
	    by,
	    limit,
	    page
	  }, responseHeadersToGet);
	};
	var fetchPackageSummaryStats = function (type, name) {
	  let period = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'month';
	  return getWithCache(`${API_HOST}/v1/stats/packages/${type}/${name}`, {
	    period
	  });
	};
	var fetchPackageVersionsStats = function (type, name) {
	  let period = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'month';
	  let by = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'hits';
	  let limit = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '5';
	  return getWithCache(`${API_HOST}/v1/stats/packages/${type}/${name}/versions`, {
	    period,
	    by,
	    limit
	  });
	};
	var fetchPackageVersionsStatsWithHeaders = function (type, name) {
	  let period = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'month';
	  let by = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'hits';
	  let limit = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 5;
	  let page = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 1;
	  let responseHeadersToGet = ['x-total-count', 'x-total-pages'];
	  return getWithCache(`${API_HOST}/v1/stats/packages/${type}/${name}/versions`, {
	    period,
	    by,
	    limit,
	    page
	  }, responseHeadersToGet);
	};
	var fetchPackageVersions = (type, name) => {
	  return getWithCache(`${API_HOST}/v1/packages/${type}/${name}`);
	};
	var fetchTopPackages = function () {
	  let period = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'month';
	  return getWithCache(`${API_HOST}/v1/stats/packages?type=npm&period=${period}`);
	};
	var fetchProjectCommits = (owner, repo) => {
	  return getWithCache(`${GITHUB_API_HOST}/repos/${owner}/${repo}/commits`);
	};
	var findProjectIssue = (owner, repo, title) => {
	  return getWithCache(`${GITHUB_API_HOST}/search/issues`, {
	    q: `${title} user:${owner} repo:${repo}`
	  });
	};
	var fetchPackageVulnerabilities = (name, version) => {
	  return _.makeHTTPRequest({
	    url: `${SNYK_API_HOST}/test/npm/lib/${name}/${version}`,
	    headers: {
	      Authorization: '8U@$Kh6Qs#b@9qxYB!QhtvLeD=e+?Hq$_b#5%x*t'
	    }
	  });
	};
	var fetchPackageEntrypoints = (type, name, version) => {
	  return getWithCache(`${API_HOST}/v1/packages/${type}/${name}@${encodeURIComponent(version)}/entrypoints`);
	};
	var getGHUserContentPackageReadme = function (packageOwner, packageName) {
	  let packageGitHead = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'HEAD';
	  return new Promise((resolve, reject) => {
	    _.makeHTTPRequest({
	      url: `${RAW_GH_USER_CONTENT_HOST}/${packageOwner}/${packageName}/${packageGitHead}/README.md`,
	      rawResponse: true
	    }).then(response => {
	      resolve(response);
	    }).catch(() => {
	      _.makeHTTPRequest({
	        url: `${RAW_GH_USER_CONTENT_HOST}/${packageOwner}/${packageName}/${packageGitHead}/README.markdown`,
	        rawResponse: true
	      }).then(response => {
	        resolve(response);
	      }).catch(err => {
	        reject(err);
	      });
	    });
	  });
	};
	var fetchCdnOssStats = function (name) {
	  let period = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'month';
	  return getWithCache(`${API_HOST}/v1/stats/proxies/${name}`, {
	    period
	  });
	};
	var fetchNetworkProviderStats = function (period) {
	  let country = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	  let continent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	  let body = {
	    period
	  };
	  country && (body.country = country);
	  continent && (body.continent = continent);
	  return getWithCache(`${API_HOST}/v1/stats/network`, body);
	};
	var fetchNetworkProviderStatsByCountry = function () {
	  let period = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'month';
	  return getWithCache(`${API_HOST}/v1/stats/network/countries`, {
	    period
	  });
	};

	/** *
	 * @param dataType - request type value: "platforms", "browsers"
	 * @param isVersionGrouped  - version grouped switchbox value: boolean
	 * @param selectedItem - selected certain platform or browser value:string
	 * @param breakdown - country breakdown, browser breakdown, platform, version breakdown
	 * @param period -  time period for which the stats are returned (s-month, s-year)
	 * @param country - country. Includes only data for this country
	 * @param continent - continent. Includes only data for this country
	 ***/
	var fetchTopPlatformBrowserStats = function (dataType, isVersionGrouped, period, selectedItem, breakdown, country, continent) {
	  let page = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 1;
	  let limit = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : 10;
	  let responseHeadersToGet = ['x-total-count', 'x-total-pages'];
	  let url = dataType === 'platform' ? `${API_HOST}/v1/stats/platforms` : `${API_HOST}/v1/stats/browsers`;
	  let body = {
	    period: _.translatePeriodsToSNotation(period),
	    page,
	    limit
	  };
	  if (country) {
	    body.country = country;
	  }
	  if (continent) {
	    body.continent = continent;
	  }
	  if (selectedItem) {
	    if (selectedItem.version) {
	      url += `/${selectedItem.name.toLowerCase()}/versions/${selectedItem.version}/countries`;
	    } else {
	      url += `/${selectedItem.name.toLowerCase()}/${breakdown}`;
	    }
	  } else if (!isVersionGrouped) {
	    url += '/versions';
	  }
	  return _.makeHTTPRequest({
	    url,
	    body,
	    responseHeadersToGet
	  });
	};
	var fetchProjectStats = function (type, period) {
	  let sortBy = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'hits';
	  let page = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
	  let limit = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 10;
	  let responseHeadersToGet = ['x-total-count', 'x-total-pages'];
	  let body = {
	    period,
	    by: sortBy,
	    page,
	    limit
	  };
	  if (type !== 'all') {
	    body.type = type;
	  }
	  return _.makeHTTPRequest({
	    url: `${API_HOST}/v1/stats/packages`,
	    body,
	    responseHeadersToGet
	  });
	};
	var fetchNetworkWideStats = () => {
	  return getWithCache(`${API_HOST}/v1/stats/network`);
	};
	var fetchNumberOfResources = () => {
	  let responseHeadersToGet = ['x-total-count'];
	  let body = {
	    limit: 1
	  };
	  return _.makeHTTPRequest({
	    url: `${API_HOST}/v1/stats/packages`,
	    body,
	    responseHeadersToGet
	  });
	};
	var fetchListStatPeriods = () => {
	  return getWithCache(`${API_HOST}/v1/stats/periods`);
	};
	var fetchGlobalpingProbes = () => {
	  return _.makeHTTPRequest({
	    url: `${GLOBALPING_HOST}/v1/probes`
	  });
	};
	var postGlobalpingMeasurement = (opts, responseHeadersToGet) => {
	  let params = {
	    method: 'POST',
	    url: `${GLOBALPING_HOST}/v1/measurements`,
	    body: opts,
	    withCredentials: /(?:^|\.)globalping\.io$/.test(location.hostname)
	  };
	  if (responseHeadersToGet) {
	    params = {
	      ...params,
	      responseHeadersToGet
	    };
	  }
	  return _.makeHTTPRequest(params);
	};
	var getGlobalpingMeasurement = id => {
	  return _.makeHTTPRequest({
	    url: `${GLOBALPING_HOST}/v1/measurements/${id}`
	  });
	};
	var getBlogRss = () => {
	  return _.makeHTTPRequest({
	    url: `/blog/rss`,
	    rawResponse: true
	  });
	};
	var getGPBlogRss = () => {
	  return _.makeHTTPRequest({
	    url: `https://blog.globalping.io/rss/`,
	    rawResponse: true
	  });
	};
	var getCdnOssFiles = function (name) {
	  let by = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'hits';
	  let limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5;
	  let page = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
	  let responseHeadersToGet = ['x-total-count', 'x-total-pages'];
	  return getWithCache(`${API_HOST}/v1/stats/proxies/${name}/files`, {
	    page,
	    limit,
	    by
	  }, responseHeadersToGet);
	};
	var getGlobalpingUser$1 = () => {
	  // Note: The authentication won't work out of the box on localhost because the cookie is set with SameSite=Strict
	  // If you need to test the page as an authenticated user (and don't want to set up a local dash and API),
	  // just set the production cookie "dash_session_token" (.globalping.io) to SameSite=None via devtools.
	  return _.makeHTTPRequest({
	    url: `${GLOBALPING_DASH_HOST}/users/me`,
	    withCredentials: true
	  }).then(body => body.data).catch(() => null);
	};
	var gpLogOut = () => {
	  return _.makeHTTPRequest({
	    method: 'POST',
	    url: `${GLOBALPING_DASH_HOST}/auth/logout`,
	    body: {
	      mode: 'session'
	    },
	    withCredentials: true,
	    rawResponse: true
	  });
	};
	var http = {
	  fetchPackageReadme: fetchPackageReadme,
	  fetchNetworkStats: fetchNetworkStats,
	  fetchPackageFiles: fetchPackageFiles,
	  fetchPackageFilesFlat: fetchPackageFilesFlat,
	  fetchPackageFileStats: fetchPackageFileStats,
	  fetchPackageFileStatsWithHeaders: fetchPackageFileStatsWithHeaders,
	  fetchPackageSummaryStats: fetchPackageSummaryStats,
	  fetchPackageVersionsStats: fetchPackageVersionsStats,
	  fetchPackageVersionsStatsWithHeaders: fetchPackageVersionsStatsWithHeaders,
	  fetchPackageVersions: fetchPackageVersions,
	  fetchTopPackages: fetchTopPackages,
	  fetchProjectCommits: fetchProjectCommits,
	  findProjectIssue: findProjectIssue,
	  fetchPackageVulnerabilities: fetchPackageVulnerabilities,
	  fetchPackageEntrypoints: fetchPackageEntrypoints,
	  getGHUserContentPackageReadme: getGHUserContentPackageReadme,
	  fetchCdnOssStats: fetchCdnOssStats,
	  fetchNetworkProviderStats: fetchNetworkProviderStats,
	  fetchNetworkProviderStatsByCountry: fetchNetworkProviderStatsByCountry,
	  fetchTopPlatformBrowserStats: fetchTopPlatformBrowserStats,
	  fetchProjectStats: fetchProjectStats,
	  fetchNetworkWideStats: fetchNetworkWideStats,
	  fetchNumberOfResources: fetchNumberOfResources,
	  fetchListStatPeriods: fetchListStatPeriods,
	  fetchGlobalpingProbes: fetchGlobalpingProbes,
	  postGlobalpingMeasurement: postGlobalpingMeasurement,
	  getGlobalpingMeasurement: getGlobalpingMeasurement,
	  getBlogRss: getBlogRss,
	  getGPBlogRss: getGPBlogRss,
	  getCdnOssFiles: getCdnOssFiles,
	  getGlobalpingUser: getGlobalpingUser$1,
	  gpLogOut: gpLogOut
	};

	var $RangeError$2 = RangeError;
	var notANan = function (it) {
	  // eslint-disable-next-line no-self-compare -- NaN check
	  if (it === it) return it;
	  throw new $RangeError$2('NaN is not allowed');
	};

	var $RangeError$1 = RangeError;
	var toPositiveInteger = function (it) {
	  var result = toIntegerOrInfinity(it);
	  if (result < 0) throw new $RangeError$1("The argument can't be less than 0");
	  return result;
	};

	var IteratorProxy = iteratorCreateProxy(function () {
	  var iterator = this.iterator;
	  var next = this.next;
	  var result, done;
	  while (this.remaining) {
	    this.remaining--;
	    result = anObject(functionCall(next, iterator));
	    done = this.done = !!result.done;
	    if (done) return;
	  }
	  result = anObject(functionCall(next, iterator));
	  done = this.done = !!result.done;
	  if (!done) return result.value;
	});

	// `Iterator.prototype.drop` method
	// https://tc39.es/ecma262/#sec-iterator.prototype.drop
	_export({
	  target: 'Iterator',
	  proto: true,
	  real: true,
	  forced: isPure
	}, {
	  drop: function drop(limit) {
	    anObject(this);
	    var remaining = toPositiveInteger(notANan(+limit));
	    return new IteratorProxy(getIteratorDirect(this), {
	      remaining: remaining
	    });
	  }
	});

	// `Iterator.prototype.every` method
	// https://tc39.es/ecma262/#sec-iterator.prototype.every
	_export({
	  target: 'Iterator',
	  proto: true,
	  real: true
	}, {
	  every: function every(predicate) {
	    anObject(this);
	    aCallable(predicate);
	    var record = getIteratorDirect(this);
	    var counter = 0;
	    return !iterate(record, function (value, stop) {
	      if (!predicate(value, counter++)) return stop();
	    }, {
	      IS_RECORD: true,
	      INTERRUPTED: true
	    }).stopped;
	  }
	});

	// `Iterator.prototype.some` method
	// https://tc39.es/ecma262/#sec-iterator.prototype.some
	_export({
	  target: 'Iterator',
	  proto: true,
	  real: true
	}, {
	  some: function some(predicate) {
	    anObject(this);
	    aCallable(predicate);
	    var record = getIteratorDirect(this);
	    var counter = 0;
	    return iterate(record, function (value, stop) {
	      if (predicate(value, counter++)) return stop();
	    }, {
	      IS_RECORD: true,
	      INTERRUPTED: true
	    }).stopped;
	  }
	});

	var functionUncurryThisAccessor = function (object, key, method) {
	  try {
	    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	    return functionUncurryThis(aCallable(Object.getOwnPropertyDescriptor(object, key)[method]));
	  } catch (error) {/* empty */}
	};

	var isPossiblePrototype = function (argument) {
	  return isObject(argument) || argument === null;
	};

	var $String = String;
	var $TypeError$2 = TypeError;
	var aPossiblePrototype = function (argument) {
	  if (isPossiblePrototype(argument)) return argument;
	  throw new $TypeError$2("Can't set " + $String(argument) + ' as a prototype');
	};

	/* eslint-disable no-proto -- safe */

	// `Object.setPrototypeOf` method
	// https://tc39.es/ecma262/#sec-object.setprototypeof
	// Works with __proto__ only. Old v8 can't work with null proto objects.
	// eslint-disable-next-line es/no-object-setprototypeof -- safe
	var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
	  var CORRECT_SETTER = false;
	  var test = {};
	  var setter;
	  try {
	    setter = functionUncurryThisAccessor(Object.prototype, '__proto__', 'set');
	    setter(test, []);
	    CORRECT_SETTER = test instanceof Array;
	  } catch (error) {/* empty */}
	  return function setPrototypeOf(O, proto) {
	    requireObjectCoercible(O);
	    aPossiblePrototype(proto);
	    if (!isObject(O)) return O;
	    if (CORRECT_SETTER) setter(O, proto);else O.__proto__ = proto;
	    return O;
	  };
	}() : undefined);

	// makes subclassing work correct for wrapped built-ins
	var inheritIfRequired = function ($this, dummy, Wrapper) {
	  var NewTarget, NewTargetPrototype;
	  if (
	  // it can work only with native `setPrototypeOf`
	  objectSetPrototypeOf &&
	  // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
	  isCallable(NewTarget = dummy.constructor) && NewTarget !== Wrapper && isObject(NewTargetPrototype = NewTarget.prototype) && NewTargetPrototype !== Wrapper.prototype) objectSetPrototypeOf($this, NewTargetPrototype);
	  return $this;
	};

	var normalizeStringArgument = function (argument, $default) {
	  return argument === undefined ? arguments.length < 2 ? '' : $default : toString_1(argument);
	};

	var domExceptionConstants = {
	  IndexSizeError: {
	    s: 'INDEX_SIZE_ERR',
	    c: 1,
	    m: 1
	  },
	  DOMStringSizeError: {
	    s: 'DOMSTRING_SIZE_ERR',
	    c: 2,
	    m: 0
	  },
	  HierarchyRequestError: {
	    s: 'HIERARCHY_REQUEST_ERR',
	    c: 3,
	    m: 1
	  },
	  WrongDocumentError: {
	    s: 'WRONG_DOCUMENT_ERR',
	    c: 4,
	    m: 1
	  },
	  InvalidCharacterError: {
	    s: 'INVALID_CHARACTER_ERR',
	    c: 5,
	    m: 1
	  },
	  NoDataAllowedError: {
	    s: 'NO_DATA_ALLOWED_ERR',
	    c: 6,
	    m: 0
	  },
	  NoModificationAllowedError: {
	    s: 'NO_MODIFICATION_ALLOWED_ERR',
	    c: 7,
	    m: 1
	  },
	  NotFoundError: {
	    s: 'NOT_FOUND_ERR',
	    c: 8,
	    m: 1
	  },
	  NotSupportedError: {
	    s: 'NOT_SUPPORTED_ERR',
	    c: 9,
	    m: 1
	  },
	  InUseAttributeError: {
	    s: 'INUSE_ATTRIBUTE_ERR',
	    c: 10,
	    m: 1
	  },
	  InvalidStateError: {
	    s: 'INVALID_STATE_ERR',
	    c: 11,
	    m: 1
	  },
	  SyntaxError: {
	    s: 'SYNTAX_ERR',
	    c: 12,
	    m: 1
	  },
	  InvalidModificationError: {
	    s: 'INVALID_MODIFICATION_ERR',
	    c: 13,
	    m: 1
	  },
	  NamespaceError: {
	    s: 'NAMESPACE_ERR',
	    c: 14,
	    m: 1
	  },
	  InvalidAccessError: {
	    s: 'INVALID_ACCESS_ERR',
	    c: 15,
	    m: 1
	  },
	  ValidationError: {
	    s: 'VALIDATION_ERR',
	    c: 16,
	    m: 0
	  },
	  TypeMismatchError: {
	    s: 'TYPE_MISMATCH_ERR',
	    c: 17,
	    m: 1
	  },
	  SecurityError: {
	    s: 'SECURITY_ERR',
	    c: 18,
	    m: 1
	  },
	  NetworkError: {
	    s: 'NETWORK_ERR',
	    c: 19,
	    m: 1
	  },
	  AbortError: {
	    s: 'ABORT_ERR',
	    c: 20,
	    m: 1
	  },
	  URLMismatchError: {
	    s: 'URL_MISMATCH_ERR',
	    c: 21,
	    m: 1
	  },
	  QuotaExceededError: {
	    s: 'QUOTA_EXCEEDED_ERR',
	    c: 22,
	    m: 1
	  },
	  TimeoutError: {
	    s: 'TIMEOUT_ERR',
	    c: 23,
	    m: 1
	  },
	  InvalidNodeTypeError: {
	    s: 'INVALID_NODE_TYPE_ERR',
	    c: 24,
	    m: 1
	  },
	  DataCloneError: {
	    s: 'DATA_CLONE_ERR',
	    c: 25,
	    m: 1
	  }
	};
	domExceptionConstants.IndexSizeError;
	domExceptionConstants.DOMStringSizeError;
	domExceptionConstants.HierarchyRequestError;
	domExceptionConstants.WrongDocumentError;
	domExceptionConstants.InvalidCharacterError;
	domExceptionConstants.NoDataAllowedError;
	domExceptionConstants.NoModificationAllowedError;
	domExceptionConstants.NotFoundError;
	domExceptionConstants.NotSupportedError;
	domExceptionConstants.InUseAttributeError;
	domExceptionConstants.InvalidStateError;
	domExceptionConstants.InvalidModificationError;
	domExceptionConstants.NamespaceError;
	domExceptionConstants.InvalidAccessError;
	domExceptionConstants.ValidationError;
	domExceptionConstants.TypeMismatchError;
	domExceptionConstants.SecurityError;
	domExceptionConstants.NetworkError;
	domExceptionConstants.AbortError;
	domExceptionConstants.URLMismatchError;
	domExceptionConstants.QuotaExceededError;
	domExceptionConstants.TimeoutError;
	domExceptionConstants.InvalidNodeTypeError;
	domExceptionConstants.DataCloneError;

	var $Error = Error;
	var replace = functionUncurryThis(''.replace);
	var TEST = function (arg) {
	  return String(new $Error(arg).stack);
	}('zxcasd');
	// eslint-disable-next-line redos/no-vulnerable, sonarjs/slow-regex -- safe
	var V8_OR_CHAKRA_STACK_ENTRY = /\n\s*at [^:]*:[^\n]*/;
	var IS_V8_OR_CHAKRA_STACK = V8_OR_CHAKRA_STACK_ENTRY.test(TEST);
	var errorStackClear = function (stack, dropEntries) {
	  if (IS_V8_OR_CHAKRA_STACK && typeof stack == 'string' && !$Error.prepareStackTrace) {
	    while (dropEntries--) stack = replace(stack, V8_OR_CHAKRA_STACK_ENTRY, '');
	  }
	  return stack;
	};

	var defineProperty = objectDefineProperty.f;
	var DOM_EXCEPTION = 'DOMException';
	var Error$1 = getBuiltIn('Error');
	var NativeDOMException = getBuiltIn(DOM_EXCEPTION);
	var $DOMException = function DOMException() {
	  anInstance(this, DOMExceptionPrototype);
	  var argumentsLength = arguments.length;
	  var message = normalizeStringArgument(argumentsLength < 1 ? undefined : arguments[0]);
	  var name = normalizeStringArgument(argumentsLength < 2 ? undefined : arguments[1], 'Error');
	  var that = new NativeDOMException(message, name);
	  var error = new Error$1(message);
	  error.name = DOM_EXCEPTION;
	  defineProperty(that, 'stack', createPropertyDescriptor(1, errorStackClear(error.stack, 1)));
	  inheritIfRequired(that, this, $DOMException);
	  return that;
	};
	var DOMExceptionPrototype = $DOMException.prototype = NativeDOMException.prototype;
	var ERROR_HAS_STACK = 'stack' in new Error$1(DOM_EXCEPTION);
	var DOM_EXCEPTION_HAS_STACK = 'stack' in new NativeDOMException(1, 2);

	// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	var descriptor = NativeDOMException && descriptors && Object.getOwnPropertyDescriptor(globalThis_1, DOM_EXCEPTION);

	// Bun ~ 0.1.1 DOMException have incorrect descriptor and we can't redefine it
	// https://github.com/Jarred-Sumner/bun/issues/399
	var BUGGY_DESCRIPTOR = !!descriptor && !(descriptor.writable && descriptor.configurable);
	var FORCED_CONSTRUCTOR = ERROR_HAS_STACK && !BUGGY_DESCRIPTOR && !DOM_EXCEPTION_HAS_STACK;

	// `DOMException` constructor patch for `.stack` where it's required
	// https://webidl.spec.whatwg.org/#es-DOMException-specialness
	_export({
	  global: true,
	  constructor: true,
	  forced: FORCED_CONSTRUCTOR
	}, {
	  // TODO: fix export logic
	  DOMException: FORCED_CONSTRUCTOR ? $DOMException : NativeDOMException
	});
	var PolyfilledDOMException = getBuiltIn(DOM_EXCEPTION);
	var PolyfilledDOMExceptionPrototype = PolyfilledDOMException.prototype;
	if (PolyfilledDOMExceptionPrototype.constructor !== PolyfilledDOMException) {
	  {
	    defineProperty(PolyfilledDOMExceptionPrototype, 'constructor', createPropertyDescriptor(1, PolyfilledDOMException));
	  }
	  for (var key in domExceptionConstants) if (hasOwnProperty_1(domExceptionConstants, key)) {
	    var constant = domExceptionConstants[key];
	    var constantName = constant.s;
	    if (!hasOwnProperty_1(PolyfilledDOMException, constantName)) {
	      defineProperty(PolyfilledDOMException, constantName, createPropertyDescriptor(6, constant.c));
	    }
	  }
	}

	var component$B = {
	  exports: {}
	};
	component$B.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "div",
	    m: [{
	      n: "class",
	      f: ["c-gp-jumbotron ", {
	        t: 2,
	        r: "className"
	      }],
	      t: 13
	    }],
	    f: [{
	      t: 4,
	      f: [{
	        t: 7,
	        e: "img",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "jumbotron_grid",
	          g: 1
	        }, {
	          n: "width",
	          f: "1440",
	          t: 13,
	          g: 1
	        }, {
	          n: "height",
	          f: "532",
	          t: 13,
	          g: 1
	        }, {
	          n: "src",
	          f: [{
	            t: 2,
	            r: "@shared.assetsHost"
	          }, "/img/globalping/globalping-grid-type-1.svg"],
	          t: 13
	        }]
	      }],
	      n: 50,
	      x: {
	        r: ["gridType"],
	        s: "_0===\"type1\""
	      }
	    }, {
	      t: 4,
	      f: [{
	        t: 7,
	        e: "img",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "jumbotron_grid",
	          g: 1
	        }, {
	          n: "width",
	          f: "1440",
	          t: 13,
	          g: 1
	        }, {
	          n: "height",
	          f: "600",
	          t: 13,
	          g: 1
	        }, {
	          n: "src",
	          f: [{
	            t: 2,
	            r: "@shared.assetsHost"
	          }, "/img/globalping/globalping-grid-type-2.svg"],
	          t: 13
	        }]
	      }, " "],
	      n: 50,
	      x: {
	        r: ["gridType"],
	        s: "_0===\"type2\""
	      },
	      l: 1
	    }, {
	      t: 4,
	      f: [" ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "grid-type-3",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "grid-type-3_under-header",
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "grid-type-3_grid-wrapper",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "img",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "jumbotron_grid",
	              g: 1
	            }, {
	              n: "width",
	              f: "1150",
	              t: 13,
	              g: 1
	            }, {
	              n: "height",
	              f: "689",
	              t: 13,
	              g: 1
	            }, {
	              n: "src",
	              f: [{
	                t: 2,
	                r: "@shared.assetsHost"
	              }, "/img/globalping/globalping-grid-type-3.svg"],
	              t: 13
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "grid-type-3_gradient",
	            g: 1
	          }]
	        }]
	      }, " "],
	      n: 50,
	      x: {
	        r: ["gridType"],
	        s: "_0===\"type3\""
	      },
	      l: 1
	    }, {
	      t: 4,
	      f: [" ", {
	        t: 7,
	        e: "img",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "jumbotron_grid",
	          g: 1
	        }, {
	          n: "width",
	          f: "1150",
	          t: 13,
	          g: 1
	        }, {
	          n: "height",
	          f: "689",
	          t: 13,
	          g: 1
	        }, {
	          n: "src",
	          f: [{
	            t: 2,
	            r: "@shared.assetsHost"
	          }, "/img/globalping/globalping-grid-type-4.svg"],
	          t: 13
	        }]
	      }],
	      n: 50,
	      x: {
	        r: ["gridType"],
	        s: "_0===\"type4\""
	      },
	      l: 1
	    }, " ", {
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "jumbotron_blur",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "jumbotron_blur_circle-one",
	          g: 1
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "jumbotron_blur_circle-two",
	          g: 1
	        }]
	      }]
	    }]
	  }],
	  e: {
	    "_0===\"type1\"": function (_0) {
	      return _0 === "type1";
	    },
	    "_0===\"type2\"": function (_0) {
	      return _0 === "type2";
	    },
	    "_0===\"type3\"": function (_0) {
	      return _0 === "type3";
	    },
	    "_0===\"type4\"": function (_0) {
	      return _0 === "type4";
	    }
	  }
	};
	var gpJumbotron = ractive__default["default"].extend(component$B.exports);

	let tooltipDecorator = function (node, content) {
	  let position = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'top';
	  let rawHtml = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	  let elementName = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'div';
	  let className = arguments.length > 5 ? arguments[5] : undefined;
	  let offsetX = arguments.length > 6 ? arguments[6] : undefined;
	  let offsetY = arguments.length > 7 ? arguments[7] : undefined;
	  let tooltip, handlers, eventName;
	  let getPositionClass = position => {
	    let resClass;
	    switch (position) {
	      case 'top':
	        resClass = 'ractive-tooltip-top';
	        break;
	      case 'left':
	        resClass = 'ractive-tooltip-left';
	        break;
	      case 'right':
	        resClass = 'ractive-tooltip-right';
	        break;
	      default:
	        resClass = 'ractive-tooltip-bottom';
	    }
	    return resClass;
	  };
	  let getYPos = position => {
	    let yPos;
	    let {
	      top,
	      bottom
	    } = node.getBoundingClientRect();
	    switch (position) {
	      case 'top':
	        yPos = top - tooltip.clientHeight - 10;
	        break;
	      case 'left':
	      case 'right':
	        yPos = (top + bottom) / 2 - tooltip.clientHeight / 2;
	        break;
	      default:
	        yPos = bottom + 10;
	    }
	    return Math.round(yPos);
	  };
	  let getXPos = position => {
	    let xPos;
	    let {
	      left,
	      right
	    } = node.getBoundingClientRect();
	    switch (position) {
	      case 'left':
	        xPos = left - tooltip.clientWidth - 10;
	        break;
	      case 'right':
	        xPos = right + 10;
	        break;
	      default:
	        xPos = left + (right - left) / 2 - tooltip.clientWidth / 2;
	    }
	    return Math.round(xPos);
	  };
	  handlers = {
	    mouseover() {
	      if (document.querySelector('#ractive-tooltip-instance') === null) {
	        tooltip = document.createElement(elementName);
	        tooltip.className = `ractive-tooltip ${getPositionClass(position)}${className ? ` ${className}` : ''}`;
	        if (rawHtml) {
	          let preTag = document.createElement('pre');
	          tooltip.classList.add('raw');
	          preTag.textContent = content;
	          tooltip.appendChild(preTag);
	        } else {
	          if (!Array.isArray(content)) {
	            tooltip.textContent = content;
	          } else {
	            content.forEach(line => {
	              tooltip.appendChild(document.createTextNode(line));
	              tooltip.appendChild(document.createElement('br'));
	            });
	          }
	        }
	        tooltip.id = 'ractive-tooltip-instance';
	        document.body.appendChild(tooltip);
	      }
	    },
	    mousemove() {
	      tooltip.style.left = `${offsetX ? offsetX : getXPos(position)}px`;
	      tooltip.style.top = `${offsetY ? offsetY : getYPos(position)}px`;
	    },
	    mouseleave() {
	      let tooltipInstance = document.querySelector('#ractive-tooltip-instance');
	      tooltipInstance.parentElement.removeChild(tooltipInstance);
	    }
	  };
	  for (eventName in handlers) {
	    if (Object.hasOwn(handlers, eventName)) {
	      node.addEventListener(eventName, handlers[eventName], false);
	    }
	  }
	  return {
	    teardown() {
	      for (eventName in handlers) {
	        if (Object.hasOwn(handlers, eventName)) {
	          node.removeEventListener(eventName, handlers[eventName], false);
	        }
	      }
	    }
	  };
	};
	var tooltip = tooltipDecorator;

	var component$A = {
	  exports: {}
	};
	component$A.exports = {
	  decorators: {
	    tooltip
	  },
	  data() {
	    return {
	      consumingValue: null,
	      remainingRequests: null,
	      availableRequests: null,
	      consumedRateLimit: null,
	      remainingCredits: null,
	      consumedCredits: null,
	      resetsInStr: null,
	      creditsDataPresented: false,
	      overallProbesCount: 0,
	      sessionTimestampStart: null,
	      sessionTimestampCurrent: null
	    };
	  },
	  oninit() {
	    if (!ractive__default["default"].isServer) {
	      // set session start time when test is started
	      // SHOULD BE THE FIRST OBSERVE
	      this.observe('testInProgress', testInProgress => {
	        if (testInProgress) {
	          this.set('sessionTimestampStart', Date.now());
	          this.set('sessionTimestampCurrent', Date.now());
	          this.set('consumedRateLimit', 0);
	          this.set('consumedCredits', 0);
	        } else {
	          this.set('sessionTimestampStart', null);
	          this.set('sessionTimestampCurrent', null);
	          this.set('overallProbesCount', 0);
	        }
	      });
	      this.observe('rateCreditsData', rateCreditsData => {
	        if (rateCreditsData && rateCreditsData['x-ratelimit-limit']) {
	          let rateLimitConsumed = Number(rateCreditsData['x-ratelimit-consumed']) || 0;
	          let rateLimitRemaining = Number(rateCreditsData['x-ratelimit-remaining']) || 0;
	          let rateLimitLimit = Number(rateCreditsData['x-ratelimit-limit']) || 0;
	          let rateLimitReset = Number(rateCreditsData['x-ratelimit-reset']) || 0;
	          let currentProbesCount = Number(rateCreditsData['x-request-cost']) || 0;
	          let rateCreditsConsumed = Number(rateCreditsData['x-credits-consumed']) || 0;
	          let rateCreditsRemaining = Number(rateCreditsData['x-credits-remaining']) || 0;
	          if (this.get('isInfiniteModeRes')) {
	            rateLimitConsumed += this.get('consumedRateLimit') || 0;
	            rateCreditsConsumed += this.get('consumedCredits') || 0;
	          }
	          this.set('currentProbesCount', currentProbesCount);

	          // handle RateLimit headers
	          this.set('remainingRequests', rateLimitRemaining);
	          this.set('availableRequests', rateLimitLimit);
	          this.set('resetsInStr', this.createResetInStr(rateLimitReset));
	          this.set('overallProbesCount', this.get('overallProbesCount') + currentProbesCount);
	          this.set('consumedRateLimit', rateLimitConsumed);

	          // handle Credits headers

	          if (rateCreditsRemaining) {
	            this.set('creditsDataPresented', true);
	            this.set('consumedCredits', rateCreditsConsumed);
	            this.set('remainingCredits', rateCreditsRemaining);
	          } else {
	            this.set('creditsDataPresented', false);
	          }
	        } else {
	          // reset to default for a new measurement
	          this.set('consumingValue', null);
	          this.set('remainingRequests', null);
	          this.set('availableRequests', null);
	          this.set('consumedRateLimit', null);
	          this.set('remainingCredits', null);
	          this.set('consumedCredits', null);
	          this.set('resetsInStr', null);
	          this.set('creditsDataPresented', false);
	          this.set('overallProbesCount', 0);
	          this.set('sessionTimestampStart', null);
	          this.set('sessionTimestampCurrent', null);
	        }
	      });

	      // update current timestamp on receiving testRResults
	      this.observe('testResults', testResults => {
	        if (testResults) {
	          this.set('sessionTimestampCurrent', Date.now());
	        }
	      });

	      // calculate consuming value
	      this.observe('testResults.length', () => {
	        let measurementsCount = this.get('testResults.length');
	        if (measurementsCount < 2) {
	          return;
	        }
	        let sessionTimestampCurrent = this.get('sessionTimestampCurrent');
	        let overallProbesCount = this.get('overallProbesCount');
	        let sessionTimestampStart = this.get('sessionTimestampStart');
	        let sessionTime = Math.round((sessionTimestampCurrent - sessionTimestampStart) / 1000);
	        let consumingValuePerSecond = (overallProbesCount - this.get('currentProbesCount')) / (sessionTime || 1);
	        this.set('consumingValue', Math.round(consumingValuePerSecond * 60));
	      }, {
	        init: false
	      });
	    }
	  },
	  createResetInStr(seconds) {
	    let minutes = seconds / 60;
	    if (minutes < 1) {
	      return '< 1 minute';
	    }
	    return `${Math.ceil(minutes)} minutes`;
	  }
	};
	component$A.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "div",
	    m: [{
	      n: "class",
	      f: ["c-gp-credits ", {
	        t: 4,
	        f: ["over-the-map"],
	        n: 50,
	        r: "mapOpened"
	      }],
	      t: 13
	    }],
	    f: [{
	      t: 4,
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "credits-wrapper",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "credits_data",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "credits_data_rate",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "span",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "credits_data_rate_header",
	                g: 1
	              }],
	              f: ["Rate limit:"]
	            }, " ", {
	              t: 7,
	              e: "span",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "credits_data_rate_details",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "span",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "credits_data_rate_details_numbers",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "span",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "credits_data_rate_details_numbers_credits-count",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 2,
	                    r: "remainingRequests"
	                  }, "/", {
	                    t: 2,
	                    r: "availableRequests"
	                  }]
	                }, " ", {
	                  t: 4,
	                  f: [{
	                    t: 7,
	                    e: "span",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "credits_data_rate_details_numbers_probes-count",
	                      g: 1
	                    }],
	                    f: ["(-", {
	                      t: 2,
	                      r: "consumedRateLimit"
	                    }, ")"]
	                  }],
	                  n: 50,
	                  r: "consumedRateLimit"
	                }]
	              }, " ", {
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "tooltip",
	                  t: 71,
	                  f: {
	                    r: ["resetsInStr"],
	                    s: "[\"Resets in \"+_0]"
	                  }
	                }, {
	                  n: "width",
	                  f: "14",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "14",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/globalping/help-icon.svg"],
	                  t: 13
	                }]
	              }]
	            }]
	          }, " ", {
	            t: 4,
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "credits_data_credits",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "span",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "credits_data_credits_header",
	                  g: 1
	                }],
	                f: ["Credits:"]
	              }, " ", {
	                t: 7,
	                e: "span",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "credits_data_rate_details",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "span",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "credits_data_rate_details_remaining-credits",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 2,
	                    r: "remainingCredits"
	                  }]
	                }, " ", {
	                  t: 4,
	                  f: [{
	                    t: 7,
	                    e: "span",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "credits_data_rate_details_consumed-credits",
	                      g: 1
	                    }],
	                    f: ["(-", {
	                      t: 2,
	                      r: "consumedCredits"
	                    }, ")"]
	                  }],
	                  n: 50,
	                  r: "consumedCredits"
	                }]
	              }]
	            }],
	            n: 50,
	            r: "creditsDataPresented"
	          }]
	        }, " ", {
	          t: 7,
	          e: "a",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "credits_add",
	            g: 1
	          }, {
	            n: "href",
	            f: "https://dash.globalping.io?view=add-credits",
	            t: 13,
	            g: 1
	          }, {
	            n: "target",
	            f: "_blank",
	            t: 13,
	            g: 1
	          }],
	          f: ["+ Add Credits"]
	        }, " ", {
	          t: 4,
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "credits_consuming",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "img",
	              m: [{
	                n: "width",
	                f: "14",
	                t: 13,
	                g: 1
	              }, {
	                n: "height",
	                f: "14",
	                t: 13,
	                g: 1
	              }, {
	                n: "src",
	                f: [{
	                  t: 2,
	                  r: "@shared.assetsHost"
	                }, "/img/globalping/alert-icon-alt.svg"],
	                t: 13
	              }]
	            }, " ", {
	              t: 7,
	              e: "span",
	              f: ["Consuming ~", {
	                t: 2,
	                r: "consumingValue"
	              }, " API credits/minute"]
	            }]
	          }],
	          n: 50,
	          x: {
	            r: ["testInProgress", "isInfiniteModeRes", "consumingValue"],
	            s: "_0&&_1&&_2"
	          }
	        }]
	      }],
	      n: 50,
	      x: {
	        r: ["remainingRequests", "availableRequests", "resetsInStr"],
	        s: "_0!==null&&_1!==null&&_2!==null"
	      }
	    }]
	  }],
	  e: {
	    "[\"Resets in \"+_0]": function (_0) {
	      return ["Resets in " + _0];
	    },
	    "_0&&_1&&_2": function (_0, _1, _2) {
	      return _0 && _1 && _2;
	    },
	    "_0!==null&&_1!==null&&_2!==null": function (_0, _1, _2) {
	      return _0 !== null && _1 !== null && _2 !== null;
	    }
	  }
	};
	var gpCredits = ractive__default["default"].extend(component$A.exports);

	var component$z = {
	  exports: {}
	};
	component$z.exports = {
	  data() {
	    return {
	      message: null
	    };
	  },
	  oninit() {
	    if (!ractive__default["default"].isServer) {
	      this.observe('rateCreditsData', rateCreditsData => {
	        if (rateCreditsData) {
	          let message;
	          let hasToken = this.get('@shared.user');
	          let resetsInPart = this.createResetInStr(rateCreditsData['x-ratelimit-reset']);
	          if (hasToken) {
	            message = this.createTokenCaseMsg(resetsInPart);
	          } else {
	            message = this.createNoTokenCaseMsg(resetsInPart);
	          }
	          this.set('message', message);
	        }
	      });
	    }
	  },
	  oncomplete() {
	    let el = document.querySelector('.c-gp-credits-message');
	    setTimeout(() => {
	      el.classList.add('show-msg');
	    }, 200);
	  },
	  createResetInStr(seconds) {
	    let minutes = seconds / 60;
	    if (minutes < 1) {
	      return '< 1 minute';
	    }
	    return `${Math.ceil(minutes)} minutes`;
	  },
	  createNoTokenCaseMsg(resetPart) {
	    return `You have run out of credits for this session. You can wait ${resetPart} for the limit to reset or get higher limits by creating an account.`;
	  },
	  createTokenCaseMsg(resetPart) {
	    return `You have run out of credits for this session. You can wait ${resetPart} for the limit to reset or get higher limits by sponsoring us or hosting probes.`;
	  }
	};
	component$z.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "div",
	    m: [{
	      t: 13,
	      n: "class",
	      f: "c-gp-credits-message",
	      g: 1
	    }],
	    f: [{
	      t: 4,
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "msg-wrapper",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "span",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "msg-wrapper_msg",
	            g: 1
	          }],
	          f: [{
	            t: 2,
	            r: "message"
	          }]
	        }, " ", {
	          t: 7,
	          e: "a",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "msg-wrapper_sign-up",
	            g: 1
	          }, {
	            n: "href",
	            f: "https://globalping.io?view=add-credits",
	            t: 13,
	            g: 1
	          }],
	          f: ["Sign up"]
	        }]
	      }],
	      n: 50,
	      r: "message"
	    }]
	  }]
	};
	var gpCreditsMessage = ractive__default["default"].extend(component$z.exports);

	var component$y = {
	  exports: {}
	};
	component$y.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "div",
	    m: [{
	      t: 13,
	      n: "class",
	      f: "c-placeholder-skeleton",
	      g: 1
	    }],
	    f: [{
	      t: 4,
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "skeleton-header",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "skeleton_animated",
	            g: 1
	          }]
	        }]
	      }],
	      n: 50,
	      x: {
	        r: ["type"],
	        s: "_0===\"header\""
	      }
	    }, {
	      t: 4,
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "skeleton-subheader",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "skeleton-subheader_content-wrapper",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "skeleton_animated",
	              g: 1
	            }]
	          }]
	        }]
	      }, " "],
	      n: 50,
	      x: {
	        r: ["type"],
	        s: "_0===\"subheader\""
	      },
	      l: 1
	    }, {
	      t: 4,
	      f: [" ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "skeleton-descr",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "skeleton_animated",
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "skeleton_animated",
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "skeleton_animated",
	            g: 1
	          }]
	        }]
	      }, " "],
	      n: 50,
	      x: {
	        r: ["type"],
	        s: "_0===\"descr\""
	      },
	      l: 1
	    }, {
	      t: 4,
	      f: [" ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "skeleton-list",
	          g: 1
	        }],
	        f: [{
	          t: 4,
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "skeleton-list_content-wrapper",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "li",
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "skeleton_animated",
	                  g: 1
	                }]
	              }]
	            }]
	          }],
	          n: 52,
	          r: "content"
	        }]
	      }],
	      n: 50,
	      x: {
	        r: ["type"],
	        s: "_0===\"list\""
	      },
	      l: 1
	    }]
	  }],
	  e: {
	    "_0===\"header\"": function (_0) {
	      return _0 === "header";
	    },
	    "_0===\"subheader\"": function (_0) {
	      return _0 === "subheader";
	    },
	    "_0===\"descr\"": function (_0) {
	      return _0 === "descr";
	    },
	    "_0===\"list\"": function (_0) {
	      return _0 === "list";
	    }
	  }
	};
	var placeholderSkeleton = ractive__default["default"].extend(component$y.exports);

	var clipboard = function (node) {
	  let title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Copy to Clipboard';
	  let tooltipPlacement = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'top';
	  let nodeSelector = arguments.length > 3 ? arguments[3] : undefined;
	  let clipboard = new ClipboardJS(node);
	  let $node = nodeSelector ? $(node).parents(nodeSelector).first() : $(node);
	  let tooltipOptions = {
	    title,
	    placement: tooltipPlacement,
	    trigger: 'hover',
	    container: 'body',
	    animation: false
	  };
	  function onDocumentClick(e) {
	    if (e.srcElement !== $node[0] && !$(e.srcElement).closest($node[0]).length) {
	      setDefaultTooltip();
	    }
	  }
	  function setDefaultTooltip() {
	    $node.tooltip('destroy').tooltip(tooltipOptions);
	  }
	  setDefaultTooltip();
	  document.addEventListener('click', onDocumentClick);
	  clipboard.on('success', () => {
	    $node.tooltip('destroy').tooltip(Object.assign({}, tooltipOptions, {
	      trigger: 'manual',
	      title: 'Copied!'
	    })).tooltip('show');
	    setTimeout(setDefaultTooltip, 1000);
	  });
	  clipboard.on('error', () => {
	    $node.tooltip('destroy').tooltip(Object.assign({}, tooltipOptions, {
	      trigger: 'manual',
	      title: 'Press Ctrl+C to copy'
	    })).tooltip('show');
	    setTimeout(setDefaultTooltip, 1000);
	  });
	  return {
	    teardown: () => {
	      document.removeEventListener('click', onDocumentClick);
	    }
	  };
	};

	var component$x = {
	  exports: {}
	};
	component$x.exports = {
	  decorators: {
	    clipboard
	  },
	  data() {
	    return {
	      shareResultsAsURL: true,
	      shareResultsText: null,
	      shareResMsg: null
	    };
	  },
	  onrender() {
	    if (!ractive__default["default"].isServer) {
	      // check shareRes state and create URL or CLI cmd respectively
	      this.observe('shareResultsAsURL measurementsMetadata', () => {
	        let {
	          shareResTextToDisplay,
	          shareResTextToCopy
	        } = this.createShareResText();
	        this.set('shareResTextToDisplay', shareResTextToDisplay);
	        this.set('shareResTextToCopy', shareResTextToCopy);
	      });

	      // select all share-res text of link on click
	      this.observe('testInProgress', testInProgress => {
	        if (!testInProgress) {
	          let shareResTextEl = this.find('#share-res-text');
	          shareResTextEl.addEventListener('click', () => {
	            window.getSelection().selectAllChildren(shareResTextEl);
	          });
	        }
	      }, {
	        defer: true
	      });
	    }
	  },
	  createShareResText() {
	    let shareResultsAsURL = this.get('shareResultsAsURL');
	    let measurementsMetadata = this.get('measurementsMetadata');
	    let isInfiniteModeRes = this.get('isInfiniteModeRes');

	    // create and return the texts of the share-results URL
	    if (shareResultsAsURL) {
	      let origin = this.get('@global.location.origin');
	      // regular measurement IDs should be separated by a comma
	      let idsDelimiter = ',';
	      let measIDsArr = Object.values(measurementsMetadata).map(v => v.measurementId);
	      let preparedMeasIDsArr = measIDsArr;
	      if (isInfiniteModeRes) {
	        // the infinite one by a plus sign
	        idsDelimiter = '.';

	        // for infinite get last 10 IDs from oldest to newest
	        preparedMeasIDsArr = measIDsArr.slice(-10);

	        // show related message for such case
	        if (measIDsArr.length >= 10) {
	          this.set('shareResMsg', 'For long-running continuous mode measurements, only the last 160 packets are shared.');
	        }
	      }
	      let textToDisplay = preparedMeasIDsArr.join(idsDelimiter);
	      let textToCopy = preparedMeasIDsArr.join(idsDelimiter);
	      return {
	        shareResTextToDisplay: `${origin}?measurement=${textToDisplay}`,
	        shareResTextToCopy: `${origin}?measurement=${textToCopy}`
	      };
	    }

	    // create and return the texts of the CLI command
	    return this.createCliCommand(this.get('testReqParams'), measurementsMetadata);
	  },
	  createCliCommand(params, measurementsMetadata) {
	    let targetsCnt = Object.values(measurementsMetadata).map(v => v.target).length;
	    let isInfiniteModeRes = this.get('isInfiniteModeRes');
	    if (targetsCnt >= 2 && !isInfiniteModeRes) {
	      return {
	        shareResTextToDisplay: 'Not supported yet',
	        shareResTextToCopy: 'Not supported yet'
	      };
	    }
	    let cmd = Object.keys(params).reduce((cmd, key) => {
	      // test type part
	      if (key === 'type') {
	        cmd.typePart += ` ${params[key]} ${params.target}`;
	        if (params.locations && params.locations.length) {
	          let locationStr = params.locations.reduce((str, loc, idx) => {
	            let locPart = loc.magic.trim();
	            if (idx === 0) {
	              return str += locPart;
	            }
	            return str += `, ${locPart}`;
	          }, '');
	          cmd.typePart += ` from ${locationStr}`;
	        }
	        if (params.measurementOptions) {
	          let str = Object.keys(params.measurementOptions).reduce((str, key) => {
	            switch (key) {
	              case 'packets':
	                str += ` --packets ${params.measurementOptions.packets}`;
	                break;
	              case 'port':
	                str += ` --port ${params.measurementOptions.port}`;
	                break;
	              case 'protocol':
	                str += ` --protocol ${params.measurementOptions.protocol}`;
	                break;
	              case 'type':
	                str += ` --type ${params.measurementOptions.type}`;
	                break;
	              case 'trace':
	                if (params.type.toLowerCase() === 'dns' && params.measurementOptions.trace) {
	                  str += ' --trace';
	                }
	                break;
	              case 'resolver':
	                str += ` --resolver ${params.measurementOptions.resolver}`;
	                break;
	              case 'request':
	                if (params.measurementOptions.request.host) {
	                  str += ` --host ${params.measurementOptions.request.host}`;
	                }
	                if (params.measurementOptions.request.path) {
	                  let path = params.measurementOptions.request.path;
	                  path = path[0] === '/' ? path : `/${path}`;
	                  str += ` --path '${path}'`;
	                }
	                if (params.measurementOptions.request.query) {
	                  str += ` --query '${params.measurementOptions.request.query}'`;
	                }
	                if (params.measurementOptions.request.method) {
	                  str += ` --method ${params.measurementOptions.request.method}`;
	                }
	                break;
	            }
	            return str;
	          }, '');
	          cmd.typePart += str;
	        }
	      }

	      // global flags part
	      if (key === 'limit') {
	        cmd.globalPart += ` --limit ${params[key]}`;
	      }
	      return cmd;
	    }, {
	      base: 'globalping',
	      typePart: '',
	      globalPart: ''
	    });

	    // add infinite flag for the Infinite flow
	    if (isInfiniteModeRes) {
	      cmd.globalPart += ' --infinite';
	    }
	    return {
	      shareResTextToDisplay: cmd.base + cmd.typePart + cmd.globalPart,
	      shareResTextToCopy: cmd.base + cmd.typePart + cmd.globalPart
	    };
	  }
	};
	component$x.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "div",
	    m: [{
	      t: 13,
	      n: "class",
	      f: "c-gp-results-share",
	      g: 1
	    }],
	    f: [{
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "c-gp-results-share_switch",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "input",
	        m: [{
	          n: "id",
	          f: "share-switch",
	          t: 13
	        }, {
	          n: "type",
	          f: "checkbox",
	          t: 13
	        }, {
	          n: "class",
	          f: ["share-type-switch ", {
	            t: 4,
	            f: ["checked"],
	            n: 51,
	            r: "shareResultsAsURL"
	          }],
	          t: 13
	        }, {
	          t: 73,
	          v: "t",
	          f: "false"
	        }]
	      }, " ", {
	        t: 7,
	        e: "label",
	        m: [{
	          n: "for",
	          f: "share-switch",
	          t: 13,
	          g: 1
	        }, {
	          n: ["click"],
	          t: 70,
	          f: {
	            r: ["@this", "shareResultsAsURL"],
	            s: "[_0.set(\"shareResultsAsURL\",!_1)]"
	          }
	        }],
	        f: [{
	          t: 7,
	          e: "span",
	          f: [{
	            t: 7,
	            e: "i",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "fa fa-link",
	              g: 1
	            }, {
	              n: "aria-hidden",
	              f: "true",
	              t: 13,
	              g: 1
	            }]
	          }, " ", {
	            t: 7,
	            e: "span",
	            f: ["Share URL"]
	          }]
	        }, " ", {
	          t: 7,
	          e: "span",
	          f: [{
	            t: 7,
	            e: "i",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "fa fa-terminal",
	              g: 1
	            }, {
	              n: "aria-hidden",
	              f: "true",
	              t: 13,
	              g: 1
	            }]
	          }, " ", {
	            t: 7,
	            e: "span",
	            f: ["Replicate in CLI"]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "slide-select",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "selected",
	              g: 1
	            }]
	          }]
	        }]
	      }]
	    }, " ", {
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "c-gp-results-share_content",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "c-gp-results-share_content_text",
	          g: 1
	        }, {
	          n: "id",
	          f: "share-res-text",
	          t: 13,
	          g: 1
	        }],
	        f: [{
	          t: 2,
	          r: "shareResTextToDisplay"
	        }]
	      }, " ", {
	        t: 4,
	        f: [{
	          t: 7,
	          e: "span",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "c-gp-results-share_content_msg",
	            g: 1
	          }],
	          f: [{
	            t: 2,
	            r: "shareResMsg"
	          }]
	        }],
	        n: 50,
	        r: "shareResMsg"
	      }, " ", {
	        t: 7,
	        e: "button",
	        m: [{
	          n: "clipboard",
	          t: 71
	        }, {
	          n: "data-clipboard-text",
	          f: [{
	            t: 2,
	            r: "shareResTextToCopy"
	          }],
	          t: 13
	        }],
	        f: [{
	          t: 7,
	          e: "img",
	          m: [{
	            n: "width",
	            f: "20",
	            t: 13,
	            g: 1
	          }, {
	            n: "height",
	            f: "20",
	            t: 13,
	            g: 1
	          }, {
	            n: "src",
	            f: [{
	              t: 2,
	              r: "@shared.assetsHost"
	            }, "/img/globalping/copy-icon-black.svg"],
	            t: 13
	          }]
	        }]
	      }]
	    }]
	  }],
	  e: {
	    "[_0.set(\"shareResultsAsURL\",!_1)]": function (_0, _1) {
	      return [_0.set("shareResultsAsURL", !_1)];
	    }
	  }
	};
	var gpResultsShare = ractive__default["default"].extend(component$x.exports);

	var component$w = {
	  exports: {}
	};
	const PROBE_MAX_TIMING = 200;
	const PROBE_MIN_TIMING = 5;
	const PROBE_NO_TIMING_VALUE$2 = _.getProbeTimeOutValue();
	const PROBE_OFFLINE_TEXT$1 = 'Probe offline';
	const PROBE_FAILED_TEXT = 'Probe failed';
	component$w.exports = {
	  decorators: {
	    tooltip
	  },
	  data() {
	    return {
	      _,
	      PROBE_NO_TIMING_VALUE: PROBE_NO_TIMING_VALUE$2,
	      PROBE_OFFLINE_TEXT: PROBE_OFFLINE_TEXT$1,
	      PROBE_FAILED_TEXT,
	      splitIPv6(address) {
	        let segments = address.split(':');
	        if (segments.filter(Boolean).length <= 4) {
	          return [address];
	        }
	        let splitAt = segments[3] ? 4 : 3;
	        return [segments.slice(0, splitAt).join(':'), ':' + segments.slice(splitAt).join(':')];
	      },
	      chartMaxHeight: 0
	    };
	  },
	  onrender() {
	    if (!ractive__default["default"].isServer) {
	      this.observe('preparedTestResults', preparedTestResults => {
	        this.setChartMaxHeight(preparedTestResults);
	        // set results block height based on content
	        this.setResultsBlockHeight(preparedTestResults);
	      });
	    }
	  },
	  oncomplete() {
	    if (!ractive__default["default"].isServer) {
	      let tableEl = this.find('.c-gp-results-table-output .results-table');
	      let allActionBtnsElements = tableEl.querySelectorAll('.results-table_column_location .results-table_column_location_actions_btn');
	      tableEl.addEventListener('mouseleave', () => {
	        allActionBtnsElements.forEach(el => el.style.visibility = 'hidden');
	      });
	    }
	  },
	  setProbeAsLocation(probeData) {
	    this.set('currSearchLocation', `AS${probeData.asn}+${probeData.city}`);
	  },
	  setChartMaxHeight(results) {
	    let allPacketRtt = results.map(test => Array.isArray(test.statsPerTarget) ? test.statsPerTarget.map(target => target.packetsRtt).flat() : []).flat();
	    this.set('chartMaxHeight', Math.max(...allPacketRtt.filter(v => typeof v === 'number')));
	  },
	  setResultsBlockHeight(results) {
	    requestAnimationFrame(() => {
	      let listWrapperEl = document.querySelector('.results-table-wrapper');
	      if (listWrapperEl) {
	        let itemsAmount = results.length;
	        let listElScrollHeight = listWrapperEl.scrollHeight;
	        let avgItemElHeight = Math.round(listElScrollHeight / itemsAmount);
	        listWrapperEl.style.height = `${itemsAmount < 8 ? avgItemElHeight * itemsAmount : avgItemElHeight * 8}px`;
	      }
	    });
	  },
	  createRealTimeGraph(data) {
	    let svgWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 48;
	    let svgHeight = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 24;
	    let svgBgColor = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '#F4F4F4';
	    let barWidth = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 2;
	    let gap = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 1;
	    if (!data) {
	      return;
	    }
	    let maxValue = this.get('chartMaxHeight');
	    let maxBars = Math.floor(svgWidth / (barWidth + gap));
	    let startIndex = Math.max(data.length - maxBars, 0);
	    let svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
	    svg.setAttribute('width', svgWidth);
	    svg.setAttribute('height', svgHeight);
	    svg.style.backgroundColor = svgBgColor;
	    for (let i = startIndex; i < data.length; i++) {
	      let percentage = data[i] === maxValue || data[i] === PROBE_NO_TIMING_VALUE$2 ? 1 : data[i] / maxValue;
	      let barHeight = percentage * svgHeight;
	      let x = svgWidth - (data.length - 1 - i) * (barWidth + gap) - barWidth;
	      let y = svgHeight - barHeight;
	      if (x >= 0) {
	        let rect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
	        rect.setAttribute('x', x);
	        rect.setAttribute('y', y);
	        rect.setAttribute('width', barWidth);
	        rect.setAttribute('height', barHeight);
	        rect.setAttribute('fill', this.pickBarColor(data[i]));
	        svg.appendChild(rect);
	      }
	    }
	    return svg.outerHTML;
	  },
	  createRegularGraph(data) {
	    let svgWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 48;
	    let svgHeight = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 24;
	    let svgBgColor = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '#F4F4F4';
	    if (!data || data.length === 0) {
	      return;
	    }
	    data = data.slice(-20);
	    let svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
	    let numBars = data.length;
	    let spaceWidth = 1;
	    let barWidth = Math.round(svgWidth / numBars - spaceWidth);
	    let maxValue = this.get('chartMaxHeight');
	    let actualWidth = barWidth * numBars + (numBars - 1) * spaceWidth;
	    svg.setAttribute('width', actualWidth > svgWidth ? actualWidth : svgWidth);
	    svg.setAttribute('height', svgHeight);
	    svg.style.backgroundColor = svgBgColor;
	    data.forEach((value, index) => {
	      let barHeight = value === PROBE_NO_TIMING_VALUE$2 ? svgHeight : value / maxValue * svgHeight;
	      let xPosition = index * spaceWidth + index * barWidth;
	      let rect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
	      rect.setAttribute('x', xPosition);
	      rect.setAttribute('y', svgHeight - barHeight);
	      rect.setAttribute('width', barWidth);
	      rect.setAttribute('height', barHeight);
	      rect.setAttribute('fill', this.pickBarColor(value));
	      svg.appendChild(rect);
	    });
	    return svg.outerHTML;
	  },
	  pickBarColor(timing) {
	    // return default color for timed out probe
	    if (timing === PROBE_NO_TIMING_VALUE$2) {
	      return '#17233A';
	    }
	    function getColorFromGradient(quotient, start, middle, end) {
	      return quotient >= 0.5 ? linear(middle, end, (quotient - 0.5) * 2) : linear(start, middle, quotient * 2);
	    }
	    function linear(startColor, endColor, quotient) {
	      let redColor = byteLinear(startColor[1] + startColor[2], endColor[1] + endColor[2], quotient);
	      let greenColor = byteLinear(startColor[3] + startColor[4], endColor[3] + endColor[4], quotient);
	      let blueColor = byteLinear(startColor[5] + startColor[6], endColor[5] + endColor[6], quotient);
	      return `#${redColor}${greenColor}${blueColor}`;
	    }
	    function byteLinear(partOne, partTwo, quotient) {
	      let color = Math.floor(('0x' + partOne) * (1 - quotient) + ('0x' + partTwo) * quotient);
	      return color.toString(16).padStart(2, '0');
	    }
	    let pureTimingValue = parseInt(timing);

	    // '#17d4a7', '#ffb800', '#e64e3d' - colors are used for timings scale on the map
	    if (pureTimingValue <= PROBE_MIN_TIMING) {
	      return '#17d4a7';
	    }
	    if (pureTimingValue >= PROBE_MAX_TIMING) {
	      return '#e64e3d';
	    }
	    return getColorFromGradient(pureTimingValue / PROBE_MAX_TIMING, '#17d4a7', '#ffb800', '#e64e3d');
	  },
	  calcQuality(statsTotal, statsDrop) {
	    if (typeof statsTotal === 'undefined' || typeof statsDrop === 'undefined' || statsTotal === 0) {
	      return {
	        qualityPercentage: null,
	        actualAmount: null
	      };
	    }
	    let actualAmount = Math.max(statsTotal - statsDrop, 0);
	    let qualityPercentage = Math.round(actualAmount / statsTotal * 100);
	    return {
	      qualityPercentage,
	      actualAmount
	    };
	  },
	  createGraph(packetsRtt) {
	    let isInfiniteModeRes = this.get('isInfiniteModeRes');
	    let memoizedCreateGraph;
	    if (isInfiniteModeRes) {
	      memoizedCreateGraph = _.memoize(this.createRealTimeGraph.bind(this));
	    } else {
	      memoizedCreateGraph = _.memoize(this.createRegularGraph.bind(this));
	    }
	    return memoizedCreateGraph(packetsRtt);
	  },
	  formatTimingValue(value) {
	    if (typeof value !== 'number' || isNaN(value)) {
	      return value;
	    }
	    if (value < 10) {
	      return value.toFixed(2);
	    } else if (value < 100) {
	      return value.toFixed(1);
	    }
	    return Math.round(value);
	  }
	};
	component$w.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "div",
	    m: [{
	      t: 13,
	      n: "class",
	      f: "c-gp-results-table-output",
	      g: 1
	    }],
	    f: [{
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "results-table-wrapper",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          n: "class",
	          f: ["results-table ", {
	            t: 4,
	            f: ["single-target"],
	            n: 50,
	            x: {
	              r: ["targetsCnt"],
	              s: "_0===1"
	            }
	          }],
	          t: 13
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "results-table_header",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "results-table_header_cell location",
	              g: 1
	            }],
	            f: ["Location"]
	          }, " ", {
	            t: 4,
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "results-table_header_cell targets",
	                g: 1
	              }]
	            }],
	            n: 50,
	            x: {
	              r: ["targetsCnt"],
	              s: "_0>1"
	            }
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "results-table_header_cell quality",
	              g: 1
	            }],
	            f: ["Quality"]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "results-table_header_cell rtt",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "span",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "rtt_text",
	                g: 1
	              }],
	              f: ["rtt last"]
	            }, " ", {
	              t: 7,
	              e: "span",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "rtt_separator",
	                g: 1
	              }],
	              f: ["/"]
	            }, " ", {
	              t: 7,
	              e: "span",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "rtt_text",
	                g: 1
	              }],
	              f: ["min"]
	            }, " ", {
	              t: 7,
	              e: "span",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "rtt_separator",
	                g: 1
	              }],
	              f: ["/"]
	            }, " ", {
	              t: 7,
	              e: "span",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "rtt_text",
	                g: 1
	              }],
	              f: ["avg"]
	            }, " ", {
	              t: 7,
	              e: "span",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "rtt_separator",
	                g: 1
	              }],
	              f: ["/"]
	            }, " ", {
	              t: 7,
	              e: "span",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "rtt_text",
	                g: 1
	              }],
	              f: ["max"]
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "results-table_header_cell ip",
	              g: 1
	            }],
	            f: ["Resolved IP"]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "results-table_header_cell graph",
	              g: 1
	            }],
	            f: ["Graph"]
	          }]
	        }, " ", {
	          t: 4,
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              n: "class",
	              f: ["results-table_row row-num-", {
	                t: 2,
	                r: "resIdx"
	              }],
	              t: 13
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "results-table_row_location",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "span",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "results-table_row_location_status-line",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "span",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "results-table_row_location_status-line_top",
	                    g: 1
	                  }, {
	                    n: "style",
	                    f: ["background-color: ", {
	                      t: 2,
	                      x: {
	                        r: ["_", "./statsPerTarget.0.avgTiming"],
	                        s: "_0.getGpProbeStatusColor(_1)"
	                      }
	                    }],
	                    t: 13
	                  }],
	                  f: []
	                }, " ", {
	                  t: 7,
	                  e: "span",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "results-table_row_location_status-line_bottom",
	                    g: 1
	                  }, {
	                    n: "style",
	                    f: ["background-color: ", {
	                      t: 2,
	                      x: {
	                        r: ["_", "./statsPerTarget.1", "./statsPerTarget.1.avgTiming", "./statsPerTarget.0.avgTiming"],
	                        s: "_0.getGpProbeStatusColor(_1?_2:_3)"
	                      }
	                    }],
	                    t: 13
	                  }],
	                  f: []
	                }]
	              }, " ", {
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "28",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "20",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: ["https://cdn.jsdelivr.net/npm/country-flag-icons@1.5.5/3x2/", {
	                    t: 2,
	                    r: "./country"
	                  }, ".svg"],
	                  t: 13
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "results-table_row_location_data",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "span",
	                  f: [{
	                    t: 2,
	                    r: "./city"
	                  }, ", ", {
	                    t: 2,
	                    r: "./country"
	                  }, ", ", {
	                    t: 2,
	                    r: "./continent"
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "span",
	                  f: [{
	                    t: 2,
	                    r: "./network"
	                  }]
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "results-table_row_location_actions",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "results-table_row_location_actions_btn",
	                    g: 1
	                  }, {
	                    n: "tooltip",
	                    t: 71,
	                    f: {
	                      r: [],
	                      s: "[\"Set as location for the next test\",\"right\"]"
	                    }
	                  }, {
	                    n: ["click"],
	                    t: 70,
	                    f: {
	                      r: ["@this", "."],
	                      s: "[_0.setProbeAsLocation(_1)]"
	                    }
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "i",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "fa fa-map-marker",
	                      g: 1
	                    }, {
	                      n: "aria-hidden",
	                      f: "true",
	                      t: 13,
	                      g: 1
	                    }]
	                  }]
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "results-table_row_stats",
	                g: 1
	              }],
	              f: [{
	                t: 4,
	                f: [{
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "results-table_row_stats_subrow",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 4,
	                    f: [{
	                      t: 7,
	                      e: "div",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "results-table_row_stats_subrow_cell targets",
	                        g: 1
	                      }],
	                      f: [{
	                        t: 7,
	                        e: "div",
	                        m: [{
	                          t: 13,
	                          n: "class",
	                          f: "results-table_row_stats_subrow_cell_value",
	                          g: 1
	                        }],
	                        f: [{
	                          t: 4,
	                          f: [{
	                            t: 7,
	                            e: "span",
	                            f: [{
	                              t: 2,
	                              r: "./target"
	                            }]
	                          }],
	                          n: 50,
	                          r: "./target"
	                        }, {
	                          t: 4,
	                          f: [{
	                            t: 7,
	                            e: "c-placeholder-skeleton",
	                            m: [{
	                              n: "type",
	                              f: "subheader",
	                              t: 13,
	                              g: 1
	                            }]
	                          }],
	                          n: 51,
	                          l: 1
	                        }]
	                      }]
	                    }],
	                    n: 50,
	                    x: {
	                      r: ["targetsCnt"],
	                      s: "_0>1"
	                    }
	                  }, " ", {
	                    t: 4,
	                    f: [{
	                      t: 7,
	                      e: "div",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "results-table_row_stats_subrow_cell probe-failed",
	                        g: 1
	                      }],
	                      f: [{
	                        t: 7,
	                        e: "span",
	                        f: [{
	                          t: 2,
	                          r: "PROBE_FAILED_TEXT"
	                        }]
	                      }, " ", {
	                        t: 7,
	                        e: "div",
	                        m: [{
	                          n: "tooltip",
	                          t: 71,
	                          f: {
	                            r: ["./failureRawOutput"],
	                            s: "[(\"\"+(_0)),\"top\",true]"
	                          }
	                        }],
	                        f: [{
	                          t: 7,
	                          e: "img",
	                          m: [{
	                            n: "width",
	                            f: "20",
	                            t: 13,
	                            g: 1
	                          }, {
	                            n: "height",
	                            f: "20",
	                            t: 13,
	                            g: 1
	                          }, {
	                            n: "src",
	                            f: [{
	                              t: 2,
	                              r: "@shared.assetsHost"
	                            }, "/img/globalping/target-icon.svg"],
	                            t: 13
	                          }]
	                        }]
	                      }]
	                    }],
	                    n: 50,
	                    r: "./isFailed"
	                  }, {
	                    t: 4,
	                    f: [{
	                      t: 7,
	                      e: "div",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "results-table_row_stats_subrow_cell probe-offline",
	                        g: 1
	                      }],
	                      f: [{
	                        t: 7,
	                        e: "span",
	                        f: [{
	                          t: 2,
	                          r: "PROBE_OFFLINE_TEXT"
	                        }]
	                      }]
	                    }, " "],
	                    n: 50,
	                    x: {
	                      r: ["./isOffline", "isInfiniteModeRes"],
	                      s: "_0&&!_1"
	                    },
	                    l: 1
	                  }, {
	                    t: 4,
	                    f: [" ", {
	                      t: 7,
	                      e: "div",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "results-table_row_stats_subrow_cell quality",
	                        g: 1
	                      }],
	                      f: [{
	                        t: 7,
	                        e: "div",
	                        m: [{
	                          t: 13,
	                          n: "class",
	                          f: "results-table_row_stats_subrow_cell_value",
	                          g: 1
	                        }],
	                        f: [{
	                          t: 7,
	                          e: "span",
	                          m: [{
	                            t: 13,
	                            n: "class",
	                            f: "results-table_row_stats_subrow_cell_value_header",
	                            g: 1
	                          }],
	                          f: ["Quality"]
	                        }, " ", {
	                          t: 4,
	                          f: [{
	                            t: 7,
	                            e: "span",
	                            f: [{
	                              t: 2,
	                              r: "./qualityStr"
	                            }]
	                          }],
	                          n: 50,
	                          r: "./qualityStr"
	                        }, {
	                          t: 4,
	                          f: [{
	                            t: 7,
	                            e: "c-placeholder-skeleton",
	                            m: [{
	                              n: "type",
	                              f: "subheader",
	                              t: 13,
	                              g: 1
	                            }]
	                          }],
	                          n: 51,
	                          l: 1
	                        }]
	                      }]
	                    }, " ", {
	                      t: 7,
	                      e: "div",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "results-table_row_stats_subrow_cell rtt",
	                        g: 1
	                      }],
	                      f: [{
	                        t: 7,
	                        e: "div",
	                        m: [{
	                          t: 13,
	                          n: "class",
	                          f: "results-table_row_stats_subrow_cell_value",
	                          g: 1
	                        }],
	                        f: [{
	                          t: 7,
	                          e: "span",
	                          m: [{
	                            n: "class",
	                            f: ["timings ", {
	                              t: 4,
	                              f: ["no-value"],
	                              n: 51,
	                              r: "areTimingsReady"
	                            }],
	                            t: 13
	                          }],
	                          f: [{
	                            t: 7,
	                            e: "span",
	                            m: [{
	                              t: 13,
	                              n: "class",
	                              f: "timings_header",
	                              g: 1
	                            }],
	                            f: [{
	                              t: 7,
	                              e: "span",
	                              f: ["rtt "]
	                            }, " ", {
	                              t: 7,
	                              e: "span",
	                              f: ["last"]
	                            }]
	                          }, " ", {
	                            t: 4,
	                            f: [{
	                              t: 7,
	                              e: "span",
	                              m: [{
	                                t: 13,
	                                n: "class",
	                                f: "timings_value",
	                                g: 1
	                              }],
	                              f: [{
	                                t: 2,
	                                x: {
	                                  r: ["@this", "./lastTiming"],
	                                  s: "_0.formatTimingValue(_1)"
	                                }
	                              }, " ", {
	                                t: 4,
	                                f: [{
	                                  t: 7,
	                                  e: "span",
	                                  m: [{
	                                    t: 13,
	                                    n: "class",
	                                    f: "timings_units",
	                                    g: 1
	                                  }],
	                                  f: ["ms"]
	                                }],
	                                n: 50,
	                                x: {
	                                  r: ["./lastTiming", "PROBE_NO_TIMING_VALUE"],
	                                  s: "_0!==_1"
	                                }
	                              }]
	                            }],
	                            n: 50,
	                            r: "./areTimingsReady"
	                          }, {
	                            t: 4,
	                            f: [{
	                              t: 7,
	                              e: "c-placeholder-skeleton",
	                              m: [{
	                                n: "type",
	                                f: "subheader",
	                                t: 13,
	                                g: 1
	                              }]
	                            }],
	                            n: 50,
	                            x: {
	                              r: ["./areTimingsReady"],
	                              s: "!_0"
	                            },
	                            l: 1
	                          }]
	                        }, " ", {
	                          t: 7,
	                          e: "span",
	                          m: [{
	                            t: 13,
	                            n: "class",
	                            f: "timings_separator",
	                            g: 1
	                          }],
	                          f: ["/"]
	                        }, " ", {
	                          t: 7,
	                          e: "span",
	                          m: [{
	                            n: "class",
	                            f: ["timings ", {
	                              t: 4,
	                              f: ["no-value"],
	                              n: 51,
	                              r: "areTimingsReady"
	                            }],
	                            t: 13
	                          }],
	                          f: [{
	                            t: 7,
	                            e: "span",
	                            m: [{
	                              t: 13,
	                              n: "class",
	                              f: "timings_header",
	                              g: 1
	                            }],
	                            f: [{
	                              t: 7,
	                              e: "span",
	                              f: ["rtt "]
	                            }, " ", {
	                              t: 7,
	                              e: "span",
	                              f: ["min"]
	                            }]
	                          }, " ", {
	                            t: 4,
	                            f: [{
	                              t: 7,
	                              e: "span",
	                              m: [{
	                                t: 13,
	                                n: "class",
	                                f: "timings_value",
	                                g: 1
	                              }],
	                              f: [{
	                                t: 2,
	                                x: {
	                                  r: ["@this", "./minTiming"],
	                                  s: "_0.formatTimingValue(_1)"
	                                }
	                              }, " ", {
	                                t: 4,
	                                f: [{
	                                  t: 7,
	                                  e: "span",
	                                  m: [{
	                                    t: 13,
	                                    n: "class",
	                                    f: "timings_units",
	                                    g: 1
	                                  }],
	                                  f: ["ms"]
	                                }],
	                                n: 50,
	                                x: {
	                                  r: ["./minTiming", "PROBE_NO_TIMING_VALUE"],
	                                  s: "_0!==_1"
	                                }
	                              }]
	                            }],
	                            n: 50,
	                            r: "./areTimingsReady"
	                          }, {
	                            t: 4,
	                            f: [{
	                              t: 7,
	                              e: "c-placeholder-skeleton",
	                              m: [{
	                                n: "type",
	                                f: "subheader",
	                                t: 13,
	                                g: 1
	                              }]
	                            }],
	                            n: 50,
	                            x: {
	                              r: ["./areTimingsReady"],
	                              s: "!_0"
	                            },
	                            l: 1
	                          }]
	                        }, " ", {
	                          t: 7,
	                          e: "span",
	                          m: [{
	                            t: 13,
	                            n: "class",
	                            f: "timings_separator",
	                            g: 1
	                          }],
	                          f: ["/"]
	                        }, " ", {
	                          t: 7,
	                          e: "span",
	                          m: [{
	                            n: "class",
	                            f: ["timings ", {
	                              t: 4,
	                              f: ["no-value"],
	                              n: 51,
	                              r: "areTimingsReady"
	                            }],
	                            t: 13
	                          }],
	                          f: [{
	                            t: 7,
	                            e: "span",
	                            m: [{
	                              t: 13,
	                              n: "class",
	                              f: "timings_header",
	                              g: 1
	                            }],
	                            f: [{
	                              t: 7,
	                              e: "span",
	                              f: ["rtt "]
	                            }, " ", {
	                              t: 7,
	                              e: "span",
	                              f: ["avg"]
	                            }]
	                          }, " ", {
	                            t: 4,
	                            f: [{
	                              t: 7,
	                              e: "span",
	                              m: [{
	                                t: 13,
	                                n: "class",
	                                f: "timings_value",
	                                g: 1
	                              }],
	                              f: [{
	                                t: 2,
	                                x: {
	                                  r: ["@this", "./avgTiming"],
	                                  s: "_0.formatTimingValue(_1)"
	                                }
	                              }, " ", {
	                                t: 4,
	                                f: [{
	                                  t: 7,
	                                  e: "span",
	                                  m: [{
	                                    t: 13,
	                                    n: "class",
	                                    f: "timings_units",
	                                    g: 1
	                                  }],
	                                  f: ["ms"]
	                                }],
	                                n: 50,
	                                x: {
	                                  r: ["./avgTiming", "PROBE_NO_TIMING_VALUE"],
	                                  s: "_0!==_1"
	                                }
	                              }]
	                            }],
	                            n: 50,
	                            r: "./areTimingsReady"
	                          }, {
	                            t: 4,
	                            f: [{
	                              t: 7,
	                              e: "c-placeholder-skeleton",
	                              m: [{
	                                n: "type",
	                                f: "subheader",
	                                t: 13,
	                                g: 1
	                              }]
	                            }],
	                            n: 50,
	                            x: {
	                              r: ["./areTimingsReady"],
	                              s: "!_0"
	                            },
	                            l: 1
	                          }]
	                        }, " ", {
	                          t: 7,
	                          e: "span",
	                          m: [{
	                            t: 13,
	                            n: "class",
	                            f: "timings_separator",
	                            g: 1
	                          }],
	                          f: ["/"]
	                        }, " ", {
	                          t: 7,
	                          e: "span",
	                          m: [{
	                            n: "class",
	                            f: ["timings ", {
	                              t: 4,
	                              f: ["no-value"],
	                              n: 51,
	                              r: "areTimingsReady"
	                            }],
	                            t: 13
	                          }],
	                          f: [{
	                            t: 7,
	                            e: "span",
	                            m: [{
	                              t: 13,
	                              n: "class",
	                              f: "timings_header",
	                              g: 1
	                            }],
	                            f: [{
	                              t: 7,
	                              e: "span",
	                              f: ["rtt "]
	                            }, " ", {
	                              t: 7,
	                              e: "span",
	                              f: ["max"]
	                            }]
	                          }, " ", {
	                            t: 4,
	                            f: [{
	                              t: 7,
	                              e: "span",
	                              m: [{
	                                t: 13,
	                                n: "class",
	                                f: "timings_value",
	                                g: 1
	                              }],
	                              f: [{
	                                t: 2,
	                                x: {
	                                  r: ["@this", "./maxTiming"],
	                                  s: "_0.formatTimingValue(_1)"
	                                }
	                              }, " ", {
	                                t: 4,
	                                f: [{
	                                  t: 7,
	                                  e: "span",
	                                  m: [{
	                                    t: 13,
	                                    n: "class",
	                                    f: "timings_units",
	                                    g: 1
	                                  }],
	                                  f: ["ms"]
	                                }],
	                                n: 50,
	                                x: {
	                                  r: ["./maxTiming", "PROBE_NO_TIMING_VALUE"],
	                                  s: "_0!==_1"
	                                }
	                              }]
	                            }],
	                            n: 50,
	                            r: "./areTimingsReady"
	                          }, {
	                            t: 4,
	                            f: [{
	                              t: 7,
	                              e: "c-placeholder-skeleton",
	                              m: [{
	                                n: "type",
	                                f: "subheader",
	                                t: 13,
	                                g: 1
	                              }]
	                            }],
	                            n: 50,
	                            x: {
	                              r: ["./areTimingsReady"],
	                              s: "!_0"
	                            },
	                            l: 1
	                          }]
	                        }, " ", {
	                          t: 4,
	                          f: [{
	                            t: 7,
	                            e: "span",
	                            m: [{
	                              t: 13,
	                              n: "class",
	                              f: "lg-screen-units",
	                              g: 1
	                            }],
	                            f: ["ms"]
	                          }],
	                          n: 50,
	                          x: {
	                            r: ["./areTimingsReady", "./minTiming", "./avgTiming", "./maxTiming", "PROBE_NO_TIMING_VALUE"],
	                            s: "_0&&_1!==_4&&_2!==_4&&_3!==_4"
	                          }
	                        }]
	                      }]
	                    }, " ", {
	                      t: 7,
	                      e: "div",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "results-table_row_stats_subrow_cell ip",
	                        g: 1
	                      }],
	                      f: [{
	                        t: 7,
	                        e: "div",
	                        m: [{
	                          t: 13,
	                          n: "class",
	                          f: "results-table_row_stats_subrow_cell_value",
	                          g: 1
	                        }],
	                        f: [{
	                          t: 7,
	                          e: "span",
	                          m: [{
	                            t: 13,
	                            n: "class",
	                            f: "results-table_row_stats_subrow_cell_value_header",
	                            g: 1
	                          }],
	                          f: ["Resolved IP"]
	                        }, " ", {
	                          t: 4,
	                          f: [{
	                            t: 7,
	                            e: "span",
	                            m: [{
	                              t: 13,
	                              n: "class",
	                              f: "visible-lg",
	                              g: 1
	                            }],
	                            f: [{
	                              t: 9,
	                              c: " We break in two lines if the value has more than 4 non-empty groups. "
	                            }, " ", {
	                              t: 4,
	                              f: [{
	                                t: 2,
	                                r: "."
	                              }, {
	                                t: 7,
	                                e: "br"
	                              }],
	                              n: 52,
	                              x: {
	                                r: ["splitIPv6", "ipAddr"],
	                                s: "_0(_1)"
	                              }
	                            }]
	                          }, " ", {
	                            t: 7,
	                            e: "span",
	                            m: [{
	                              t: 13,
	                              n: "class",
	                              f: "hidden-lg",
	                              g: 1
	                            }],
	                            f: [{
	                              t: 2,
	                              r: "./ipAddr"
	                            }]
	                          }],
	                          n: 50,
	                          r: "./ipAddr"
	                        }, {
	                          t: 4,
	                          f: [{
	                            t: 7,
	                            e: "c-placeholder-skeleton",
	                            m: [{
	                              n: "type",
	                              f: "subheader",
	                              t: 13,
	                              g: 1
	                            }]
	                          }],
	                          n: 50,
	                          x: {
	                            r: ["./ipAddr"],
	                            s: "!_0"
	                          },
	                          l: 1
	                        }]
	                      }]
	                    }, " ", {
	                      t: 7,
	                      e: "div",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "results-table_row_stats_subrow_cell graph",
	                        g: 1
	                      }],
	                      f: [{
	                        t: 7,
	                        e: "div",
	                        m: [{
	                          t: 13,
	                          n: "class",
	                          f: "results-table_row_stats_subrow_cell_value",
	                          g: 1
	                        }],
	                        f: [{
	                          t: 7,
	                          e: "span",
	                          m: [{
	                            t: 13,
	                            n: "class",
	                            f: "results-table_row_stats_subrow_cell_value_header",
	                            g: 1
	                          }],
	                          f: ["Graph"]
	                        }, " ", {
	                          t: 4,
	                          f: [{
	                            t: 7,
	                            e: "div",
	                            f: [{
	                              t: 3,
	                              x: {
	                                r: ["@this", "./packetsRtt"],
	                                s: "_0.createGraph(_1)"
	                              }
	                            }]
	                          }],
	                          n: 50,
	                          x: {
	                            r: ["./packetsRtt", "./packetsRtt.length"],
	                            s: "typeof _0!==\"undefined\"&&_1"
	                          }
	                        }, {
	                          t: 4,
	                          f: [{
	                            t: 7,
	                            e: "c-placeholder-skeleton",
	                            m: [{
	                              n: "type",
	                              f: "subheader",
	                              t: 13,
	                              g: 1
	                            }]
	                          }],
	                          n: 51,
	                          l: 1
	                        }]
	                      }]
	                    }],
	                    n: 51,
	                    l: 1
	                  }]
	                }],
	                n: 52,
	                r: "./statsPerTarget"
	              }]
	            }]
	          }],
	          n: 52,
	          i: "resIdx",
	          r: "preparedTestResults"
	        }]
	      }]
	    }, " ", {
	      t: 4,
	      f: [{
	        t: 7,
	        e: "c-gp-results-share",
	        m: [{
	          n: "testReqParams",
	          f: [{
	            t: 2,
	            r: "testReqParams"
	          }],
	          t: 13
	        }, {
	          n: "measurementsMetadata",
	          f: [{
	            t: 2,
	            r: "measurementsMetadata"
	          }],
	          t: 13
	        }, {
	          n: "isInfiniteModeRes",
	          f: [{
	            t: 2,
	            r: "isInfiniteModeRes"
	          }],
	          t: 13
	        }, {
	          n: "testInProgress",
	          f: [{
	            t: 2,
	            r: "testInProgress"
	          }],
	          t: 13
	        }],
	        f: []
	      }],
	      n: 50,
	      x: {
	        r: ["testReqParams.id", "testInProgress"],
	        s: "_0&&!_1"
	      }
	    }]
	  }],
	  e: {
	    "_0===1": function (_0) {
	      return _0 === 1;
	    },
	    "_0>1": function (_0) {
	      return _0 > 1;
	    },
	    "_0.getGpProbeStatusColor(_1)": function (_0, _1) {
	      return _0.getGpProbeStatusColor(_1);
	    },
	    "_0.getGpProbeStatusColor(_1?_2:_3)": function (_0, _1, _2, _3) {
	      return _0.getGpProbeStatusColor(_1 ? _2 : _3);
	    },
	    "[\"Set as location for the next test\",\"right\"]": function () {
	      return ["Set as location for the next test", "right"];
	    },
	    "[_0.setProbeAsLocation(_1)]": function (_0, _1) {
	      return [_0.setProbeAsLocation(_1)];
	    },
	    "[(\"\"+(_0)),\"top\",true]": function (_0) {
	      return ["" + _0, "top", true];
	    },
	    "_0&&!_1": function (_0, _1) {
	      return _0 && !_1;
	    },
	    "_0.formatTimingValue(_1)": function (_0, _1) {
	      return _0.formatTimingValue(_1);
	    },
	    "_0!==_1": function (_0, _1) {
	      return _0 !== _1;
	    },
	    "!_0": function (_0) {
	      return !_0;
	    },
	    "_0&&_1!==_4&&_2!==_4&&_3!==_4": function (_0, _1, _2, _3, _4) {
	      return _0 && _1 !== _4 && _2 !== _4 && _3 !== _4;
	    },
	    "_0(_1)": function (_0, _1) {
	      return _0(_1);
	    },
	    "_0.createGraph(_1)": function (_0, _1) {
	      return _0.createGraph(_1);
	    },
	    "typeof _0!==\"undefined\"&&_1": function (_0, _1) {
	      return typeof _0 !== "undefined" && _1;
	    }
	  }
	};
	component$w.exports.components = {
	  "c-placeholder-skeleton": placeholderSkeleton,
	  "c-gp-results-share": gpResultsShare
	};
	var gpResultsTableOutput = ractive__default["default"].extend(component$w.exports);

	var component$v = {
	  exports: {}
	};
	component$v.exports = {
	  data() {
	    return {
	      _
	    };
	  },
	  computed: {
	    placement() {
	      return this.get('screenWidth') >= 1200 ? 'right' : 'top';
	    },
	    template() {
	      return `<div class="popover ${this.get('tls.authorized') ? '' : 'popover-danger'}" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>`;
	    }
	  },
	  onrender() {
	    if (!ractive__default["default"].isServer) {
	      this.observe('placement', (newValue, oldValue) => {
	        if (oldValue) {
	          $(this.find('button')).popover('destroy');
	        }
	        setTimeout(() => {
	          let button = this.find('button');
	          let closeHandler = e => {
	            if (e.target !== button && $(e.target).closest('.popover').length === 0) {
	              button.click();
	            }
	          };
	          let unbind = () => {
	            $(document).off('click', closeHandler);
	            $(document).off('resize', closeHandler);
	            $('.c-gp-results-raw-output_list').off('scroll', closeHandler);
	          };
	          $(button).on('show.bs.popover', () => {
	            $(document).on('click', closeHandler);
	            $(document).on('resize', closeHandler);
	            $('.c-gp-results-raw-output_list').on('scroll', closeHandler);
	          }).on('hide.bs.popover', unbind);
	          this.on('unrender', unbind);
	        }, 600);
	      }, {
	        defer: true
	      });
	    }
	  },
	  ondetach() {
	    if (!ractive__default["default"].isServer) {
	      $(this.find('button')).popover('destroy');
	    }
	  },
	  togglePopover() {
	    $(this.find('button')).popover({
	      placement: this.get('placement'),
	      template: this.get('template')
	    }).popover('toggle');
	  },
	  getTlsString(tls) {
	    return `
				<table class="table tls-table" style="margin-bottom: 0; overflow-wrap: anywhere;">
					${tls.authorized ? '' : `<tr style="color: #eb3333;">
						<th>Error</th>
						<td>${tls.error}</td>
					</tr>`}
					<tr>
						<th style="min-width: 86px;">Subject</th>
						<td>${tls.subject.CN}; ${tls.subject.alt}</td>
					</tr>
					<tr>
						<th>Issuer</th>
						<td>${tls.issuer.CN}; ${tls.issuer.O}; ${tls.issuer.C}</td>
					</tr>
					<tr>
						<th>Validity</th>
						<td>${_.formatDateTime(tls.createdAt)}; ${_.formatDateTime(tls.expiresAt)}</td>
					</tr>
					<tr>
						<th>Serial number</th>
						<td>${tls.serialNumber}</td>
					</tr>
					<tr>
						<th>Fingerprint</th>
						<td>${tls.fingerprint256}</td>
					</tr>
					<tr>
						<th>Key type</th>
						<td>${tls.keyType}${tls.keyBits}</td>
					</tr>
				</table>
			`;
	  }
	};
	component$v.exports.template = {
	  v: 4,
	  t: [{
	    t: 4,
	    f: [{
	      t: 7,
	      e: "button",
	      m: [{
	        n: "type",
	        f: "button",
	        t: 13,
	        g: 1
	      }, {
	        n: ["click"],
	        t: 70,
	        f: {
	          r: ["@this"],
	          s: "[_0.togglePopover()]"
	        }
	      }, {
	        n: "class",
	        f: ["btn ", {
	          t: 4,
	          f: ["btn-outline-danger"],
	          n: 51,
	          r: "tls.authorized"
	        }],
	        t: 13
	      }, {
	        n: "title",
	        f: [{
	          t: 2,
	          r: "tls.protocol"
	        }, " - ", {
	          t: 2,
	          r: "tls.cipherName"
	        }],
	        t: 13
	      }, {
	        n: "data-content",
	        f: [{
	          t: 2,
	          x: {
	            r: ["@this", "tls"],
	            s: "_0.getTlsString(_1)"
	          }
	        }],
	        t: 13
	      }, {
	        n: "data-html",
	        f: "true",
	        t: 13,
	        g: 1
	      }, {
	        n: "data-container",
	        f: ".c-gp-results-raw-output_list",
	        t: 13,
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "i",
	        m: [{
	          n: "class",
	          f: ["fa ", {
	            t: 4,
	            f: ["fa-lock"],
	            n: 50,
	            r: "tls.authorized"
	          }, {
	            t: 4,
	            f: ["fa-exclamation-triangle"],
	            n: 51,
	            l: 1
	          }],
	          t: 13
	        }, {
	          n: "aria-hidden",
	          f: "true",
	          t: 13,
	          g: 1
	        }]
	      }, " TLS details"]
	    }],
	    n: 50,
	    r: "tls"
	  }],
	  e: {
	    "[_0.togglePopover()]": function (_0) {
	      return [_0.togglePopover()];
	    },
	    "_0.getTlsString(_1)": function (_0, _1) {
	      return _0.getTlsString(_1);
	    }
	  }
	};
	var gpTlsDetails = ractive__default["default"].extend(component$v.exports);

	var component$u = {
	  exports: {}
	};
	const PROBE_STATUS_FAILED$1 = _.getProbeStatusFailedValue();
	const PROBE_STATUS_OFFLINE$2 = _.getProbeStatusOfflineValue();
	component$u.exports = {
	  decorators: {
	    tooltip
	  },
	  data() {
	    return {
	      _,
	      hiddenTestResults: [],
	      PROBE_STATUS_FAILED: PROBE_STATUS_FAILED$1,
	      PROBE_STATUS_OFFLINE: PROBE_STATUS_OFFLINE$2
	    };
	  },
	  onrender() {
	    if (!ractive__default["default"].isServer) {
	      // open result under specific index when scrool to this element from the parent called
	      this.observe('scrolledToResIdx', scrolledToResIdx => {
	        if (scrolledToResIdx === null) {
	          return;
	        }
	        let hiddenTestResults = this.get('hiddenTestResults');
	        if (hiddenTestResults.includes(scrolledToResIdx)) {
	          this.hideShowTestResult(scrolledToResIdx);
	        }
	        this.set('scrolledToResIdx', null);
	      }, {
	        init: false
	      });
	      this.observe('preparedTestResults', preparedTestResults => {
	        // set results block height based on content
	        this.setResultsBlockHeight(preparedTestResults);
	      });
	    }
	  },
	  hideShowTestResult(idx) {
	    let hiddenTestResults = this.get('hiddenTestResults');
	    if (hiddenTestResults.includes(idx)) {
	      hiddenTestResults.splice(hiddenTestResults.indexOf(idx), 1);
	    } else {
	      hiddenTestResults.push(idx);
	    }
	    this.set('hiddenTestResults', hiddenTestResults);
	  },
	  setResultsBlockHeight(results) {
	    requestAnimationFrame(() => {
	      let listEl = document.querySelector('.c-gp-results-raw-output_list');
	      if (listEl) {
	        let itemsAmount = results.length;
	        let listElScrollHeight = listEl.scrollHeight;
	        let avgItemElHeight = Math.round(listElScrollHeight / itemsAmount);
	        listEl.style.height = `${itemsAmount < 3 ? avgItemElHeight * itemsAmount : avgItemElHeight * 3}px`;
	      }
	    });
	  },
	  setProbeAsLocation(probeData) {
	    this.set('currSearchLocation', `AS${probeData.asn}+${probeData.city}`);
	  },
	  getTimingValueToDisplay(data, activeTargetIdx) {
	    let {
	      avgTiming,
	      isFailed,
	      isOffline,
	      areTimingsReady
	    } = data.statsPerTarget[activeTargetIdx];
	    if (isFailed) {
	      return PROBE_STATUS_FAILED$1;
	    } else if (isOffline) {
	      return PROBE_STATUS_OFFLINE$2;
	    } else if (typeof avgTiming === 'number') {
	      return `${Math.round(avgTiming)} ms`;
	    } else if (areTimingsReady) {
	      return avgTiming;
	    }
	  }
	};
	component$u.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "div",
	    m: [{
	      t: 13,
	      n: "class",
	      f: "c-gp-results-raw-output",
	      g: 1
	    }],
	    f: [{
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "c-gp-results-raw-output_list",
	        g: 1
	      }],
	      f: [{
	        t: 4,
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "c-gp-results-raw-output_list_item_top-wrapper",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "c-gp-results-raw-output_list_item_inner-wrapper",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "c-gp-results-raw-output_list_item",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "c-gp-results-raw-output_list_item_header",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "span",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "c-gp-results-raw-output_list_item_header_info",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "span",
	                    f: [{
	                      t: 7,
	                      e: "img",
	                      m: [{
	                        n: "width",
	                        f: "28",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "height",
	                        f: "20",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "src",
	                        f: ["https://cdn.jsdelivr.net/npm/country-flag-icons@1.5.5/3x2/", {
	                          t: 2,
	                          r: "./country"
	                        }, ".svg"],
	                        t: 13
	                      }]
	                    }, " ", {
	                      t: 2,
	                      r: "./city"
	                    }, ", ", {
	                      t: 2,
	                      r: "./country"
	                    }, ", ", {
	                      t: 2,
	                      r: "./continent"
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "span",
	                    f: [" - "]
	                  }, " ", {
	                    t: 7,
	                    e: "span",
	                    f: [{
	                      t: 2,
	                      r: "./network"
	                    }, " (AS", {
	                      t: 2,
	                      r: "./asn"
	                    }, ")"]
	                  }]
	                }, " ", {
	                  t: 4,
	                  f: [{
	                    t: 7,
	                    e: "span",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "c-gp-results-raw-output_list_item_header_time main-value",
	                      g: 1
	                    }],
	                    f: [{
	                      t: 7,
	                      e: "img",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "c-gp-results-raw-output_list_item_header_time_dot-icon",
	                        g: 1
	                      }, {
	                        n: "width",
	                        f: "4",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "height",
	                        f: "4",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "src",
	                        f: [{
	                          t: 2,
	                          r: "@shared.assetsHost"
	                        }, "/img/globalping/dot-icon.svg"],
	                        t: 13
	                      }]
	                    }, " ", {
	                      t: 7,
	                      e: "span",
	                      f: ["Time:"]
	                    }, " ", {
	                      t: 7,
	                      e: "span",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "c-gp-results-raw-output_list_item_header_time_value",
	                        g: 1
	                      }],
	                      f: [{
	                        t: 2,
	                        x: {
	                          r: ["@this", ".", "activeTargetIdx"],
	                          s: "_0.getTimingValueToDisplay(_1,_2)"
	                        }
	                      }]
	                    }]
	                  }],
	                  n: 50,
	                  x: {
	                    r: ["@this", ".", "activeTargetIdx"],
	                    s: "_0.getTimingValueToDisplay(_1,_2)"
	                  }
	                }, " ", {
	                  t: 4,
	                  f: [{
	                    t: 4,
	                    f: [{
	                      t: 7,
	                      e: "span",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "c-gp-results-raw-output_list_item_header_time",
	                        g: 1
	                      }],
	                      f: [{
	                        t: 7,
	                        e: "span",
	                        f: [{
	                          t: 2,
	                          r: "./text"
	                        }, ":"]
	                      }, " ", {
	                        t: 7,
	                        e: "span",
	                        m: [{
	                          t: 13,
	                          n: "class",
	                          f: "c-gp-results-raw-output_list_item_header_time_value",
	                          g: 1
	                        }],
	                        f: [{
	                          t: 2,
	                          r: "./value"
	                        }, {
	                          t: 2,
	                          r: "./units"
	                        }]
	                      }]
	                    }],
	                    n: 52,
	                    rx: {
	                      r: "./statsPerTarget",
	                      m: [{
	                        t: 30,
	                        n: "activeTargetIdx"
	                      }, "extraValues"]
	                    }
	                  }],
	                  n: 51,
	                  x: {
	                    r: ["activeTargetIdx", "./statsPerTarget", "PROBE_STATUS_OFFLINE"],
	                    s: "_1[_0].isFailed||_1[_0].avgTiming===_2"
	                  }
	                }, " ", {
	                  t: 7,
	                  e: "c-gp-tls-details",
	                  m: [{
	                    n: "tls",
	                    f: [{
	                      t: 2,
	                      rx: {
	                        r: "./statsPerTarget",
	                        m: [{
	                          t: 30,
	                          n: "activeTargetIdx"
	                        }, "tls"]
	                      }
	                    }],
	                    t: 13
	                  }, {
	                    n: "screenWidth",
	                    f: [{
	                      t: 2,
	                      r: "screenWidth"
	                    }],
	                    t: 13
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "img",
	                  m: [{
	                    n: ["click"],
	                    t: 70,
	                    f: {
	                      r: ["@this", "idx"],
	                      s: "[_0.hideShowTestResult(_1)]"
	                    }
	                  }, {
	                    n: "class",
	                    f: ["c-gp-results-raw-output_list_item_header_dropdown-icon ", {
	                      t: 4,
	                      f: ["upside-down"],
	                      n: 50,
	                      x: {
	                        r: ["hiddenTestResults", "idx"],
	                        s: "_0.includes(_1)"
	                      }
	                    }],
	                    t: 13
	                  }, {
	                    n: "width",
	                    f: "24",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "24",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "src",
	                    f: [{
	                      t: 2,
	                      r: "@shared.assetsHost"
	                    }, "/img/globalping/chevron-up-icon.svg"],
	                    t: 13
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "c-gp-results-raw-output_list_item_status-line",
	                    g: 1
	                  }, {
	                    n: "style",
	                    f: ["background-color: ", {
	                      t: 2,
	                      x: {
	                        r: ["_", "activeTargetIdx", "./statsPerTarget", "testReqParams.type"],
	                        s: "_0.getGpProbeStatusColor(_2[_1].avgTiming,_3===\"http\"?1000:200)||\"\""
	                      }
	                    }],
	                    t: 13
	                  }],
	                  f: []
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "c-gp-results-raw-output_list_item_top-wrapper_actions",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "div",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "c-gp-results-raw-output_list_item_top-wrapper_actions_btn",
	                      g: 1
	                    }, {
	                      n: "tooltip",
	                      t: 71,
	                      f: {
	                        r: [],
	                        s: "[\"Set as location for the next test\",\"right\"]"
	                      }
	                    }, {
	                      n: ["click"],
	                      t: 70,
	                      f: {
	                        r: ["@this", "."],
	                        s: "[_0.setProbeAsLocation(_1)]"
	                      }
	                    }],
	                    f: [{
	                      t: 7,
	                      e: "i",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "fa fa-map-marker",
	                        g: 1
	                      }, {
	                        n: "aria-hidden",
	                        f: "true",
	                        t: 13,
	                        g: 1
	                      }]
	                    }]
	                  }]
	                }]
	              }, " ", {
	                t: 7,
	                e: "pre",
	                m: [{
	                  n: "class",
	                  f: [{
	                    t: 4,
	                    f: ["hidden"],
	                    n: 50,
	                    x: {
	                      r: ["hiddenTestResults", "idx"],
	                      s: "_0.includes(_1)"
	                    }
	                  }],
	                  t: 13
	                }],
	                f: [{
	                  t: 2,
	                  rx: {
	                    r: "./statsPerTarget",
	                    m: [{
	                      t: 30,
	                      n: "activeTargetIdx"
	                    }, "rawOutput"]
	                  }
	                }]
	              }, " ", {
	                t: 4,
	                f: [{
	                  t: 7,
	                  e: "pre",
	                  m: [{
	                    n: "class",
	                    f: [{
	                      t: 4,
	                      f: ["hidden"],
	                      n: 50,
	                      x: {
	                        r: ["hiddenTestResults", "idx"],
	                        s: "_0.includes(_1)"
	                      }
	                    }],
	                    t: 13
	                  }],
	                  f: [{
	                    t: 2,
	                    rx: {
	                      r: "./statsPerTarget",
	                      m: [{
	                        t: 30,
	                        n: "activeTargetIdx"
	                      }, "rawFooter"]
	                    }
	                  }]
	                }],
	                n: 50,
	                x: {
	                  r: ["testInProgress", "isInfiniteModeRes"],
	                  s: "_0===false&&_1"
	                }
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "style",
	                f: "position: relative;",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "c-gp-results-raw-output_list_item_inner-wrapper_bottom-line",
	                  g: 1
	                }]
	              }]
	            }]
	          }]
	        }],
	        n: 52,
	        i: "idx",
	        r: "preparedTestResults"
	      }]
	    }, " ", {
	      t: 4,
	      f: [{
	        t: 7,
	        e: "c-gp-results-share",
	        m: [{
	          n: "testReqParams",
	          f: [{
	            t: 2,
	            r: "testReqParams"
	          }],
	          t: 13
	        }, {
	          n: "measurementsMetadata",
	          f: [{
	            t: 2,
	            r: "measurementsMetadata"
	          }],
	          t: 13
	        }, {
	          n: "isInfiniteModeRes",
	          f: [{
	            t: 2,
	            r: "isInfiniteModeRes"
	          }],
	          t: 13
	        }, {
	          n: "testInProgress",
	          f: [{
	            t: 2,
	            r: "testInProgress"
	          }],
	          t: 13
	        }],
	        f: []
	      }],
	      n: 50,
	      x: {
	        r: ["testReqParams.id", "testInProgress"],
	        s: "_0&&!_1"
	      }
	    }]
	  }],
	  e: {
	    "_0.getTimingValueToDisplay(_1,_2)": function (_0, _1, _2) {
	      return _0.getTimingValueToDisplay(_1, _2);
	    },
	    "_1[_0].isFailed||_1[_0].avgTiming===_2": function (_0, _1, _2) {
	      return _1[_0].isFailed || _1[_0].avgTiming === _2;
	    },
	    "[_0.hideShowTestResult(_1)]": function (_0, _1) {
	      return [_0.hideShowTestResult(_1)];
	    },
	    "_0.includes(_1)": function (_0, _1) {
	      return _0.includes(_1);
	    },
	    "_0.getGpProbeStatusColor(_2[_1].avgTiming,_3===\"http\"?1000:200)||\"\"": function (_0, _1, _2, _3) {
	      return _0.getGpProbeStatusColor(_2[_1].avgTiming, _3 === "http" ? 1000 : 200) || "";
	    },
	    "[\"Set as location for the next test\",\"right\"]": function () {
	      return ["Set as location for the next test", "right"];
	    },
	    "[_0.setProbeAsLocation(_1)]": function (_0, _1) {
	      return [_0.setProbeAsLocation(_1)];
	    },
	    "_0===false&&_1": function (_0, _1) {
	      return _0 === false && _1;
	    },
	    "_0&&!_1": function (_0, _1) {
	      return _0 && !_1;
	    }
	  }
	};
	component$u.exports.components = {
	  "c-gp-tls-details": gpTlsDetails,
	  "c-gp-results-share": gpResultsShare
	};
	var gpResultsRawOutput = ractive__default["default"].extend(component$u.exports);

	var component$t = {
	  exports: {}
	};
	component$t.exports = {
	  handleTabSwitch(idx) {
	    let isRawOutputMode = this.get('rawOutputMode');
	    if (isRawOutputMode) {
	      this.set('activeTargetIdx', idx);
	    }
	  },
	  handleOutputModeSwitch() {
	    let rawOutputMode = this.get('rawOutputMode');
	    let testType = this.get('testType');
	    if (testType === 'ping') {
	      this.set('rawOutputMode', !rawOutputMode);
	    }
	  }
	};
	component$t.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "div",
	    m: [{
	      t: 13,
	      n: "class",
	      f: "c-gp-results-controls",
	      g: 1
	    }],
	    f: [{
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "content-wrapper",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          n: "class",
	          f: ["content-wrapper_tabs ", {
	            t: 4,
	            f: ["single-target"],
	            n: 50,
	            x: {
	              r: ["targets", "targets.length"],
	              s: "_0&&_1===1"
	            }
	          }, " ", {
	            t: 4,
	            f: ["table-mode"],
	            n: 51,
	            r: "rawOutputMode"
	          }],
	          t: 13
	        }],
	        f: [{
	          t: 4,
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              n: ["click"],
	              t: 70,
	              f: {
	                r: ["@this", "idx"],
	                s: "[_0.handleTabSwitch(_1)]"
	              }
	            }, {
	              n: "class",
	              f: ["content-wrapper_tabs_tab ", {
	                t: 4,
	                f: ["active"],
	                n: 50,
	                x: {
	                  r: ["idx", "activeTargetIdx", "rawOutputMode"],
	                  s: "_0===_1&&_2"
	                }
	              }, " ", {
	                t: 4,
	                f: ["disabled"],
	                n: 51,
	                r: "rawOutputMode"
	              }],
	              t: 13
	            }],
	            f: [{
	              t: 7,
	              e: "span",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "content-wrapper_tabs_tab_text",
	                g: 1
	              }],
	              f: [{
	                t: 2,
	                r: "."
	              }]
	            }, " ", {
	              t: 7,
	              e: "span",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "active-tab-bar",
	                g: 1
	              }]
	            }]
	          }],
	          n: 52,
	          i: "idx",
	          r: "targets"
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "content-wrapper_ctrls",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "content-wrapper_ctrls_display-settings",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "span",
	            f: ["Display settings:"]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "content-wrapper_ctrls_display-settings_switch",
	              g: 1
	            }, {
	              n: ["click"],
	              t: 70,
	              f: {
	                r: ["@this"],
	                s: "[_0.handleOutputModeSwitch()]"
	              }
	            }],
	            f: [{
	              t: 7,
	              e: "img",
	              m: [{
	                n: "width",
	                f: "16",
	                t: 13,
	                g: 1
	              }, {
	                n: "height",
	                f: "16",
	                t: 13,
	                g: 1
	              }, {
	                n: "src",
	                f: [{
	                  t: 2,
	                  r: "@shared.assetsHost"
	                }, "/img/globalping/raw-output-icon", {
	                  t: 4,
	                  f: [".active"],
	                  n: 50,
	                  r: "rawOutputMode"
	                }, ".svg"],
	                t: 13
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "content-wrapper_ctrls_display-settings_switch_line",
	                g: 1
	              }]
	            }, " ", {
	              t: 7,
	              e: "img",
	              m: [{
	                n: "width",
	                f: "16",
	                t: 13,
	                g: 1
	              }, {
	                n: "height",
	                f: "16",
	                t: 13,
	                g: 1
	              }, {
	                n: "src",
	                f: [{
	                  t: 2,
	                  r: "@shared.assetsHost"
	                }, "/img/globalping/table-output-icon", {
	                  t: 4,
	                  f: [".active"],
	                  n: 51,
	                  r: "rawOutputMode"
	                }, ".svg"],
	                t: 13
	              }, {
	                t: 4,
	                f: [{
	                  n: "style",
	                  f: "opacity: 0.5; cursor: not-allowed;",
	                  t: 13
	                }],
	                n: 50,
	                x: {
	                  r: ["testType"],
	                  s: "_0!==\"ping\""
	                }
	              }]
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "content-wrapper_ctrls_map-switch",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "span",
	            f: ["Map:"]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "content-wrapper_ctrls_map-switch_switch",
	              g: 1
	            }, {
	              n: ["click"],
	              t: 70,
	              f: {
	                r: ["@this", "showMap"],
	                s: "[_0.set(\"originalShowMap\",!_1),_0.set(\"showMap\",!_1)]"
	              }
	            }],
	            f: [{
	              t: 7,
	              e: "img",
	              m: [{
	                n: "width",
	                f: "16",
	                t: 13,
	                g: 1
	              }, {
	                n: "height",
	                f: "16",
	                t: 13,
	                g: 1
	              }, {
	                n: "src",
	                f: [{
	                  t: 2,
	                  r: "@shared.assetsHost"
	                }, "/img/globalping/map-icon", {
	                  t: 4,
	                  f: [".active"],
	                  n: 50,
	                  r: "showMap"
	                }, ".svg"],
	                t: 13
	              }]
	            }]
	          }]
	        }]
	      }]
	    }]
	  }],
	  e: {
	    "_0&&_1===1": function (_0, _1) {
	      return _0 && _1 === 1;
	    },
	    "[_0.handleTabSwitch(_1)]": function (_0, _1) {
	      return [_0.handleTabSwitch(_1)];
	    },
	    "_0===_1&&_2": function (_0, _1, _2) {
	      return _0 === _1 && _2;
	    },
	    "[_0.handleOutputModeSwitch()]": function (_0) {
	      return [_0.handleOutputModeSwitch()];
	    },
	    "_0!==\"ping\"": function (_0) {
	      return _0 !== "ping";
	    },
	    "[_0.set(\"originalShowMap\",!_1),_0.set(\"showMap\",!_1)]": function (_0, _1) {
	      return [_0.set("originalShowMap", !_1), _0.set("showMap", !_1)];
	    }
	  }
	};
	var gpResultsControls = ractive__default["default"].extend(component$t.exports);

	// MIT licensed from https://www.npmjs.com/package/ip-regex
	const word = '[a-fA-F\\d:]';
	const boundry = options => options && options.includeBoundaries ? `(?:(?<=\\s|^)(?=${word})|(?<=${word})(?=\\s|$))` : '';
	const v4 = '(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}';
	const v6segment = '[a-fA-F\\d]{1,4}';
	const v6 = `
(?:
(?:${v6segment}:){7}(?:${v6segment}|:)|                                    // 1:2:3:4:5:6:7::  1:2:3:4:5:6:7:8
(?:${v6segment}:){6}(?:${v4}|:${v6segment}|:)|                             // 1:2:3:4:5:6::    1:2:3:4:5:6::8   1:2:3:4:5:6::8  1:2:3:4:5:6::1.2.3.4
(?:${v6segment}:){5}(?::${v4}|(?::${v6segment}){1,2}|:)|                   // 1:2:3:4:5::      1:2:3:4:5::7:8   1:2:3:4:5::8    1:2:3:4:5::7:1.2.3.4
(?:${v6segment}:){4}(?:(?::${v6segment}){0,1}:${v4}|(?::${v6segment}){1,3}|:)| // 1:2:3:4::        1:2:3:4::6:7:8   1:2:3:4::8      1:2:3:4::6:7:1.2.3.4
(?:${v6segment}:){3}(?:(?::${v6segment}){0,2}:${v4}|(?::${v6segment}){1,4}|:)| // 1:2:3::          1:2:3::5:6:7:8   1:2:3::8        1:2:3::5:6:7:1.2.3.4
(?:${v6segment}:){2}(?:(?::${v6segment}){0,3}:${v4}|(?::${v6segment}){1,5}|:)| // 1:2::            1:2::4:5:6:7:8   1:2::8          1:2::4:5:6:7:1.2.3.4
(?:${v6segment}:){1}(?:(?::${v6segment}){0,4}:${v4}|(?::${v6segment}){1,6}|:)| // 1::              1::3:4:5:6:7:8   1::8            1::3:4:5:6:7:1.2.3.4
(?::(?:(?::${v6segment}){0,5}:${v4}|(?::${v6segment}){1,7}|:))             // ::2:3:4:5:6:7:8  ::2:3:4:5:6:7:8  ::8             ::1.2.3.4
)(?:%[0-9a-zA-Z]{1,})?                                             // %eth0            %1
`.replace(/\s*\/\/.*$/gm, '').replace(/\n/g, '').trim();

	// Pre-compile only the exact regexes because adding a global flag make regexes stateful
	const v46Exact = new RegExp(`(?:^${v4}$)|(?:^${v6}$)`);
	const v4exact = new RegExp(`^${v4}$`);
	const v6exact = new RegExp(`^${v6}$`);
	const ipRegex = options => options && options.exact ? v46Exact : new RegExp(`(?:${boundry(options)}${v4}${boundry(options)})|(?:${boundry(options)}${v6}${boundry(options)})`, 'g');
	ipRegex.v4 = options => options && options.exact ? v4exact : new RegExp(`${boundry(options)}${v4}${boundry(options)}`, 'g');
	ipRegex.v6 = options => options && options.exact ? v6exact : new RegExp(`${boundry(options)}${v6}${boundry(options)}`, 'g');
	var ipRegex_1 = ipRegex;

	var debounce = function (fn) {
	  let wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
	  let timeout;
	  return function () {
	    clearTimeout(timeout);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    timeout = setTimeout(fn, wait, ...args);
	  };
	};

	var throttle = function (fn) {
	  let wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
	  let lastCalled, timeout;
	  return function () {
	    let now = Date.now();
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    if (lastCalled && now - lastCalled < wait) {
	      clearTimeout(timeout);
	      return timeout = setTimeout(fn, wait - (now - lastCalled), ...args);
	    }
	    lastCalled = now;
	    clearTimeout(timeout);
	    fn(...args);
	  };
	};

	const addManagedListener = (component, target, event, handler) => {
	  if (!target || typeof target.addEventListener !== 'function' || typeof target.removeEventListener !== 'function') {
	    console.warn('Invalid target passed to addManagedListener');
	    return;
	  }
	  target.addEventListener(event, handler);
	  if (!component || typeof component.on !== 'function') {
	    console.warn('Invalid component passed to addManagedListener');
	    return;
	  }
	  component.on('unrender', () => {
	    target.removeEventListener(event, handler);
	  });
	};
	var addManagedListener_1 = addManagedListener;
	var screenWidthListener = component => {
	  component.set('screenWidth', window.innerWidth);
	  addManagedListener(component, window, 'resize', debounce(throttle(() => component.set('screenWidth', window.innerWidth), 200)));
	};
	var stickySidebarScrollListener = component => {
	  let sidebar = document.querySelector('.page-content_side-menu');
	  if (sidebar) {
	    let top = sidebar.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop);
	    let handleStickySidebarScroll = () => {
	      let y = document.scrollingElement.scrollTop;
	      let currentSidebarTop = sidebar.getBoundingClientRect().top;
	      if (currentSidebarTop <= 20 && currentSidebarTop >= 0 || y > top) {
	        sidebar.setAttribute('style', 'position: sticky; top: 20px');
	      } else {
	        sidebar.removeAttribute('style');
	      }
	    };
	    addManagedListener(component, window, 'scroll', handleStickySidebarScroll);
	    handleStickySidebarScroll();
	  }
	};
	var listeners = {
	  addManagedListener: addManagedListener_1,
	  screenWidthListener: screenWidthListener,
	  stickySidebarScrollListener: stickySidebarScrollListener
	};

	var component$s = {
	  exports: {}
	};
	const IP_V4_VALUE = 4;
	const IP_V6_VALUE = 6;
	component$s.exports = {
	  decorators: {
	    tooltip
	  },
	  data() {
	    return {
	      invalidValue: null,
	      errMsgTopPos: false,
	      inputValue: '',
	      inputWrapperIdPrefix: 'tags-block-',
	      valuesDelimiter: ',',
	      maxTagsAllowed: 2,
	      tagsArr: [],
	      isDisabled: false,
	      useGpTargetHandler: false,
	      // ipVersion should be set only for 1 target when it is a domain name
	      ipVersion: null,
	      ipVersionDisplayed: null,
	      ipSwitchLocked: false,
	      IP_V4_VALUE,
	      IP_V6_VALUE
	    };
	  },
	  oninit() {
	    if (!ractive__default["default"].isServer) {
	      this.observe('error', error => {
	        if (error) {
	          this.set('invalidValue', this.get('value'));
	          this.set('ipVersion', null);
	          this.set('ipVersionDisplayed', null);
	        } else {
	          let tagsArr = this.get('tagsArr');
	          this.handleIpSwitchState(tagsArr[0]);
	        }
	      }, {
	        init: false
	      });
	      this.observe('value', value => {
	        let invalidValue = this.get('invalidValue');
	        let error = this.get('error');
	        if (error && invalidValue !== value) {
	          this.set('error', undefined);
	        }
	      });
	      this.observe('screenWidth', screenWidth => {
	        if ((screenWidth || window.innerWidth) < 768) {
	          this.set('errMsgTopPos', true);
	        } else {
	          this.set('errMsgTopPos', false);
	        }
	      });
	      this.observe('value', value => {
	        let valuesDelimiter = this.get('valuesDelimiter');
	        this.set('tagsArr', value ? value.split(valuesDelimiter) : []);
	      });

	      // handle ip type switch
	      this.observe('tagsArr', tagsArr => {
	        let currIpVersionDisplayed = this.get('ipVersionDisplayed');
	        if (tagsArr.length > 1) {
	          this.set('ipVersion', null);
	          this.set('ipVersionDisplayed', null);
	          this.set('ipSwitchLocked', true);
	          if (currIpVersionDisplayed) {
	            this.set('prevIpVersionDisplayed', currIpVersionDisplayed);
	          }
	          return;
	        }
	        this.handleIpSwitchState(tagsArr[0]);
	      });

	      // set default value is it was passed as prop
	      this.observe('defaultValue', defaultValue => {
	        let setDefaultValueInitialy = this.get('setDefaultValueInitialy');
	        if (defaultValue && setDefaultValueInitialy) {
	          this.set('value', defaultValue);
	        }
	      });

	      // for share-results case we need to set displayed value
	      this.observe('ipVersion', ipVersion => {
	        this.set('ipVersionDisplayed', ipVersion);
	      });
	    }
	  },
	  onrender() {
	    listeners.screenWidthListener(this);
	  },
	  oncomplete() {
	    if (!ractive__default["default"].isServer) {
	      let inputWrapperIdPrefix = this.get('inputWrapperIdPrefix');
	      let inputId = this.get('inputId');
	      let inputEl = this.find(`#${inputId}`);
	      let ipTypeSwitchEl = this.find('.switch-ip-type-wrapper');
	      let tagsBlockEl = this.find(`#${inputWrapperIdPrefix + inputId}`);

	      // handle input changes
	      inputEl.addEventListener('keydown', e => {
	        let currMaxTagsAllowed = this.get('maxTagsAllowed');
	        let currTagsArr = this.get('tagsArr');
	        let inputValue = this.get('inputValue');
	        let defaultValue = this.get('defaultValue');
	        if (this.get('isDisabled')) {
	          e.preventDefault();
	          return;
	        }

	        // while there are already max tags and key is not Backspace - ignore input changes
	        if (currTagsArr.length === currMaxTagsAllowed && e.key !== 'Tab' && e.key !== 'Backspace' && e.key !== 'Enter') {
	          e.preventDefault();
	          return;
	        }

	        // if input has some value which is not added as tag yet - add tag on Enter/Tab, on second Enter/Tab run measurement/switch to the next field
	        // if user did not passed any value, on Enter add default one, if presented, and run measurement
	        // handle keys for adding new tags, removing tags, allow to bubble event on Enter key etc.
	        if (['Enter', 'Tab'].includes(e.key) && !inputValue) {
	          if (defaultValue && currTagsArr.length === 0) {
	            this.set('value', defaultValue);
	          }
	          tagsBlockEl.classList.remove('focused');
	        } else if (['Enter', 'Tab', ' ', ','].includes(e.key)) {
	          this.addTag();

	          // Prevent Enter always and Tab when only 1 target is filled
	          if (e.key === 'Enter') {
	            e.preventDefault();
	          }
	          if (e.key === 'Tab') {
	            if (currTagsArr.length < currMaxTagsAllowed) {
	              e.preventDefault();
	            } else {
	              tagsBlockEl.classList.remove('focused');
	            }
	          }
	        } else if (e.key === 'Backspace') {
	          this.removeLastTag();
	        }
	      });

	      // on focusout add the content of the input as a tag if it matches conditions
	      inputEl.addEventListener('focusout', () => {
	        let inputValue = this.get('inputValue');
	        let tagsArr = this.get('tagsArr');
	        let defaultValue = this.get('defaultValue');

	        // set default value if user did not fill in something and focusout
	        if (defaultValue && !inputValue && tagsArr.length === 0) {
	          this.set('value', defaultValue);
	        } else {
	          this.addTag();
	        }
	      });

	      // handle focus styles
	      tagsBlockEl.addEventListener('click', e => {
	        let switchIpTypeEl = this.find('.switch-ip-type-wrapper');
	        if (!switchIpTypeEl.contains(e.target)) {
	          this.handleInputFocus(tagsBlockEl);
	        }
	      });
	      inputEl.addEventListener('focus', () => {
	        this.handleInputFocus(tagsBlockEl);
	      });
	      let handleOnClickOutside = e => {
	        if (e.target.isConnected && !tagsBlockEl.contains(e.target)) {
	          tagsBlockEl.classList.remove('focused');
	        }
	      };
	      listeners.addManagedListener(this, document, 'click', handleOnClickOutside);
	      this.observe('isDisabled', isDisabled => {
	        if (isDisabled) {
	          tagsBlockEl.classList.remove('focused');
	        }
	      });

	      // handle paste event
	      inputEl.addEventListener('paste', event => {
	        event.preventDefault();
	        let rawPasteContent = (event.clipboardData || window.clipboardData).getData('text');
	        let tagsArr = this.get('tagsArr');
	        let valuesDelimiter = this.get('valuesDelimiter');
	        this.handleOptsOnTargetInputFullURL(rawPasteContent, tagsArr, valuesDelimiter);
	      });

	      // toggle IP version switch on SPACE
	      ipTypeSwitchEl.addEventListener('keydown', e => {
	        if ([' '].includes(e.key)) {
	          e.stopPropagation();
	          e.preventDefault();
	          let ipVersion = this.get('ipVersion');
	          let ipVersionDisplayed = this.get('ipVersionDisplayed') || IP_V4_VALUE;
	          let ipSwitchLocked = this.get('ipSwitchLocked');
	          if (!ipSwitchLocked) {
	            this.set('ipVersion', ipVersion === null ? ipVersion : ipVersion === IP_V4_VALUE ? IP_V6_VALUE : IP_V4_VALUE);
	            this.set('ipVersionDisplayed', ipVersionDisplayed === IP_V4_VALUE ? IP_V6_VALUE : IP_V4_VALUE);
	          }
	        }
	      });
	      ipTypeSwitchEl.addEventListener('focus', e => {
	        this.handleIpTypeSwitchFocus(e, tagsBlockEl);
	      });
	    }
	  },
	  addTag() {
	    let clearInput = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	    let maxTagsAllowed = this.get('maxTagsAllowed');
	    let valuesDelimiter = this.get('valuesDelimiter');
	    let inputValue = this.get('inputValue');
	    let tagsArr = this.get('tagsArr');
	    if (tagsArr.length < maxTagsAllowed) {
	      if (!tagsArr.includes(inputValue) && inputValue !== '') {
	        let updTagsArr = [...tagsArr, inputValue];
	        let targetInputValue = updTagsArr.join(valuesDelimiter);
	        if (this.get('useGpTargetHandler')) {
	          this.handleOptsOnTargetInputFullURL(inputValue, tagsArr, valuesDelimiter);
	        } else {
	          this.set('value', targetInputValue);
	        }
	      }

	      // to overwrite inputValues as ',' or '' set by browser we should call it via setTimeout
	      if (clearInput) {
	        setTimeout(() => {
	          this.set('inputValue', '');
	        }, 4);
	      }
	    }
	  },
	  removeLastTag() {
	    let valuesDelimiter = this.get('valuesDelimiter');
	    let inputValue = this.get('inputValue');
	    let tagsArr = this.get('tagsArr');
	    if (inputValue === '') {
	      tagsArr.pop();
	      this.set('value', tagsArr.join(valuesDelimiter));
	    }
	  },
	  removeTagByIdx(tagIdx) {
	    if (this.get('isDisabled')) {
	      return;
	    }
	    let valuesDelimiter = this.get('valuesDelimiter');
	    let tagsArr = this.get('tagsArr');
	    tagsArr.splice(tagIdx, 1);
	    this.set('value', tagsArr.join(valuesDelimiter));

	    // set back focus to the input
	    let inputId = this.get('inputId');
	    let inputEl = this.find(`#${inputId}`);
	    inputEl.focus();
	  },
	  handleInputFocus(tagsBlockEl) {
	    let isDisabled = this.get('isDisabled');
	    let defaultValue = this.get('defaultValue');
	    let currentValue = this.get('value');
	    if (!isDisabled && !tagsBlockEl.classList.contains('focused')) {
	      tagsBlockEl.classList.add('focused');

	      // clear default tag on focus
	      if (defaultValue && currentValue && currentValue === defaultValue) {
	        this.set('value', '');
	      }
	    }
	  },
	  onTagClick(index) {
	    this.addTag(false);
	    this.set('inputValue', this.get('tagsArr')[index]);
	    this.removeTagByIdx(index);
	  },
	  handleOptsOnTargetInputFullURL(url) {
	    let tagsArr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	    let delimiter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	    try {
	      let {
	        protocol,
	        port,
	        pathname,
	        hostname,
	        search
	      } = new URL(url);
	      if (!hostname) {
	        // Just one extra check. The constructor above may throw too.
	        throw new Error('Invalid URL');
	      }
	      this.set('gpMainOpts.type', 'HTTP');
	      this.set('gpMainOpts.target', tagsArr ? [...tagsArr, hostname].join(delimiter) : hostname);
	      this.set('gpHttpOpts.protocol', protocol.replace(':', '').toUpperCase());
	      this.set('gpNotAppliedOpts.port', port);
	      this.set('gpNotAppliedOpts.request.path', pathname !== '/' ? pathname : '');
	      this.set('gpNotAppliedOpts.request.query', search.replace('?', ''));
	      this.set('tagsArr', tagsArr ? [...tagsArr, hostname] : [hostname]);
	    } catch (err) {
	      this.set('gpMainOpts.target', tagsArr ? [...tagsArr, url].join(delimiter) : url);
	      this.set('tagsArr', tagsArr ? [...tagsArr, url] : [url]);
	    } finally {
	      let gpUrlHandlerCb = this.get('gpUrlHandlerCb');
	      gpUrlHandlerCb();
	    }
	  },
	  handleIpVersionSwitch(ipVersion) {
	    let isDisabled = this.get('isDisabled');
	    let ipSwitchLocked = this.get('ipSwitchLocked');
	    if (isDisabled || ipSwitchLocked) {
	      return;
	    }
	    this.set('ipVersion', ipVersion);
	    this.set('ipVersionDisplayed', ipVersion);
	  },
	  handleIpTypeSwitchFocus(e, tagsBlockEl) {
	    tagsBlockEl.classList.remove('focused');
	  },
	  handleIpSwitchState(target) {
	    let ipv4regex = ipRegex_1.v4({
	      exact: true
	    });
	    let ipv6regex = ipRegex_1.v6({
	      exact: true
	    });
	    if (ipv4regex.test(target)) {
	      this.set('ipVersion', null);
	      this.set('ipVersionDisplayed', IP_V4_VALUE);
	      this.set('ipSwitchLocked', true);
	    } else if (ipv6regex.test(target)) {
	      this.set('ipVersion', null);
	      this.set('ipVersionDisplayed', IP_V6_VALUE);
	      this.set('ipSwitchLocked', true);
	    } else {
	      let ipVersionDisplayed = this.get('ipVersionDisplayed') || this.get('prevIpVersionDisplayed') || IP_V4_VALUE;
	      this.set('ipVersion', ipVersionDisplayed);
	      this.set('ipVersionDisplayed', ipVersionDisplayed);
	      this.set('ipSwitchLocked', false);
	    }
	  }
	};
	component$s.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "div",
	    m: [{
	      n: "class",
	      f: ["c-tags-input ", {
	        t: 2,
	        r: "classList"
	      }, " ", {
	        t: 4,
	        f: ["with-input-icon"],
	        n: 50,
	        r: "inputIcon"
	      }, " ", {
	        t: 4,
	        f: ["no-values"],
	        n: 51,
	        r: "value"
	      }, " ", {
	        t: 4,
	        f: ["error"],
	        n: 50,
	        r: "error"
	      }, " ", {
	        t: 4,
	        f: ["disabled"],
	        n: 50,
	        r: "isDisabled"
	      }],
	      t: 13
	    }],
	    f: [{
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "c-tags-input_info",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "span",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "c-tags-input_info_label",
	          g: 1
	        }],
	        f: [{
	          t: 2,
	          r: "labelText"
	        }, " ", {
	          t: 4,
	          f: [{
	            t: 8,
	            r: "labelIcon"
	          }],
	          n: 50,
	          r: "@this.partials.labelIcon"
	        }]
	      }, " ", {
	        t: 4,
	        f: [{
	          t: 7,
	          e: "span",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "c-tags-input_info_errorMsg",
	            g: 1
	          }],
	          f: [{
	            t: 2,
	            r: "error"
	          }]
	        }],
	        n: 50,
	        r: "error"
	      }]
	    }, " ", {
	      t: 7,
	      e: "div",
	      m: [{
	        n: "class",
	        f: ["c-tags-input_tags-block ", {
	          t: 4,
	          f: ["full"],
	          n: 50,
	          x: {
	            r: ["tagsArr", "tagsArr.length", "./maxTagsAllowed"],
	            s: "_0&&_1===_2"
	          }
	        }, " ", {
	          t: 4,
	          f: ["has-error"],
	          n: 50,
	          r: "error"
	        }],
	        t: 13
	      }, {
	        n: "id",
	        f: [{
	          t: 2,
	          x: {
	            r: ["inputWrapperIdPrefix", "inputId"],
	            s: "_0+_1"
	          }
	        }],
	        t: 13
	      }],
	      f: [{
	        t: 4,
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "c-tags-input_tags-block_tags-list",
	            g: 1
	          }],
	          f: [{
	            t: 4,
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "c-tags-input_tags-block_tags-list_tag",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "span",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "c-tags-input_tags-block_tags-list_tag_text",
	                  g: 1
	                }, {
	                  n: ["click"],
	                  t: 70,
	                  f: {
	                    r: ["@this", "tagIdx"],
	                    s: "[_0.onTagClick(_1)]"
	                  }
	                }],
	                f: [{
	                  t: 2,
	                  r: "."
	                }]
	              }, " ", {
	                t: 7,
	                e: "img",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "c-tags-input_tags-block_tags-list_tag_close-icon",
	                  g: 1
	                }, {
	                  n: "width",
	                  f: "16",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "16",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: ["click"],
	                  t: 70,
	                  f: {
	                    r: ["@this", "tagIdx"],
	                    s: "[_0.removeTagByIdx(_1)]"
	                  }
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/globalping/tag-input-close-icon.svg"],
	                  t: 13
	                }]
	              }]
	            }],
	            n: 52,
	            i: "tagIdx",
	            r: "tagsArr"
	          }]
	        }],
	        n: 50,
	        x: {
	          r: ["tagsArr", "tagsArr.length"],
	          s: "_0&&_1"
	        }
	      }, " ", {
	        t: 4,
	        f: [{
	          t: 7,
	          e: "img",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "c-tags-input_input-icon",
	            g: 1
	          }, {
	            n: "width",
	            f: "20",
	            t: 13,
	            g: 1
	          }, {
	            n: "height",
	            f: "20",
	            t: 13,
	            g: 1
	          }, {
	            n: "src",
	            f: [{
	              t: 2,
	              r: "@shared.assetsHost"
	            }, "/img/globalping/", {
	              t: 2,
	              r: "inputIcon"
	            }],
	            t: 13
	          }]
	        }],
	        n: 50,
	        x: {
	          r: ["value", "inputIcon"],
	          s: "!_0&&_1"
	        }
	      }, " ", {
	        t: 4,
	        f: [{
	          t: 7,
	          e: "img",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "c-tags-input_tags-block_err-icon",
	            g: 1
	          }, {
	            n: "width",
	            f: "20",
	            t: 13,
	            g: 1
	          }, {
	            n: "height",
	            f: "20",
	            t: 13,
	            g: 1
	          }, {
	            n: "src",
	            f: [{
	              t: 2,
	              r: "@shared.assetsHost"
	            }, "/img/globalping/alert-icon.svg"],
	            t: 13
	          }]
	        }],
	        n: 50,
	        r: "error"
	      }, " ", {
	        t: 7,
	        e: "input",
	        m: [{
	          n: "id",
	          f: [{
	            t: 2,
	            r: "inputId"
	          }],
	          t: 13
	        }, {
	          n: "value",
	          f: [{
	            t: 2,
	            r: "inputValue"
	          }],
	          t: 13
	        }, {
	          n: "type",
	          f: "text",
	          t: 13
	        }, {
	          n: "placeholder",
	          f: [{
	            t: 2,
	            r: "placeholder"
	          }],
	          t: 13
	        }, {
	          n: "class",
	          f: [{
	            t: 4,
	            f: ["tags-limit"],
	            n: 50,
	            x: {
	              r: ["tagsArr.length", "maxTagsAllowed"],
	              s: "_0>=_1"
	            }
	          }, " ", {
	            t: 4,
	            f: ["disabled-input"],
	            n: 50,
	            r: "isDisabled"
	          }],
	          t: 13
	        }]
	      }, " ", {
	        t: 4,
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            n: "tabindex",
	            f: "0",
	            t: 13,
	            g: 1
	          }, {
	            n: "class",
	            f: ["switch-ip-type-wrapper ", {
	              t: 4,
	              f: ["disabled"],
	              n: 50,
	              r: "isDisabled"
	            }, " ", {
	              t: 4,
	              f: ["hidden"],
	              n: 51,
	              r: "ipVersionDisplayed"
	            }, " ", {
	              t: 4,
	              f: ["locked"],
	              n: 50,
	              r: "ipSwitchLocked"
	            }],
	            t: 13
	          }],
	          f: [{
	            t: 7,
	            e: "input",
	            m: [{
	              n: "id",
	              f: "switch-ip-type",
	              t: 13
	            }, {
	              n: "type",
	              f: "checkbox",
	              t: 13
	            }, {
	              t: 73,
	              v: "t",
	              f: "false"
	            }, {
	              n: "class",
	              f: ["switch-input ", {
	                t: 4,
	                f: ["checked"],
	                n: 51,
	                x: {
	                  r: ["ipVersionDisplayed", "IP_V4_VALUE"],
	                  s: "_0===_1"
	                }
	              }],
	              t: 13
	            }]
	          }, " ", {
	            t: 7,
	            e: "label",
	            m: [{
	              n: "for",
	              f: "switch-ip-type",
	              t: 13,
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "span",
	              m: [{
	                n: ["click"],
	                t: 70,
	                f: {
	                  r: ["@this", "IP_V4_VALUE"],
	                  s: "[_0.handleIpVersionSwitch(_1)]"
	                }
	              }],
	              f: ["IPv4"]
	            }, " ", {
	              t: 7,
	              e: "span",
	              m: [{
	                n: ["click"],
	                t: 70,
	                f: {
	                  r: ["@this", "IP_V6_VALUE"],
	                  s: "[_0.handleIpVersionSwitch(_1)]"
	                }
	              }],
	              f: ["IPv6"]
	            }]
	          }]
	        }],
	        n: 50,
	        r: "showIPSwitch"
	      }]
	    }]
	  }],
	  e: {
	    "_0&&_1===_2": function (_0, _1, _2) {
	      return _0 && _1 === _2;
	    },
	    "_0+_1": function (_0, _1) {
	      return _0 + _1;
	    },
	    "[_0.onTagClick(_1)]": function (_0, _1) {
	      return [_0.onTagClick(_1)];
	    },
	    "[_0.removeTagByIdx(_1)]": function (_0, _1) {
	      return [_0.removeTagByIdx(_1)];
	    },
	    "_0&&_1": function (_0, _1) {
	      return _0 && _1;
	    },
	    "!_0&&_1": function (_0, _1) {
	      return !_0 && _1;
	    },
	    "_0>=_1": function (_0, _1) {
	      return _0 >= _1;
	    },
	    "_0===_1": function (_0, _1) {
	      return _0 === _1;
	    },
	    "[_0.handleIpVersionSwitch(_1)]": function (_0, _1) {
	      return [_0.handleIpVersionSwitch(_1)];
	    }
	  }
	};
	var tagsInput = ractive__default["default"].extend(component$s.exports);

	var component$r = {
	  exports: {}
	};
	const DEFAULT_TEXTAREA_ROWS_AMOUNT = 2;
	component$r.exports = {
	  data() {
	    return {
	      invalidValue: null,
	      errMsgTopPos: false,
	      taRowsAmount: DEFAULT_TEXTAREA_ROWS_AMOUNT,
	      taValue: null
	    };
	  },
	  oninit() {
	    var _this = this;
	    if (!ractive__default["default"].isServer) {
	      this.observeOnce('error', () => {
	        this.set('invalidValue', this.get('value'));
	      }, {
	        init: false
	      });
	      this.observe('value', value => {
	        let invalidValue = this.get('invalidValue');
	        let error = this.get('error');
	        if (error && invalidValue !== value) {
	          this.set('error', undefined);
	        }
	      });
	      this.observe('screenWidth', screenWidth => {
	        if ((screenWidth || window.innerWidth) < 768) {
	          this.set('errMsgTopPos', true);
	        } else {
	          this.set('errMsgTopPos', false);
	        }
	      });

	      // parse passed teaxtarea value (expected input { <any-key>: string }) to taValue
	      this.observe('value', value => {
	        let currTaElCnt = (this.get('taValue') || '').split(/(\r\n|\n|\r)/).filter(Boolean);
	        if (value && Object.keys(value) && currTaElCnt < Object.keys(value).length) {
	          let taValue = Object.keys(value).reduce((str, key) => {
	            return str += `${key}: ${value[key]}\n`;
	          }, '');
	          this.set('taValue', taValue);
	        }
	      });

	      // handle Textarea rows value based on the content
	      this.observe('taValue', function () {
	        let taValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	        if (taValue === null) {
	          return;
	        }
	        let taRowsAmount = DEFAULT_TEXTAREA_ROWS_AMOUNT;
	        let newLines = taValue.match(/(\r\n|\n|\r)/g);
	        if (newLines && newLines.length + 1 >= DEFAULT_TEXTAREA_ROWS_AMOUNT) {
	          taRowsAmount = newLines.length + 2;
	        }
	        _this.set('taRowsAmount', taRowsAmount);
	      });

	      // parse Textarea taValue and set value
	      this.observe('taValue', function () {
	        let taValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	        if (taValue === null) {
	          return;
	        }
	        let rows = taValue.split(/(\r\n|\n|\r)/).filter(Boolean);
	        let parsedHeaders = rows.reduce((res, row) => {
	          let keyValueRegex = /^([^:]+):(.+)$/;
	          let match = row.trim().match(keyValueRegex);
	          if (match) {
	            let key = match[1].trim();
	            let value = match[2].trim();
	            if (key && value) {
	              res[key] = value;
	            }
	          }
	          return res;
	        }, {});
	        _this.set('value', parsedHeaders);
	      });
	    }
	  },
	  onrender() {
	    listeners.screenWidthListener(this);
	  }
	};
	component$r.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "label",
	    m: [{
	      n: "class",
	      f: ["c-controlled-textarea ", {
	        t: 2,
	        r: "classList"
	      }],
	      t: 13
	    }],
	    f: [{
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "c-controlled-textarea_info",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "span",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "c-controlled-textarea_info_label",
	          g: 1
	        }],
	        f: [{
	          t: 2,
	          r: "labelText"
	        }, " ", {
	          t: 4,
	          f: [{
	            t: 8,
	            r: "labelIcon"
	          }],
	          n: 50,
	          x: {
	            r: ["@this.partials.labelIcon", "hideLabelIcon"],
	            s: "_0&&!_1"
	          }
	        }]
	      }, " ", {
	        t: 4,
	        f: [{
	          t: 7,
	          e: "span",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "c-controlled-textarea_info_errorMsg",
	            g: 1
	          }],
	          f: [{
	            t: 2,
	            r: "error"
	          }]
	        }, " ", {
	          t: 7,
	          e: "img",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "c-controlled-textarea_err-icon",
	            g: 1
	          }, {
	            n: "width",
	            f: "20",
	            t: 13,
	            g: 1
	          }, {
	            n: "height",
	            f: "20",
	            t: 13,
	            g: 1
	          }, {
	            n: "src",
	            f: [{
	              t: 2,
	              r: "@shared.assetsHost"
	            }, "/img/globalping/alert-icon.svg"],
	            t: 13
	          }]
	        }],
	        n: 50,
	        r: "error"
	      }]
	    }, " ", {
	      t: 7,
	      e: "textarea",
	      m: [{
	        t: 4,
	        f: [{
	          n: "id",
	          f: [{
	            t: 2,
	            r: "id"
	          }],
	          t: 13
	        }],
	        n: 50,
	        r: "id"
	      }, {
	        n: "rows",
	        f: [{
	          t: 2,
	          r: "taRowsAmount"
	        }],
	        t: 13
	      }, {
	        n: "value",
	        f: [{
	          t: 2,
	          r: "taValue"
	        }],
	        t: 13
	      }, {
	        n: "placeholder",
	        f: [{
	          t: 2,
	          r: "placeholder"
	        }],
	        t: 13
	      }, {
	        n: "class",
	        f: [{
	          t: 4,
	          f: ["has-error"],
	          n: 50,
	          r: "error"
	        }, {
	          t: 4,
	          f: ["is-disabled"],
	          n: 50,
	          r: "disabled"
	        }],
	        t: 13
	      }, {
	        n: "disabled",
	        f: [{
	          t: 2,
	          r: "disabled"
	        }],
	        t: 13
	      }],
	      f: ["\t"]
	    }]
	  }],
	  e: {
	    "_0&&!_1": function (_0, _1) {
	      return _0 && !_1;
	    }
	  }
	};
	var controlledTextarea = ractive__default["default"].extend(component$r.exports);

	var $TypeError$1 = TypeError;
	var deletePropertyOrThrow = function (O, P) {
	  if (!delete O[P]) throw new $TypeError$1('Cannot delete property ' + tryToString(P) + ' of ' + tryToString(O));
	};

	// IE8-
	var INCORRECT_RESULT = [].unshift(0) !== 1;

	// V8 ~ Chrome < 71 and Safari <= 15.4, FF < 23 throws InternalError
	var properErrorOnNonWritableLength = function () {
	  try {
	    // eslint-disable-next-line es/no-object-defineproperty -- safe
	    Object.defineProperty([], 'length', {
	      writable: false
	    }).unshift();
	  } catch (error) {
	    return error instanceof TypeError;
	  }
	};
	var FORCED = INCORRECT_RESULT || !properErrorOnNonWritableLength();

	// `Array.prototype.unshift` method
	// https://tc39.es/ecma262/#sec-array.prototype.unshift
	_export({
	  target: 'Array',
	  proto: true,
	  arity: 1,
	  forced: FORCED
	}, {
	  // eslint-disable-next-line no-unused-vars -- required for `.length`
	  unshift: function unshift(item) {
	    var O = toObject(this);
	    var len = lengthOfArrayLike(O);
	    var argCount = arguments.length;
	    if (argCount) {
	      doesNotExceedSafeInteger(len + argCount);
	      var k = len;
	      while (k--) {
	        var to = k + argCount;
	        if (k in O) O[to] = O[k];else deletePropertyOrThrow(O, to);
	      }
	      for (var j = 0; j < argCount; j++) {
	        O[j] = arguments[j];
	      }
	    }
	    return arraySetLength(O, len + argCount);
	  }
	});

	var usaStates$1 = [
		{
			code: "AL",
			name: "Alabama"
		},
		{
			code: "AK",
			name: "Alaska"
		},
		{
			code: "AS",
			name: "American Samoa"
		},
		{
			code: "AZ",
			name: "Arizona"
		},
		{
			code: "AR",
			name: "Arkansas"
		},
		{
			code: "CA",
			name: "California"
		},
		{
			code: "CO",
			name: "Colorado"
		},
		{
			code: "CT",
			name: "Connecticut"
		},
		{
			code: "DE",
			name: "Delaware"
		},
		{
			code: "DC",
			name: "Washington, D.C."
		},
		{
			code: "DC",
			name: "District Of Columbia"
		},
		{
			code: "FM",
			name: "Federated States Of Micronesia"
		},
		{
			code: "FL",
			name: "Florida"
		},
		{
			code: "GA",
			name: "Georgia"
		},
		{
			code: "GU",
			name: "Guam"
		},
		{
			code: "HI",
			name: "Hawaii"
		},
		{
			code: "ID",
			name: "Idaho"
		},
		{
			code: "IL",
			name: "Illinois"
		},
		{
			code: "IN",
			name: "Indiana"
		},
		{
			code: "IA",
			name: "Iowa"
		},
		{
			code: "KS",
			name: "Kansas"
		},
		{
			code: "KY",
			name: "Kentucky"
		},
		{
			code: "LA",
			name: "Louisiana"
		},
		{
			code: "ME",
			name: "Maine"
		},
		{
			code: "MH",
			name: "Marshall Islands"
		},
		{
			code: "MD",
			name: "Maryland"
		},
		{
			code: "MA",
			name: "Massachusetts"
		},
		{
			code: "MI",
			name: "Michigan"
		},
		{
			code: "MN",
			name: "Minnesota"
		},
		{
			code: "MS",
			name: "Mississippi"
		},
		{
			code: "MO",
			name: "Missouri"
		},
		{
			code: "MT",
			name: "Montana"
		},
		{
			code: "NE",
			name: "Nebraska"
		},
		{
			code: "NV",
			name: "Nevada"
		},
		{
			code: "NH",
			name: "New Hampshire"
		},
		{
			code: "NJ",
			name: "New Jersey"
		},
		{
			code: "NM",
			name: "New Mexico"
		},
		{
			code: "NY",
			name: "New York"
		},
		{
			code: "NC",
			name: "North Carolina"
		},
		{
			code: "ND",
			name: "North Dakota"
		},
		{
			code: "MP",
			name: "Northern Mariana Islands"
		},
		{
			code: "OH",
			name: "Ohio"
		},
		{
			code: "OK",
			name: "Oklahoma"
		},
		{
			code: "OR",
			name: "Oregon"
		},
		{
			code: "PW",
			name: "Palau"
		},
		{
			code: "PA",
			name: "Pennsylvania"
		},
		{
			code: "PR",
			name: "Puerto Rico"
		},
		{
			code: "RI",
			name: "Rhode Island"
		},
		{
			code: "SC",
			name: "South Carolina"
		},
		{
			code: "SD",
			name: "South Dakota"
		},
		{
			code: "TN",
			name: "Tennessee"
		},
		{
			code: "TX",
			name: "Texas"
		},
		{
			code: "UT",
			name: "Utah"
		},
		{
			code: "VT",
			name: "Vermont"
		},
		{
			code: "VI",
			name: "Virgin Islands"
		},
		{
			code: "VA",
			name: "Virginia"
		},
		{
			code: "WA",
			name: "Washington"
		},
		{
			code: "WV",
			name: "West Virginia"
		},
		{
			code: "WI",
			name: "Wisconsin"
		},
		{
			code: "WY",
			name: "Wyoming"
		}
	];

	var usaStates$2 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		'default': usaStates$1
	});

	var countries$1 = [
		{
			code: "AD",
			name: "Andorra"
		},
		{
			code: "AE",
			name: "United Arab Emirates"
		},
		{
			code: "AF",
			name: "Afghanistan"
		},
		{
			code: "AG",
			name: "Antigua and Barbuda"
		},
		{
			code: "AI",
			name: "Anguilla"
		},
		{
			code: "AL",
			name: "Albania"
		},
		{
			code: "AM",
			name: "Armenia"
		},
		{
			code: "AO",
			name: "Angola"
		},
		{
			code: "AQ",
			name: "Antarctica"
		},
		{
			code: "AR",
			name: "Argentina"
		},
		{
			code: "AS",
			name: "American Samoa"
		},
		{
			code: "AT",
			name: "Austria"
		},
		{
			code: "AU",
			name: "Australia"
		},
		{
			code: "AW",
			name: "Aruba"
		},
		{
			code: "AX",
			name: "Åland"
		},
		{
			code: "AZ",
			name: "Azerbaijan"
		},
		{
			code: "BA",
			name: "Bosnia and Herzegovina"
		},
		{
			code: "BB",
			name: "Barbados"
		},
		{
			code: "BD",
			name: "Bangladesh"
		},
		{
			code: "BE",
			name: "Belgium"
		},
		{
			code: "BF",
			name: "Burkina Faso"
		},
		{
			code: "BG",
			name: "Bulgaria"
		},
		{
			code: "BH",
			name: "Bahrain"
		},
		{
			code: "BI",
			name: "Burundi"
		},
		{
			code: "BJ",
			name: "Benin"
		},
		{
			code: "BL",
			name: "Saint Barthélemy"
		},
		{
			code: "BM",
			name: "Bermuda"
		},
		{
			code: "BN",
			name: "Brunei"
		},
		{
			code: "BO",
			name: "Bolivia"
		},
		{
			code: "BQ",
			name: "Bonaire"
		},
		{
			code: "BR",
			name: "Brazil"
		},
		{
			code: "BS",
			name: "Bahamas"
		},
		{
			code: "BT",
			name: "Bhutan"
		},
		{
			code: "BV",
			name: "Bouvet Island"
		},
		{
			code: "BW",
			name: "Botswana"
		},
		{
			code: "BY",
			name: "Belarus"
		},
		{
			code: "BZ",
			name: "Belize"
		},
		{
			code: "CA",
			name: "Canada"
		},
		{
			code: "CC",
			name: "Cocos [Keeling] Islands"
		},
		{
			code: "CD",
			name: "Democratic Republic of the Congo"
		},
		{
			code: "CF",
			name: "Central African Republic"
		},
		{
			code: "CG",
			name: "Republic of the Congo"
		},
		{
			code: "CH",
			name: "Switzerland"
		},
		{
			code: "CI",
			name: "Ivory Coast"
		},
		{
			code: "CK",
			name: "Cook Islands"
		},
		{
			code: "CL",
			name: "Chile"
		},
		{
			code: "CM",
			name: "Cameroon"
		},
		{
			code: "CN",
			name: "China"
		},
		{
			code: "CO",
			name: "Colombia"
		},
		{
			code: "CR",
			name: "Costa Rica"
		},
		{
			code: "CU",
			name: "Cuba"
		},
		{
			code: "CV",
			name: "Cape Verde"
		},
		{
			code: "CW",
			name: "Curacao"
		},
		{
			code: "CX",
			name: "Christmas Island"
		},
		{
			code: "CY",
			name: "Cyprus"
		},
		{
			code: "CZ",
			name: "Czech Republic"
		},
		{
			code: "DE",
			name: "Germany"
		},
		{
			code: "DJ",
			name: "Djibouti"
		},
		{
			code: "DK",
			name: "Denmark"
		},
		{
			code: "DM",
			name: "Dominica"
		},
		{
			code: "DO",
			name: "Dominican Republic"
		},
		{
			code: "DZ",
			name: "Algeria"
		},
		{
			code: "EC",
			name: "Ecuador"
		},
		{
			code: "EE",
			name: "Estonia"
		},
		{
			code: "EG",
			name: "Egypt"
		},
		{
			code: "EH",
			name: "Western Sahara"
		},
		{
			code: "ER",
			name: "Eritrea"
		},
		{
			code: "ES",
			name: "Spain"
		},
		{
			code: "ET",
			name: "Ethiopia"
		},
		{
			code: "FI",
			name: "Finland"
		},
		{
			code: "FJ",
			name: "Fiji"
		},
		{
			code: "FK",
			name: "Falkland Islands"
		},
		{
			code: "FM",
			name: "Micronesia"
		},
		{
			code: "FO",
			name: "Faroe Islands"
		},
		{
			code: "FR",
			name: "France"
		},
		{
			code: "GA",
			name: "Gabon"
		},
		{
			code: "GB",
			name: "United Kingdom"
		},
		{
			code: "GD",
			name: "Grenada"
		},
		{
			code: "GE",
			name: "Georgia"
		},
		{
			code: "GF",
			name: "French Guiana"
		},
		{
			code: "GG",
			name: "Guernsey"
		},
		{
			code: "GH",
			name: "Ghana"
		},
		{
			code: "GI",
			name: "Gibraltar"
		},
		{
			code: "GL",
			name: "Greenland"
		},
		{
			code: "GM",
			name: "Gambia"
		},
		{
			code: "GN",
			name: "Guinea"
		},
		{
			code: "GP",
			name: "Guadeloupe"
		},
		{
			code: "GQ",
			name: "Equatorial Guinea"
		},
		{
			code: "GR",
			name: "Greece"
		},
		{
			code: "GS",
			name: "South Georgia and the South Sandwich Islands"
		},
		{
			code: "GT",
			name: "Guatemala"
		},
		{
			code: "GU",
			name: "Guam"
		},
		{
			code: "GW",
			name: "Guinea-Bissau"
		},
		{
			code: "GY",
			name: "Guyana"
		},
		{
			code: "HK",
			name: "Hong Kong"
		},
		{
			code: "HM",
			name: "Heard Island and McDonald Islands"
		},
		{
			code: "HN",
			name: "Honduras"
		},
		{
			code: "HR",
			name: "Croatia"
		},
		{
			code: "HT",
			name: "Haiti"
		},
		{
			code: "HU",
			name: "Hungary"
		},
		{
			code: "ID",
			name: "Indonesia"
		},
		{
			code: "IE",
			name: "Ireland"
		},
		{
			code: "IL",
			name: "Israel"
		},
		{
			code: "IM",
			name: "Isle of Man"
		},
		{
			code: "IN",
			name: "India"
		},
		{
			code: "IO",
			name: "British Indian Ocean Territory"
		},
		{
			code: "IQ",
			name: "Iraq"
		},
		{
			code: "IR",
			name: "Iran"
		},
		{
			code: "IS",
			name: "Iceland"
		},
		{
			code: "IT",
			name: "Italy"
		},
		{
			code: "JE",
			name: "Jersey"
		},
		{
			code: "JM",
			name: "Jamaica"
		},
		{
			code: "JO",
			name: "Jordan"
		},
		{
			code: "JP",
			name: "Japan"
		},
		{
			code: "KE",
			name: "Kenya"
		},
		{
			code: "KG",
			name: "Kyrgyzstan"
		},
		{
			code: "KH",
			name: "Cambodia"
		},
		{
			code: "KI",
			name: "Kiribati"
		},
		{
			code: "KM",
			name: "Comoros"
		},
		{
			code: "KN",
			name: "Saint Kitts and Nevis"
		},
		{
			code: "KP",
			name: "North Korea"
		},
		{
			code: "KR",
			name: "South Korea"
		},
		{
			code: "KW",
			name: "Kuwait"
		},
		{
			code: "KY",
			name: "Cayman Islands"
		},
		{
			code: "KZ",
			name: "Kazakhstan"
		},
		{
			code: "LA",
			name: "Laos"
		},
		{
			code: "LB",
			name: "Lebanon"
		},
		{
			code: "LC",
			name: "Saint Lucia"
		},
		{
			code: "LI",
			name: "Liechtenstein"
		},
		{
			code: "LK",
			name: "Sri Lanka"
		},
		{
			code: "LR",
			name: "Liberia"
		},
		{
			code: "LS",
			name: "Lesotho"
		},
		{
			code: "LT",
			name: "Lithuania"
		},
		{
			code: "LU",
			name: "Luxembourg"
		},
		{
			code: "LV",
			name: "Latvia"
		},
		{
			code: "LY",
			name: "Libya"
		},
		{
			code: "MA",
			name: "Morocco"
		},
		{
			code: "MC",
			name: "Monaco"
		},
		{
			code: "MD",
			name: "Moldova"
		},
		{
			code: "ME",
			name: "Montenegro"
		},
		{
			code: "MF",
			name: "Saint Martin"
		},
		{
			code: "MG",
			name: "Madagascar"
		},
		{
			code: "MH",
			name: "Marshall Islands"
		},
		{
			code: "MK",
			name: "North Macedonia"
		},
		{
			code: "ML",
			name: "Mali"
		},
		{
			code: "MM",
			name: "Myanmar [Burma]"
		},
		{
			code: "MN",
			name: "Mongolia"
		},
		{
			code: "MO",
			name: "Macao"
		},
		{
			code: "MP",
			name: "Northern Mariana Islands"
		},
		{
			code: "MQ",
			name: "Martinique"
		},
		{
			code: "MR",
			name: "Mauritania"
		},
		{
			code: "MS",
			name: "Montserrat"
		},
		{
			code: "MT",
			name: "Malta"
		},
		{
			code: "MU",
			name: "Mauritius"
		},
		{
			code: "MV",
			name: "Maldives"
		},
		{
			code: "MW",
			name: "Malawi"
		},
		{
			code: "MX",
			name: "Mexico"
		},
		{
			code: "MY",
			name: "Malaysia"
		},
		{
			code: "MZ",
			name: "Mozambique"
		},
		{
			code: "NA",
			name: "Namibia"
		},
		{
			code: "NC",
			name: "New Caledonia"
		},
		{
			code: "NE",
			name: "Niger"
		},
		{
			code: "NF",
			name: "Norfolk Island"
		},
		{
			code: "NG",
			name: "Nigeria"
		},
		{
			code: "NI",
			name: "Nicaragua"
		},
		{
			code: "NL",
			name: "Netherlands"
		},
		{
			code: "NO",
			name: "Norway"
		},
		{
			code: "NP",
			name: "Nepal"
		},
		{
			code: "NR",
			name: "Nauru"
		},
		{
			code: "NU",
			name: "Niue"
		},
		{
			code: "NZ",
			name: "New Zealand"
		},
		{
			code: "OM",
			name: "Oman"
		},
		{
			code: "PA",
			name: "Panama"
		},
		{
			code: "PE",
			name: "Peru"
		},
		{
			code: "PF",
			name: "French Polynesia"
		},
		{
			code: "PG",
			name: "Papua New Guinea"
		},
		{
			code: "PH",
			name: "Philippines"
		},
		{
			code: "PK",
			name: "Pakistan"
		},
		{
			code: "PL",
			name: "Poland"
		},
		{
			code: "PM",
			name: "Saint Pierre and Miquelon"
		},
		{
			code: "PN",
			name: "Pitcairn Islands"
		},
		{
			code: "PR",
			name: "Puerto Rico"
		},
		{
			code: "PS",
			name: "Palestine"
		},
		{
			code: "PT",
			name: "Portugal"
		},
		{
			code: "PW",
			name: "Palau"
		},
		{
			code: "PY",
			name: "Paraguay"
		},
		{
			code: "QA",
			name: "Qatar"
		},
		{
			code: "RE",
			name: "Réunion"
		},
		{
			code: "RO",
			name: "Romania"
		},
		{
			code: "RS",
			name: "Serbia"
		},
		{
			code: "RU",
			name: "Russia"
		},
		{
			code: "RW",
			name: "Rwanda"
		},
		{
			code: "SA",
			name: "Saudi Arabia"
		},
		{
			code: "SB",
			name: "Solomon Islands"
		},
		{
			code: "SC",
			name: "Seychelles"
		},
		{
			code: "SD",
			name: "Sudan"
		},
		{
			code: "SE",
			name: "Sweden"
		},
		{
			code: "SG",
			name: "Singapore"
		},
		{
			code: "SH",
			name: "Saint Helena"
		},
		{
			code: "SI",
			name: "Slovenia"
		},
		{
			code: "SJ",
			name: "Svalbard and Jan Mayen"
		},
		{
			code: "SK",
			name: "Slovakia"
		},
		{
			code: "SL",
			name: "Sierra Leone"
		},
		{
			code: "SM",
			name: "San Marino"
		},
		{
			code: "SN",
			name: "Senegal"
		},
		{
			code: "SO",
			name: "Somalia"
		},
		{
			code: "SR",
			name: "Suriname"
		},
		{
			code: "SS",
			name: "South Sudan"
		},
		{
			code: "ST",
			name: "São Tomé and Príncipe"
		},
		{
			code: "SV",
			name: "El Salvador"
		},
		{
			code: "SX",
			name: "Sint Maarten"
		},
		{
			code: "SY",
			name: "Syria"
		},
		{
			code: "SZ",
			name: "Swaziland"
		},
		{
			code: "TC",
			name: "Turks and Caicos Islands"
		},
		{
			code: "TD",
			name: "Chad"
		},
		{
			code: "TF",
			name: "French Southern Territories"
		},
		{
			code: "TG",
			name: "Togo"
		},
		{
			code: "TH",
			name: "Thailand"
		},
		{
			code: "TJ",
			name: "Tajikistan"
		},
		{
			code: "TK",
			name: "Tokelau"
		},
		{
			code: "TL",
			name: "East Timor"
		},
		{
			code: "TM",
			name: "Turkmenistan"
		},
		{
			code: "TN",
			name: "Tunisia"
		},
		{
			code: "TO",
			name: "Tonga"
		},
		{
			code: "TR",
			name: "Turkey"
		},
		{
			code: "TT",
			name: "Trinidad and Tobago"
		},
		{
			code: "TV",
			name: "Tuvalu"
		},
		{
			code: "TW",
			name: "Taiwan"
		},
		{
			code: "TZ",
			name: "Tanzania"
		},
		{
			code: "UA",
			name: "Ukraine"
		},
		{
			code: "UG",
			name: "Uganda"
		},
		{
			code: "UM",
			name: "U.S. Minor Outlying Islands"
		},
		{
			code: "US",
			name: "United States"
		},
		{
			code: "UY",
			name: "Uruguay"
		},
		{
			code: "UZ",
			name: "Uzbekistan"
		},
		{
			code: "VA",
			name: "Vatican City"
		},
		{
			code: "VC",
			name: "Saint Vincent and the Grenadines"
		},
		{
			code: "VE",
			name: "Venezuela"
		},
		{
			code: "VG",
			name: "British Virgin Islands"
		},
		{
			code: "VI",
			name: "U.S. Virgin Islands"
		},
		{
			code: "VN",
			name: "Vietnam"
		},
		{
			code: "VU",
			name: "Vanuatu"
		},
		{
			code: "WF",
			name: "Wallis and Futuna"
		},
		{
			code: "WS",
			name: "Samoa"
		},
		{
			code: "XK",
			name: "Kosovo"
		},
		{
			code: "YE",
			name: "Yemen"
		},
		{
			code: "YT",
			name: "Mayotte"
		},
		{
			code: "ZA",
			name: "South Africa"
		},
		{
			code: "ZM",
			name: "Zambia"
		},
		{
			code: "ZW",
			name: "Zimbabwe"
		}
	];

	var countries$2 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		'default': countries$1
	});

	var continents = [
		{
			code: "AN",
			name: "Antarctica"
		},
		{
			code: "AS",
			name: "Asia"
		},
		{
			code: "EU",
			name: "Europe"
		},
		{
			code: "NA",
			name: "North America"
		},
		{
			code: "OC",
			name: "Oceania"
		},
		{
			code: "SA",
			name: "South America"
		},
		{
			code: "AF",
			name: "Africa"
		}
	];

	var continents$1 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		'default': continents
	});

	var usaStates = getCjsExportFromNamespace(usaStates$2);

	var countries = getCjsExportFromNamespace(countries$2);

	var CONTINENTS = getCjsExportFromNamespace(continents$1);

	var component$q = {
	  exports: {}
	};
	const statesByCode = Object.fromEntries(usaStates.map(state => [`US-${state.code}`, state]));
	const countriesByCode = Object.fromEntries(countries.map(country => [country.code, country]));
	const continentsByCode = Object.fromEntries(CONTINENTS.map(continent => [continent.code, continent]));
	const networkNameCleanupPattern = /[\s,]+(?:(?:\w{1,2}\.)+\w{0,2}|Ltd|Limited|Inc|Incorporated|Corp|Corporation|LLC|LLP|PLC|GmbH|S\.?\s?A\.?|Pty|Co|Company|AG|OÜ|ApS|A\/S|IVS|K\/S|AB|HB|KB|AS|ASA|ANS|NUF|Oy|Oyj|Ay|Ky|Tmi|EHF|HF|OHG|KG|GbR|BV|NV|VOF|Comm\.?\s?V|CV|SARL|SCA|SCS|ASBL|TÜ|MTÜ|FIE|Srl|SpA|SNC|SAS|EURL|UG|KGaA|SE|SCP|SCI|SARL-S|SCSp|Kft|Bt|Rt|Zrt|Nyrt|SIA|IK|PS|KS|ĀKF|BO|VSIA|VAS|UAB|VšĮ|IĮ|TŪB|KŪB|MB|BĮ|PP)[.,\s]*$/gi;
	const escapeRegExp = string => string.replace(/[\\^$.*+?()[\]{}|]/g, '\\$&');
	component$q.exports = {
	  decorators: {
	    tooltip
	  },
	  data() {
	    return {
	      invalidValue: null,
	      errMsgTopPos: false,
	      rawProbes: []
	    };
	  },
	  oninit() {
	    if (!ractive__default["default"].isServer) {
	      this.observeOnce('error', () => {
	        this.set('invalidValue', this.get('value'));
	      }, {
	        init: false
	      });
	      this.observe('value', value => {
	        let invalidValue = this.get('invalidValue');
	        let error = this.get('error');
	        if (error && invalidValue !== value) {
	          this.set('error', undefined);
	        }
	      });
	      this.observe('screenWidth', screenWidth => {
	        if ((screenWidth || window.innerWidth) < 768) {
	          this.set('errMsgTopPos', true);
	        } else {
	          this.set('errMsgTopPos', false);
	        }
	      });
	    }
	  },
	  onrender() {
	    listeners.screenWidthListener(this);
	    if (!ractive__default["default"].isServer) {
	      let normalizedProbes;
	      let indexForConditions;
	      let initLimit = value => function runLimit(rawSources) {
	        let sources = rawSources.flat().filter(Boolean);
	        let nonEmptySources = 0;
	        let totalItems = 0;
	        sources.forEach(source => {
	          nonEmptySources += source.count ? 1 : 0;
	          totalItems += source.count;
	        });
	        if (totalItems === 0) {
	          return [];
	        }
	        let minLimitPerSource = Math.ceil(value / nonEmptySources);
	        let maxLimitPerSource = Math.max(Math.min(totalItems, value), minLimitPerSource);
	        let limitedSources;
	        for (let currentLimit = minLimitPerSource; currentLimit <= maxLimitPerSource; currentLimit++) {
	          let sharedLimitRemaining = value;
	          limitedSources = sources.map((source, index) => {
	            let isLastSource = index === sources.length - 1;
	            let sourceLimit = isLastSource ? sharedLimitRemaining : Math.min(currentLimit, sharedLimitRemaining);
	            let items = source.getItems().slice(0, sourceLimit);
	            sharedLimitRemaining = Math.max(sharedLimitRemaining - items.length, 0);
	            return {
	              ...source,
	              getItems() {
	                return items;
	              }
	            };
	          });
	          if (!sharedLimitRemaining) {
	            return limitedSources;
	          }
	        }
	        return limitedSources;
	      };
	      let columns = (html, left, right) => html`
					<div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
						<div>${left}</div>
						<div class="aa-gp-item-count">${right}</div>
					</div>
				`;
	      let limit = initLimit(12);
	      let {
	        autocomplete
	      } = window['@algolia/autocomplete-js'];
	      let customTabHandlingActive = false;
	      let overrideState = false;
	      let isAsyncOpen = false;
	      let activeItemId;
	      let currentCompletion;
	      let currentCollections;
	      let {
	        setQuery,
	        setActiveItemId,
	        destroy
	      } = autocomplete({
	        container: this.find('.aa-gp-container'),
	        onStateChange: _ref => {
	          let {
	            state
	          } = _ref;
	          activeItemId = state.activeItemId;
	          setTimeout(() => isAsyncOpen = state.isOpen);
	          if (overrideState) {
	            overrideState = false;
	            return;
	          }
	          if (state.isOpen) {
	            currentCompletion = state.completion;
	            currentCollections = state.collections;
	            if (state.query && !currentCompletion && activeItemId === null) {
	              setActiveItemId(0);
	              customTabHandlingActive = true;
	            } else if (state.activeItemId !== 0) {
	              customTabHandlingActive = false;
	            }
	          }
	          this.set('value', state.isOpen ? state.query : state.completion || state.query);
	        },
	        onSubmit: () => {
	          this.fire('enter');
	        },
	        detachedMediaQuery: 'none',
	        placeholder: this.get('placeholder'),
	        openOnFocus: true,
	        classNames: {
	          panelLayout: 'dropdown-menu',
	          input: this.get('error') ? 'has-error' : ''
	        },
	        render(_ref2, root) {
	          let {
	            sections,
	            render,
	            html
	          } = _ref2;
	          render(html`
							<div class="aa-PanelLayout aa-Panel--scrollable">
								<section class="aa-gp-info"><i class="fa fa-lightbulb-o" aria-hidden="true"></i> Try one of these suggestions or use your own value.</section>
								${sections}
							</div>`, root);
	        },
	        renderNoResults(_ref3, root) {
	          let {
	            html,
	            render,
	            state
	          } = _ref3;
	          return render(html`
							<div class="aa-PanelLayout">
								<section class="aa-gp-info">
									Search for <code>${state.query}</code> across all probes.
								</section>

								<div class="aa-gp-no-results">
									Our magic search supports names of continents, regions, countries, US states, cities, networks, and custom tags.<br/><br/>
									Use <code>+</code> to combine multiple filters, and <code>,</code> to select multiple locations.
								</div>
							</div>
						`, root);
	        },
	        reshape(_ref4) {
	          let {
	            sources
	          } = _ref4;
	          return [limit(sources)];
	        },
	        getSources(_ref5) {
	          let {
	            query
	          } = _ref5;
	          // The input allows several queries separated by a comma.
	          // Each query may have multiple parts separated by a plus sign.
	          // We always operate on the last part of the last query but need to preserve anything before it.
	          let queries = query.split(',');
	          let previousQueries = queries.length > 1 ? queries.slice(0, -1) : [];
	          let currentQuery = queries.at(-1);
	          let currentQueryParts = currentQuery.split('+');
	          let currentQueryPrevParts = currentQueryParts.length > 1 ? currentQueryParts.slice(0, -1) : [];
	          let currentQueryPrevPartsNormalized = currentQueryPrevParts.map(q => q.trim()).filter(v => v).map(s => s.toLowerCase()).sort();
	          let currentQueryPrevPartsNormalizedString = currentQueryPrevPartsNormalized.join('+');
	          let currentQueryCurrentPart = currentQueryParts.at(-1) || '';
	          let currentQueryCurrentPartLeadingWhitespace = currentQueryCurrentPart.match(/^\s+/)?.[0] || '';
	          let currentQueryCurrentPartTrimmed = currentQueryCurrentPart.trim();
	          let escapedQuery = escapeRegExp(currentQueryCurrentPartTrimmed);
	          let queryPrefix = previousQueries.join(',');
	          if (queryPrefix) {
	            queryPrefix += ',';
	          }
	          if (currentQueryPrevParts.length) {
	            queryPrefix += `${currentQueryPrevParts.join('+')}+`;
	          }
	          queryPrefix += currentQueryCurrentPartLeadingWhitespace;
	          if (!indexForConditions[currentQueryPrevPartsNormalizedString]) {
	            createIndexFor(currentQueryPrevPartsNormalized);
	          }
	          let index = indexForConditions[currentQueryPrevPartsNormalizedString];
	          let rankedPatterns = escapedQuery ? [new RegExp(`^${escapedQuery}$`, 'im'),
	          // new RegExp(`^${escapedQuery}\\b`, 'im'),
	          new RegExp(`^${escapedQuery}`, 'im'), new RegExp(`\\b${escapedQuery}\\b`, 'im'), new RegExp(`\\b${escapedQuery}`, 'im'), new RegExp(`${escapedQuery}`, 'im')] : [/./];
	          let initSource = (name, properties) => {
	            return _.deepExtend({
	              sourceId: name,
	              getItems: () => {
	                return index[name];
	              },
	              getItemInputValue(_ref6) {
	                let {
	                  item
	                } = _ref6;
	                // Some items have multiple valid ways to refer to them, e.g., EU and Europe. Preserve the existing value in that case.
	                let allowedValue = item.inputValues?.find(v => v.toLowerCase() === currentQueryCurrentPartTrimmed.toLowerCase());

	                // Cities are composed of two parts, which requires special handling to avoid duplicating one of them.
	                let valueToAdd = allowedValue || item.value;
	                let partsToAdd = valueToAdd.split('+').filter(v => !currentQueryPrevPartsNormalized.includes(v.toLowerCase()));
	                return queryPrefix + partsToAdd.join('+');
	              },
	              templates: {
	                header() {
	                  return _.capitalizeFirstLetter(name);
	                }
	              }
	            }, properties);
	          };
	          let filterSourceResults = source => {
	            let filtered = [];
	            let bestRank = Infinity;
	            for (let item of source.getItems()) {
	              if (item.count > index.countCap && (!index.countCap || source.sourceId !== 'cities' || source.getItemInputValue({
	                item
	              }) === queryPrefix)) {
	                continue;
	              }
	              for (let i = 0; i < rankedPatterns.length; i++) {
	                if (rankedPatterns[i].test(item.normalizedValue)) {
	                  filtered.push({
	                    ...item,
	                    rank: i
	                  });
	                  if (i < bestRank) {
	                    bestRank = i;
	                  }
	                  break;
	                }
	              }
	            }
	            filtered.sort((a, b) => {
	              if (a.rank === b.rank) {
	                return b.count - a.count;
	              }
	              return a.rank - b.rank;
	            });
	            return {
	              ...source,
	              getItems: () => filtered,
	              count: filtered.length,
	              rank: bestRank
	            };
	          };
	          return [initSource('tags', {
	            templates: {
	              item(_ref7) {
	                let {
	                  item,
	                  html
	                } = _ref7;
	                return columns(html, item.value, `${item.count}`);
	              }
	            }
	          }), initSource('countries', {
	            templates: {
	              item(_ref8) {
	                let {
	                  item,
	                  html
	                } = _ref8;
	                return columns(html, html`${item.value}<span class="aa-gp-item-extra"> (${item.countryCode})</span>`, `${item.count}`);
	              }
	            }
	          }), initSource('continents', {
	            templates: {
	              item(_ref9) {
	                let {
	                  item,
	                  html
	                } = _ref9;
	                return columns(html, `${item.value}`, `${item.count}`);
	              }
	            }
	          }), initSource('cities', {
	            templates: {
	              item(_ref10) {
	                let {
	                  item,
	                  html
	                } = _ref10;
	                return columns(html, html`${item.displayValue}<span class="aa-gp-item-extra">, ${item.state || item.country}</span>`, `${item.count}`);
	              }
	            }
	          }), initSource('regions', {
	            templates: {
	              item(_ref11) {
	                let {
	                  item,
	                  html
	                } = _ref11;
	                return columns(html, `${item.value}`, `${item.count}`);
	              }
	            }
	          }), initSource('states', {
	            templates: {
	              item(_ref12) {
	                let {
	                  item,
	                  html
	                } = _ref12;
	                return columns(html, html`${item.displayValue}<span class="aa-gp-item-extra"> (${item.stateCode})</span>`, `${item.count}`);
	              }
	            }
	          }), initSource('networks', {
	            templates: {
	              item(_ref13) {
	                let {
	                  item,
	                  html
	                } = _ref13;
	                return columns(html, `${item.value}`, `${item.count}`);
	              }
	            }
	          })].map(source => {
	            return filterSourceResults(source);
	          }).sort((a, b) => {
	            // For sections with the same rank, order by the number of probes in the first location.
	            if (a.rank === b.rank) {
	              return (b.getItems()[0]?.count || 0) - (a.getItems()[0]?.count || 0);
	            }
	            return a.rank - b.rank;
	          });
	        }
	      });
	      let input = this.el.querySelector('.aa-Input');

	      // Enter handling - run the measurement.
	      let handleEnter = event => {
	        if (event.key === 'Enter' && !isAsyncOpen) {
	          this.fire('enter');
	        }
	      };
	      input.addEventListener('keydown', handleEnter);
	      this.on('unrender', () => input.removeEventListener('keydown', handleEnter));

	      // Tab handling - autocomplete.
	      let handleTab = event => {
	        if (event.key === 'Tab' && customTabHandlingActive) {
	          let collection = currentCollections.find(c => c.items.length);
	          if (collection) {
	            setQuery(collection.source.getItemInputValue({
	              item: collection.items[0]
	            }));
	          }
	        } else if (['ArrowDown', 'ArrowUp'].includes(event.key)) {
	          // Preserve the original unfinished query at "null" position (default behavior without our modifications).
	          if (activeItemId === 0 && !currentCompletion) {
	            overrideState = true;
	            customTabHandlingActive = false;
	            setActiveItemId(null);
	          }
	        }
	      };
	      input.addEventListener('keydown', handleTab);
	      this.on('unrender', () => input.removeEventListener('keydown', handleTab));

	      // Focus handling - select the text.
	      let handleFocus = () => {
	        if (this.get('value').toLowerCase() === 'world') {
	          input.select();
	        }
	      };
	      input.addEventListener('focus', handleFocus);
	      this.on('unrender', () => input.removeEventListener('focus', handleFocus));

	      // Propagate state changes.
	      this.observe('value', newValue => {
	        setQuery(newValue);
	      }, {
	        init: false
	      });
	      this.observe('disabled', newValue => {
	        input.classList.toggle('is-disabled', !!newValue);
	        input.disabled = !!newValue;
	      }, {
	        init: false
	      });
	      this.observe('error', newValue => {
	        input.classList.toggle('has-error', !!newValue);
	      }, {
	        init: false
	      });

	      // Fill in the initial value and show the input.
	      setQuery(this.get('value') || '');
	      setTimeout(() => {
	        this.set('swapInputs', true);
	      });

	      // Prepare the source data.
	      let uniqCountSortNormalize = values => {
	        let countValues = values.reduce((acc, value) => {
	          acc[value] = (acc[value] || 0) + 1;
	          return acc;
	        }, {});
	        return Object.keys(countValues).map(key => ({
	          value: key,
	          normalizedValue: key.toLowerCase(),
	          count: countValues[key]
	        })).sort((a, b) => b.count - a.count);
	      };
	      let createNormalizedProbeList = probes => {
	        normalizedProbes = probes.map(probe => {
	          let countryName = countriesByCode[probe.location.country]?.name || probe.location.country;
	          let continentName = continentsByCode[probe.location.continent]?.name || probe.location.continent;
	          let normalizedProbe = {
	            city: `${probe.location.city}\n${probe.location.state ? `US-${probe.location.state}\n` : '\n'}${countryName}\n${probe.location.country}`,
	            region: probe.location.region,
	            state: probe.location.state ? `US-${probe.location.state}` : '',
	            country: `${countryName}\n${probe.location.country}`,
	            continent: `${continentName}\n${probe.location.continent}`,
	            network: probe.location.network.replace(networkNameCleanupPattern, '').trim(),
	            tags: probe.tags.filter(tag => !tag.startsWith('u-'))
	          };
	          if (probe.location.country === 'GB') {
	            normalizedProbe.country += `\nUK\nGreat Britain\nEngland`.toLowerCase();
	          }
	          return {
	            ...normalizedProbe,
	            allValues: Object.values(normalizedProbe).map(value => Array.isArray(value) ? value.join('\n').toLowerCase() : value.toLowerCase()).join('\n')
	          };
	        });
	        indexForConditions = Object.create(null);
	      };
	      let createIndexFor = conditions => {
	        let index = {};
	        let filteredProbes = conditions.reduce((filteredProbes, condition) => {
	          let exactPattern = new RegExp(`(?:^|\n)${escapeRegExp(condition)}(?:$|\n)`, 'm');
	          let exactMatchFound = false;
	          let looseMatchFound = false;
	          filteredProbes = filteredProbes.filter(probe => {
	            if (!probe.allValues.includes(condition)) {
	              return false;
	            }
	            if (exactPattern.test(probe.allValues)) {
	              exactMatchFound = true;
	            } else {
	              looseMatchFound = true;
	            }
	            return true;
	          });
	          if (exactMatchFound && looseMatchFound) {
	            filteredProbes = filteredProbes.filter(probe => exactPattern.test(probe.allValues));
	          }
	          return filteredProbes;
	        }, normalizedProbes);
	        index.global = ['World'];
	        index.tags = filteredProbes.map(probe => probe.tags).flat();
	        index.cities = filteredProbes.map(probe => probe.city);
	        index.countries = filteredProbes.map(probe => probe.country);
	        index.continents = filteredProbes.map(probe => probe.continent);
	        index.regions = filteredProbes.map(probe => probe.region);
	        index.states = filteredProbes.map(probe => probe.state).filter(v => v);
	        index.networks = filteredProbes.map(probe => probe.network).filter(network => network && !network.includes(','));
	        Object.keys(index).forEach(key => {
	          index[key] = uniqCountSortNormalize(index[key]);
	        });
	        index.cities = index.cities.map(cityRow => {
	          let [city, stateCode, countryName, countryCode] = cityRow.value.split('\n');
	          let stateName = statesByCode[stateCode]?.name || stateCode;
	          return {
	            ...cityRow,
	            value: `${city}+${stateCode || countryCode}`,
	            normalizedValue: `${cityRow.normalizedValue}\n${stateName.toLowerCase()}`,
	            displayValue: `${city}`,
	            country: `${countryName} (${countryCode})`,
	            state: stateName ? `${stateName} (${stateCode})` : ''
	          };
	        });
	        index.countries = index.countries.map(countryRow => {
	          let [countryName, countryCode] = countryRow.value.split('\n');
	          return {
	            ...countryRow,
	            value: countryName,
	            inputValues: [countryName, countryCode],
	            countryCode
	          };
	        });
	        index.continents = index.continents.map(continentRow => {
	          let [continentName] = continentRow.value.split('\n');
	          return {
	            ...continentRow,
	            value: continentName,
	            inputValues: [continentName]
	          };
	        });
	        index.states = index.states.map(stateRow => {
	          let stateCode = stateRow.value;
	          let stateName = statesByCode[stateCode]?.name || stateCode;
	          return {
	            ...stateRow,
	            value: stateCode,
	            normalizedValue: `${stateRow.normalizedValue}\n${stateName.toLowerCase()}`,
	            displayValue: stateName,
	            stateCode
	          };
	        });
	        index.count = filteredProbes.length;
	        index.countCap = conditions.length ? index.count - 1 : index.count;
	        index.tags.unshift(...index.global);
	        index.tags[0].count = filteredProbes.length;
	        indexForConditions[conditions.join('+')] = index;
	      };
	      this.observe('rawProbes', probes => {
	        createNormalizedProbeList(probes);
	      });
	      this.on('unrender', () => destroy());
	    }
	  }
	};
	component$q.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "div",
	    m: [{
	      n: "class",
	      f: ["c-controlled-input ", {
	        t: 2,
	        r: "classList"
	      }],
	      t: 13
	    }],
	    f: [{
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "c-controlled-input_info",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "span",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "c-controlled-input_info_label",
	          g: 1
	        }],
	        f: [{
	          t: 2,
	          r: "labelText"
	        }, " ", {
	          t: 4,
	          f: [{
	            t: 8,
	            r: "labelIcon"
	          }],
	          n: 50,
	          x: {
	            r: ["@this.partials.labelIcon", "hideLabelIcon"],
	            s: "_0&&!_1"
	          }
	        }]
	      }, " ", {
	        t: 4,
	        f: [{
	          t: 7,
	          e: "span",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "c-controlled-input_info_errorMsg",
	            g: 1
	          }],
	          f: [{
	            t: 2,
	            r: "error"
	          }]
	        }, " ", {
	          t: 7,
	          e: "img",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "c-controlled-input_err-icon",
	            g: 1
	          }, {
	            n: "width",
	            f: "20",
	            t: 13,
	            g: 1
	          }, {
	            n: "height",
	            f: "20",
	            t: 13,
	            g: 1
	          }, {
	            n: "src",
	            f: [{
	              t: 2,
	              r: "@shared.assetsHost"
	            }, "/img/globalping/alert-icon.svg"],
	            t: 13
	          }]
	        }],
	        n: 50,
	        r: "error"
	      }]
	    }, " ", {
	      t: 9,
	      c: " Use a server-rendered input and swap it for the real on init to avoid having visible empty space here during init. "
	    }, " ", {
	      t: 7,
	      e: "input",
	      m: [{
	        n: "type",
	        f: "text",
	        t: 13
	      }, {
	        n: "value",
	        f: [{
	          t: 2,
	          r: "value"
	        }],
	        t: 13
	      }, {
	        n: "placeholder",
	        f: [{
	          t: 2,
	          r: "placeholder"
	        }],
	        t: 13
	      }, {
	        n: "class",
	        f: [{
	          t: 4,
	          f: ["hidden"],
	          n: 50,
	          r: "swapInputs"
	        }],
	        t: 13
	      }]
	    }, " ", {
	      t: 7,
	      e: "div",
	      m: [{
	        n: "class",
	        f: ["aa-gp-container ", {
	          t: 4,
	          f: ["hidden"],
	          n: 51,
	          r: "swapInputs"
	        }],
	        t: 13
	      }]
	    }]
	  }],
	  e: {
	    "_0&&!_1": function (_0, _1) {
	      return _0 && !_1;
	    }
	  }
	};
	var locationInput = ractive__default["default"].extend(component$q.exports);

	var component$p = {
	  exports: {}
	};
	component$p.exports = {
	  decorators: {
	    tooltip
	  },
	  data() {
	    return {
	      invalidValue: null,
	      errMsgTopPos: false
	    };
	  },
	  oninit() {
	    if (!ractive__default["default"].isServer) {
	      this.observeOnce('error', () => {
	        this.set('invalidValue', this.get('value'));
	      }, {
	        init: false
	      });
	      this.observe('value', value => {
	        let invalidValue = this.get('invalidValue');
	        let error = this.get('error');
	        if (error && invalidValue !== value) {
	          this.set('error', undefined);
	        }
	      });
	      this.observe('screenWidth', screenWidth => {
	        if ((screenWidth || window.innerWidth) < 768) {
	          this.set('errMsgTopPos', true);
	        } else {
	          this.set('errMsgTopPos', false);
	        }
	      });
	    }
	  },
	  onrender() {
	    listeners.screenWidthListener(this);
	  }
	};
	component$p.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "div",
	    m: [{
	      n: "class",
	      f: ["c-controlled-input ", {
	        t: 2,
	        r: "classList"
	      }],
	      t: 13
	    }],
	    f: [{
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "c-controlled-input_info",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "span",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "c-controlled-input_info_label",
	          g: 1
	        }],
	        f: [{
	          t: 2,
	          r: "labelText"
	        }, " ", {
	          t: 4,
	          f: [{
	            t: 8,
	            r: "labelIcon"
	          }],
	          n: 50,
	          x: {
	            r: ["@this.partials.labelIcon", "hideLabelIcon"],
	            s: "_0&&!_1"
	          }
	        }]
	      }, " ", {
	        t: 4,
	        f: [{
	          t: 7,
	          e: "span",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "c-controlled-input_info_errorMsg",
	            g: 1
	          }],
	          f: [{
	            t: 2,
	            r: "error"
	          }]
	        }, " ", {
	          t: 7,
	          e: "img",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "c-controlled-input_err-icon",
	            g: 1
	          }, {
	            n: "width",
	            f: "20",
	            t: 13,
	            g: 1
	          }, {
	            n: "height",
	            f: "20",
	            t: 13,
	            g: 1
	          }, {
	            n: "src",
	            f: [{
	              t: 2,
	              r: "@shared.assetsHost"
	            }, "/img/globalping/alert-icon.svg"],
	            t: 13
	          }]
	        }],
	        n: 50,
	        r: "error"
	      }]
	    }, " ", {
	      t: 7,
	      e: "input",
	      m: [{
	        t: 4,
	        f: [{
	          n: "id",
	          f: [{
	            t: 2,
	            r: "id"
	          }],
	          t: 13
	        }],
	        n: 50,
	        r: "id"
	      }, {
	        n: "value",
	        f: [{
	          t: 2,
	          r: "value"
	        }],
	        t: 13
	      }, {
	        n: "type",
	        f: "text",
	        t: 13
	      }, {
	        n: "placeholder",
	        f: [{
	          t: 2,
	          r: "placeholder"
	        }],
	        t: 13
	      }, {
	        n: "class",
	        f: [{
	          t: 4,
	          f: ["has-error"],
	          n: 50,
	          r: "error"
	        }, {
	          t: 4,
	          f: ["is-disabled"],
	          n: 50,
	          r: "disabled"
	        }],
	        t: 13
	      }, {
	        n: "disabled",
	        f: [{
	          t: 2,
	          r: "disabled"
	        }],
	        t: 13
	      }]
	    }]
	  }],
	  e: {
	    "_0&&!_1": function (_0, _1) {
	      return _0 && !_1;
	    }
	  }
	};
	var controlledInput = ractive__default["default"].extend(component$p.exports);

	var has$6 = {
	  localStorage() {
	    try {
	      localStorage.setItem('localStorageTest', 1);
	      localStorage.removeItem('localStorageTest');
	    } catch (e) {
	      return false;
	    }
	    return true;
	  },
	  sessionStorage() {
	    try {
	      sessionStorage.setItem('sessionStorageTest', 1);
	      sessionStorage.removeItem('sessionStorageTest');
	    } catch (e) {
	      return false;
	    }
	    return true;
	  }
	};

	var component$o = {
	  exports: {}
	};
	const notificationKey = 'job-1-notificationSeen';
	component$o.exports = {
	  data() {
	    return {
	      notificationSeen: true
	    };
	  },
	  oninit() {
	    if (ractive__default["default"].isServer) {
	      this.set('notificationSeen', true);
	    } else {
	      if (has$6.localStorage()) {
	        if (localStorage.getItem(notificationKey)) {
	          this.set('notificationSeen', true);
	        }
	        this.observe('notificationSeen', newValue => {
	          localStorage.setItem(notificationKey, JSON.stringify(newValue));
	        }, {
	          init: false
	        });
	      }

	      // this.observe('notificationSeen', (newValue) => {
	      // 	document.body.classList[newValue ? 'remove' : 'add']('c-notification-visible');
	      // });
	    }
	  }
	};
	component$o.exports.template = {
	  v: 4,
	  t: [{
	    t: 4,
	    f: [{
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "c-notification",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "i",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "fa fa-bullhorn",
	          g: 1
	        }, {
	          n: "aria-hidden",
	          f: "true",
	          t: 13,
	          g: 1
	        }]
	      }, " ", {
	        t: 7,
	        e: "a",
	        m: [{
	          n: "href",
	          f: "https://gist.github.com/jimaek/de24cee25048de8bbe3f0d811695cdf7",
	          t: 13,
	          g: 1
	        }, {
	          n: "target",
	          f: "_blank",
	          t: 13,
	          g: 1
	        }],
	        f: ["We're looking for a Senior Node.js Engineer to help expand our open-source projects!"]
	      }, " ", {
	        t: 7,
	        e: "a",
	        m: [{
	          n: ["click"],
	          t: 70,
	          f: {
	            r: ["@this"],
	            s: "[_0.set(\"notificationSeen\",true)]"
	          }
	        }, {
	          n: "aria-label",
	          f: "Close",
	          t: 13,
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "i",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "fa fa-times",
	            g: 1
	          }, {
	            n: "aria-hidden",
	            f: "true",
	            t: 13,
	            g: 1
	          }]
	        }]
	      }]
	    }],
	    n: 50,
	    x: {
	      r: ["notificationSeen"],
	      s: "!_0"
	    }
	  }],
	  e: {
	    "[_0.set(\"notificationSeen\",true)]": function (_0) {
	      return [_0.set("notificationSeen", true)];
	    },
	    "!_0": function (_0) {
	      return !_0;
	    }
	  }
	};
	var notification = ractive__default["default"].extend(component$o.exports);

	var component$n = {
	  exports: {}
	};
	component$n.exports = {
	  data() {
	    return {
	      date: new Date(),
	      docInnerHtml: null,
	      gpLinksData: [[{
	        text: 'Ping from Europe',
	        url: '/network-tools/ping-from-europe'
	      }, {
	        text: 'Ping from USA',
	        url: '/network-tools/ping-from-united-states'
	      }, {
	        text: 'Ping globally',
	        url: '/network-tools/ping'
	      }, {
	        text: 'Ping from AWS',
	        url: '/network-tools/ping-from-amazoncom-inc'
	      }], [{
	        text: 'Traceroute from Europe',
	        url: '/network-tools/traceroute-from-europe'
	      }, {
	        text: 'Traceroute from USA',
	        url: '/network-tools/traceroute-from-united-states'
	      }, {
	        text: 'Traceroute globally',
	        url: '/network-tools/traceroute'
	      }, {
	        text: 'Traceroute from AWS',
	        url: '/network-tools/traceroute-from-amazoncom-inc'
	      }], [{
	        text: 'DNS/dig resolve from Europe',
	        url: '/network-tools/dns-from-europe'
	      }, {
	        text: 'DNS/dig resolve from USA',
	        url: '/network-tools/dns-from-united-states'
	      }, {
	        text: 'DNS/dig resolve globally',
	        url: '/network-tools/dns'
	      }, {
	        text: 'DNS/dig resolve from AWS',
	        url: '/network-tools/dns-from-amazoncom-inc'
	      }], [{
	        text: 'HTTP/curl from Europe',
	        url: '/network-tools/http-from-europe'
	      }, {
	        text: 'HTTP/curl from USA',
	        url: '/network-tools/http-from-united-states'
	      }, {
	        text: 'HTTP/curl globally',
	        url: '/network-tools/http'
	      }, {
	        text: 'HTTP/curl from AWS',
	        url: '/network-tools/http-from-amazoncom-inc'
	      }]],
	      blogLinksData: null
	    };
	  },
	  oninit() {
	    if (!ractive__default["default"].isServer) {
	      http.getGPBlogRss().then(response => {
	        if (response) {
	          let document = new window.DOMParser().parseFromString(response, 'text/xml');
	          let items = document.documentElement.childNodes[0].getElementsByTagName('item');
	          let data = [];
	          for (let i = 0; i < items.length; i++) {
	            let currItemNodesList = items[i].childNodes;
	            let currItemTitle;
	            let currItemLink;
	            let currItemPubDate;
	            for (let k = 0; k < currItemNodesList.length; k++) {
	              if (currItemNodesList[k].nodeName === 'title') {
	                currItemTitle = currItemNodesList[k].textContent;
	              } else if (currItemNodesList[k].nodeName === 'link') {
	                currItemLink = currItemNodesList[k].textContent;
	              } else if (currItemNodesList[k].nodeName === 'pubDate') {
	                currItemPubDate = currItemNodesList[k].textContent;
	              }
	            }
	            data.push({
	              text: currItemTitle,
	              url: currItemLink,
	              date: new Date(currItemPubDate).getTime()
	            });
	          }
	          data.sort((a, b) => b.date - a.date);
	          this.set('blogLinksData', data.slice(0, 5));
	        }
	      });
	    }
	  }
	};
	component$n.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "footer",
	    m: [{
	      t: 13,
	      n: "class",
	      f: "c-footer c-gp-footer",
	      g: 1
	    }],
	    f: [{
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "wrapper",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "container-fluid container-mw",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "row block-main",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "col-xs-12 col-sm-4 main-left",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "style",
	                f: "padding: 0;",
	                g: 1
	              }, {
	                t: 13,
	                n: "class",
	                f: "block-list",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "title-copy op-64",
	                  g: 1
	                }],
	                f: ["© globalping.io, 2022 - ", {
	                  t: 2,
	                  x: {
	                    r: ["date"],
	                    s: "_0.getFullYear()"
	                  }
	                }]
	              }]
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "col-xs-12 col-sm-8 main-right",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "main-right-container",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "style",
	                  f: "padding: 0;",
	                  g: 1
	                }, {
	                  t: 13,
	                  n: "class",
	                  f: "block-list",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "row list-primary list-small-row",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "div",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "col-sm-12",
	                      g: 1
	                    }],
	                    f: [{
	                      t: 7,
	                      e: "ul",
	                      f: [{
	                        t: 7,
	                        e: "li",
	                        f: [{
	                          t: 7,
	                          e: "a",
	                          m: [{
	                            n: "href",
	                            f: "/about-us",
	                            t: 13,
	                            g: 1
	                          }],
	                          f: ["About"]
	                        }]
	                      }, " ", {
	                        t: 7,
	                        e: "li",
	                        f: [{
	                          t: 7,
	                          e: "a",
	                          m: [{
	                            n: "href",
	                            f: "/sponsors",
	                            t: 13,
	                            g: 1
	                          }],
	                          f: ["Our Sponsors"]
	                        }]
	                      }, " ", {
	                        t: 7,
	                        e: "li",
	                        f: [{
	                          t: 7,
	                          e: "a",
	                          m: [{
	                            n: "href",
	                            f: "/terms",
	                            t: 13,
	                            g: 1
	                          }],
	                          f: ["Terms & Policies"]
	                        }]
	                      }, " ", {
	                        t: 7,
	                        e: "li",
	                        f: [{
	                          t: 7,
	                          e: "a",
	                          m: [{
	                            n: "href",
	                            f: "mailto:d@jsdelivr.com",
	                            t: 13,
	                            g: 1
	                          }],
	                          f: ["d@globalping.io"]
	                        }]
	                      }]
	                    }]
	                  }]
	                }]
	              }]
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "footer-separator",
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "row block-main",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "col-xs-12 col-sm-8 main-left",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "style",
	                f: "padding: 0;",
	                g: 1
	              }, {
	                t: 13,
	                n: "class",
	                f: "block-list",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "title-copy-bottom op-64",
	                  g: 1
	                }],
	                f: ["Integrations"]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "row list-primary",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "col-sm-12",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "div",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "title-copy op-64",
	                      g: 1
	                    }],
	                    f: ["Integrations"]
	                  }]
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "row list-second list-small-column",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "col-sm-12",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "ul",
	                    f: [{
	                      t: 7,
	                      e: "li",
	                      f: [{
	                        t: 7,
	                        e: "a",
	                        m: [{
	                          t: 13,
	                          n: "class",
	                          f: "router-ignore",
	                          g: 1
	                        }, {
	                          n: "href",
	                          f: "/docs/api.globalping.io",
	                          t: 13,
	                          g: 1
	                        }],
	                        f: ["REST API"]
	                      }]
	                    }, " ", {
	                      t: 7,
	                      e: "li",
	                      f: [{
	                        t: 7,
	                        e: "a",
	                        m: [{
	                          n: "href",
	                          f: "/cli",
	                          t: 13,
	                          g: 1
	                        }],
	                        f: ["CLI"]
	                      }]
	                    }, " ", {
	                      t: 7,
	                      e: "li",
	                      f: [{
	                        t: 7,
	                        e: "a",
	                        m: [{
	                          n: "href",
	                          f: "/slack",
	                          t: 13,
	                          g: 1
	                        }],
	                        f: ["Slack App"]
	                      }]
	                    }, " ", {
	                      t: 7,
	                      e: "li",
	                      f: [{
	                        t: 7,
	                        e: "a",
	                        m: [{
	                          n: "href",
	                          f: "https://github.com/globalping",
	                          t: 13,
	                          g: 1
	                        }, {
	                          n: "target",
	                          f: "_blank",
	                          t: 13,
	                          g: 1
	                        }],
	                        f: ["GitHub Bot ", {
	                          t: 7,
	                          e: "i",
	                          m: [{
	                            t: 13,
	                            n: "class",
	                            f: "fa fa-external-link",
	                            g: 1
	                          }, {
	                            n: "aria-hidden",
	                            f: "true",
	                            t: 13,
	                            g: 1
	                          }]
	                        }]
	                      }]
	                    }]
	                  }]
	                }]
	              }]
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "col-xs-12 col-sm-4 main-right",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "main-right-container",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "subscribe-header",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "span",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "text-footer-14",
	                    g: 1
	                  }],
	                  f: ["Sign up to our newsletter"]
	                }]
	              }, " ", {
	                t: 7,
	                e: "form",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "form-inline subscribe-content",
	                  g: 1
	                }, {
	                  n: "action",
	                  f: "https://jsdelivr.us11.list-manage.com/subscribe?u=0c85fe2c9a60310df9a3d6751&id=283887f736",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "method",
	                  f: "POST",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "target",
	                  f: "_blank",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "form-group",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "input",
	                    m: [{
	                      n: "type",
	                      f: "email",
	                      t: 13
	                    }, {
	                      n: "autocomplete",
	                      f: "email",
	                      t: 13
	                    }, {
	                      n: "class",
	                      f: "form-control",
	                      t: 13
	                    }, {
	                      n: "name",
	                      f: "MERGE0",
	                      t: 13
	                    }, {
	                      n: "id",
	                      f: "new-email",
	                      t: 13
	                    }, {
	                      n: "placeholder",
	                      f: "Enter your e-mail",
	                      t: 13
	                    }]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "button",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "btn btn-default semi-bold",
	                    g: 1
	                  }, {
	                    n: "type",
	                    f: "submit",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: ["Subscribe"]
	                }]
	              }]
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "footer-separator",
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "footer-blog-links",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "footer-blog-links_title op-64",
	              g: 1
	            }],
	            f: ["From our Blog"]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "footer-blog-links_block",
	              g: 1
	            }],
	            f: [{
	              t: 4,
	              f: [{
	                t: 7,
	                e: "a",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "router-ignore",
	                  g: 1
	                }, {
	                  n: "target",
	                  f: "_blank",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "href",
	                  f: [{
	                    t: 2,
	                    r: "./url"
	                  }],
	                  t: 13
	                }],
	                f: [{
	                  t: 2,
	                  r: "./text"
	                }]
	              }],
	              n: 52,
	              r: "blogLinksData"
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "footer-separator",
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "footer-gp-links",
	            g: 1
	          }],
	          f: [{
	            t: 4,
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "footer-gp-links_block",
	                g: 1
	              }],
	              f: [{
	                t: 4,
	                f: [{
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "router-ignore",
	                    g: 1
	                  }, {
	                    n: "href",
	                    f: [{
	                      t: 2,
	                      r: "@shared.serverHost"
	                    }, {
	                      t: 2,
	                      r: "./url"
	                    }],
	                    t: 13
	                  }],
	                  f: [{
	                    t: 2,
	                    r: "./text"
	                  }]
	                }],
	                n: 52,
	                r: "."
	              }]
	            }],
	            n: 52,
	            r: "gpLinksData"
	          }]
	        }]
	      }]
	    }]
	  }],
	  e: {
	    "_0.getFullYear()": function (_0) {
	      return _0.getFullYear();
	    }
	  }
	};
	var gpFooter = ractive__default["default"].extend(component$n.exports);

	var component$m = {
	  exports: {}
	};
	component$m.exports = {
	  data() {
	    return {};
	  },
	  oninit() {
	    if (ractive__default["default"].isServer) {
	      this.set('actualPath', this.root.get('actualPath'));
	    } else {
	      this.set('actualPath', this.get('@shared')?.app?.router?.uri?.path);
	    }
	  },
	  signIn() {
	    let url = new URL('https://dash-directus.globalping.io/auth/login/github');
	    url.searchParams.set('redirect', `${this.get('@shared.serverHost')}/auth/callback?redirect=${encodeURIComponent(location.href)}`);
	    location.href = url.toString();
	  },
	  signOut() {
	    http.gpLogOut().then(() => this.set('@shared.user', null));
	  }
	};
	component$m.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "header",
	    m: [{
	      n: "class",
	      f: ["c-header ", {
	        t: 4,
	        f: [{
	          t: 2,
	          r: "additionalClasses"
	        }],
	        n: 50,
	        r: "additionalClasses"
	      }],
	      t: 13
	    }],
	    f: [{
	      t: 7,
	      e: "nav",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "navbar navbar-default navbar-filled",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "container-fluid container-mw",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "navbar-header",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "a",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "main-logo",
	              g: 1
	            }, {
	              n: "href",
	              f: "/",
	              t: 13,
	              g: 1
	            }, {
	              n: ["click"],
	              t: 70,
	              f: {
	                r: ["@this"],
	                s: "[_0.fire(\"main-logo-click\")]"
	              }
	            }],
	            f: [{
	              t: 9,
	              c: "\n\t\t\t\t\t\tLooking for the logo?\n\t\t\t\t\t\tGet all versions here: https://github.com/jsdelivr/globalping-media\n\t\t\t\t\t"
	            }, " ", {
	              t: 4,
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "138",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "34",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/globalping/", {
	                    t: 2,
	                    r: "mainLogoName"
	                  }],
	                  t: 13
	                }, {
	                  n: "title",
	                  f: "Globalping",
	                  t: 13,
	                  g: 1
	                }]
	              }],
	              n: 50,
	              r: "mainLogoName"
	            }, {
	              t: 4,
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "138",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "34",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/globalping/globalping.svg"],
	                  t: 13
	                }, {
	                  n: "title",
	                  f: "Globalping",
	                  t: 13,
	                  g: 1
	                }]
	              }],
	              n: 51,
	              l: 1
	            }]
	          }, " ", {
	            t: 7,
	            e: "a",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "main-logo_text globalping",
	              g: 1
	            }, {
	              n: "href",
	              f: "https://www.jsdelivr.com",
	              t: 13,
	              g: 1
	            }],
	            f: ["by jsDelivr"]
	          }, " ", {
	            t: 7,
	            e: "button",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "navbar-toggle collapsed",
	              g: 1
	            }, {
	              n: "type",
	              f: "button",
	              t: 13,
	              g: 1
	            }, {
	              n: "data-toggle",
	              f: "collapse",
	              t: 13,
	              g: 1
	            }, {
	              n: "data-target",
	              f: "#main-navbar",
	              t: 13,
	              g: 1
	            }, {
	              n: "aria-expanded",
	              f: "false",
	              t: 13,
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "span",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "sr-only",
	                g: 1
	              }],
	              f: ["Toggle navigation"]
	            }, " ", {
	              t: 7,
	              e: "span",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "icon-bar",
	                g: 1
	              }]
	            }, " ", {
	              t: 7,
	              e: "span",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "icon-bar",
	                g: 1
	              }]
	            }, " ", {
	              t: 7,
	              e: "span",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "icon-bar",
	                g: 1
	              }]
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "collapse navbar-collapse",
	            g: 1
	          }, {
	            n: "id",
	            f: "main-navbar",
	            t: 13,
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "ul",
	            m: [{
	              n: "class",
	              f: ["nav navbar-nav navbar-right ", {
	                t: 2,
	                x: {
	                  r: ["actualPath"],
	                  s: "!_0?\"navbar-hidden\":\"about-navbar-right\""
	                }
	              }],
	              t: 13
	            }],
	            f: [{
	              t: 7,
	              e: "li",
	              f: [{
	                t: 7,
	                e: "a",
	                m: [{
	                  n: "href",
	                  f: "/cli",
	                  t: 13,
	                  g: 1
	                }],
	                f: ["CLI"]
	              }]
	            }, " ", {
	              t: 7,
	              e: "li",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "dropdown",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "a",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "dropdown-toggle",
	                  g: 1
	                }, {
	                  n: "data-toggle",
	                  f: "dropdown",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "role",
	                  f: "button",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "aria-haspopup",
	                  f: "true",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "aria-expanded",
	                  f: "false",
	                  t: 13,
	                  g: 1
	                }],
	                f: ["Integrations ", {
	                  t: 7,
	                  e: "i",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "fa fa-angle-down",
	                    g: 1
	                  }, {
	                    n: "aria-hidden",
	                    f: "true",
	                    t: 13,
	                    g: 1
	                  }]
	                }]
	              }, " ", {
	                t: 7,
	                e: "ul",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "dropdown-menu",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "li",
	                  f: [{
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      n: "href",
	                      f: "/slack",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: ["Slack App"]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "li",
	                  f: [{
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      n: "href",
	                      f: "https://github.com/globalping",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "target",
	                      f: "_blank",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: ["GitHub Bot ", {
	                      t: 7,
	                      e: "i",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "fa fa-external-link",
	                        g: 1
	                      }, {
	                        n: "aria-hidden",
	                        f: "true",
	                        t: 13,
	                        g: 1
	                      }]
	                    }]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "li",
	                  f: [{
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "router-ignore",
	                      g: 1
	                    }, {
	                      n: "href",
	                      f: "/docs/api.globalping.io",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: ["REST API"]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "li",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "divider",
	                    g: 1
	                  }, {
	                    n: "role",
	                    f: "separator",
	                    t: 13,
	                    g: 1
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "li",
	                  f: [{
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      n: "href",
	                      f: "/integrations",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: ["All Integrations"]
	                  }]
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "li",
	              f: [{
	                t: 7,
	                e: "a",
	                m: [{
	                  n: "href",
	                  f: "/credits",
	                  t: 13,
	                  g: 1
	                }],
	                f: ["Credits"]
	              }]
	            }, " ", {
	              t: 7,
	              e: "li",
	              f: [{
	                t: 7,
	                e: "a",
	                m: [{
	                  n: "href",
	                  f: "/network",
	                  t: 13,
	                  g: 1
	                }],
	                f: ["Network"]
	              }]
	            }, " ", {
	              t: 7,
	              e: "li",
	              f: [{
	                t: 7,
	                e: "a",
	                m: [{
	                  n: "href",
	                  f: "/sponsors",
	                  t: 13,
	                  g: 1
	                }],
	                f: ["Sponsors"]
	              }]
	            }, " ", {
	              t: 7,
	              e: "li",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "dropdown",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "a",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "dropdown-toggle",
	                  g: 1
	                }, {
	                  n: "data-toggle",
	                  f: "dropdown",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "role",
	                  f: "button",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "aria-haspopup",
	                  f: "true",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "aria-expanded",
	                  f: "false",
	                  t: 13,
	                  g: 1
	                }],
	                f: ["The Project ", {
	                  t: 7,
	                  e: "i",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "fa fa-angle-down",
	                    g: 1
	                  }, {
	                    n: "aria-hidden",
	                    f: "true",
	                    t: 13,
	                    g: 1
	                  }]
	                }]
	              }, " ", {
	                t: 7,
	                e: "ul",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "dropdown-menu",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "li",
	                  f: [{
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      n: "href",
	                      f: "/about-us",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: ["About Us"]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "li",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "divider",
	                    g: 1
	                  }, {
	                    n: "role",
	                    f: "separator",
	                    t: 13,
	                    g: 1
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "li",
	                  f: [{
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "router-ignore",
	                      g: 1
	                    }, {
	                      n: "target",
	                      f: "_blank",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "href",
	                      f: "https://blog.globalping.io",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: ["Blog ", {
	                      t: 7,
	                      e: "i",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "fa fa-external-link",
	                        g: 1
	                      }, {
	                        n: "aria-hidden",
	                        f: "true",
	                        t: 13,
	                        g: 1
	                      }]
	                    }]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "li",
	                  f: [{
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "router-ignore",
	                      g: 1
	                    }, {
	                      n: "target",
	                      f: "_blank",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "href",
	                      f: "https://github.com/jsdelivr/globalping",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: ["GitHub ", {
	                      t: 7,
	                      e: "i",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "fa fa-external-link",
	                        g: 1
	                      }, {
	                        n: "aria-hidden",
	                        f: "true",
	                        t: 13,
	                        g: 1
	                      }]
	                    }]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "li",
	                  f: [{
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      n: "target",
	                      f: "_blank",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "rel",
	                      f: "noopener noreferrer",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "href",
	                      f: "https://jsdelivr.us11.list-manage.com/subscribe?u=0c85fe2c9a60310df9a3d6751&id=283887f736",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: ["Newsletter ", {
	                      t: 7,
	                      e: "i",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "fa fa-external-link",
	                        g: 1
	                      }, {
	                        n: "aria-hidden",
	                        f: "true",
	                        t: 13,
	                        g: 1
	                      }]
	                    }]
	                  }]
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "li",
	              f: [{
	                t: 7,
	                e: "a",
	                m: [{
	                  n: "target",
	                  f: "_blank",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "rel",
	                  f: "noopener noreferrer",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "href",
	                  f: "https://twitter.com/jsDelivr",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "title",
	                  f: "Twitter",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "i",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "fa fa-twitter",
	                    g: 1
	                  }, {
	                    n: "aria-hidden",
	                    f: "true",
	                    t: 13,
	                    g: 1
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "span",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "icon-label-mobile",
	                    g: 1
	                  }],
	                  f: ["Twitter"]
	                }]
	              }]
	            }, " ", {
	              t: 4,
	              f: [{
	                t: 7,
	                e: "li",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "dashboard-section",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "btn btn-dash",
	                    g: 1
	                  }, {
	                    n: "href",
	                    f: "https://dash.globalping.io",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "svg",
	                    m: [{
	                      t: 13,
	                      n: "style",
	                      f: "margin-right: 8px;",
	                      g: 1
	                    }, {
	                      n: "width",
	                      f: "14",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "14",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "viewBox",
	                      f: "0 0 20 20",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "fill",
	                      f: "none",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "stroke",
	                      f: "currentColor",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "xmlns",
	                      f: "http://www.w3.org/2000/svg",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: [{
	                      t: 7,
	                      e: "path",
	                      m: [{
	                        n: "d",
	                        f: "M8.33333 2.5H2.5V8.33333H8.33333V2.5Z",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "stroke-width",
	                        f: "2",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "stroke-linecap",
	                        f: "round",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "stroke-linejoin",
	                        f: "round",
	                        t: 13,
	                        g: 1
	                      }]
	                    }, " ", {
	                      t: 7,
	                      e: "path",
	                      m: [{
	                        n: "d",
	                        f: "M17.5 2.5H11.6667V8.33333H17.5V2.5Z",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "stroke-width",
	                        f: "2",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "stroke-linecap",
	                        f: "round",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "stroke-linejoin",
	                        f: "round",
	                        t: 13,
	                        g: 1
	                      }]
	                    }, " ", {
	                      t: 7,
	                      e: "path",
	                      m: [{
	                        n: "d",
	                        f: "M17.5 11.6667H11.6667V17.5001H17.5V11.6667Z",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "stroke-width",
	                        f: "2",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "stroke-linecap",
	                        f: "round",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "stroke-linejoin",
	                        f: "round",
	                        t: 13,
	                        g: 1
	                      }]
	                    }, " ", {
	                      t: 7,
	                      e: "path",
	                      m: [{
	                        n: "d",
	                        f: "M8.33333 11.6667H2.5V17.5001H8.33333V11.6667Z",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "stroke-width",
	                        f: "2",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "stroke-linecap",
	                        f: "round",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "stroke-linejoin",
	                        f: "round",
	                        t: 13,
	                        g: 1
	                      }]
	                    }]
	                  }, " Dashboard"]
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "dropdown",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "button",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "btn dropdown-toggle hidden-xs hidden-sm",
	                      g: 1
	                    }, {
	                      n: "type",
	                      f: "button",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "data-toggle",
	                      f: "dropdown",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "aria-haspopup",
	                      f: "true",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "aria-expanded",
	                      f: "false",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: [{
	                      t: 7,
	                      e: "svg",
	                      m: [{
	                        t: 13,
	                        n: "style",
	                        f: "vertical-align: middle;",
	                        g: 1
	                      }, {
	                        n: "fill",
	                        f: "currentColor",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "width",
	                        f: "20px",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "height",
	                        f: "20px",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "xmlns",
	                        f: "http://www.w3.org/2000/svg",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "viewBox",
	                        f: "0 0 24 24",
	                        t: 13,
	                        g: 1
	                      }],
	                      f: [{
	                        t: 7,
	                        e: "g",
	                        m: [{
	                          n: "id",
	                          f: "user",
	                          t: 13,
	                          g: 1
	                        }],
	                        f: [{
	                          t: 7,
	                          e: "path",
	                          m: [{
	                            n: "d",
	                            f: "M12,12.25A3.75,3.75,0,1,1,15.75,8.5,3.75,3.75,0,0,1,12,12.25Zm0-6A2.25,2.25,0,1,0,14.25,8.5,2.25,2.25,0,0,0,12,6.25Z",
	                            t: 13,
	                            g: 1
	                          }]
	                        }, " ", {
	                          t: 7,
	                          e: "path",
	                          m: [{
	                            n: "d",
	                            f: "M19,19.25a.76.76,0,0,1-.75-.75c0-1.95-1.06-3.25-6.25-3.25s-6.25,1.3-6.25,3.25a.75.75,0,0,1-1.5,0c0-4.75,5.43-4.75,7.75-4.75s7.75,0,7.75,4.75A.76.76,0,0,1,19,19.25Z",
	                            t: 13,
	                            g: 1
	                          }]
	                        }]
	                      }]
	                    }, " ", {
	                      t: 7,
	                      e: "span",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "caret",
	                        g: 1
	                      }]
	                    }, " ", {
	                      t: 7,
	                      e: "span",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "sr-only",
	                        g: 1
	                      }],
	                      f: ["Toggle Dropdown"]
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "ul",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "dropdown-menu",
	                      g: 1
	                    }],
	                    f: [{
	                      t: 7,
	                      e: "li",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "current-user",
	                        g: 1
	                      }],
	                      f: [{
	                        t: 2,
	                        r: "@shared.user.github_username"
	                      }]
	                    }, " ", {
	                      t: 7,
	                      e: "li",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "divider",
	                        g: 1
	                      }, {
	                        n: "role",
	                        f: "separator",
	                        t: 13,
	                        g: 1
	                      }]
	                    }, " ", {
	                      t: 7,
	                      e: "li",
	                      f: [{
	                        t: 7,
	                        e: "a",
	                        m: [{
	                          n: ["click"],
	                          t: 70,
	                          f: {
	                            r: ["@this"],
	                            s: "[_0.signOut()]"
	                          }
	                        }],
	                        f: ["Sign Out"]
	                      }]
	                    }]
	                  }]
	                }]
	              }, " ", {
	                t: 7,
	                e: "li",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "hidden-md hidden-lg",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    n: ["click"],
	                    t: 70,
	                    f: {
	                      r: ["@this"],
	                      s: "[_0.signOut()]"
	                    }
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "i",
	                    m: [{
	                      t: 13,
	                      n: "style",
	                      f: "margin-right: 8px;",
	                      g: 1
	                    }, {
	                      t: 13,
	                      n: "class",
	                      f: "fa fa-sign-out",
	                      g: 1
	                    }]
	                  }, "Sign Out"]
	                }]
	              }],
	              n: 50,
	              r: "@shared.user"
	            }, {
	              t: 4,
	              f: [{
	                t: 7,
	                e: "li",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "dashboard-section",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "btn btn-sign-in",
	                    g: 1
	                  }, {
	                    n: ["click"],
	                    t: 70,
	                    f: {
	                      r: ["@this"],
	                      s: "[_0.signIn()]"
	                    }
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "i",
	                    m: [{
	                      t: 13,
	                      n: "style",
	                      f: "margin-right: 8px;",
	                      g: 1
	                    }, {
	                      t: 13,
	                      n: "class",
	                      f: "fa fa-sign-in hidden-md hidden-lg",
	                      g: 1
	                    }]
	                  }, " Sign in ", {
	                    t: 7,
	                    e: "span",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "hidden-md hidden-lg",
	                      g: 1
	                    }],
	                    f: [" with GitHub"]
	                  }, {
	                    t: 7,
	                    e: "i",
	                    m: [{
	                      t: 13,
	                      n: "style",
	                      f: "margin-left: 8px;",
	                      g: 1
	                    }, {
	                      t: 13,
	                      n: "class",
	                      f: "fa fa-github hidden-xs hidden-sm",
	                      g: 1
	                    }]
	                  }]
	                }]
	              }, " "],
	              n: 50,
	              x: {
	                r: ["@shared.user"],
	                s: "_0===null"
	              },
	              l: 1
	            }, {
	              t: 4,
	              f: [" ", {
	                t: 7,
	                e: "li",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "dashboard-section",
	                  g: 1
	                }]
	              }],
	              n: 51,
	              l: 1
	            }]
	          }]
	        }]
	      }]
	    }]
	  }],
	  e: {
	    "[_0.fire(\"main-logo-click\")]": function (_0) {
	      return [_0.fire("main-logo-click")];
	    },
	    "!_0?\"navbar-hidden\":\"about-navbar-right\"": function (_0) {
	      return !_0 ? "navbar-hidden" : "about-navbar-right";
	    },
	    "[_0.signOut()]": function (_0) {
	      return [_0.signOut()];
	    },
	    "[_0.signIn()]": function (_0) {
	      return [_0.signIn()];
	    },
	    "_0===null": function (_0) {
	      return _0 === null;
	    }
	  }
	};
	var gpHeader = ractive__default["default"].extend(component$m.exports);

	var component$l = {
	  exports: {}
	};
	component$l.exports.template = {
	  v: 4,
	  t: [{
	    t: 4,
	    f: [{
	      t: 7,
	      e: "script",
	      m: [{
	        n: "type",
	        f: "text/plain",
	        t: 13,
	        g: 1
	      }, {
	        n: "id",
	        f: "ractive-data",
	        t: 13,
	        g: 1
	      }],
	      f: ["\t\t<<RACTIVE_SERIALIZED_DATA>>\n\t"]
	    }, " ", {
	      t: 7,
	      e: "script",
	      m: [{
	        n: "type",
	        f: "text/plain",
	        t: 13,
	        g: 1
	      }, {
	        n: "id",
	        f: "ractive-shared",
	        t: 13,
	        g: 1
	      }],
	      f: ["\t\t", {
	        t: 2,
	        x: {
	          r: ["@shared", "@shared.serverHost", "@shared.assetsHost", "@shared.apiDocsHost", "@shared.assetsVersion", "@shared.route", "@shared.params", "@shared.qsParams", "@shared.options"],
	          s: "_0.escape(JSON.stringify({serverHost:_1,assetsHost:_2,apiDocsHost:_3,assetsVersion:_4,route:_5,params:_6,qsParams:_7,options:_8}))"
	        }
	      }, "\n\t"]
	    }],
	    n: 50,
	    r: "@shared.isServer"
	  }],
	  e: {
	    "_0.escape(JSON.stringify({serverHost:_1,assetsHost:_2,apiDocsHost:_3,assetsVersion:_4,route:_5,params:_6,qsParams:_7,options:_8}))": function (_0, _1, _2, _3, _4, _5, _6, _7, _8) {
	      return _0.escape(JSON.stringify({
	        serverHost: _1,
	        assetsHost: _2,
	        apiDocsHost: _3,
	        assetsVersion: _4,
	        route: _5,
	        params: _6,
	        qsParams: _7,
	        options: _8
	      }));
	    }
	  }
	};
	var rSerialize = ractive__default["default"].extend(component$l.exports);

	var component$k = {
	  exports: {}
	};
	const R_META_CLASS = 'r-meta-e';
	ractive__default["default"].sharedSet('R_META_CLASS', R_META_CLASS);
	component$k.exports = {
	  oninit() {
	    let rPage = this.findParent('r-page');
	    let tMeta = rPage.partials.meta;
	    let tSeo = rPage.partials.seo;
	    let filterNodes = (o, predicate) => {
	      if (Array.isArray(o)) {
	        return o.filter(predicate).map(n => filterNodes(n, predicate));
	      } else if (o && typeof o === 'object') {
	        return Object.fromEntries(Object.entries(o).map(_ref => {
	          let [key, value] = _ref;
	          return [key, filterNodes(value, predicate)];
	        }));
	      }
	      return o;
	    };
	    let walkElements = (o, callback) => {
	      if (Array.isArray(o)) {
	        o.forEach(i => walkElements(i, callback));
	      } else if (o && typeof o === 'object') {
	        if (o.t === 7) {
	          callback(o);
	        }
	        Object.values(o).forEach(v => walkElements(v, callback));
	      }
	    };
	    if (!tMeta._metaDecorated) {
	      tMeta = filterNodes(tMeta, n => n.t !== 9);
	      walkElements(tMeta, e => {
	        e.m = e.m || [];
	        e.m.push({
	          t: 13,
	          n: 'class',
	          f: R_META_CLASS
	        });
	      });
	      tMeta._metaDecorated = true;
	    }
	    if (tSeo && !tSeo._metaDecorated) {
	      tSeo = filterNodes(tSeo, n => n.t !== 9);
	      walkElements(tSeo, e => {
	        e.m = e.m || [];
	        e.m.push({
	          t: 13,
	          n: 'class',
	          f: R_META_CLASS
	        });
	      });
	      tSeo._metaDecorated = true;
	    }

	    // We need a way to identify the nodes rendered by the component via SSR
	    // when running on the client. We do this by injecting a special class into
	    // all elements in the template.
	    rPage.partials.seo = tSeo;
	    rPage.partials.meta = tMeta;
	    this.partials = rPage.partials;
	    this.resetPartial('meta', tMeta);

	    // A bit of context hacking:
	    // the meta partial itself renders with the context of r-page
	    // the seo partial renders with the context of the current page (root context)
	    this.link('', 'rootContext', {
	      instance: rPage.parent
	    });
	    this.link('', 'rPageContext', {
	      instance: rPage
	    });

	    // Update the shared path on page switch.
	    this.set('@shared.actualPath', this.get('@shared')?.app?.router?.uri?.path);
	  }
	};
	component$k.exports.template = {
	  v: 4,
	  t: [{
	    t: 8,
	    r: "meta",
	    c: {
	      r: "rPageContext"
	    }
	  }]
	};
	var rMeta = ractive__default["default"].extend(component$k.exports);

	var component$j = {
	  exports: {}
	};
	component$j.exports = {
	  data() {
	    return {
	      publicRoot: ''
	    };
	  },
	  onrender() {
	    document.querySelectorAll(`.${ractive__default["default"].sharedGet('R_META_CLASS')}`).forEach(e => e.remove());
	    // eslint-disable-next-line new-cap
	    app.meta = new this.components['r-meta']({
	      el: document.head,
	      append: document.querySelector('meta').nextElementSibling,
	      parent: this
	    });
	  },
	  onunrender() {
	    app.meta.teardown();
	  }
	};
	component$j.exports.template = {
	  v: 4,
	  t: [{
	    t: 4,
	    f: [{
	      t: 16
	    }],
	    n: 50,
	    x: {
	      r: ["@shared.isServer"],
	      s: "!_0"
	    }
	  }, {
	    t: 4,
	    f: [{
	      t: 18,
	      a: " html"
	    }, " ", {
	      t: 7,
	      e: "html",
	      m: [{
	        n: "lang",
	        f: "en",
	        t: 13,
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "head",
	        f: [{
	          t: 7,
	          e: "meta",
	          m: [{
	            n: "charset",
	            f: "utf-8",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "r-meta"
	        }, " ", {
	          t: 9,
	          c: " Static part that doesn't change after the initial render. "
	        }, " ", {
	          t: 9,
	          c: " Maybe will be useful in Firefox at some point. "
	        }, " ", {
	          t: 7,
	          e: "link",
	          m: [{
	            n: "rel",
	            f: "dns-prefetch",
	            t: 13,
	            g: 1
	          }, {
	            n: "href",
	            f: "https://cdn.jsdelivr.net/",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "link",
	          m: [{
	            n: "rel",
	            f: "dns-prefetch",
	            t: 13,
	            g: 1
	          }, {
	            n: "href",
	            f: "https://fonts.gstatic.com/",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 9,
	          c: "\t\t\t<link rel=\"dns-prefetch\" href=\"https://datum.jsdelivr.com/\">"
	        }, " ", {
	          t: 7,
	          e: "link",
	          m: [{
	            n: "rel",
	            f: "preconnect",
	            t: 13,
	            g: 1
	          }, {
	            n: "href",
	            f: "https://cdn.jsdelivr.net/",
	            t: 13,
	            g: 1
	          }, {
	            n: "crossorigin",
	            f: "anonymous",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "link",
	          m: [{
	            n: "rel",
	            f: "preconnect",
	            t: 13,
	            g: 1
	          }, {
	            n: "href",
	            f: "https://fonts.gstatic.com/",
	            t: 13,
	            g: 1
	          }, {
	            n: "crossorigin",
	            f: "anonymous",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 9,
	          c: "\t\t\t<link rel=\"preconnect\" href=\"https://datum.jsdelivr.com/\" crossorigin=\"anonymous\">"
	        }, " ", {
	          t: 7,
	          e: "link",
	          m: [{
	            n: "rel",
	            f: "preconnect",
	            t: 13,
	            g: 1
	          }, {
	            n: "href",
	            f: "https://fonts.googleapis.com",
	            t: 13,
	            g: 1
	          }, {
	            n: "crossorigin",
	            f: "anonymous",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "link",
	          m: [{
	            n: "rel",
	            f: "stylesheet",
	            t: 13,
	            g: 1
	          }, {
	            n: "href",
	            f: "https://fonts.googleapis.com/css2?family=Lexend:wght@400;500;600&display=swap",
	            t: 13,
	            g: 1
	          }, {
	            n: "media",
	            f: "print",
	            t: 13,
	            g: 1
	          }, {
	            n: "onload",
	            f: "this.media='all'",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "link",
	          m: [{
	            n: "rel",
	            f: "stylesheet",
	            t: 13,
	            g: 1
	          }, {
	            n: "href",
	            f: "https://fonts.googleapis.com/css2?family=Source+Code+Pro:wght@500&display=swap",
	            t: 13,
	            g: 1
	          }, {
	            n: "media",
	            f: "print",
	            t: 13,
	            g: 1
	          }, {
	            n: "onload",
	            f: "this.media='all'",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "link",
	          m: [{
	            n: "rel",
	            f: "stylesheet",
	            t: 13,
	            g: 1
	          }, {
	            n: "href",
	            f: [{
	              t: 2,
	              r: "@shared.assetsHost"
	            }, "/css/app.css?v=", {
	              t: 2,
	              r: "@shared.assetsVersion"
	            }],
	            t: 13
	          }]
	        }, " ", {
	          t: 7,
	          e: "link",
	          m: [{
	            n: "rel",
	            f: "stylesheet",
	            t: 13,
	            g: 1
	          }, {
	            n: "href",
	            f: "https://cdn.jsdelivr.net/npm/font-awesome@4.7.0/css/font-awesome.min.css",
	            t: 13,
	            g: 1
	          }, {
	            n: "media",
	            f: "print",
	            t: 13,
	            g: 1
	          }, {
	            n: "onload",
	            f: "this.media='all'",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "link",
	          m: [{
	            n: "rel",
	            f: "stylesheet",
	            t: 13,
	            g: 1
	          }, {
	            n: "href",
	            f: "https://fonts.googleapis.com/css2?family=Inter&display=swap",
	            t: 13,
	            g: 1
	          }, {
	            n: "media",
	            f: "print",
	            t: 13,
	            g: 1
	          }, {
	            n: "onload",
	            f: "this.media='all'",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "link",
	          m: [{
	            n: "rel",
	            f: "sitemap",
	            t: 13,
	            g: 1
	          }, {
	            n: "href",
	            f: "/sitemap/index.xml",
	            t: 13,
	            g: 1
	          }, {
	            n: "type",
	            f: "application/xml",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 16,
	          r: "css"
	        }]
	      }, " ", {
	        t: 7,
	        e: "body",
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            n: "id",
	            f: "page",
	            t: 13,
	            g: 1
	          }],
	          f: [{
	            t: 4,
	            f: [{
	              t: 16
	            }],
	            n: 51,
	            r: "noYield"
	          }]
	        }, " ", {
	          t: 7,
	          e: "r-serialize"
	        }, " ", {
	          t: 7,
	          e: "script",
	          m: [{
	            n: "src",
	            f: "https://cdn.jsdelivr.net/npm/ractive@1.4.0/runtime.min.js",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "script",
	          m: [{
	            n: "src",
	            f: "https://cdn.jsdelivr.net/npm/ractive-route@0.3.11/ractive-route.min.js",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "script",
	          m: [{
	            n: "src",
	            f: "https://cdn.jsdelivr.net/npm/ractive-decorators-sortable@0.2.1/Ractive-decorators-sortable.min.js",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "script",
	          m: [{
	            n: "src",
	            f: "https://cdn.jsdelivr.net/npm/ractive-transitions-fly@0.3.0/dist/ractive-transitions-fly.umd.min.js",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "script",
	          m: [{
	            n: "src",
	            f: "https://cdn.jsdelivr.net/npm/ractive-transitions-slide@0.4.0/dist/ractive-transitions-slide.umd.min.js",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "script",
	          m: [{
	            n: "src",
	            f: "https://cdn.jsdelivr.net/npm/jquery@3.6.3/dist/jquery.slim.min.js",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "script",
	          m: [{
	            n: "src",
	            f: "https://cdn.jsdelivr.net/npm/bootstrap@3.3.7/dist/js/bootstrap.js",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "script",
	          m: [{
	            n: "src",
	            f: "https://cdn.jsdelivr.net/npm/clipboard@2.0.11/dist/clipboard.min.js",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "script",
	          m: [{
	            n: "src",
	            f: "https://cdn.jsdelivr.net/npm/@algolia/autocomplete-js@1.18.1/dist/umd/index.production.min.js",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 16,
	          r: "js"
	        }, " ", {
	          t: 7,
	          e: "script",
	          m: [{
	            n: "src",
	            f: [{
	              t: 2,
	              r: "@shared.assetsHost"
	            }, "/js/app-globalping.js?v=", {
	              t: 2,
	              r: "@shared.assetsVersion"
	            }],
	            t: 13
	          }]
	        }, " ", {
	          t: 7,
	          e: "script",
	          m: [{
	            n: "defer",
	            f: 0,
	            t: 13
	          }, {
	            n: "data-domain",
	            f: "globalping.io",
	            t: 13,
	            g: 1
	          }, {
	            n: "src",
	            f: "https://datum.jsdelivr.com/js/script.js",
	            t: 13,
	            g: 1
	          }]
	        }]
	      }]
	    }],
	    n: 51,
	    l: 1
	  }],
	  p: {
	    meta: [{
	      t: 9,
	      c: " Dynamic metadata that may change between pages. "
	    }, " ", {
	      t: 7,
	      e: "meta",
	      m: [{
	        n: "name",
	        f: "viewport",
	        t: 13,
	        g: 1
	      }, {
	        n: "content",
	        f: "width=device-width, initial-scale=1",
	        t: 13,
	        g: 1
	      }]
	    }, " ", {
	      t: 7,
	      e: "meta",
	      m: [{
	        n: "name",
	        f: "description",
	        t: 13,
	        g: 1
	      }, {
	        n: "content",
	        f: [{
	          t: 2,
	          x: {
	            r: ["description"],
	            s: "_0||\"Run free latency tests and network commands like ping, traceroute, HTTP and DNS resolve on probes located worldwide.\""
	          }
	        }],
	        t: 13
	      }]
	    }, " ", {
	      t: 7,
	      e: "meta",
	      m: [{
	        n: "name",
	        f: "keywords",
	        t: 13,
	        g: 1
	      }, {
	        n: "content",
	        f: "globalping, jsdelivr, free, open source, oss",
	        t: 13,
	        g: 1
	      }]
	    }, " ", {
	      t: 7,
	      e: "meta",
	      m: [{
	        n: "property",
	        f: "og:locale",
	        t: 13,
	        g: 1
	      }, {
	        n: "content",
	        f: "en_US",
	        t: 13,
	        g: 1
	      }]
	    }, " ", {
	      t: 7,
	      e: "meta",
	      m: [{
	        n: "property",
	        f: "og:type",
	        t: 13,
	        g: 1
	      }, {
	        n: "content",
	        f: "website",
	        t: 13,
	        g: 1
	      }]
	    }, " ", {
	      t: 7,
	      e: "meta",
	      m: [{
	        n: "property",
	        f: "og:title",
	        t: 13,
	        g: 1
	      }, {
	        n: "content",
	        f: [{
	          t: 2,
	          x: {
	            r: ["title"],
	            s: "_0||\"Globalping - Internet and web infrastructure monitoring and benchmarking\""
	          }
	        }],
	        t: 13
	      }]
	    }, " ", {
	      t: 7,
	      e: "meta",
	      m: [{
	        n: "property",
	        f: "og:description",
	        t: 13,
	        g: 1
	      }, {
	        n: "content",
	        f: [{
	          t: 2,
	          x: {
	            r: ["description"],
	            s: "_0||\"Run free latency tests and network commands like ping, traceroute, HTTP and DNS resolve on probes located worldwide.\""
	          }
	        }],
	        t: 13
	      }]
	    }, " ", {
	      t: 7,
	      e: "meta",
	      m: [{
	        n: "property",
	        f: "og:url",
	        t: 13,
	        g: 1
	      }, {
	        n: "content",
	        f: [{
	          t: 2,
	          r: "@shared.serverHost"
	        }, {
	          t: 2,
	          r: "@shared.actualPath"
	        }],
	        t: 13
	      }]
	    }, " ", {
	      t: 7,
	      e: "meta",
	      m: [{
	        n: "property",
	        f: "og:site_name",
	        t: 13,
	        g: 1
	      }, {
	        n: "content",
	        f: "Globalping",
	        t: 13,
	        g: 1
	      }]
	    }, " ", {
	      t: 4,
	      f: [{
	        t: 7,
	        e: "meta",
	        m: [{
	          n: "property",
	          f: "og:image",
	          t: 13,
	          g: 1
	        }, {
	          n: "content",
	          f: [{
	            t: 2,
	            r: "openGraphImage"
	          }],
	          t: 13
	        }]
	      }, " ", {
	        t: 7,
	        e: "meta",
	        m: [{
	          n: "property",
	          f: "og:image:secure_url",
	          t: 13,
	          g: 1
	        }, {
	          n: "content",
	          f: [{
	            t: 2,
	            r: "openGraphImage"
	          }],
	          t: 13
	        }]
	      }, " ", {
	        t: 7,
	        e: "meta",
	        m: [{
	          n: "property",
	          f: "og:image:width",
	          t: 13,
	          g: 1
	        }, {
	          n: "content",
	          f: "1280",
	          t: 13,
	          g: 1
	        }]
	      }, " ", {
	        t: 7,
	        e: "meta",
	        m: [{
	          n: "property",
	          f: "og:image:height",
	          t: 13,
	          g: 1
	        }, {
	          n: "content",
	          f: "640",
	          t: 13,
	          g: 1
	        }]
	      }, " ", {
	        t: 7,
	        e: "meta",
	        m: [{
	          n: "name",
	          f: "twitter:image",
	          t: 13,
	          g: 1
	        }, {
	          n: "content",
	          f: [{
	            t: 2,
	            r: "openGraphImage"
	          }],
	          t: 13
	        }]
	      }],
	      n: 50,
	      r: "openGraphImage"
	    }, {
	      t: 4,
	      f: [{
	        t: 7,
	        e: "meta",
	        m: [{
	          n: "property",
	          f: "og:image",
	          t: 13,
	          g: 1
	        }, {
	          n: "content",
	          f: [{
	            t: 2,
	            r: "@shared.assetsHost"
	          }, "/img/og-globalping.png"],
	          t: 13
	        }]
	      }, " ", {
	        t: 7,
	        e: "meta",
	        m: [{
	          n: "property",
	          f: "og:image:secure_url",
	          t: 13,
	          g: 1
	        }, {
	          n: "content",
	          f: [{
	            t: 2,
	            r: "@shared.assetsHost"
	          }, "/img/og-globalping.png"],
	          t: 13
	        }]
	      }, " ", {
	        t: 7,
	        e: "meta",
	        m: [{
	          n: "property",
	          f: "og:image:width",
	          t: 13,
	          g: 1
	        }, {
	          n: "content",
	          f: "1280",
	          t: 13,
	          g: 1
	        }]
	      }, " ", {
	        t: 7,
	        e: "meta",
	        m: [{
	          n: "property",
	          f: "og:image:height",
	          t: 13,
	          g: 1
	        }, {
	          n: "content",
	          f: "640",
	          t: 13,
	          g: 1
	        }]
	      }, " ", {
	        t: 7,
	        e: "meta",
	        m: [{
	          n: "name",
	          f: "twitter:image",
	          t: 13,
	          g: 1
	        }, {
	          n: "content",
	          f: [{
	            t: 2,
	            r: "@shared.assetsHost"
	          }, "/img/og-globalping.png"],
	          t: 13
	        }]
	      }],
	      n: 51,
	      l: 1
	    }, " ", {
	      t: 7,
	      e: "meta",
	      m: [{
	        n: "name",
	        f: "twitter:card",
	        t: 13,
	        g: 1
	      }, {
	        n: "content",
	        f: "summary_large_image",
	        t: 13,
	        g: 1
	      }]
	    }, " ", {
	      t: 7,
	      e: "meta",
	      m: [{
	        n: "name",
	        f: "twitter:title",
	        t: 13,
	        g: 1
	      }, {
	        n: "content",
	        f: [{
	          t: 2,
	          x: {
	            r: ["title"],
	            s: "_0||\"Globalping - Internet and web infrastructure monitoring and benchmarking\""
	          }
	        }],
	        t: 13
	      }]
	    }, " ", {
	      t: 7,
	      e: "meta",
	      m: [{
	        n: "name",
	        f: "twitter:description",
	        t: 13,
	        g: 1
	      }, {
	        n: "content",
	        f: [{
	          t: 2,
	          x: {
	            r: ["description"],
	            s: "_0||\"Run free latency tests and network commands like ping, traceroute, HTTP and DNS resolve on probes located worldwide.\""
	          }
	        }],
	        t: 13
	      }]
	    }, " ", {
	      t: 7,
	      e: "meta",
	      m: [{
	        n: "name",
	        f: "twitter:site",
	        t: 13,
	        g: 1
	      }, {
	        n: "content",
	        f: "@jsdelivr",
	        t: 13,
	        g: 1
	      }]
	    }, " ", {
	      t: 7,
	      e: "meta",
	      m: [{
	        n: "name",
	        f: "twitter:creator",
	        t: 13,
	        g: 1
	      }, {
	        n: "content",
	        f: "@jsdelivr",
	        t: 13,
	        g: 1
	      }]
	    }, " ", {
	      t: 7,
	      e: "title",
	      f: [{
	        t: 2,
	        x: {
	          r: ["title"],
	          s: "_0||\"Globalping - Internet and web infrastructure monitoring and benchmarking\""
	        }
	      }]
	    }, " ", {
	      t: 7,
	      e: "link",
	      m: [{
	        n: "rel",
	        f: "icon",
	        t: 13,
	        g: 1
	      }, {
	        n: "type",
	        f: "image/x-icon",
	        t: 13,
	        g: 1
	      }, {
	        n: "href",
	        f: [{
	          t: 2,
	          r: "publicRoot"
	        }, "/favicon.ico"],
	        t: 13
	      }]
	    }, " ", {
	      t: 7,
	      e: "link",
	      m: [{
	        n: "rel",
	        f: "icon",
	        t: 13,
	        g: 1
	      }, {
	        n: "type",
	        f: "image/svg+xml",
	        t: 13,
	        g: 1
	      }, {
	        n: "href",
	        f: [{
	          t: 2,
	          r: "publicRoot"
	        }, "/icons/favicon.svg"],
	        t: 13
	      }]
	    }, " ", {
	      t: 7,
	      e: "link",
	      m: [{
	        n: "rel",
	        f: "icon",
	        t: 13,
	        g: 1
	      }, {
	        n: "type",
	        f: "image/png",
	        t: 13,
	        g: 1
	      }, {
	        n: "sizes",
	        f: "48x48",
	        t: 13,
	        g: 1
	      }, {
	        n: "href",
	        f: [{
	          t: 2,
	          r: "publicRoot"
	        }, "/icons/favicon-48x48.png"],
	        t: 13
	      }]
	    }, " ", {
	      t: 7,
	      e: "link",
	      m: [{
	        n: "rel",
	        f: "icon",
	        t: 13,
	        g: 1
	      }, {
	        n: "type",
	        f: "image/png",
	        t: 13,
	        g: 1
	      }, {
	        n: "sizes",
	        f: "32x32",
	        t: 13,
	        g: 1
	      }, {
	        n: "href",
	        f: [{
	          t: 2,
	          r: "publicRoot"
	        }, "/icons/favicon-32x32.png"],
	        t: 13
	      }]
	    }, " ", {
	      t: 7,
	      e: "link",
	      m: [{
	        n: "rel",
	        f: "icon",
	        t: 13,
	        g: 1
	      }, {
	        n: "type",
	        f: "image/png",
	        t: 13,
	        g: 1
	      }, {
	        n: "sizes",
	        f: "16x16",
	        t: 13,
	        g: 1
	      }, {
	        n: "href",
	        f: [{
	          t: 2,
	          r: "publicRoot"
	        }, "/icons/favicon-16x16.png"],
	        t: 13
	      }]
	    }, " ", {
	      t: 7,
	      e: "link",
	      m: [{
	        n: "rel",
	        f: "apple-touch-icon",
	        t: 13,
	        g: 1
	      }, {
	        n: "sizes",
	        f: "180x180",
	        t: 13,
	        g: 1
	      }, {
	        n: "href",
	        f: [{
	          t: 2,
	          r: "publicRoot"
	        }, "/icons/apple-touch-icon.png"],
	        t: 13
	      }]
	    }, " ", {
	      t: 7,
	      e: "link",
	      m: [{
	        n: "rel",
	        f: "manifest",
	        t: 13,
	        g: 1
	      }, {
	        n: "href",
	        f: [{
	          t: 2,
	          r: "publicRoot"
	        }, "/icons/site.webmanifest"],
	        t: 13
	      }]
	    }, " ", {
	      t: 7,
	      e: "link",
	      m: [{
	        n: "rel",
	        f: "mask-icon",
	        t: 13,
	        g: 1
	      }, {
	        n: "href",
	        f: [{
	          t: 2,
	          r: "publicRoot"
	        }, "/icons/safari-pinned-tab.svg"],
	        t: 13
	      }, {
	        n: "color",
	        f: "#e64e3d",
	        t: 13,
	        g: 1
	      }]
	    }, " ", {
	      t: 7,
	      e: "meta",
	      m: [{
	        n: "name",
	        f: "apple-mobile-web-app-title",
	        t: 13,
	        g: 1
	      }, {
	        n: "content",
	        f: "Globalping",
	        t: 13,
	        g: 1
	      }]
	    }, " ", {
	      t: 7,
	      e: "meta",
	      m: [{
	        n: "name",
	        f: "application-name",
	        t: 13,
	        g: 1
	      }, {
	        n: "content",
	        f: "Globalping",
	        t: 13,
	        g: 1
	      }]
	    }, " ", {
	      t: 7,
	      e: "meta",
	      m: [{
	        n: "name",
	        f: "msapplication-TileColor",
	        t: 13,
	        g: 1
	      }, {
	        n: "content",
	        f: "#ffffff",
	        t: 13,
	        g: 1
	      }]
	    }, " ", {
	      t: 7,
	      e: "meta",
	      m: [{
	        n: "name",
	        f: "msapplication-config",
	        t: 13,
	        g: 1
	      }, {
	        n: "content",
	        f: [{
	          t: 2,
	          r: "publicRoot"
	        }, "/icons/browserconfig.xml"],
	        t: 13
	      }]
	    }, " ", {
	      t: 7,
	      e: "meta",
	      m: [{
	        n: "name",
	        f: "theme-color",
	        t: 13,
	        g: 1
	      }, {
	        n: "content",
	        f: "#ffffff",
	        t: 13,
	        g: 1
	      }]
	    }, " ", {
	      t: 8,
	      r: "seo",
	      c: {
	        r: "~/rootContext"
	      }
	    }]
	  },
	  e: {
	    "!_0": function (_0) {
	      return !_0;
	    },
	    "_0||\"Run free latency tests and network commands like ping, traceroute, HTTP and DNS resolve on probes located worldwide.\"": function (_0) {
	      return _0 || "Run free latency tests and network commands like ping, traceroute, HTTP and DNS resolve on probes located worldwide.";
	    },
	    "_0||\"Globalping - Internet and web infrastructure monitoring and benchmarking\"": function (_0) {
	      return _0 || "Globalping - Internet and web infrastructure monitoring and benchmarking";
	    }
	  }
	};
	component$j.exports.components = {
	  "r-serialize": rSerialize,
	  "r-meta": rMeta
	};
	var rPageGlobalping = ractive__default["default"].extend(component$j.exports);

	var component$i = {
	  exports: {}
	};
	const CLIENT_DEFAULT_PING_OPTS = {};
	const API_DEFAULT_PING_OPTS = {};
	const CLIENT_DEFAULT_TRACEROUTE_OPTS = {
	  protocol: 'ICMP'
	};
	const API_DEFAULT_TRACEROUTE_OPTS = {
	  protocol: 'ICMP'
	};
	const CLIENT_DEFAULT_DNS_OPTS = {
	  protocol: 'UDP',
	  query: {
	    type: 'A'
	  },
	  trace: false
	};
	const API_DEFAULT_DNS_OPTS = {
	  protocol: 'UDP',
	  query: {
	    type: 'A'
	  },
	  trace: false
	};
	const CLIENT_DEFAULT_MTR_OPTS = {
	  protocol: 'ICMP'
	};
	const API_DEFAULT_MTR_OPTS = {
	  protocol: 'ICMP'
	};
	const CLIENT_DEFAULT_HTTP_OPTS = {
	  protocol: 'HTTPS',
	  request: {
	    method: 'GET'
	  }
	};
	const API_DEFAULT_HTTP_OPTS = {
	  protocol: 'HTTPS',
	  request: {
	    method: 'HEAD'
	  }
	};
	const DEFAULT_PACKETS_AMOUNT = 3;
	const DEFAULT_LIMIT$1 = 1;
	const DOCKER_CMD_CONTENT = 'docker run -d --log-driver local --network host --restart=always --name globalping-probe globalping/globalping-probe';
	const DOCKER_CMD_CONTENT_FULL = [{
	  cmd: 'docker run -d \\',
	  comment: ' # Make sure the container runs on boot'
	}, {
	  cmd: '--log-driver local \\',
	  comment: ' # Use the modern logging driver to ensure old logs are deleted'
	}, {
	  cmd: '--network host \\',
	  comment: ' # Bypass overlay and mesh networking to ensure they dont impact latency tests'
	}, {
	  cmd: '--restart=always \\',
	  comment: ' # Restart the container in case it crashes'
	}, {
	  cmd: '--name globalping-probe globalping/globalping-probe',
	  comment: ''
	}];
	const PODMAN_CMD_CONTENT = 'sudo podman run -d --cap-add=NET_RAW --network host --restart=always --name globalping-probe globalping/globalping-probe';
	const PODMAN_CMD_CONTENT_FULL = [{
	  cmd: 'sudo \\',
	  comment: ' # Allows the --cap-add=NET_RAW option to work properly'
	}, {
	  cmd: 'podman run -d \\',
	  comment: ' # The container will NOT start on boot. You need to create a systemd service first.'
	}, {
	  cmd: '--cap-add=NET_RAW \\',
	  comment: ' # Network permissions to run ping'
	}, {
	  cmd: '--network host \\',
	  comment: '# Bypass overlay and mesh networking to ensure they dont impact latency tests'
	}, {
	  cmd: '--restart=always \\',
	  comment: ' # Restart the container in case it crashes'
	}, {
	  cmd: '--name globalping-probe globalping/globalping-probe',
	  comment: ''
	}];
	const INITIAL_MAIN_OPTS_VALUES = {
	  type: 'ping',
	  target: '',
	  location: 'World',
	  limit: '10'
	};
	const MAP_MIN_ZOOM$1 = 2;
	const MAP_MAX_ZOOM$1 = 22;
	const MAP_ZOOM_REG$1 = 3.74;
	const MAP_CENTER_REG$1 = {
	  lat: 48,
	  lng: 16
	};
	const MAP_ZOOM_ALT$1 = 2.14;
	const MAP_CENTER_ALT$1 = {
	  lat: 30,
	  lng: 18
	};
	const DEFAULT_MARKER_COLOR = '#C0C0C0';
	const PROBE_NO_TIMING_VALUE$1 = _.getProbeTimeOutValue();
	const PROBE_STATUS_FAILED = _.getProbeStatusFailedValue();
	const PROBE_STATUS_OFFLINE$1 = _.getProbeStatusOfflineValue();
	const PROBE_OFFLINE_TEXT = 'Probe offline';
	const RAW_OUTPUT_LINES_BATCH_LIMIT = 40;
	const DEFAULT_TARGET_VALUE = 'cdn.jsdelivr.net';
	const INFINITE_MEASUREMENT_PACKETS = 16;
	const INFINITE_MEASUREMENT_LIMIT = 5;
	const RATE_LIMIT_HEADERS = ['x-ratelimit-limit', 'x-ratelimit-consumed', 'x-ratelimit-remaining', 'x-ratelimit-reset', 'x-credits-consumed', 'x-credits-remaining', 'x-request-cost'];
	const DEFAULT_MEASUREMENT_ERR_MSG = 'All tests failed. Maybe you specified a non existing endpoint?';
	const getMarkerSize$1 = (probeCount, zoom) => {
	  let size = {
	    svgWidth: 16,
	    svgHeight: 16,
	    circleRadius: 4.5,
	    strokeWidth: 1.5
	  };
	  if (probeCount > 1) {
	    let scalingFactor = probeCount.toString().length;
	    size.svgWidth += 4 * scalingFactor + 4;
	    size.svgHeight += 4 * scalingFactor + 4;
	    size.circleRadius += 2 * scalingFactor + 1.5;
	    size.strokeWidth += .5;
	  }
	  if (zoom >= 5) {
	    size.svgWidth *= 1.1;
	    size.svgHeight *= 1.1;
	  }
	  if (zoom >= 10) {
	    size.svgWidth *= 1.1;
	    size.svgHeight *= 1.1;
	  }
	  return size;
	};
	const originalMapMarkersPos = new Map();
	const DEFAULT_MARKER_DIMENSIONS = 24;
	let map$1;
	let infoWindows$1 = [];
	let mapMarkers$1 = [];
	let probesMarkers = [];
	let probesInfoWindows = [];
	let mapProbesClusters = [];
	component$i.exports = {
	  decorators: {
	    clipboard
	  },
	  data() {
	    return {
	      _,
	      rawProbes: '',
	      PROBE_NO_TIMING_VALUE: PROBE_NO_TIMING_VALUE$1,
	      PROBE_STATUS_FAILED,
	      PROBE_STATUS_OFFLINE: PROBE_STATUS_OFFLINE$1,
	      DEFAULT_TARGET_VALUE,
	      INFINITE_MEASUREMENT_LIMIT,
	      INITIAL_MAIN_OPTS_VALUES,
	      testTypesList: ['ping', 'traceroute', 'DNS', 'MTR', 'HTTP'],
	      mainOptions: {
	        ...INITIAL_MAIN_OPTS_VALUES
	      },
	      showMap: true,
	      originalShowMap: true,
	      transitionMap: true,
	      infiniteSwitchEnabled: false,
	      showMeasurementOpts: false,
	      dnsTypesList: ['A', 'AAAA', 'ANY', 'CNAME', 'DNSKEY', 'DS', 'MX', 'NS', 'NSEC', 'PTR', 'RRSIG', 'SOA', 'TXT', 'SRV', 'SVCB'],
	      netDockerCmdText: DOCKER_CMD_CONTENT,
	      netDockerCmdTextFull: DOCKER_CMD_CONTENT_FULL,
	      netPodmanCmdText: PODMAN_CMD_CONTENT,
	      netPodmanCmdTextFull: PODMAN_CMD_CONTENT_FULL,
	      totalProbes: 0,
	      totalCities: 0,
	      totalCountries: 0,
	      pingOpts: CLIENT_DEFAULT_PING_OPTS,
	      tracerouteOpts: CLIENT_DEFAULT_TRACEROUTE_OPTS,
	      dnsOpts: CLIENT_DEFAULT_DNS_OPTS,
	      mtrOpts: CLIENT_DEFAULT_MTR_OPTS,
	      httpOpts: CLIENT_DEFAULT_HTTP_OPTS,
	      inputErrors: {},
	      testResults: null,
	      testInProgress: false,
	      testReqInterval: null,
	      notAppliedOpts: {},
	      defaultPacketsAmount: DEFAULT_PACKETS_AMOUNT,
	      defaultLimit: DEFAULT_LIMIT$1,
	      probesMinTiming: 5,
	      joinNetSwitchValue: 'docker',
	      showCommandsBlock: false,
	      scrolledToResIdx: null,
	      modifiedMeasOptsCnt: 0,
	      appliedMeasOpts: {},
	      shareResHeaderData: null,
	      runTestBtnText: 'Run Test',
	      testReqParams: null,
	      probesResponse: null,
	      shareResFlow: false,
	      activeTargetIdx: 0,
	      rawOutputMode: true,
	      measurementsMetadata: null,
	      targetsArr: [],
	      qsMeasurementIdsArr: [],
	      showCreditsError: false,
	      infiniteMeasIds: [],
	      isInfiniteMeasStopped: false,
	      prevProbesMeasId: null,
	      preparedTestResults: [],
	      ddHandlerSet: false,
	      showCreditsData: false,
	      rateCreditsData: null,
	      measurementErrMsg: null,
	      probesMaxTiming: 200
	    };
	  },
	  onrender() {
	    if (!ractive__default["default"].isServer) {
	      this.set('@shared.googleMapsLoaded', true);
	      if (app.loaded) {
	        this.initMap();
	      }
	      listeners.screenWidthListener(this);
	    }
	  },
	  oninit() {
	    if (!ractive__default["default"].isServer) {
	      this.on('c-header.main-logo-click', () => {
	        this.set('measurement', '');
	        return false;
	      });

	      // check if ids are present in query string
	      // if so - it is a share-results-flow
	      let measurement = this.get('measurement');
	      let qsMeasurementIdsArr = [];
	      let isInfiniteMeas = false;

	      // A separator for IDs for regular link is a comma, for infinite one - plus sign
	      if (measurement && measurement.includes(',')) {
	        qsMeasurementIdsArr = measurement.split(',');
	      } else if (measurement && measurement.includes('.')) {
	        qsMeasurementIdsArr = measurement.split('.');
	        isInfiniteMeas = true;
	        this.set('infiniteSwitchEnabled', true);
	        this.set('isInfiniteModeRes', true);
	        this.set('rawOutputMode', false);
	      } else if (measurement) {
	        qsMeasurementIdsArr = [measurement];
	      }
	      if (qsMeasurementIdsArr.length) {
	        this.set('qsMeasurementIdsArr', qsMeasurementIdsArr);
	        this.set('shareResFlow', true);
	        this.getMultipleTestMeasurementById(qsMeasurementIdsArr, isInfiniteMeas);
	      }

	      // get probes from sessionStorage or fetch them and handle
	      this.getProbesData();

	      // handle test type switch
	      this.observe('mainOptions.type', type => {
	        // if qsMeasurementIdsArr - share-results-flow, so type would be set, we should ignore this case
	        if (this.get('qsMeasurementIdsArr').length) {
	          return;
	        }
	        this.set('showMeasurementOpts', false);
	        this.set('inputErrors', {});
	        this.set(`${type.toLowerCase()}Opts`, this.getDefaultClientMeasOptsByTestName(type));
	        this.set('appliedMeasOpts', {});
	        this.set('notAppliedOpts', {});
	        this.set('measurementErrMsg', null);
	        this.set('modifiedMeasOptsCnt', 0);
	        this.set('infiniteSwitchEnabled', false);
	      }, {
	        init: false
	      });

	      // when infinite switch is enabled set limit to INFINITE_MEASUREMENT_LIMIT if limit is bigger than INFINITE_MEASUREMENT_LIMIT
	      this.observe('infiniteSwitchEnabled', infiniteSwitchEnabled => {
	        let currentLimit = this.get('mainOptions.limit');
	        if (infiniteSwitchEnabled && currentLimit > INFINITE_MEASUREMENT_LIMIT) {
	          this.set('mainOptions.limit', INFINITE_MEASUREMENT_LIMIT);
	        } else if (infiniteSwitchEnabled === false && currentLimit > INFINITE_MEASUREMENT_LIMIT) {
	          this.set('mainOptions.limit', INITIAL_MAIN_OPTS_VALUES.limit);
	        }
	      });

	      // handle limit changing when infinite switch is enabled - disable input if it is bigger than INFINITE_MEASUREMENT_LIMIT
	      this.observe('mainOptions.limit', currentLimit => {
	        let infiniteSwitchEnabled = this.get('infiniteSwitchEnabled');
	        if (infiniteSwitchEnabled && currentLimit >= INFINITE_MEASUREMENT_LIMIT) {
	          this.set('mainOptions.limit', INFINITE_MEASUREMENT_LIMIT);
	        }
	      });

	      // handle join-network switch and commands content
	      this.observe('joinNetSwitchValue', joinNetSwitchValue => {
	        let netCmdText;
	        let netCmdTextFull;
	        switch (joinNetSwitchValue) {
	          case 'podman':
	            netCmdText = this.get('netPodmanCmdText');
	            netCmdTextFull = this.get('netPodmanCmdTextFull');
	            break;
	          case 'docker':
	          default:
	            netCmdText = this.get('netDockerCmdText');
	            netCmdTextFull = this.get('netDockerCmdTextFull');
	        }
	        this.set('netCmdText', netCmdText);
	        this.set('netCmdTextFull', netCmdTextFull);
	        let clipboardValue = netCmdTextFull.map(part => part.cmd).join('\n');
	        this.set('netCmdTextFullClipboard', clipboardValue);
	        if (this.get('showCommandsBlock')) {
	          this.set('showCommandsBlock', false);
	        }
	      });

	      // handle show-hide full join-network command
	      this.observe('showCommandsBlock', showCommandsBlock => {
	        if (showCommandsBlock) {
	          this.expandCmdBlock();
	        } else {
	          this.collapseCmdBlock();
	        }
	      }, {
	        init: false,
	        defer: true
	      });

	      // zoom to results once we get the first response
	      this.observe('realTimeTestResResponse', (responses, prevResponses) => {
	        if (!prevResponses && responses && responses.every(r => r.results.length) && responses[0]) {
	          this.zoomToResults(responses[0].locations);
	        }
	      }, {
	        init: false
	      });

	      // handle test results in real time
	      this.observe('realTimeTestResResponse', realTimeTestResResponse => {
	        if (!realTimeTestResResponse) {
	          return;
	        }

	        // clear interval for the related request when it's finished, collect reponses statuses
	        let respStatuses = realTimeTestResResponse.reduce((statusObj, r, rIdx) => {
	          if (r.status === 'finished') {
	            clearInterval(this.get('testReqInterval')[rIdx]);
	            return {
	              ...statusObj,
	              [rIdx]: true
	            };
	          }
	          return {
	            ...statusObj,
	            [rIdx]: false
	          };
	        }, {});

	        // check respStatuses and handle the case when all requests are finished unless it is an infinite flow
	        let infiniteSwitchEnabled = this.get('infiniteSwitchEnabled');
	        let targetsArrLength = this.get('targetsArr').length;
	        if (!(targetsArrLength === 1 && infiniteSwitchEnabled) && Object.values(respStatuses).length === targetsArrLength && Object.values(respStatuses).every(s => s === true)) {
	          this.set('testInProgress', false);

	          // if it is a share-results-flow - scroll mapBlock into the view
	          if (this.get('shareResFlow')) {
	            this.scrollMapIntoView();
	          }
	        }
	        if (realTimeTestResResponse && realTimeTestResResponse.length) {
	          realTimeTestResResponse.forEach((rtTestRes, rtTestResIdx) => {
	            let prevTestResults = this.get(`testResults[${rtTestResIdx}]`);
	            let testResults = rtTestRes.results.map((res, resIdx) => ({
	              id: rtTestRes.id,
	              clientSideId: resIdx,
	              target: rtTestRes.target,
	              type: rtTestRes.type,
	              clientSideStartedAt: prevTestResults ? prevTestResults[resIdx].clientSideStartedAt : rtTestRes.clientSideStartedAt,
	              clientSideUpdatedAt: rtTestRes.clientSideUpdatedAt,
	              serverTime: new Date(rtTestRes.updatedAt).getTime() - new Date(rtTestRes.createdAt).getTime(),
	              status: rtTestRes.status,
	              ...res
	            }));
	            if (JSON.stringify(testResults) !== JSON.stringify(prevTestResults)) {
	              this.set(`testResults[${rtTestResIdx}]`, testResults);
	            }
	          });
	        }
	      }, {
	        init: false
	      });

	      // prepare data for Markers of the map, timings for the map scale
	      this.observe('testResults', testResults => {
	        if (!testResults) {
	          return;
	        }
	        let dnsOpts = this.get('dnsOpts');
	        let testType = this.get('mainOptions.type');
	        let targetsCnt = this.get('targetsArr').length;
	        let infiniteSwitchEnabled = this.get('infiniteSwitchEnabled');

	        // combine results
	        // if it is a regular measurement then each array element is corresponds to each target, these arrays elements contain data per probe for this target
	        // if Infinite measurement - each array element is a new request's response, each el inside such array is a data for probe
	        let parsedMeasData = testResults.reduce((mData, tRes, tResIdx) => {
	          if (!tRes || !tRes.length) {
	            return mData;
	          }
	          let mappedRes = tRes.map((res, resIdx) => {
	            let calcTiming = null;
	            let data = {
	              id: res.id,
	              clientSideId: res.clientSideId,
	              network: res.probe.network,
	              city: res.probe.city,
	              country: res.probe.country,
	              lat: res.probe.latitude,
	              lng: res.probe.longitude,
	              targets: [res.target]
	            };
	            if (infiniteSwitchEnabled) {
	              let {
	                packetsRtt
	              } = _.parseGpRawOutputForTimings(res.result.rawOutput);
	              let prevPacketsRtt = tResIdx - 1 >= 0 ? mData[tResIdx - 1][resIdx].packetsRtt : [];
	              let allCurrPacketsRtt = [...prevPacketsRtt, ...packetsRtt];
	              let numericPacketsRtt = allCurrPacketsRtt.filter(v => typeof v === 'number');
	              data = {
	                ...data,
	                packetsRtt: allCurrPacketsRtt
	              };
	              if (res.result.status === PROBE_STATUS_FAILED) {
	                calcTiming = {
	                  value: PROBE_STATUS_FAILED
	                };
	              } else if (res.result.status === PROBE_STATUS_OFFLINE$1) {
	                calcTiming = {
	                  value: PROBE_STATUS_OFFLINE$1
	                };
	              } else if (numericPacketsRtt.length) {
	                calcTiming = {
	                  value: Math.round(numericPacketsRtt.reduce((sum, rtt) => sum += rtt, 0) / numericPacketsRtt.length),
	                  units: ' ms'
	                };
	              } else if (packetsRtt.length && packetsRtt.every(v => v === _.getProbeTimeOutValue())) {
	                calcTiming = {
	                  value: _.getProbeTimeOutValue()
	                };
	              } else {
	                calcTiming = {
	                  value: tResIdx - 1 >= 0 ? mData[tResIdx - 1][resIdx].timings[0] : null
	                };
	              }
	            } else if (res.result.status !== 'in-progress') {
	              calcTiming = _.calcGpTestResTiming(testType, res, dnsOpts.trace);
	            }
	            let resTiming = !calcTiming ? null : typeof calcTiming.value === 'number' ? `${Math.round(calcTiming.value)}${calcTiming.units}` : calcTiming.value;
	            return {
	              ...data,
	              timings: [resTiming]
	            };
	          });
	          return {
	            ...mData,
	            [tResIdx]: mappedRes
	          };
	        }, {});

	        // markersData for the first target, regular flow
	        let markersData = parsedMeasData[0];

	        // in case of infinite flow, get the latest data
	        if (infiniteSwitchEnabled) {
	          let lastIdx = Object.keys(parsedMeasData).length - 1;
	          markersData = parsedMeasData[lastIdx];
	        }

	        // if there are another targets then we should add its data to markersData respectively
	        if (targetsCnt > 1) {
	          for (let cnt = 1; cnt < targetsCnt; cnt++) {
	            if (!parsedMeasData[cnt]) {
	              return;
	            }
	            markersData = markersData.map(mD => {
	              let secReqMD = parsedMeasData[cnt].find(i => i.clientSideId === mD.clientSideId);
	              return {
	                ...mD,
	                timings: [...mD.timings, ...secReqMD.timings],
	                targets: [...mD.targets, ...secReqMD.targets]
	              };
	            });
	          }
	        }
	        this.set('markersData', markersData);
	      }, {
	        init: false
	      });

	      // check the statuses of probes in the measurement and stop measurement if all of them are failed
	      this.observe('testResults', testResults => {
	        for (let i in testResults) {
	          if (testResults[i].every(r => r.result.status === PROBE_STATUS_FAILED)) {
	            this.stopInfiniteTest();
	            return;
	          }
	        }
	      });

	      // prepare results for gp-results-raw-output and gp-results-table-output, regular or infinite flow
	      this.observe('testResults', testResults => {
	        if (!testResults) {
	          return;
	        }
	        let testType = this.get('testReqParams.type');
	        let isInfiniteModeRes = this.get('isInfiniteModeRes');
	        let preparedTestResults;
	        if (testType === 'ping' && isInfiniteModeRes) {
	          preparedTestResults = this.prepareInfiniteResults(testResults);
	        } else {
	          preparedTestResults = this.prepareRegularResults(testResults);
	        }
	        this.set('preparedTestResults', preparedTestResults);
	      });

	      // set initial screenWidth value
	      this.observe('screenWidth', screenWidth => {
	        if (!screenWidth) {
	          this.set('screenWidth', window.innerWidth);
	        }
	      });

	      // handle tooltips positions depending on the screen size
	      this.observe('screenWidth', screenWidth => {
	        let ttPositions = {};
	        if (screenWidth >= 1272) {
	          ttPositions.targetTtPos = 'top';
	          ttPositions.locationTtPos = 'top';
	          ttPositions.limitTtPos = 'top';
	        } else if (screenWidth >= 768) {
	          ttPositions.targetTtPos = 'top';
	          ttPositions.locationTtPos = 'right';
	          ttPositions.limitTtPos = 'top';
	        } else {
	          ttPositions.targetTtPos = 'right';
	          ttPositions.locationTtPos = 'right';
	          ttPositions.limitTtPos = 'right';
	        }
	        this.set('ttPositions', ttPositions);
	      });

	      // disable Infinite switch if there is more than one target
	      this.observe('mainOptions.target', target => {
	        if (target.split(',').length > 1) {
	          let infiniteSwitchEnabled = this.get('infiniteSwitchEnabled');
	          if (infiniteSwitchEnabled) {
	            this.set('notAppliedOpts.packets', '');
	            this.set('infiniteSwitchEnabled', false);
	            this.applyOptions();
	          }
	        }
	      });

	      // add navigation functionality once the Run Test button with dropdown appeared
	      this.observe('testInProgress', testInProgress => {
	        let prevProbesMeasId = this.get('prevProbesMeasId');
	        if (prevProbesMeasId && !testInProgress) {
	          this.handleDropDownRunTestBtnNav();
	        }
	      });
	      this.observe('showMap', newValue => {
	        if (!newValue && this.get('originalShowMap')) {
	          this.set('transitionMap', false);
	        } else {
	          // using a deferred observer somehow isn't sufficient here
	          setTimeout(() => {
	            this.set('transitionMap', true);
	          }, 100);
	        }
	      });
	    }
	  },
	  oncomplete() {
	    if (!ractive__default["default"].isServer) {
	      // run the test if user is pressed Enter inside of any of main options inputs
	      let targetInput = this.find('#targetInput');
	      let limitInput = this.find('#limitInput');
	      let handleEnterBtn = event => {
	        if (event.key === 'Enter') {
	          event.preventDefault();
	          this.resetMapAndRunTest();
	        }
	      };
	      targetInput.addEventListener('keypress', handleEnterBtn);
	      limitInput.addEventListener('keypress', handleEnterBtn);
	    }
	  },
	  proceedToTest(prevProbesMeasId) {
	    let {
	      type,
	      target,
	      location,
	      limit,
	      ipVersion
	    } = this.get('mainOptions');
	    let appliedMeasOpts = this.get('appliedMeasOpts');
	    let measurementOpts = _.deepExtend({}, appliedMeasOpts.initPresetOpts, appliedMeasOpts.notPresetOpts);
	    let targetsArr = target.split(',').map(target => target.trim());
	    let infiniteSwitchEnabled = this.get('infiniteSwitchEnabled');

	    // create parameters for the measurement request
	    let reqParams = {
	      type,
	      // to get test results in real time
	      inProgressUpdates: true
	    };

	    // ipVersion should be passed only if there is 1 target and it is a domain name and test type is not a DNS
	    if (ipVersion && type.toLowerCase() !== 'dns') {
	      measurementOpts = {
	        ...measurementOpts,
	        ipVersion
	      };
	    }
	    reqParams.limit = limit || DEFAULT_LIMIT$1;
	    if (location) {
	      reqParams.locations = location.split(',').map(loc => ({
	        magic: loc
	      }));
	    } else {
	      this.set('mainOptions.location', INITIAL_MAIN_OPTS_VALUES.location);
	      reqParams.locations = [{
	        magic: INITIAL_MAIN_OPTS_VALUES.location
	      }];
	    }

	    // since packets field default value is present only for Ping and MTR type
	    if (type.toLowerCase() === 'ping' || type.toLowerCase() === 'mtr') {
	      reqParams.measurementOptions = {
	        // set default values in case if user did not set them manually
	        packets: DEFAULT_PACKETS_AMOUNT
	      };
	    } else {
	      delete measurementOpts.packets;
	      if (type.toLowerCase() === 'http') {
	        reqParams.measurementOptions = {
	          request: {
	            method: measurementOpts?.request?.method || CLIENT_DEFAULT_HTTP_OPTS.request.method
	          }
	        };
	      }
	    }
	    if (Object.keys(measurementOpts).length) {
	      reqParams.measurementOptions = {
	        ...(reqParams.measurementOptions || {}),
	        ...measurementOpts
	      };
	    }

	    // clear all data from the previous test, close additional options menu, show spinner, set up Map's data etc.
	    this.set('testResults', null);
	    this.set('markersData', null);
	    this.set('probesResponse', null);
	    this.set('showMeasurementOpts', false);
	    this.set('testInProgress', true);
	    this.set('measurementErrMsg', null);
	    this.set('shareResHeaderDate', null);
	    this.set('testReqParams', null);
	    this.set('shareResFlow', false);
	    this.set('shareResHeaderData', null);
	    this.set('realTimeTestResResponse', null);
	    this.set('activeTargetIdx', 0);
	    this.set('measurementsMetadata', null);
	    this.set('showCreditsError', false);
	    this.set('targetsArr', targetsArr);
	    this.set('infiniteMeasIds', []);
	    this.set('isInfiniteMeasStopped', false);
	    this.set('showCreditsData', true);
	    this.set('prevProbesMeasId', null);
	    this.set('preparedTestResults', []);
	    this.set('rateCreditsData', null);
	    this.set('probesMaxTiming', type.toLowerCase() === 'http' ? 1000 : 200);

	    // since Table output mode is available only for the Ping measurement
	    if (type !== 'ping') {
	      this.set('rawOutputMode', true);
	    }

	    // if it is infinite measurement then we should show TableOutput by default
	    // otherwise leave prev value set by user
	    if (type === 'ping' && infiniteSwitchEnabled) {
	      this.set('rawOutputMode', false);
	    }

	    // is designed to prevent the way the test results are displayed from changing when the user toggles the infinite switch
	    this.set('isInfiniteModeRes', infiniteSwitchEnabled);

	    // re-use probes case
	    if (prevProbesMeasId) {
	      reqParams = {
	        ...reqParams,
	        locations: prevProbesMeasId
	      };
	    }

	    // run Infinite type of the measurement
	    if (type === 'ping' && targetsArr.length === 1 && infiniteSwitchEnabled) {
	      this.postInfiniteGlobalpingMeasurement({
	        reqParams,
	        target: targetsArr[0]
	      });
	      return;
	    }

	    // common type of the measurement
	    http.postGlobalpingMeasurement({
	      ...reqParams,
	      target: targetsArr[0]
	    }, RATE_LIMIT_HEADERS).then(res => {
	      // set measurement ID for re-use probes case
	      this.set('prevProbesMeasId', res.response.id);

	      // Update the URL.
	      this.set('measurement', res.response.id);

	      // set response headers for gp-credits/gp-credits-message
	      this.set('rateCreditsData', {
	        ...res.responseHeaders
	      });
	      if (targetsArr[1]) {
	        let secReqParams;

	        // prepare params depending whether there is prevProbesMeasId or not
	        if (prevProbesMeasId) {
	          secReqParams = {
	            locations: res.response.id,
	            ...reqParams,
	            target: targetsArr[1]
	          };
	        } else {
	          secReqParams = {
	            ...reqParams,
	            locations: res.response.id,
	            target: targetsArr[1]
	          };
	        }
	        http.postGlobalpingMeasurement(secReqParams, RATE_LIMIT_HEADERS).then(res1 => {
	          let combinedHeaders = {
	            ...res1.responseHeaders
	          };
	          ['x-ratelimit-consumed', 'x-credits-consumed', 'x-request-cost'].forEach(header => {
	            combinedHeaders[header] = (Number(res.responseHeaders[header]) || 0) + (Number(res1.responseHeaders[header]) || 0);
	          });

	          // set response headers for gp-credits/gp-credits-message
	          this.set('rateCreditsData', combinedHeaders);
	          this.getTestMeasurementById({
	            measurementId: res.response.id
	          });
	          this.getTestMeasurementById({
	            measurementId: res1.response.id,
	            resNumber: 1
	          });
	          this.set('showMap', this.get('originalShowMap'));

	          // Update the URL without creating a new history entry.
	          app.router.replaceQueryParam('measurement', `${this.get('measurement')},${res1.response.id}`);
	        }).catch(err => {
	          this.handlePostGPMeasError(err);
	        });
	      } else {
	        this.getTestMeasurementById({
	          measurementId: res.response.id
	        });
	        this.set('showMap', this.get('originalShowMap'));
	      }
	    }).catch(err => {
	      this.handlePostGPMeasError(err);
	    });
	  },
	  applyOptions() {
	    // filter opts from empty values
	    let filterOptsFromEmptyOne = opts => Object.keys(opts).reduce((res, key) => {
	      if (typeof opts[key] === 'object') {
	        res[key] = Object.keys(opts[key]).reduce((secRes, secKey) => {
	          if (opts[key][secKey] !== '') {
	            secRes[secKey] = opts[key][secKey];
	          }
	          return secRes;
	        }, {});
	      } else if (opts[key] !== '') {
	        res[key] = opts[key];
	      }
	      return res;
	    }, {});
	    let {
	      type
	    } = this.get('mainOptions');
	    let currOptsName = `${type.toLowerCase()}Opts`;
	    let initPresetOpts = filterOptsFromEmptyOne(this.get(currOptsName));
	    let notPresetOpts = filterOptsFromEmptyOne(this.get('notAppliedOpts'));
	    let opts = {
	      initPresetOpts,
	      notPresetOpts
	    };
	    this.set('appliedMeasOpts', opts);
	    this.countModifiedMeasurementOpts(type, initPresetOpts, notPresetOpts);
	    this.set('showMeasurementOpts', false);
	  },
	  initMap() {
	    let mq = window.matchMedia('(min-width: 768px)');
	    map$1 = new google.maps.Map(this.find('#gp-map'), {
	      zoom: MAP_ZOOM_REG$1,
	      center: MAP_CENTER_REG$1,
	      mapTypeId: 'roadmap',
	      draggableCursor: 'default',
	      mapTypeControl: false,
	      streetViewControl: false,
	      fullscreenControl: false,
	      minZoom: MAP_MIN_ZOOM$1,
	      maxZoom: MAP_MAX_ZOOM$1,
	      mapId: 'ce04bbf9d49b6f34'
	    });
	    if (mq.matches) {
	      map$1.setCenter(MAP_CENTER_ALT$1);
	      map$1.setZoom(MAP_ZOOM_ALT$1);
	    }

	    // handle map changes on zoom
	    map$1.addListener('zoom_changed', () => {
	      // close all IWs on zoom
	      infoWindows$1.forEach(iw => iw.close());
	      probesInfoWindows.forEach(piw => piw.close());
	      this.despiderifyMapMarkers(mapMarkers$1);

	      // scale cluster's markers size on zoom
	      probesMarkers.forEach(m => {
	        let {
	          svgWidth,
	          svgHeight
	        } = getMarkerSize$1(Number(m.content.getAttribute('data-probe-count')), map$1.zoom);
	        m.content.style.width = `${svgWidth}px`;
	        m.content.style.height = `${svgHeight}px`;
	      });
	    });

	    // draw probes Clusers or clear the map from them
	    this.observe('probesResponse', probesResponse => {
	      // when we run a new test probesResponse will be cleared ergo we should clear the map from the probesClusters
	      if (probesResponse === null) {
	        this.clearProbesClusters();
	        // display probesCLusters on the map only when we have probesData and not in share-results-flow
	      } else if (probesResponse && !this.get('shareResFlow')) {
	        this.updateClusters(probesResponse);
	      }
	    });

	    // check whether we should clear the Map from the markers or update them
	    this.observe('markersData', (markersData, prevMarkersData) => {
	      if (markersData === null) {
	        this.clearTestResponseMarkers();
	      } else if (JSON.stringify(markersData) !== JSON.stringify(prevMarkersData)) {
	        // update Markers on the map (replace or add new) if Markers data is different
	        this.updateMarkers(markersData, prevMarkersData);
	      }
	    }, {
	      init: false
	    });
	  },
	  updateMarkers(markersData, prevMarkersData) {
	    markersData.forEach(markerData => {
	      let markerIdToReplace = null;
	      let currentMarkerIdx = markerData.clientSideId;

	      // check if the new Marker is the old one but with a timing value
	      // and get Marker index to replace it later on the Map
	      // get index for every Marker we draw or redraw on the map to provide proper work of InfoWindows, Results and Actions etc.
	      if (prevMarkersData) {
	        // stop once we found the match to get proper currentMarkerIdx
	        prevMarkersData.every(pmd => {
	          if (pmd.clientSideId === markerData.clientSideId && markerData.timings !== null && markerData.timings.every(t => t)) {
	            markerIdToReplace = pmd.clientSideId;
	            currentMarkerIdx = pmd.clientSideId;
	            return false;
	          }
	          return true;
	        });
	      }

	      // create a new marker and add it to the map or update existing with new data
	      if (markerIdToReplace !== null) {
	        mapMarkers$1.forEach((mm, mmIdx) => {
	          if (markerIdToReplace === mmIdx && JSON.stringify(markerData.timings) !== JSON.stringify(prevMarkersData[markerIdToReplace].timings)) {
	            this.updateMapMarkerWithIW(mm, markerData, currentMarkerIdx);
	          }
	        });
	      } else if (!mapMarkers$1[markerData.clientSideId]) {
	        // collect markers added to the map
	        this.createMapMarkerWithIW(markerData, currentMarkerIdx);
	      }
	    });

	    // close IWs on click on Map
	    google.maps.event.addListener(map$1, 'click', () => {
	      infoWindows$1.forEach(iw => iw.close());
	      this.despiderifyMapMarkers(mapMarkers$1);
	    });
	  },
	  updateClusters(probes) {
	    let preparedMarkers = Object.keys(probes).map(key => {
	      let [lat, lng] = key.split(', ');
	      let marker = probesMarkers.find(pm => pm.position.lat === lat && pm.position.lng === lng);
	      if (!marker) {
	        marker = this.createMapClusterMarkerWithIW(key, probes[key]);
	        probesMarkers.push(marker);
	      }
	      marker.map = map$1;
	      return marker;
	    });

	    // eslint-disable-next-line no-undef
	    let probeCluster = new markerClusterer.MarkerClusterer({
	      markers: preparedMarkers,
	      map: map$1,
	      renderer: {
	        render(_ref) {
	          let {
	            markers,
	            position
	          } = _ref;
	          let totalCustomNumber = markers.reduce((sum, marker) => sum + (marker.markersCount || 0), 0);
	          let clusterSvg = window.btoa(`<svg xmlns="http://www.w3.org/2000/svg" width="68" height="68" fill="none">
							<g clip-path="url(#a)">
							<path fill="url(#b)" d="M30 2.31a8 8 0 0 1 8 0l21.445 12.38a8 8 0 0 1 4 6.929V46.38a8 8 0 0 1-4 6.928L38 65.691a8 8 0 0 1-8 0L8.555 53.309a8 8 0 0 1-4-6.928V21.62a8 8 0 0 1 4-6.928z"/>
							<path stroke="#69E7C8" stroke-width="1.5" d="M30.375 4.959a7.25 7.25 0 0 1 7.25 0L57.338 16.34a7.25 7.25 0 0 1 3.625 6.279V45.38a7.25 7.25 0 0 1-3.625 6.279L37.625 63.04a7.25 7.25 0 0 1-7.25 0L10.662 51.66a7.25 7.25 0 0 1-3.625-6.279V22.62a7.25 7.25 0 0 1 3.625-6.279L30.375 4.96Z"/>
							</g>
							<text x="34" y="40" fill="#fff" font-family="Lexend, sans-serif" font-size="16px" font-weight="600" text-anchor="middle">
							${totalCustomNumber}
							</text>
							<defs>
							<linearGradient id="b" x1="34" x2="34" y1="0" y2="68" gradientUnits="userSpaceOnUse">
							<stop stop-color="#17D4A7"/>
							<stop offset="1" stop-color="#17D4A7"/>
							</linearGradient>
							<clipPath id="a">
							<path fill="#fff" d="M0 0h68v68H0z"/>
							</clipPath>
							</defs>
						</svg>`);
	          let clusterDiv = document.createElement('div');
	          let clusterImg = document.createElement('img');
	          clusterDiv.style.position = 'relative';
	          clusterDiv.style.width = '68px';
	          clusterDiv.style.height = '68px';
	          clusterDiv.style.background = 'transparent';
	          clusterImg.src = `data:image/svg+xml;base64,${clusterSvg}`;
	          clusterImg.width = '68';
	          clusterImg.height = '68';
	          clusterDiv.appendChild(clusterImg);
	          return new google.maps.marker.AdvancedMarkerElement({
	            position,
	            content: clusterDiv
	          });
	        }
	      },
	      // eslint-disable-next-line no-undef
	      algorithm: new markerClusterer.SuperClusterAlgorithm({
	        radius: 200
	      })
	    });
	    mapProbesClusters.push(probeCluster);
	    google.maps.event.addListener(map$1, 'click', () => {
	      probesInfoWindows.forEach(piw => piw.close());
	    });
	  },
	  clearTestResponseMarkers() {
	    infoWindows$1.forEach(iw => iw.close());
	    mapMarkers$1.forEach(mm => mm.setMap(null));
	    infoWindows$1 = [];
	    mapMarkers$1 = [];
	  },
	  clearProbesClusters() {
	    probesInfoWindows.forEach(piw => piw.close());
	    mapProbesClusters.forEach(pc => pc.setMap(null));
	    probesMarkers = [];
	    probesInfoWindows = [];
	    mapProbesClusters = [];
	  },
	  collapseCmdBlock() {
	    let element = document.querySelector('.gp_join-network_cmd-block_command');
	    requestAnimationFrame(() => {
	      element.style.height = `${element.scrollHeight}px`;
	      requestAnimationFrame(() => {
	        element.style.height = '56px';
	      });
	    });
	  },
	  expandCmdBlock() {
	    let element = document.querySelector('.gp_join-network_cmd-block_command');
	    requestAnimationFrame(() => {
	      element.style.height = '56px';
	      requestAnimationFrame(() => {
	        element.style.height = `${element.scrollHeight}px`;
	      });
	    });
	  },
	  handleSeeResults(resIdx) {
	    let el;
	    if (this.get('rawOutputMode')) {
	      el = this.find(`.c-gp-results-raw-output_list .c-gp-results-raw-output_list_item_top-wrapper:nth-child(${resIdx + 1})`);
	    } else {
	      el = this.find(`.c-gp-results-table-output .results-table_row.row-num-${resIdx}`);
	    }

	    // this prop will be passed to c-gp-results-raw-output in order for it to show the specific result element if it was hidden
	    this.set('scrolledToResIdx', resIdx);
	    el.scrollIntoView({
	      behavior: 'smooth'
	    });
	  },
	  getTestMeasurementById(_ref2) {
	    let {
	      measurementId,
	      resNumber = '0',
	      isShareResCase = false,
	      isFirstShareReq = false,
	      isLastShareReq = false,
	      isInfiniteMeas = false,
	      reqParams = {}
	    } = _ref2;
	    return new Promise((resolve, reject) => {
	      let testReqInterval = setInterval(() => {
	        http.getGlobalpingMeasurement(measurementId).then(testRes => {
	          if (isShareResCase) {
	            let currentTargets = this.get('mainOptions.target');
	            let currTargetsArr = _.removeDuplicatedTargets(currentTargets ? currentTargets.split(',') : []);
	            let updTargetsArr = currTargetsArr.indexOf(testRes.target) < 0 ? [...currTargetsArr, testRes.target] : currTargetsArr;
	            this.set('mainOptions.target', updTargetsArr.join(','));

	            // if infinite measurement we need to set targetsArr ASAP since we know there is only one target
	            if (isInfiniteMeas) {
	              this.set('targetsArr', updTargetsArr);
	            }

	            // only the first target's response returns locations
	            if (isFirstShareReq) {
	              let magicValue = testRes.locations?.reduce((res, loc) => {
	                if (loc.magic) {
	                  res += res.length ? `, ${loc.magic}` : loc.magic;
	                  return res;
	                }
	                return res;
	              }, '');
	              this.set('mainOptions.location', magicValue);
	            }
	            if (isLastShareReq) {
	              this.set('targetsArr', updTargetsArr);
	              this.set('shareResHeaderData', `Showing results from ${_.formatDateTime(new Date(testRes.createdAt))}`);
	              this.set('mainOptions.type', this.translateTestTypeName(testRes.type));
	              this.set('mainOptions.limit', testRes.limit || DEFAULT_LIMIT$1);

	              // handle map max timing for HTTP measurement
	              if (testRes.type.toLowerCase() === 'http') {
	                this.set('probesMaxTiming', 1000);
	              }

	              // ipVersion (target ip-type-switch) came with the measurementOptions but should be treated as the mainOptions
	              if (testRes.measurementOptions?.ipVersion) {
	                // if there is one target and it has IPv6 format (not a domain name) we shouldn't set ipVersion
	                if (updTargetsArr.length !== 1 || !ipRegex_1.v6({
	                  exact: true
	                }).test(updTargetsArr[0])) {
	                  this.set('mainOptions.ipVersion', testRes.measurementOptions.ipVersion);
	                }
	                delete testRes.measurementOptions.ipVersion;
	              }
	              let defaultAPIOpts = this.getDefaultAPIMeasOptsByTestName(testRes.type);
	              let combinedOptions = _.deepExtend({}, defaultAPIOpts, testRes.measurementOptions);
	              let receivedInitPresetOpts = this.filterForInitPresetOpts(defaultAPIOpts, combinedOptions);
	              let receivedNotPresetOpts = this.filterForNotPresetOpts(defaultAPIOpts, combinedOptions);
	              this.set('notAppliedOpts', receivedNotPresetOpts);
	              this.set(`${testRes.type.toLowerCase()}Opts`, receivedInitPresetOpts);
	              this.applyOptions();
	              if (!isInfiniteMeas) {
	                this.set('runTestBtnText', 'Run Again');
	              }

	              // clear qsMeasurementIdsArr so the mainOptions.type observer could work now
	              this.set('qsMeasurementIdsArr', []);
	            }
	          }
	          let isInfiniteMeasStopped = this.get('isInfiniteMeasStopped');

	          // check if infinite measurement was stopped
	          if (isInfiniteMeas && isInfiniteMeasStopped) {
	            clearInterval(testReqInterval);
	            resolve();
	          }

	          // prepare and set request params to pass them to gp-test-results
	          let testReqParams = JSON.parse(JSON.stringify(testRes));
	          delete testReqParams.results;
	          delete testReqParams.status;
	          delete testReqParams.updatedAt;
	          delete testReqParams.createdAt;
	          testReqParams = {
	            inProgressUpdates: true,
	            limit: DEFAULT_LIMIT$1,
	            ...testReqParams,
	            measurementOptions: {
	              trace: false,
	              ...testReqParams.measurementOptions
	            }
	          };

	          // set testReqParams to pass them to c-gp-results-raw-output
	          this.set('testReqParams', testReqParams);

	          // collect IDs of each target's measurement response
	          let updMeasMetadata = {
	            ...this.get('measurementsMetadata'),
	            [resNumber]: {
	              target: testReqParams.target,
	              measurementId: testReqParams.id
	            }
	          };
	          this.set('measurementsMetadata', updMeasMetadata);

	          // set the local/client time of the response received
	          let currentTimestamp = Date.now();
	          let testResUpd = {
	            ...testRes,
	            clientSideStartedAt: currentTimestamp,
	            clientSideUpdatedAt: currentTimestamp
	          };

	          // should be after the mainOptions.type was set
	          this.set(`realTimeTestResResponse[${resNumber}]`, testResUpd);

	          // handle infinite test flow, once at least one probe is finished we shuld run measurement again
	          if (this.get('shareResFlow') === false && isInfiniteMeas && testRes.results.some(r => r.result.status === 'finished')) {
	            let infiniteMeasIds = this.get('infiniteMeasIds');
	            if (!infiniteMeasIds.includes(testRes.id)) {
	              this.set('infiniteMeasIds', [...infiniteMeasIds, testRes.id]);
	              if (!isInfiniteMeasStopped) {
	                this.postInfiniteGlobalpingMeasurement({
	                  reqParams,
	                  target: testRes.target,
	                  isInfiniteMeas: true,
	                  resNumber: infiniteMeasIds.length + 1
	                });
	              }
	            }
	          }
	          resolve(testRes);
	        }).catch(e => {
	          clearInterval(testReqInterval);
	          if (e.responseStatusCode === 404) {
	            this.set('shareResHeaderData', 'This measurement has expired!');
	            this.set('runTestBtnText', 'Run Test');
	            this.scrollMapIntoView();
	          }
	          reject(e);
	        });
	      }, 1000);
	      this.set(`testReqInterval[${resNumber}]`, testReqInterval);
	    });
	  },
	  handleProbesResponse(isStored) {
	    return response => {
	      if (!isStored) {
	        sessionStorage.setItem('probesResponse', JSON.stringify(response));
	      } else {
	        response = JSON.parse(response);
	      }
	      this.set('rawProbes', response);
	      let {
	        totalCities,
	        totalCountries
	      } = response.reduce((res, item) => {
	        if (!res.citiesList.includes(item.location.city)) {
	          res.citiesList.push(item.location.city);
	        }
	        if (!res.countriesList.includes(item.location.country)) {
	          res.countriesList.push(item.location.country);
	        }
	        res.totalCities = res.citiesList.length;
	        res.totalCountries = res.countriesList.length;
	        return res;
	      }, {
	        citiesList: [],
	        countriesList: [],
	        totalCities: 0,
	        totalCountries: 0
	      });
	      this.animate('totalProbes', response.length, {
	        duration: 2000
	      });
	      this.animate('totalCities', totalCities, {
	        duration: 2000
	      });
	      this.animate('totalCountries', totalCountries, {
	        duration: 2000
	      });
	      this.set('probesResponse', this.groupProbes(response));
	    };
	  },
	  translateTestTypeName(name) {
	    switch (name.toLowerCase()) {
	      case 'ping':
	      case 'traceroute':
	        return name.toLowerCase();
	      case 'dns':
	      case 'mtr':
	      case 'http':
	        return name.toUpperCase();
	    }
	  },
	  getDefaultClientMeasOptsByTestName(name) {
	    let res;
	    switch (name.toLowerCase()) {
	      case 'ping':
	        res = CLIENT_DEFAULT_PING_OPTS;
	        break;
	      case 'traceroute':
	        res = CLIENT_DEFAULT_TRACEROUTE_OPTS;
	        break;
	      case 'dns':
	        res = CLIENT_DEFAULT_DNS_OPTS;
	        break;
	      case 'mtr':
	        res = CLIENT_DEFAULT_MTR_OPTS;
	        break;
	      case 'http':
	        res = CLIENT_DEFAULT_HTTP_OPTS;
	        break;
	    }

	    // create deep copy to avoid mutations
	    return JSON.parse(JSON.stringify(res));
	  },
	  getDefaultAPIMeasOptsByTestName(name) {
	    let res;
	    switch (name.toLowerCase()) {
	      case 'ping':
	        res = API_DEFAULT_PING_OPTS;
	        break;
	      case 'traceroute':
	        res = API_DEFAULT_TRACEROUTE_OPTS;
	        break;
	      case 'dns':
	        res = API_DEFAULT_DNS_OPTS;
	        break;
	      case 'mtr':
	        res = API_DEFAULT_MTR_OPTS;
	        break;
	      case 'http':
	        res = API_DEFAULT_HTTP_OPTS;
	        break;
	    }

	    // create deep copy to avoid mutations
	    return JSON.parse(JSON.stringify(res));
	  },
	  handleToggleMeasOpts() {
	    if (this.get('testInProgress')) {
	      return;
	    }
	    let prevValue = this.get('showMeasurementOpts');
	    this.set('showMeasurementOpts', !prevValue);

	    // if opts were not applied we should em reset to default or to prev applied state on closing of MeasOpts dropdown
	    if (prevValue === true) {
	      let testType = this.get('mainOptions.type');
	      let appliedMeasOpts = this.get('appliedMeasOpts');
	      let defaultOpts = this.getDefaultClientMeasOptsByTestName(testType);
	      if (Object.keys(appliedMeasOpts).length) {
	        this.set(`${testType.toLowerCase()}Opts`, {
	          ...JSON.parse(JSON.stringify(appliedMeasOpts.initPresetOpts))
	        });
	        this.set('notAppliedOpts', {
	          ...JSON.parse(JSON.stringify(appliedMeasOpts.notPresetOpts))
	        });
	      } else {
	        this.set(`${testType.toLowerCase()}Opts`, defaultOpts);
	        this.set('notAppliedOpts', {});
	      }
	    }
	  },
	  countModifiedMeasurementOpts(type, initPresetOpts, notPresetOpts) {
	    let defaultOpts = this.getDefaultClientMeasOptsByTestName(type);
	    let modifiedMeasOptsCnt = Object.keys(notPresetOpts).reduce((cnt, key) => {
	      if (typeof notPresetOpts[key] === 'object') {
	        if (key === 'request' && notPresetOpts[key].headers) {
	          // each header should be treated as 1 modified option
	          let headersCnt = Object.keys(notPresetOpts[key].headers).length;
	          let otherPropsCnt = Object.keys(notPresetOpts[key]).length - 1; // -1 for headers

	          return cnt + headersCnt + otherPropsCnt;
	        }
	        return cnt + Object.keys(notPresetOpts[key]).length;
	      }
	      return ++cnt;
	    }, 0);
	    Object.keys(defaultOpts).forEach(key => {
	      if (typeof defaultOpts[key] === 'object') {
	        Object.keys(defaultOpts[key]).forEach(secKey => {
	          if (defaultOpts[key][secKey] !== initPresetOpts[key][secKey]) {
	            modifiedMeasOptsCnt++;
	          }
	        });
	      } else if (defaultOpts[key] !== initPresetOpts[key]) {
	        modifiedMeasOptsCnt++;
	      }
	    });
	    this.set('modifiedMeasOptsCnt', modifiedMeasOptsCnt);
	  },
	  resetMapAndRunTest() {
	    let prevProbesMeasId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    let mq = window.matchMedia('(min-width: 768px)');
	    if (mq.matches) {
	      map$1.setCenter(MAP_CENTER_ALT$1);
	      map$1.setZoom(MAP_ZOOM_ALT$1);
	    } else {
	      map$1.setCenter(MAP_CENTER_REG$1);
	      map$1.setZoom(MAP_ZOOM_REG$1);
	    }

	    // once zoom is ended the idle event will be fired
	    map$1.addListener('idle', () => {
	      this.proceedToTest(prevProbesMeasId);
	      // remove listener to avoid unintended test runs while zoom
	      google.maps.event.clearListeners(map$1, 'idle');
	    });
	  },
	  filterForInitPresetOpts(defaultOpts, optionsToFilter) {
	    return Object.keys(optionsToFilter).reduce((res, key) => {
	      if (Object.hasOwn(defaultOpts, key)) {
	        if (typeof defaultOpts[key] === 'object') {
	          res = {
	            ...res,
	            [key]: this.filterForInitPresetOpts(defaultOpts[key], optionsToFilter[key])
	          };
	        } else {
	          res = {
	            ...res,
	            [key]: optionsToFilter[key]
	          };
	        }
	      }
	      return res;
	    }, {});
	  },
	  filterForNotPresetOpts(defaultOpts, optionsToFilter) {
	    return Object.keys(optionsToFilter).reduce((res, key) => {
	      if (Object.hasOwn(defaultOpts, key)) {
	        if (typeof optionsToFilter[key] === 'object') {
	          res = {
	            ...res,
	            [key]: this.filterForNotPresetOpts(defaultOpts[key], optionsToFilter[key])
	          };
	        }
	      } else {
	        res = {
	          ...res,
	          [key]: optionsToFilter[key]
	        };
	      }
	      return res;
	    }, {});
	  },
	  zoomToResults(locations) {
	    setTimeout(() => {
	      // do not zoom if test was done for the World.
	      if (!locations || locations.length === 1 && (locations[0].magic.toLowerCase() === 'world' || locations[0].magic === '')) {
	        return;
	      }

	      // limit max zoom temp to avoid unnecessary zooming
	      map$1.setOptions({
	        maxZoom: 6
	      });
	      let bounds = new google.maps.LatLngBounds();
	      mapMarkers$1.forEach(mm => {
	        bounds.extend(mm.position);
	      });
	      google.maps.event.addListenerOnce(map$1, 'bounds_changed', () => {
	        map$1.panTo(bounds.getCenter());
	        // restore default zoom
	        map$1.setOptions({
	          maxZoom: MAP_MAX_ZOOM$1
	        });
	      });
	      map$1.fitBounds(bounds);
	    }, 400);
	  },
	  getProbesData() {
	    if (has$6.sessionStorage()) {
	      let probesResponse = sessionStorage.getItem('probesResponse');
	      if (probesResponse) {
	        this.handleProbesResponse(true)(probesResponse);
	      } else {
	        http.fetchGlobalpingProbes().then(this.handleProbesResponse(false));
	      }
	    } else {
	      http.fetchGlobalpingProbes().then(this.handleProbesResponse(false));
	    }
	  },
	  scrollMapIntoView() {
	    let mapBlockEl = this.find('.gp_map-block');
	    mapBlockEl.scrollIntoView({
	      behavior: 'smooth'
	    });
	  },
	  updateMapMarkerWithIW(marker, markerData, currentMarkerIdx) {
	    let updSvg = this.createMapMarkerSvg(markerData);
	    let currIw = infoWindows$1[currentMarkerIdx];
	    marker.content.style.backgroundImage = `url('data:image/svg+xml;base64,${updSvg}')`;
	    currIw.setContent(this.createInfoWindowContent(markerData, currentMarkerIdx));
	  },
	  createMapMarkerWithIW(markerData, currentMarkerIdx) {
	    // create Popup element which will be shown on click on the marker
	    let infoWindow = new google.maps.InfoWindow();

	    // create svg to use as a Marker icon
	    let svg = this.createMapMarkerSvg(markerData);

	    // add listener to IW for Results and Actions button
	    google.maps.event.addListener(infoWindow, 'domready', () => {
	      let clickableEl = document.getElementById(`iw-${currentMarkerIdx}`);
	      let hasListener = clickableEl.dataset.hasListener;
	      if (!hasListener) {
	        clickableEl.addEventListener('click', () => {
	          this.handleSeeResults(currentMarkerIdx);
	          clickableEl.dataset.hasListener = true;
	        });
	      }
	    });

	    // collect IWs
	    infoWindows$1.push(infoWindow);
	    infoWindow.setContent(this.createInfoWindowContent(markerData, currentMarkerIdx));
	    let markerContent = document.createElement('div');
	    markerContent.style.backgroundImage = `url('data:image/svg+xml;base64,${svg}')`;
	    markerContent.style.width = `${DEFAULT_MARKER_DIMENSIONS}px`;
	    markerContent.style.height = `${DEFAULT_MARKER_DIMENSIONS}px`;
	    markerContent.style.backgroundRepeat = 'no-repeat';
	    markerContent.style.backgroundPosition = 'center';
	    markerContent.style.backgroundSize = 'contain';

	    // create a new Marker
	    let marker = new google.maps.marker.AdvancedMarkerElement({
	      map: map$1,
	      content: markerContent,
	      position: {
	        lat: markerData.lat,
	        lng: markerData.lng
	      },
	      zIndex: 1
	    });

	    // keep original markers positions
	    originalMapMarkersPos.set(marker, marker.position);
	    mapMarkers$1.push(marker);

	    // open IW on click, close all other IWs, handle markers spiderifying
	    marker.addListener('click', () => {
	      infoWindows$1.forEach(iw => iw.close());

	      // check if marker is overlapping with other and should be spiderified
	      if (this.shouldMapMarkersSpiderify(marker, mapMarkers$1, map$1) && marker.isSpiderPart !== true) {
	        // despiderify markers
	        this.despiderifyMapMarkers(mapMarkers$1);
	        // spiderify overlapping markers
	        this.spiderifyMapMarkers(marker, mapMarkers$1, map$1);
	      } else {
	        // open InfoWindow if marker is already spiderified or do not needed to be
	        infoWindow.open({
	          map: map$1,
	          anchor: marker
	        });
	      }
	    });
	  },
	  async getMultipleTestMeasurementById(idsArr) {
	    let isInfiniteMeas = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	    for (let i = 0; i < idsArr.length; i++) {
	      await this.getTestMeasurementById({
	        measurementId: idsArr[i],
	        resNumber: i,
	        isShareResCase: true,
	        isFirstShareReq: i === 0,
	        isLastShareReq: idsArr.length - 1 === i,
	        isInfiniteMeas
	      });
	    }
	  },
	  postInfiniteGlobalpingMeasurement(_ref3) {
	    let {
	      reqParams,
	      target,
	      isInfiniteMeas = true,
	      resNumber = 0
	    } = _ref3;
	    this.set('runTestBtnText', 'Stop');
	    http.postGlobalpingMeasurement({
	      ...reqParams,
	      target
	    }, RATE_LIMIT_HEADERS).then(res => {
	      // set response headers for gp-credits/gp-credits-message
	      this.set('rateCreditsData', {
	        ...res.responseHeaders,
	        probesCount: res.response.probesCount
	      });

	      // set measurement ID for re-use probes case
	      this.set('prevProbesMeasId', res.response.id);

	      // Update the URL.
	      if (resNumber === 0) {
	        this.set('measurement', res.response.id);
	      } else {
	        app.router.replaceQueryParam('measurement', `${this.get('measurement').split('.').slice(-9).join('.')}.${res.response.id}`);
	      }
	      let updReqParams = {
	        ...reqParams,
	        locations: res.response.id
	      };
	      this.getTestMeasurementById({
	        measurementId: res.response.id,
	        resNumber,
	        isInfiniteMeas,
	        reqParams: updReqParams
	      });
	      this.set('showMap', this.get('originalShowMap'));
	    }).catch(err => {
	      this.handlePostGPMeasError(err);
	    });
	  },
	  isInfiniteOptsCorrect() {
	    let {
	      type,
	      target
	    } = this.get('mainOptions');
	    return type === 'ping' && target.split(',').length <= 1;
	  },
	  handleInfiniteSwitch() {
	    if (this.get('testInProgress') || !this.isInfiniteOptsCorrect()) {
	      return;
	    }
	    let infiniteSwitchEnabled = this.get('infiniteSwitchEnabled');
	    if (infiniteSwitchEnabled) {
	      this.set('notAppliedOpts.packets', '');
	    } else {
	      this.set('notAppliedOpts.packets', INFINITE_MEASUREMENT_PACKETS);
	    }
	    this.set('infiniteSwitchEnabled', !infiniteSwitchEnabled);
	    this.applyOptions();
	  },
	  handleInfiniteSwitchKeyDown(e) {
	    if (e.key === 'Enter') {
	      this.handleInfiniteSwitch();
	    }
	  },
	  handleInfiniteMeasBtn() {
	    let testInProgress = this.get('testInProgress');
	    if (testInProgress) {
	      this.stopInfiniteTest();
	    } else {
	      this.resetMapAndRunTest();
	    }
	  },
	  stopInfiniteTest() {
	    this.set('testInProgress', false);
	    this.set('isInfiniteMeasStopped', true);
	    this.set('runTestBtnText', 'Run Again');
	  },
	  handlePostGPMeasError(err) {
	    let isInfiniteModeRes = this.get('isInfiniteModeRes');
	    let testResults = this.get('testResults');
	    this.set('testInProgress', false);
	    // we show the error block under the map block only if it is not an infinite measurement or the one with no results
	    this.set('runTestBtnText', 'Run Test');
	    // set response headers (from error) for gp-credits/gp-credits-message
	    this.set('rateCreditsData', err.responseHeaders);
	    if (err.responseStatusCode === 429) {
	      let measurementErrMsg = this.createMeasCreditsErrMsg(err.responseHeaders, isInfiniteModeRes, testResults);
	      this.set('measurementErrMsg', measurementErrMsg);
	      if (isInfiniteModeRes && testResults) {
	        this.set('showCreditsError', true);
	      } else {
	        this.set('showCreditsData', false);
	        this.set('showMap', false);
	      }
	    } else if (err.error.type === 'validation_error') {
	      let measurementOptsErr = false;
	      let inputErrors = Object.keys(err.error.params).reduce((res, key) => {
	        let splittedKeyName = key.split('.');
	        let splittedKeyNameLength = splittedKeyName.length;
	        let fieldName = splittedKeyName[splittedKeyNameLength - 1];
	        if (['locations', 'magic'].includes(fieldName)) {
	          fieldName = 'location';
	        }
	        res[fieldName] = err.error.params[key].replace(/".*"/, fieldName);
	        if (splittedKeyName[0] === 'measurementOptions') {
	          measurementOptsErr = true;
	        }
	        return res;
	      }, {});
	      this.set('inputErrors', inputErrors);

	      // open measurement options menu if it contains errors
	      if (measurementOptsErr) {
	        this.set('showMeasurementOpts', true);
	      }
	    } else {
	      this.set('measurementErrMsg', err.error.message);
	      this.set('showMap', false);
	    }
	  },
	  reUseProbesRunTest() {
	    let prevProbesMeasId = this.get('prevProbesMeasId');
	    this.resetMapAndRunTest(prevProbesMeasId);
	  },
	  handleDropDownRunTestBtnNav() {
	    // set this handler only once
	    if (this.get('ddHandlerSet')) {
	      return;
	    }
	    setTimeout(() => {
	      let dropdownComponent = document.getElementById('dd-run-test-btn');
	      dropdownComponent.addEventListener('focusout', event => {
	        let dropdownMenu = dropdownComponent.querySelector('.dropdown-menu');
	        let button = dropdownComponent.querySelector('.dropdown-toggle');
	        let buttonWrapper = dropdownComponent.querySelector('.gp_map-block_settings-wrapper_split-btn');
	        if (dropdownMenu && event.relatedTarget && !dropdownMenu.contains(event.relatedTarget)) {
	          dropdownMenu.querySelectorAll('.dropdown-item').forEach(item => item.classList.remove('active'));
	          button.setAttribute('aria-expanded', false);
	          buttonWrapper.classList.remove('open');
	        }
	      });
	      dropdownComponent.addEventListener('keydown', event => {
	        let dropdownMenu = dropdownComponent.querySelector('.dropdown-menu');
	        let activeItem = dropdownComponent.querySelector('.dropdown-item.active');
	        let button = dropdownComponent.querySelector('.dropdown-toggle');
	        if (dropdownMenu) {
	          if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
	            if (!activeItem) {
	              let firstItem = dropdownMenu.firstElementChild;
	              if (firstItem) {
	                firstItem.classList.add('active');
	              }
	            } else {
	              let nextItem;
	              if (event.key === 'ArrowDown') {
	                nextItem = activeItem.nextElementSibling;
	              } else if (event.key === 'ArrowUp') {
	                nextItem = activeItem.previousElementSibling;
	              }
	              if (nextItem) {
	                activeItem.classList.remove('active');
	                nextItem.classList.add('active');
	              } else if (event.key === 'ArrowUp') {
	                activeItem.classList.remove('active');
	                button.focus();
	              }
	            }
	          } else if (event.key === 'Enter' && activeItem) {
	            activeItem.click();
	          }
	        }
	      });
	      this.set('ddHandlerSet', true);
	    }, 4);
	  },
	  createMapMarkerSvg(markerData) {
	    let svg;
	    let svgFillColors = [];
	    let targetsCnt = this.get('targetsArr').length;
	    let probesMaxTiming = this.get('probesMaxTiming');
	    let probesMinTiming = this.get('probesMinTiming');
	    for (let i = 0; i < targetsCnt; i++) {
	      svgFillColors.push(markerData.timings[i] ? _.getGpProbeStatusColor(markerData.timings[i], probesMaxTiming, probesMinTiming) : DEFAULT_MARKER_COLOR);
	    }
	    if (markerData.timings.length > 1) {
	      svg = window.btoa(`<svg width="${DEFAULT_MARKER_DIMENSIONS}" height="${DEFAULT_MARKER_DIMENSIONS}" viewBox="0 0 ${DEFAULT_MARKER_DIMENSIONS} ${DEFAULT_MARKER_DIMENSIONS}" fill="none" xmlns="http://www.w3.org/2000/svg">
					<g filter="url(#filter0_d_6106_3045)">
					<circle cx="12" cy="10" r="6" fill="${svgFillColors[1]}"/>
					<clipPath id="cut-off">
					<rect x="6" y="4" width="6" height="1112"/>
					</clipPath>
					<circle cx="12" cy="10" r="6" fill="${svgFillColors[0]}" clip-path="url(#cut-off)"/>
					<circle cx="12" cy="10" r="7" stroke="white" stroke-width="2"/>
					</g>
					<defs>
					<filter id="filter0_d_6106_3045" x="0" y="0" width="${DEFAULT_MARKER_DIMENSIONS}" height="${DEFAULT_MARKER_DIMENSIONS}" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
					<feFlood flood-opacity="0" result="BackgroundImageFix"/>
					<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
					<feOffset dy="2"/>
					<feGaussianBlur stdDeviation="2"/>
					<feComposite in2="hardAlpha" operator="out"/>
					<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/>
					<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_6106_3045"/>
					<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_6106_3045" result="shape"/>
					</filter>
					</defs>
					</svg>`);
	    } else {
	      svg = window.btoa(`<svg width="${DEFAULT_MARKER_DIMENSIONS}" height="${DEFAULT_MARKER_DIMENSIONS}" viewBox="0 0 ${DEFAULT_MARKER_DIMENSIONS} ${DEFAULT_MARKER_DIMENSIONS}" fill="none" xmlns="http://www.w3.org/2000/svg">
					<g filter="url(#filter0_d_6106_3045)">
					<circle cx="12" cy="10" r="6" fill="${svgFillColors[0]}"/>
					<circle cx="12" cy="10" r="7" stroke="white" stroke-width="2"/>
					</g>
					<defs>
					<filter id="filter0_d_6106_3045" x="0" y="0" width="${DEFAULT_MARKER_DIMENSIONS}" height="${DEFAULT_MARKER_DIMENSIONS}" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
					<feFlood flood-opacity="0" result="BackgroundImageFix"/>
					<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
					<feOffset dy="2"/>
					<feGaussianBlur stdDeviation="2"/>
					<feComposite in2="hardAlpha" operator="out"/>
					<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/>
					<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_6106_3045"/>
					<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_6106_3045" result="shape"/>
					</filter>
					</defs>
					</svg>`);
	    }
	    return svg;
	  },
	  createInfoWindowContent(markerData, currentMarkerIdx) {
	    let targetsCnt = this.get('targetsArr').length;
	    let probesMaxTiming = this.get('probesMaxTiming');
	    let probesMinTiming = this.get('probesMinTiming');
	    let infoWindowContent = '<div class="gp-map_popup">';
	    infoWindowContent += `<div class="gp-map_popup${targetsCnt > 1 ? '_multi' : '_single'}">`;
	    if (targetsCnt === 1) {
	      infoWindowContent += `<div class="gp-map_popup_single_timing">${markerData.timings[0] || ''}</div>`;
	      infoWindowContent += `<div class="gp-map_popup_single_network">${markerData.network}</div>`;
	      infoWindowContent += `<div class="gp-map_popup_single_location">(${markerData.city}, ${markerData.country})</div>`;
	    } else {
	      infoWindowContent += `<div class="gp-map_popup_multi_network">${markerData.network}</div>`;
	      infoWindowContent += `<div class="gp-map_popup_multi_location">(${markerData.city}, ${markerData.country})</div>`;
	      markerData.targets.forEach((target, targetIdx) => {
	        infoWindowContent += '<div class="gp-map_popup_multi_data">';
	        infoWindowContent += `<span class="gp-map_popup_multi_data_target">${target}</span>`;
	        infoWindowContent += `<span class="gp-map_popup_multi_data_timing"
						style='color: ${_.getGpProbeStatusColor(markerData.timings[targetIdx], probesMaxTiming, probesMinTiming)}'>${markerData.timings[targetIdx] || ''}</span>`;
	        infoWindowContent += '</div>';
	      });
	    }
	    infoWindowContent += '</div>';
	    infoWindowContent += `<div class="gp-map_popup_see-results ${targetsCnt > 1 ? 'centered' : ''}" id="iw-${currentMarkerIdx}">`;
	    infoWindowContent += `<img width="20" height="20" src="${this.get('@shared.assetsHost')}/img/globalping/see-results-icon.svg">`;
	    infoWindowContent += '<span>Results and Actions</span>';
	    infoWindowContent += '</div>';
	    infoWindowContent += '</div>';
	    return infoWindowContent;
	  },
	  prepareRegularResults(testResults) {
	    return testResults.reduce((prepResults, resArr, resArrIdx) => {
	      let dnsTraceEnabled = this.get('testReqParams.measurementOptions.trace');
	      if (resArrIdx === 0) {
	        return resArr.map(res => {
	          let preparedRes = {
	            clientSideId: res.clientSideId,
	            ...res.probe,
	            statsPerTarget: [{
	              target: res.target
	            }]
	          };
	          if (res.result.status !== 'in-progress') {
	            let {
	              isFailed = false,
	              lastTiming,
	              value: avgTiming,
	              extraValues
	            } = _.calcGpTestResTiming(res.type, res, dnsTraceEnabled);
	            let {
	              packetsRtt,
	              packetsTotal
	            } = _.parseGpRawOutputForTimings(res.result.rawOutput);
	            let minTiming = res.result?.stats?.min || PROBE_NO_TIMING_VALUE$1;
	            let maxTiming = res.result?.stats?.max || PROBE_NO_TIMING_VALUE$1;
	            let statsTotal = res.result?.stats?.total;
	            let statsDrop = res.result?.stats?.drop;
	            let isOffline = res.result.status === PROBE_STATUS_OFFLINE$1;
	            preparedRes.statsPerTarget = [{
	              ...preparedRes.statsPerTarget[0],
	              ipAddr: res.result.resolvedAddress,
	              lastTiming,
	              minTiming,
	              avgTiming,
	              maxTiming,
	              statsTotal,
	              statsDrop,
	              isFailed,
	              isOffline,
	              packetsRtt,
	              extraValues,
	              failureRawOutput: this.getFailureProbeRawOutput(res),
	              rawOutput: res.result.rawOutput,
	              qualityStr: this.createQualityString(isOffline, statsTotal, statsDrop),
	              areTimingsReady: this.checkAreTimingsReady(lastTiming, maxTiming, minTiming, avgTiming, packetsTotal),
	              tls: res.result.tls
	            }];
	          }
	          return preparedRes;
	        });
	      }
	      return prepResults.map(pR => {
	        let nextReqRes = resArr.find(rA => rA.clientSideId === pR.clientSideId);
	        if (nextReqRes) {
	          let preparedNextRes = {
	            ...pR,
	            statsPerTarget: [...pR.statsPerTarget, {
	              target: nextReqRes.target
	            }]
	          };
	          if (nextReqRes.result.status !== 'in-progress') {
	            let {
	              isFailed = false,
	              lastTiming,
	              value: avgTiming,
	              extraValues
	            } = _.calcGpTestResTiming(nextReqRes.type, nextReqRes, dnsTraceEnabled);
	            let {
	              packetsRtt,
	              packetsTotal
	            } = _.parseGpRawOutputForTimings(nextReqRes.result.rawOutput);
	            let minTiming = nextReqRes.result?.stats?.min || PROBE_NO_TIMING_VALUE$1;
	            let maxTiming = nextReqRes.result?.stats?.max || PROBE_NO_TIMING_VALUE$1;
	            let statsTotal = nextReqRes.result?.stats?.total;
	            let statsDrop = nextReqRes.result?.stats?.drop;
	            let isOffline = nextReqRes.result.status === PROBE_STATUS_OFFLINE$1;
	            preparedNextRes.statsPerTarget = [...pR.statsPerTarget, {
	              ...preparedNextRes.statsPerTarget[1],
	              ipAddr: nextReqRes.result.resolvedAddress,
	              lastTiming,
	              minTiming,
	              avgTiming,
	              maxTiming,
	              statsTotal,
	              statsDrop,
	              isFailed,
	              isOffline,
	              packetsRtt,
	              extraValues,
	              failureRawOutput: this.getFailureProbeRawOutput(nextReqRes),
	              rawOutput: nextReqRes.result.rawOutput,
	              qualityStr: this.createQualityString(isOffline, statsTotal, statsDrop),
	              areTimingsReady: this.checkAreTimingsReady(lastTiming, maxTiming, minTiming, avgTiming, packetsTotal)
	            }];
	          }
	          return preparedNextRes;
	        }
	        return pR;
	      });
	    }, []);
	  },
	  prepareInfiniteResults(rawResults) {
	    let probesAmount = rawResults[0].length;
	    let probesMeasurements = [];

	    // gather probe's data from different measurements, with each sub array representing a single probe's data
	    for (let i = 0; i < probesAmount; i++) {
	      probesMeasurements.push(rawResults.map(rr => rr[i]));
	    }

	    // prepare data for gp-raw-output, gp-table-output components
	    return probesMeasurements.map(pbm => {
	      return pbm.reduce((combinedProbeData, probeData) => {
	        let {
	          packetsRtt,
	          packetsDrop,
	          packetsTotal
	        } = _.parseGpRawOutputForTimings(probeData.result.rawOutput);
	        let isOffline = probeData.result.status === PROBE_STATUS_OFFLINE$1;
	        let packetsRttCombined = [...(combinedProbeData.packetsRtt || []), ...packetsRtt];
	        let packetsDropCombined = (combinedProbeData.packetsDrop || 0) + packetsDrop;
	        let packetsTotalCombined = (combinedProbeData.packetsTotal || 0) + packetsTotal;
	        let numericPacketsRttCombined = packetsRttCombined.filter(v => typeof v === 'number');
	        let maxTiming = numericPacketsRttCombined.length ? Math.max(...numericPacketsRttCombined) : PROBE_NO_TIMING_VALUE$1;
	        let minTiming = numericPacketsRttCombined.length ? Math.min(...numericPacketsRttCombined) : PROBE_NO_TIMING_VALUE$1;
	        let avgTiming = numericPacketsRttCombined.length ? Number((numericPacketsRttCombined.reduce((res, rtt) => res += rtt, 0) / numericPacketsRttCombined.length).toFixed(2)) : PROBE_NO_TIMING_VALUE$1;
	        let lastTiming = packetsRttCombined[packetsRttCombined.length - 1] || PROBE_NO_TIMING_VALUE$1;
	        let lossValue = this.calcLoss(packetsRttCombined.length + packetsDropCombined, packetsDropCombined);
	        let {
	          packetLines,
	          linesHeader,
	          lastLineIdx
	        } = this.parseLinesFromRawOutput(probeData.result.rawOutput, combinedProbeData.lastLineIdx || 0);
	        let outputLinesCombined = [...(combinedProbeData.rawOutputLines || []), ...packetLines];
	        let ipAddr = combinedProbeData.ipAddr || this.parseIPFromRawOutput(probeData.result.rawOutput);
	        let rawOutputCombined = this.handleRawOutput([linesHeader, ...outputLinesCombined]);
	        let clientSideMeasTime = probeData.clientSideUpdatedAt - probeData.clientSideStartedAt;
	        let measurementTimeCombined = combinedProbeData.measurementTime || 0;

	        // if measurement is finished we should take a server time (updatedAt - createdAt)
	        if (probeData.status === 'finished') {
	          measurementTimeCombined += probeData.serverTime;
	        } else {
	          // otherwise we should take a local time
	          measurementTimeCombined += clientSideMeasTime;
	        }
	        return {
	          ...combinedProbeData,
	          lastLineIdx,
	          packetsRtt: packetsRttCombined,
	          packetsDrop: packetsDropCombined,
	          packetsTotal: packetsTotalCombined,
	          rawOutputLines: outputLinesCombined,
	          measurementTime: measurementTimeCombined,
	          ipAddr,
	          clientSideId: probeData.clientSideId,
	          ...probeData.probe,
	          statsPerTarget: [{
	            target: probeData.target,
	            ipAddr,
	            lastTiming,
	            minTiming,
	            avgTiming,
	            maxTiming,
	            statsTotal: packetsRttCombined.length,
	            statsDrop: packetsDropCombined,
	            isFailed: probeData.result.status === PROBE_STATUS_FAILED,
	            isOffline,
	            failureRawOutput: this.getFailureProbeRawOutput(probeData),
	            packetsRtt: packetsRttCombined,
	            qualityStr: this.createQualityString(isOffline, numericPacketsRttCombined.length + packetsDropCombined, packetsDropCombined),
	            areTimingsReady: this.checkAreTimingsReady(lastTiming, maxTiming, minTiming, avgTiming, packetsTotalCombined),
	            rawOutput: rawOutputCombined,
	            extraValues: lossValue !== null ? {
	              loss: {
	                text: 'Loss',
	                value: lossValue,
	                units: '%'
	              }
	            } : {},
	            rawFooter: this.createRawFooter(probeData.target, numericPacketsRttCombined, packetsTotalCombined, numericPacketsRttCombined.length, lossValue, minTiming, avgTiming, maxTiming, measurementTimeCombined, rawOutputCombined)
	          }]
	        };
	      }, {});
	    });
	  },
	  getFailureProbeRawOutput(probeData) {
	    let rawOutput;
	    let {
	      status = null
	    } = probeData.result;
	    if (status === PROBE_STATUS_OFFLINE$1 || status === PROBE_STATUS_FAILED) {
	      rawOutput = probeData.result.rawOutput;
	    }
	    return rawOutput;
	  },
	  createQualityString(isOffline, statsTotal, statsDrop) {
	    if (isOffline) {
	      return PROBE_OFFLINE_TEXT;
	    }
	    let {
	      actualAmount,
	      qualityPercentage
	    } = this.calcQuality(statsTotal, statsDrop);
	    return qualityPercentage !== null ? `${actualAmount}/${statsTotal} - ${qualityPercentage}%` : '';
	  },
	  checkAreTimingsReady(lastTiming, maxTiming, minTiming, avgTiming, packetsTotal) {
	    if (!packetsTotal || typeof lastTiming === 'undefined' || typeof maxTiming === 'undefined' || typeof minTiming === 'undefined' || typeof avgTiming === 'undefined') {
	      return false;
	    }
	    return true;
	  },
	  calcQuality(statsTotal, statsDrop) {
	    if (typeof statsTotal === 'undefined' || typeof statsDrop === 'undefined' || statsTotal === 0) {
	      return {
	        qualityPercentage: null,
	        actualAmount: null
	      };
	    }
	    let actualAmount = Math.max(statsTotal - statsDrop, 0);
	    let qualityPercentage = Math.round(actualAmount / statsTotal * 100);
	    return {
	      qualityPercentage,
	      actualAmount
	    };
	  },
	  parseIPFromRawOutput(raw) {
	    let regex = ipRegex_1();
	    let match = raw.match(regex);
	    if (match) {
	      return match[0];
	    }
	    return '';
	  },
	  parseLinesFromRawOutput(raw) {
	    let idxShift = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	    let lines = raw.split('\n').filter(l => l);
	    let linesHeader;
	    let packetLines = [];
	    let lastLineIdx = idxShift;
	    for (let i = 0; i < lines.length; i++) {
	      if (i === 0) {
	        linesHeader = lines[i];
	        continue;
	      }
	      if (lines[i].includes('---')) {
	        break;
	      }
	      let match = lines[i].match(/icmp_seq=(\d+)/);
	      lastLineIdx = idxShift + Number(match[1]);
	      let substitute = `icmp_seq=${lastLineIdx}`;
	      let numberedLine = lines[i].replace(/icmp_seq=\d+/, substitute);
	      packetLines.push(numberedLine);
	    }
	    return {
	      packetLines,
	      linesHeader,
	      lastLineIdx
	    };
	  },
	  calcLoss(statsTotal, statsDrop) {
	    if (typeof statsTotal === 'undefined' || typeof statsDrop === 'undefined' || statsTotal === 0) {
	      return null;
	    }
	    let actualAmount = Math.max(statsTotal - statsDrop, 0);
	    return Math.round(statsDrop / actualAmount * 100);
	  },
	  handleRawOutput(lines) {
	    let limitedLines = lines.length > RAW_OUTPUT_LINES_BATCH_LIMIT ? ['...', ...lines.slice(-RAW_OUTPUT_LINES_BATCH_LIMIT)] : lines;
	    return limitedLines.join('\n');
	  },
	  setMainOptsTestType(newTestType) {
	    if (this.get('testInProgress')) {
	      return;
	    }
	    this.set('mainOptions.type', newTestType);
	  },
	  createRawFooter(target, rtts, packetsTotal, packetsReceived, lossValue, minTiming, avgTiming, maxTiming, time) {
	    let rawOutput = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : '';
	    let mdev = this.calculateMeanDeviation(rtts);
	    let showRttUnits = [minTiming, avgTiming, maxTiming, mdev].some(i => i !== PROBE_NO_TIMING_VALUE$1);
	    let str = `${rawOutput ? '\n' : ''}--- ${target} ping statistics ---
${packetsTotal} packets transmitted, ${packetsReceived} received, ${lossValue || 0}% packet loss, time ${time}ms
rtt min/avg/max/mdev = ${minTiming}/${avgTiming}/${maxTiming}/${mdev}${showRttUnits ? ' ms' : ''}`;
	    return str;
	  },
	  calculateMeanDeviation(rtts) {
	    if (rtts.length === 0) {
	      return PROBE_NO_TIMING_VALUE$1;
	    }
	    let rttsNumber = rtts.length;
	    let rttsSquaredSum = rtts.reduce((sum, rtt) => sum + rtt * rtt, 0);
	    let rttsSum = rtts.reduce((sum, rtt) => sum + rtt, 0);
	    let mdev = Math.sqrt(rttsSquaredSum / rttsNumber - Math.pow(rttsSum / rttsNumber, 2));
	    return Math.round(mdev * 1000) / 1000;
	  },
	  createResetInStr(seconds) {
	    let minutes = seconds / 60;
	    if (minutes < 1) {
	      return '< 1 minute';
	    }
	    return `${Math.ceil(minutes)} minutes`;
	  },
	  createMeasCreditsErrMsg(responseHeaders, isInfinite, testResults) {
	    // do not show err msg if while infinite meas we've got the 429's err and we already have results
	    if (testResults && isInfinite) {
	      return null;
	    }
	    let hasToken = this.get('@shared.user');
	    let timeToReset = this.createResetInStr(responseHeaders['x-ratelimit-reset']);
	    let remainingCredits = Number(responseHeaders['x-ratelimit-remaining'] || 0) + Number(responseHeaders['x-credits-remaining'] || 0);
	    let requiredCredits = Number(responseHeaders['x-request-cost'] || 0);
	    if (isInfinite === false && remainingCredits) {
	      let msg = `<span>You only have ${remainingCredits} credits remaining, and ${requiredCredits} were required.</span>`;
	      msg += `<span>Try requesting fewer probes or wait ${timeToReset} for the limit to reset.</span>`;
	      if (hasToken) {
	        msg += '<span>You can get higher limits by sponsoring us or hosting probes</span>';
	      } else {
	        msg += '<span>You can get higher limits by creating an account. <a href="https://dash.globalping.io">Sign up</a><span>';
	      }
	      return msg;
	    } else if (isInfinite && !testResults || !remainingCredits) {
	      let msg = `<span>You have run out of credits for this session.</span>`;
	      msg += `<span>You can wait ${timeToReset} for the limit to reset or get higher limits by`;
	      if (hasToken) {
	        msg += ` sponsoring us or hosting probes.</span>`;
	      } else {
	        msg += ` creating an account. <a href='https://dash.globalping.io'>Sign up</a></span>`;
	      }
	      return msg;
	    }
	    return DEFAULT_MEASUREMENT_ERR_MSG;
	  },
	  groupProbes(probes) {
	    // group probes by Continents and Coordinates
	    let groups = probes.reduce((res, probe) => {
	      let coords = `${probe.location.latitude}, ${probe.location.longitude}`;

	      // group by Coordinates
	      if (!Object.hasOwn(res, coords)) {
	        res[coords] = [];
	      }
	      res[coords].push(probe);
	      return res;
	    }, {});
	    return groups;
	  },
	  createMapClusterMarkerWithIW(key, markersByCoords) {
	    let [lat, lng] = key.split(', ');
	    let svg = this.createClusterMarkerSVG(markersByCoords.length);
	    let probeInfoWindow = new google.maps.InfoWindow();

	    // Collect InfoWindows
	    probesInfoWindows.push(probeInfoWindow);
	    probeInfoWindow.setContent(this.createClusterMarkerInfoWindowContent(markersByCoords));
	    let markerContent = document.createElement('div');
	    markerContent.style.backgroundImage = `url('data:image/svg+xml;base64,${svg}')`;
	    markerContent.style.backgroundRepeat = 'no-repeat';
	    markerContent.style.backgroundPosition = 'center';
	    markerContent.style.backgroundSize = 'contain';
	    markerContent.setAttribute('data-probe-count', markersByCoords.length);
	    let {
	      svgWidth,
	      svgHeight
	    } = getMarkerSize$1(markersByCoords.length, map$1.zoom);
	    markerContent.style.width = `${svgWidth}px`;
	    markerContent.style.height = `${svgHeight}px`;
	    let probeMarker = new google.maps.marker.AdvancedMarkerElement({
	      map: map$1,
	      content: markerContent,
	      position: {
	        lat: Number(lat),
	        lng: Number(lng)
	      },
	      zIndex: 1
	    });
	    probeMarker.addListener('click', () => {
	      probesInfoWindows.forEach(iw => iw.close());
	      probeInfoWindow.open({
	        map: map$1,
	        anchor: probeMarker
	      });
	    });
	    probeMarker.markersCount = markersByCoords.length || 0;
	    return probeMarker;
	  },
	  createClusterMarkerInfoWindowContent(markersByCoords) {
	    let markersCnt = markersByCoords.length;
	    let groupedNetworks = markersByCoords.reduce((res, m) => {
	      let marker = res.find(i => i.location.network === m.location.network);
	      if (marker) {
	        marker.cnt += 1;
	      } else {
	        res.push({
	          ...m,
	          cnt: 1,
	          sortKey: m.location.network.toLowerCase()
	        });
	      }
	      return res;
	    }, []).sort((a, b) => a.sortKey < b.sortKey ? -1 : a.sortKey > b.sortKey);
	    let infoWindowContent = `<div class="gp_map-cluster-iw">`;
	    if (markersCnt === 1) {
	      let {
	        network,
	        city,
	        country
	      } = markersByCoords[0].location;
	      infoWindowContent += `<span>${network} (${city}, ${country})</span>`;
	    } else {
	      // in this case we should render a list of probes
	      groupedNetworks.forEach((m, mIdx) => {
	        if (mIdx === 0) {
	          // add header content
	          infoWindowContent += '<span class="gp_map-cluster-iw_header">';
	          infoWindowContent += `<img width="16" height="16" src="${this.get('@shared.assetsHost')}/img/globalping/location-icon.svg">`;
	          infoWindowContent += `<span class="gp_map-cluster-iw_header_location">${m.location.city}, ${m.location.country}</span>`;
	          infoWindowContent += `<span class="gp_map-cluster-iw_header_cnt">${markersByCoords.length}</span>`;
	          infoWindowContent += '</span>';
	        }

	        // render the list of the probes, grouped by the same network
	        infoWindowContent += `<span class="gp_map-cluster-iw_row">${m.location.network} ${m.cnt > 1 ? `<span class="gp_map-cluster-iw_row_network-cnt">${m.cnt}</span>` : ''}</span>`;
	      });
	    }
	    infoWindowContent += '</div>';
	    return infoWindowContent;
	  },
	  createClusterMarkerSVG(elementsCnt) {
	    let {
	      svgWidth,
	      svgHeight,
	      circleRadius,
	      strokeWidth
	    } = getMarkerSize$1(elementsCnt, 1); // here zoom must always be 1

	    return window.btoa(`
				<svg width="${svgWidth}" height="${svgHeight}" viewBox="0 0 ${svgWidth} ${svgHeight}" fill="none" xmlns="http://www.w3.org/2000/svg">
					<g filter="url(#filter0_d_6106_3045)">
						<circle cx="${svgWidth / 2}" cy="${svgHeight / 2}" r="${circleRadius}" fill="#17D4A7"/>
						<circle cx="${svgWidth / 2}" cy="${svgHeight / 2}" r="${circleRadius + 1}" stroke="white" stroke-width="${strokeWidth}"/>
					</g>
					${elementsCnt !== 1 ? `<text x="${svgWidth / 2}" y="${svgHeight / 2}" text-anchor="middle" dy=".35em" font-family="Arial" font-size="10" font-weight="bold" fill="#fff">${elementsCnt}</text>` : ''}
					<defs>
						<filter id="filter0_d_6106_3045" x="0" y="0" width="${svgWidth}" height="${svgHeight}" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
							<feFlood flood-opacity="0" result="BackgroundImageFix"/>
							<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
							<feOffset dy="1"/>
							<feGaussianBlur stdDeviation="1"/>
							<feComposite in2="hardAlpha" operator="out"/>
							<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/>
							<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_6106_3045"/>
							<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_6106_3045" result="shape"/>
						</filter>
					</defs>
				</svg>
			`);
	  },
	  spiderifyMapMarkers(clickedMarker, markers, map) {
	    let projection = map.getProjection();
	    let clickedPos = projection.fromLatLngToPoint(clickedMarker.position);
	    let markerWidth = DEFAULT_MARKER_DIMENSIONS;
	    let a = markerWidth;
	    let b = 0.2 * markerWidth;
	    let theta = 0;
	    let overlappedMarkers = markers.filter(marker => {
	      if (marker === clickedMarker) {
	        return false;
	      }
	      let markerPos = projection.fromLatLngToPoint(marker.position);
	      let pixelDistance = Math.sqrt(Math.pow(clickedPos.x - markerPos.x, 2) + Math.pow(clickedPos.y - markerPos.y, 2)) * Math.pow(2, map.zoom);
	      return pixelDistance <= markerWidth;
	    });
	    let spiderMarkers = [clickedMarker, ...overlappedMarkers];
	    spiderMarkers.forEach((marker, index) => {
	      marker.isSpiderPart = true;
	      if (index === 0) {
	        // keep the clicked marker in place
	        marker.position = clickedMarker.position;
	      } else {
	        // spiral calculation
	        let r = a + b * theta;
	        let offsetX = r * Math.cos(theta);
	        let offsetY = r * Math.sin(theta);
	        let x = clickedPos.x + offsetX / Math.pow(2, map.zoom);
	        let y = clickedPos.y + offsetY / Math.pow(2, map.zoom);
	        let point = new google.maps.Point(x, y);
	        let latLng = projection.fromPointToLatLng(point);
	        marker.position = new google.maps.LatLng(latLng.lat(), latLng.lng());
	        marker.zIndex = 99999;

	        // increment angle
	        theta += markerWidth / r;
	      }
	    });
	  },
	  despiderifyMapMarkers(markers) {
	    markers.forEach(m => {
	      let originalPos = originalMapMarkersPos.get(m);
	      if (originalPos) {
	        m.position = originalPos;
	        m.zIndex = 1;
	        m.isSpiderPart = false;
	      }
	    });
	  },
	  shouldMapMarkersSpiderify(clickedMarker, markers, map) {
	    let projection = map.getProjection();
	    let clickedPos = projection.fromLatLngToPoint(clickedMarker.position);
	    let overlapThreshold = DEFAULT_MARKER_DIMENSIONS / 2;
	    return markers.some(marker => {
	      if (marker !== clickedMarker) {
	        let markerPos = projection.fromLatLngToPoint(marker.position);
	        let pixelDistance = Math.sqrt(Math.pow(clickedPos.x - markerPos.x, 2) + Math.pow(clickedPos.y - markerPos.y, 2)) * Math.pow(2, map.zoom);
	        return pixelDistance <= overlapThreshold;
	      }
	      return false;
	    });
	  }
	};
	component$i.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "r-page",
	    m: [{
	      n: "noYield",
	      f: [{
	        t: 2,
	        r: "noYield"
	      }],
	      t: 13
	    }, {
	      n: "title",
	      f: [{
	        t: 2,
	        r: "title"
	      }],
	      t: 13
	    }, {
	      n: "description",
	      f: [{
	        t: 2,
	        r: "description"
	      }],
	      t: 13
	    }, {
	      n: "openGraphImage",
	      f: [{
	        t: 4,
	        f: [{
	          t: 2,
	          r: "@shared.serverHost"
	        }, "/open-graph/image/measurement/", {
	          t: 2,
	          r: "measurement"
	        }],
	        n: 50,
	        r: "measurement"
	      }],
	      t: 13
	    }],
	    f: [{
	      t: 7,
	      e: "script",
	      m: [{
	        n: "src",
	        f: "https://cdn.jsdelivr.net/npm/@googlemaps/markerclusterer@2.5.3/dist/index.umd.min.js",
	        t: 13,
	        g: 1
	      }]
	    }, " ", {
	      t: 4,
	      f: [{
	        t: 7,
	        e: "script",
	        f: ["\t\t\tfunction onDocumentReady (fn) {\n\t\t\t\tif (document.readyState !== 'loading') {\n\t\t\t\t\tfn();\n\t\t\t\t} else {\n\t\t\t\t\tdocument.addEventListener('DOMContentLoaded', fn);\n\t\t\t\t}\n\t\t\t}\n\t\t\t/* eslint-disable */\n\t\t\tfunction initMap () {\n\t\t\t\tonDocumentReady(function () {\n\t\t\t\t\tapp.loaded = true;\n\n\t\t\t\t\tif (app.router.route && app.router.route.view && app.router.route.view.initMap) {\n\t\t\t\t\t\tapp.router.route.view.initMap();\n\t\t\t\t\t}\n\t\t\t\t});\n\t\t\t}\n\t\t"]
	      }, " ", {
	        t: 7,
	        e: "script",
	        m: [{
	          n: "src",
	          f: "https://maps.googleapis.com/maps/api/js?key=AIzaSyBTICLY5LgWNJ0Uly61Q1sNXz_1KZIECwg&language=en&callback=initMap&libraries=marker&loading=async",
	          t: 13,
	          g: 1
	        }, {
	          n: "async",
	          f: 0,
	          t: 13
	        }]
	      }],
	      n: 50,
	      x: {
	        r: ["@shared.isServer", "@shared.googleMapsLoaded"],
	        s: "!_0&&!_1"
	      }
	    }, " ", {
	      t: 7,
	      e: "c-notification"
	    }, " ", {
	      t: 7,
	      e: "c-gp-header",
	      m: [{
	        n: "additionalClasses",
	        f: "header-with-globalping-bg",
	        t: 13,
	        g: 1
	      }]
	    }, " ", {
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "p-globalping",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "c-gp-jumbotron",
	        m: [{
	          n: "className",
	          f: "main",
	          t: 13,
	          g: 1
	        }, {
	          n: "gridType",
	          f: "type1",
	          t: 13,
	          g: 1
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "gp_main-info",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "gp_main-info_descr",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "span",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp_main-info_descr_green",
	              g: 1
	            }],
	            f: ["Monitor, debug and benchmark"]
	          }, " ", {
	            t: 7,
	            e: "span",
	            f: ["your internet infrastructure from a globally distributed network of probes."]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "gp_main-info_stats",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp_main-info_stats_item",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "span",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "gp_main-info_stats_item_number",
	                g: 1
	              }],
	              f: [{
	                t: 2,
	                x: {
	                  r: ["totalProbes"],
	                  s: "Math.floor(_0)"
	                }
	              }, " ", {
	                t: 7,
	                e: "span"
	              }]
	            }, " ", {
	              t: 7,
	              e: "span",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "gp_main-info_stats_item_text",
	                g: 1
	              }],
	              f: ["connected probes"]
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp_main-info_stats_item",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "span",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "gp_main-info_stats_item_number",
	                g: 1
	              }],
	              f: [{
	                t: 2,
	                x: {
	                  r: ["totalCities"],
	                  s: "Math.floor(_0)"
	                }
	              }, " ", {
	                t: 7,
	                e: "span"
	              }]
	            }, " ", {
	              t: 7,
	              e: "span",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "gp_main-info_stats_item_text",
	                g: 1
	              }],
	              f: ["different cities"]
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp_main-info_stats_item",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "span",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "gp_main-info_stats_item_number",
	                g: 1
	              }],
	              f: [{
	                t: 2,
	                x: {
	                  r: ["totalCountries"],
	                  s: "Math.floor(_0)"
	                }
	              }, " ", {
	                t: 7,
	                e: "span"
	              }]
	            }, " ", {
	              t: 7,
	              e: "span",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "gp_main-info_stats_item_text",
	                g: 1
	              }],
	              f: ["different countries"]
	            }]
	          }]
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "gp_map-block",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "gp_map-block_header",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "span"
	          }, " ", {
	            t: 7,
	            e: "span"
	          }, " ", {
	            t: 7,
	            e: "span"
	          }, " ", {
	            t: 4,
	            f: [{
	              t: 7,
	              e: "span",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "gp_map-block_header_share-res-msg",
	                g: 1
	              }],
	              f: [{
	                t: 2,
	                r: "shareResHeaderData"
	              }]
	            }],
	            n: 50,
	            r: "shareResHeaderData"
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "gp_map-block_settings-wrapper",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp_map-block_settings-wrapper_settings",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "gp_map-block_settings-wrapper_settings_grouped",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "gp_dropdown_reg",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "span",
	                  f: ["Test type"]
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "btn-group",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "button",
	                    m: [{
	                      n: "type",
	                      f: "button",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "class",
	                      f: ["dropdown-toggle ", {
	                        t: 4,
	                        f: ["disabled"],
	                        n: 50,
	                        r: "testInProgress"
	                      }],
	                      t: 13
	                    }, {
	                      n: "data-toggle",
	                      f: "dropdown",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "aria-haspopup",
	                      f: "true",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "aria-expanded",
	                      f: "false",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: [{
	                      t: 7,
	                      e: "span",
	                      f: [{
	                        t: 2,
	                        r: "~/mainOptions.type"
	                      }]
	                    }, " ", {
	                      t: 7,
	                      e: "i",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "fa fa-angle-down",
	                        g: 1
	                      }, {
	                        n: "aria-hidden",
	                        f: "true",
	                        t: 13,
	                        g: 1
	                      }]
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "div",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "dropdown-menu",
	                      g: 1
	                    }],
	                    f: [{
	                      t: 4,
	                      f: [{
	                        t: 7,
	                        e: "div",
	                        m: [{
	                          n: ["click"],
	                          t: 70,
	                          f: {
	                            r: ["@this", "."],
	                            s: "[_0.setMainOptsTestType(_1)]"
	                          }
	                        }],
	                        f: [{
	                          t: 2,
	                          r: "."
	                        }]
	                      }],
	                      n: 52,
	                      r: "~/testTypesList"
	                    }]
	                  }]
	                }]
	              }, " ", {
	                t: 7,
	                e: "c-tags-input",
	                m: [{
	                  n: "inputId",
	                  f: "targetInput",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "value",
	                  f: [{
	                    t: 2,
	                    r: "mainOptions.target"
	                  }],
	                  t: 13
	                }, {
	                  n: "defaultValue",
	                  f: [{
	                    t: 2,
	                    r: "DEFAULT_TARGET_VALUE"
	                  }],
	                  t: 13
	                }, {
	                  n: "error",
	                  f: [{
	                    t: 2,
	                    r: "inputErrors.target"
	                  }],
	                  t: 13
	                }, {
	                  n: "placeholder",
	                  f: "IP or domain",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "labelText",
	                  f: "Target(s)",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "isDisabled",
	                  f: [{
	                    t: 2,
	                    r: "testInProgress"
	                  }],
	                  t: 13
	                }, {
	                  n: "setDefaultValueInitialy",
	                  f: [{
	                    t: 2,
	                    x: {
	                      r: ["shareResFlow"],
	                      s: "!_0"
	                    }
	                  }],
	                  t: 13
	                }, {
	                  n: "useGpTargetHandler",
	                  f: [{
	                    t: 2,
	                    x: {
	                      r: [],
	                      s: "true"
	                    }
	                  }],
	                  t: 13
	                }, {
	                  n: "gpMainOpts",
	                  f: [{
	                    t: 2,
	                    r: "mainOptions"
	                  }],
	                  t: 13
	                }, {
	                  n: "gpHttpOpts",
	                  f: [{
	                    t: 2,
	                    r: "httpOpts"
	                  }],
	                  t: 13
	                }, {
	                  n: "gpNotAppliedOpts",
	                  f: [{
	                    t: 2,
	                    r: "notAppliedOpts"
	                  }],
	                  t: 13
	                }, {
	                  n: "gpUrlHandlerCb",
	                  f: [{
	                    t: 2,
	                    r: "@this.applyOptions"
	                  }],
	                  t: 13
	                }, {
	                  n: "showIPSwitch",
	                  f: [{
	                    t: 2,
	                    x: {
	                      r: ["mainOptions.type"],
	                      s: "_0!==\"DNS\""
	                    }
	                  }],
	                  t: 13
	                }, {
	                  n: "ipVersion",
	                  f: [{
	                    t: 2,
	                    r: "mainOptions.ipVersion"
	                  }],
	                  t: 13
	                }, {
	                  n: "ttPos",
	                  f: [{
	                    t: 2,
	                    r: "ttPositions.targetTtPos"
	                  }],
	                  t: 13
	                }],
	                f: [],
	                p: {
	                  labelIcon: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "tooltip",
	                      t: 71,
	                      f: {
	                        r: ["ttPos"],
	                        s: "[\"Up to 2 IP addresses or domains\",_0]"
	                      }
	                    }, {
	                      n: "width",
	                      f: "14",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "14",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/globalping/help-icon.svg"],
	                      t: 13
	                    }]
	                  }]
	                }
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "gp_map-block_settings-wrapper_settings_grouped",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "c-location-input",
	                m: [{
	                  n: ["enter"],
	                  t: 70,
	                  f: {
	                    r: ["@this"],
	                    s: "[_0.resetMapAndRunTest()]"
	                  }
	                }, {
	                  n: "rawProbes",
	                  f: [{
	                    t: 2,
	                    r: "rawProbes"
	                  }],
	                  t: 13
	                }, {
	                  n: "value",
	                  f: [{
	                    t: 2,
	                    r: "mainOptions.location"
	                  }],
	                  t: 13
	                }, {
	                  n: "error",
	                  f: [{
	                    t: 2,
	                    r: "inputErrors.location"
	                  }],
	                  t: 13
	                }, {
	                  n: "placeholder",
	                  f: "Enter location",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "labelText",
	                  f: "Location",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "classList",
	                  f: "gp_map-block_settings-wrapper_settings_location gp_input",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "disabled",
	                  f: [{
	                    t: 2,
	                    r: "testInProgress"
	                  }],
	                  t: 13
	                }, {
	                  n: "ttPos",
	                  f: [{
	                    t: 2,
	                    r: "ttPositions.locationTtPos"
	                  }],
	                  t: 13
	                }],
	                f: [],
	                p: {
	                  labelIcon: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "tooltip",
	                      t: 71,
	                      f: {
	                        r: ["ttPos"],
	                        s: "[[\"This magic field supports names of continents, regions, countries, US states, cities, networks, and our custom tags.\",\"\",\"Use + to combine multiple filters.\",\"Use , to select multiple locations.\"],_0,undefined,undefined,\"multiline\"]"
	                      }
	                    }, {
	                      n: "width",
	                      f: "14",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "14",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/globalping/help-icon.svg"],
	                      t: 13
	                    }]
	                  }]
	                }
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "gp_map-block_settings-wrapper_settings_subgroup",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "c-controlled-input",
	                  m: [{
	                    n: "id",
	                    f: "limitInput",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "value",
	                    f: [{
	                      t: 2,
	                      r: "mainOptions.limit"
	                    }],
	                    t: 13
	                  }, {
	                    n: "error",
	                    f: [{
	                      t: 2,
	                      r: "inputErrors.limit"
	                    }],
	                    t: 13
	                  }, {
	                    n: "placeholder",
	                    f: [{
	                      t: 2,
	                      r: "defaultLimit"
	                    }],
	                    t: 13
	                  }, {
	                    n: "labelText",
	                    f: "Limit",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "classList",
	                    f: "gp_map-block_settings-wrapper_settings_limit gp_input",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "hideLabelIcon",
	                    f: [{
	                      t: 2,
	                      x: {
	                        r: ["infiniteSwitchEnabled"],
	                        s: "_0===false"
	                      }
	                    }],
	                    t: 13
	                  }, {
	                    n: "disabled",
	                    f: [{
	                      t: 2,
	                      r: "testInProgress"
	                    }],
	                    t: 13
	                  }, {
	                    n: "ttPos",
	                    f: [{
	                      t: 2,
	                      r: "ttPositions.limitTtPos"
	                    }],
	                    t: 13
	                  }],
	                  f: [],
	                  p: {
	                    labelIcon: [{
	                      t: 7,
	                      e: "img",
	                      m: [{
	                        n: "tooltip",
	                        t: 71,
	                        f: {
	                          r: ["ttPos"],
	                          s: "[\"Values up to 5 are supported for infinite measurements\",_0,undefined,undefined,\"gp_tt-limit\"]"
	                        }
	                      }, {
	                        n: "width",
	                        f: "14",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "height",
	                        f: "14",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "src",
	                        f: [{
	                          t: 2,
	                          r: "@shared.assetsHost"
	                        }, "/img/globalping/help-icon.svg"],
	                        t: 13
	                      }]
	                    }]
	                  }
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    n: "class",
	                    f: ["gp_map-block_settings-wrapper_settings_subgroup_options-block ", {
	                      t: 4,
	                      f: ["disabled"],
	                      n: 50,
	                      r: "testInProgress"
	                    }],
	                    t: 13
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "button",
	                    m: [{
	                      n: "class",
	                      f: [{
	                        t: 4,
	                        f: ["active"],
	                        n: 50,
	                        r: "showMeasurementOpts"
	                      }],
	                      t: 13
	                    }, {
	                      n: ["click"],
	                      t: 70,
	                      f: {
	                        r: ["@this"],
	                        s: "[_0.handleToggleMeasOpts()]"
	                      }
	                    }],
	                    f: [{
	                      t: 7,
	                      e: "img",
	                      m: [{
	                        n: "width",
	                        f: "20",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "height",
	                        f: "20",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "src",
	                        f: [{
	                          t: 2,
	                          r: "@shared.assetsHost"
	                        }, "/img/globalping/settings-icon.svg"],
	                        t: 13
	                      }]
	                    }, " ", {
	                      t: 4,
	                      f: [{
	                        t: 7,
	                        e: "div",
	                        m: [{
	                          t: 13,
	                          n: "class",
	                          f: "additional-opts-total",
	                          g: 1
	                        }],
	                        f: [{
	                          t: 2,
	                          r: "modifiedMeasOptsCnt"
	                        }]
	                      }],
	                      n: 50,
	                      x: {
	                        r: ["infiniteSwitchEnabled", "modifiedMeasOptsCnt", "showMeasurementOpts"],
	                        s: "_0===false&&_1&&_2===false"
	                      }
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "div",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "gp_map-block_settings-wrapper_settings_subgroup_options-block_specific-set",
	                      g: 1
	                    }],
	                    f: [{
	                      t: 4,
	                      f: [{
	                        t: 7,
	                        e: "div",
	                        m: [{
	                          t: 13,
	                          n: "class",
	                          f: "typePing",
	                          g: 1
	                        }],
	                        f: [{
	                          t: 7,
	                          e: "c-controlled-input",
	                          m: [{
	                            n: "value",
	                            f: [{
	                              t: 2,
	                              r: "notAppliedOpts.packets"
	                            }],
	                            t: 13
	                          }, {
	                            n: "error",
	                            f: [{
	                              t: 2,
	                              r: "inputErrors.packets"
	                            }],
	                            t: 13
	                          }, {
	                            n: "placeholder",
	                            f: [{
	                              t: 2,
	                              r: "defaultPacketsAmount"
	                            }],
	                            t: 13
	                          }, {
	                            n: "labelText",
	                            f: "Packets",
	                            t: 13,
	                            g: 1
	                          }, {
	                            n: "classList",
	                            f: "gp_input",
	                            t: 13,
	                            g: 1
	                          }, {
	                            n: "disabled",
	                            f: [{
	                              t: 2,
	                              r: "infiniteSwitchEnabled"
	                            }],
	                            t: 13
	                          }],
	                          f: []
	                        }]
	                      }],
	                      n: 50,
	                      x: {
	                        r: ["mainOptions.type"],
	                        s: "_0===\"ping\""
	                      }
	                    }, " ", {
	                      t: 4,
	                      f: [{
	                        t: 7,
	                        e: "div",
	                        m: [{
	                          t: 13,
	                          n: "class",
	                          f: "typeTraceroute",
	                          g: 1
	                        }],
	                        f: [{
	                          t: 7,
	                          e: "div",
	                          m: [{
	                            t: 13,
	                            n: "class",
	                            f: "pair",
	                            g: 1
	                          }],
	                          f: [{
	                            t: 7,
	                            e: "c-controlled-input",
	                            m: [{
	                              n: "value",
	                              f: [{
	                                t: 2,
	                                r: "notAppliedOpts.port"
	                              }],
	                              t: 13
	                            }, {
	                              n: "error",
	                              f: [{
	                                t: 2,
	                                r: "inputErrors.port"
	                              }],
	                              t: 13
	                            }, {
	                              n: "placeholder",
	                              f: "53",
	                              t: 13,
	                              g: 1
	                            }, {
	                              n: "labelText",
	                              f: "Port",
	                              t: 13,
	                              g: 1
	                            }, {
	                              n: "classList",
	                              f: "port-input gp_input",
	                              t: 13,
	                              g: 1
	                            }],
	                            f: []
	                          }, " ", {
	                            t: 7,
	                            e: "div",
	                            m: [{
	                              t: 13,
	                              n: "class",
	                              f: "gp_dropdown_reg",
	                              g: 1
	                            }],
	                            f: [{
	                              t: 7,
	                              e: "span",
	                              f: ["Protocol"]
	                            }, " ", {
	                              t: 7,
	                              e: "div",
	                              m: [{
	                                t: 13,
	                                n: "class",
	                                f: "btn-group",
	                                g: 1
	                              }],
	                              f: [{
	                                t: 7,
	                                e: "button",
	                                m: [{
	                                  t: 13,
	                                  n: "class",
	                                  f: "dropdown-toggle",
	                                  g: 1
	                                }, {
	                                  n: "type",
	                                  f: "button",
	                                  t: 13,
	                                  g: 1
	                                }, {
	                                  n: "data-toggle",
	                                  f: "dropdown",
	                                  t: 13,
	                                  g: 1
	                                }, {
	                                  n: "aria-haspopup",
	                                  f: "true",
	                                  t: 13,
	                                  g: 1
	                                }, {
	                                  n: "aria-expanded",
	                                  f: "false",
	                                  t: 13,
	                                  g: 1
	                                }],
	                                f: [{
	                                  t: 7,
	                                  e: "span",
	                                  f: [{
	                                    t: 2,
	                                    r: "~/tracerouteOpts.protocol"
	                                  }]
	                                }, " ", {
	                                  t: 7,
	                                  e: "i",
	                                  m: [{
	                                    t: 13,
	                                    n: "class",
	                                    f: "fa fa-angle-down",
	                                    g: 1
	                                  }, {
	                                    n: "aria-hidden",
	                                    f: "true",
	                                    t: 13,
	                                    g: 1
	                                  }]
	                                }]
	                              }, " ", {
	                                t: 7,
	                                e: "div",
	                                m: [{
	                                  t: 13,
	                                  n: "class",
	                                  f: "dropdown-menu",
	                                  g: 1
	                                }],
	                                f: [{
	                                  t: 7,
	                                  e: "div",
	                                  m: [{
	                                    n: ["click"],
	                                    t: 70,
	                                    f: {
	                                      r: ["@this"],
	                                      s: "[_0.set(\"tracerouteOpts.protocol\",\"TCP\")]"
	                                    }
	                                  }],
	                                  f: ["TCP"]
	                                }, " ", {
	                                  t: 7,
	                                  e: "div",
	                                  m: [{
	                                    n: ["click"],
	                                    t: 70,
	                                    f: {
	                                      r: ["@this"],
	                                      s: "[_0.set(\"tracerouteOpts.protocol\",\"UDP\")]"
	                                    }
	                                  }],
	                                  f: ["UDP"]
	                                }, " ", {
	                                  t: 7,
	                                  e: "div",
	                                  m: [{
	                                    n: ["click"],
	                                    t: 70,
	                                    f: {
	                                      r: ["@this"],
	                                      s: "[_0.set(\"tracerouteOpts.protocol\",\"ICMP\")]"
	                                    }
	                                  }],
	                                  f: ["ICMP"]
	                                }]
	                              }]
	                            }]
	                          }]
	                        }]
	                      }],
	                      n: 50,
	                      x: {
	                        r: ["mainOptions.type"],
	                        s: "_0===\"traceroute\""
	                      }
	                    }, " ", {
	                      t: 4,
	                      f: [{
	                        t: 7,
	                        e: "div",
	                        m: [{
	                          t: 13,
	                          n: "class",
	                          f: "typeDNS",
	                          g: 1
	                        }],
	                        f: [{
	                          t: 7,
	                          e: "div",
	                          m: [{
	                            t: 13,
	                            n: "class",
	                            f: "rows",
	                            g: 1
	                          }],
	                          f: [{
	                            t: 7,
	                            e: "div",
	                            m: [{
	                              t: 13,
	                              n: "class",
	                              f: "rows_row-one",
	                              g: 1
	                            }],
	                            f: [{
	                              t: 7,
	                              e: "c-controlled-input",
	                              m: [{
	                                n: "value",
	                                f: [{
	                                  t: 2,
	                                  r: "notAppliedOpts.port"
	                                }],
	                                t: 13
	                              }, {
	                                n: "error",
	                                f: [{
	                                  t: 2,
	                                  r: "inputErrors.port"
	                                }],
	                                t: 13
	                              }, {
	                                n: "placeholder",
	                                f: "53",
	                                t: 13,
	                                g: 1
	                              }, {
	                                n: "labelText",
	                                f: "Port",
	                                t: 13,
	                                g: 1
	                              }, {
	                                n: "classList",
	                                f: "port-input gp_input",
	                                t: 13,
	                                g: 1
	                              }],
	                              f: []
	                            }, " ", {
	                              t: 7,
	                              e: "div",
	                              m: [{
	                                t: 13,
	                                n: "class",
	                                f: "gp_dropdown_reg",
	                                g: 1
	                              }],
	                              f: [{
	                                t: 7,
	                                e: "span",
	                                f: ["Protocol"]
	                              }, " ", {
	                                t: 7,
	                                e: "div",
	                                m: [{
	                                  t: 13,
	                                  n: "class",
	                                  f: "btn-group",
	                                  g: 1
	                                }],
	                                f: [{
	                                  t: 7,
	                                  e: "button",
	                                  m: [{
	                                    t: 13,
	                                    n: "class",
	                                    f: "dropdown-toggle",
	                                    g: 1
	                                  }, {
	                                    n: "type",
	                                    f: "button",
	                                    t: 13,
	                                    g: 1
	                                  }, {
	                                    n: "data-toggle",
	                                    f: "dropdown",
	                                    t: 13,
	                                    g: 1
	                                  }, {
	                                    n: "aria-haspopup",
	                                    f: "true",
	                                    t: 13,
	                                    g: 1
	                                  }, {
	                                    n: "aria-expanded",
	                                    f: "false",
	                                    t: 13,
	                                    g: 1
	                                  }],
	                                  f: [{
	                                    t: 7,
	                                    e: "span",
	                                    f: [{
	                                      t: 2,
	                                      r: "~/dnsOpts.protocol"
	                                    }]
	                                  }, " ", {
	                                    t: 7,
	                                    e: "i",
	                                    m: [{
	                                      t: 13,
	                                      n: "class",
	                                      f: "fa fa-angle-down",
	                                      g: 1
	                                    }, {
	                                      n: "aria-hidden",
	                                      f: "true",
	                                      t: 13,
	                                      g: 1
	                                    }]
	                                  }]
	                                }, " ", {
	                                  t: 7,
	                                  e: "div",
	                                  m: [{
	                                    t: 13,
	                                    n: "class",
	                                    f: "dropdown-menu",
	                                    g: 1
	                                  }],
	                                  f: [{
	                                    t: 7,
	                                    e: "div",
	                                    m: [{
	                                      n: ["click"],
	                                      t: 70,
	                                      f: {
	                                        r: ["@this"],
	                                        s: "[_0.set(\"dnsOpts.protocol\",\"UDP\")]"
	                                      }
	                                    }],
	                                    f: ["UDP"]
	                                  }, " ", {
	                                    t: 7,
	                                    e: "div",
	                                    m: [{
	                                      n: ["click"],
	                                      t: 70,
	                                      f: {
	                                        r: ["@this"],
	                                        s: "[_0.set(\"dnsOpts.protocol\",\"TCP\")]"
	                                      }
	                                    }],
	                                    f: ["TCP"]
	                                  }]
	                                }]
	                              }]
	                            }]
	                          }, " ", {
	                            t: 7,
	                            e: "div",
	                            m: [{
	                              t: 13,
	                              n: "class",
	                              f: "rows_row-two",
	                              g: 1
	                            }],
	                            f: [{
	                              t: 7,
	                              e: "div",
	                              m: [{
	                                t: 13,
	                                n: "class",
	                                f: "gp_dropdown_reg",
	                                g: 1
	                              }],
	                              f: [{
	                                t: 7,
	                                e: "span",
	                                f: ["Type"]
	                              }, " ", {
	                                t: 7,
	                                e: "div",
	                                m: [{
	                                  t: 13,
	                                  n: "class",
	                                  f: "btn-group",
	                                  g: 1
	                                }],
	                                f: [{
	                                  t: 7,
	                                  e: "button",
	                                  m: [{
	                                    t: 13,
	                                    n: "class",
	                                    f: "dropdown-toggle",
	                                    g: 1
	                                  }, {
	                                    n: "type",
	                                    f: "button",
	                                    t: 13,
	                                    g: 1
	                                  }, {
	                                    n: "data-toggle",
	                                    f: "dropdown",
	                                    t: 13,
	                                    g: 1
	                                  }, {
	                                    n: "aria-haspopup",
	                                    f: "true",
	                                    t: 13,
	                                    g: 1
	                                  }, {
	                                    n: "aria-expanded",
	                                    f: "false",
	                                    t: 13,
	                                    g: 1
	                                  }],
	                                  f: [{
	                                    t: 7,
	                                    e: "span",
	                                    f: [{
	                                      t: 2,
	                                      r: "~/dnsOpts.query.type"
	                                    }]
	                                  }, " ", {
	                                    t: 7,
	                                    e: "i",
	                                    m: [{
	                                      t: 13,
	                                      n: "class",
	                                      f: "fa fa-angle-down",
	                                      g: 1
	                                    }, {
	                                      n: "aria-hidden",
	                                      f: "true",
	                                      t: 13,
	                                      g: 1
	                                    }]
	                                  }]
	                                }, " ", {
	                                  t: 7,
	                                  e: "div",
	                                  m: [{
	                                    t: 13,
	                                    n: "class",
	                                    f: "dropdown-menu",
	                                    g: 1
	                                  }],
	                                  f: [{
	                                    t: 4,
	                                    f: [{
	                                      t: 7,
	                                      e: "div",
	                                      m: [{
	                                        n: ["click"],
	                                        t: 70,
	                                        f: {
	                                          r: ["@this", "."],
	                                          s: "[_0.set(\"dnsOpts.query.type\",_1)]"
	                                        }
	                                      }],
	                                      f: [{
	                                        t: 2,
	                                        r: "."
	                                      }]
	                                    }],
	                                    n: 52,
	                                    r: "~/dnsTypesList"
	                                  }]
	                                }]
	                              }]
	                            }, " ", {
	                              t: 7,
	                              e: "div",
	                              m: [{
	                                t: 13,
	                                n: "class",
	                                f: "rows_row-two_switch-block",
	                                g: 1
	                              }],
	                              f: [{
	                                t: 7,
	                                e: "label",
	                                m: [{
	                                  t: 13,
	                                  n: "class",
	                                  f: "gp_switch",
	                                  g: 1
	                                }],
	                                f: [{
	                                  t: 7,
	                                  e: "input",
	                                  m: [{
	                                    n: "type",
	                                    f: "checkbox",
	                                    t: 13
	                                  }, {
	                                    n: ["click"],
	                                    t: 70,
	                                    f: {
	                                      r: ["@this", "dnsOpts.trace"],
	                                      s: "[_0.set(\"dnsOpts.trace\",!_1)]"
	                                    }
	                                  }, {
	                                    n: "checked",
	                                    f: [{
	                                      t: 2,
	                                      r: "dnsOpts.trace"
	                                    }],
	                                    t: 13
	                                  }]
	                                }, " ", {
	                                  t: 7,
	                                  e: "span",
	                                  m: [{
	                                    t: 13,
	                                    n: "class",
	                                    f: "slider round",
	                                    g: 1
	                                  }]
	                                }]
	                              }, " ", {
	                                t: 7,
	                                e: "span",
	                                f: ["Trace"]
	                              }]
	                            }]
	                          }]
	                        }, " ", {
	                          t: 7,
	                          e: "c-controlled-input",
	                          m: [{
	                            n: "value",
	                            f: [{
	                              t: 2,
	                              r: "notAppliedOpts.resolver"
	                            }],
	                            t: 13
	                          }, {
	                            n: "error",
	                            f: [{
	                              t: 2,
	                              r: "inputErrors.resolver"
	                            }],
	                            t: 13
	                          }, {
	                            n: "placeholder",
	                            f: "IP address",
	                            t: 13,
	                            g: 1
	                          }, {
	                            n: "labelText",
	                            f: "Resolver",
	                            t: 13,
	                            g: 1
	                          }, {
	                            n: "classList",
	                            f: "resolver-input gp_input",
	                            t: 13,
	                            g: 1
	                          }],
	                          f: []
	                        }]
	                      }],
	                      n: 50,
	                      x: {
	                        r: ["mainOptions.type"],
	                        s: "_0===\"DNS\""
	                      }
	                    }, " ", {
	                      t: 4,
	                      f: [{
	                        t: 7,
	                        e: "div",
	                        m: [{
	                          t: 13,
	                          n: "class",
	                          f: "typeMTR",
	                          g: 1
	                        }],
	                        f: [{
	                          t: 7,
	                          e: "div",
	                          m: [{
	                            t: 13,
	                            n: "class",
	                            f: "pair",
	                            g: 1
	                          }],
	                          f: [{
	                            t: 7,
	                            e: "c-controlled-input",
	                            m: [{
	                              n: "value",
	                              f: [{
	                                t: 2,
	                                r: "notAppliedOpts.port"
	                              }],
	                              t: 13
	                            }, {
	                              n: "error",
	                              f: [{
	                                t: 2,
	                                r: "inputErrors.port"
	                              }],
	                              t: 13
	                            }, {
	                              n: "placeholder",
	                              f: "53",
	                              t: 13,
	                              g: 1
	                            }, {
	                              n: "labelText",
	                              f: "Port",
	                              t: 13,
	                              g: 1
	                            }, {
	                              n: "classList",
	                              f: "port-input gp_input",
	                              t: 13,
	                              g: 1
	                            }],
	                            f: []
	                          }, " ", {
	                            t: 7,
	                            e: "div",
	                            m: [{
	                              t: 13,
	                              n: "class",
	                              f: "gp_dropdown_reg",
	                              g: 1
	                            }],
	                            f: [{
	                              t: 7,
	                              e: "span",
	                              f: ["Protocol"]
	                            }, " ", {
	                              t: 7,
	                              e: "div",
	                              m: [{
	                                t: 13,
	                                n: "class",
	                                f: "btn-group",
	                                g: 1
	                              }],
	                              f: [{
	                                t: 7,
	                                e: "button",
	                                m: [{
	                                  t: 13,
	                                  n: "class",
	                                  f: "dropdown-toggle",
	                                  g: 1
	                                }, {
	                                  n: "type",
	                                  f: "button",
	                                  t: 13,
	                                  g: 1
	                                }, {
	                                  n: "data-toggle",
	                                  f: "dropdown",
	                                  t: 13,
	                                  g: 1
	                                }, {
	                                  n: "aria-haspopup",
	                                  f: "true",
	                                  t: 13,
	                                  g: 1
	                                }, {
	                                  n: "aria-expanded",
	                                  f: "false",
	                                  t: 13,
	                                  g: 1
	                                }],
	                                f: [{
	                                  t: 7,
	                                  e: "span",
	                                  f: [{
	                                    t: 2,
	                                    r: "~/mtrOpts.protocol"
	                                  }]
	                                }, " ", {
	                                  t: 7,
	                                  e: "i",
	                                  m: [{
	                                    t: 13,
	                                    n: "class",
	                                    f: "fa fa-angle-down",
	                                    g: 1
	                                  }, {
	                                    n: "aria-hidden",
	                                    f: "true",
	                                    t: 13,
	                                    g: 1
	                                  }]
	                                }]
	                              }, " ", {
	                                t: 7,
	                                e: "div",
	                                m: [{
	                                  t: 13,
	                                  n: "class",
	                                  f: "dropdown-menu",
	                                  g: 1
	                                }],
	                                f: [{
	                                  t: 7,
	                                  e: "div",
	                                  m: [{
	                                    n: ["click"],
	                                    t: 70,
	                                    f: {
	                                      r: ["@this"],
	                                      s: "[_0.set(\"mtrOpts.protocol\",\"UDP\")]"
	                                    }
	                                  }],
	                                  f: ["UDP"]
	                                }, " ", {
	                                  t: 7,
	                                  e: "div",
	                                  m: [{
	                                    n: ["click"],
	                                    t: 70,
	                                    f: {
	                                      r: ["@this"],
	                                      s: "[_0.set(\"mtrOpts.protocol\",\"TCP\")]"
	                                    }
	                                  }],
	                                  f: ["TCP"]
	                                }, " ", {
	                                  t: 7,
	                                  e: "div",
	                                  m: [{
	                                    n: ["click"],
	                                    t: 70,
	                                    f: {
	                                      r: ["@this"],
	                                      s: "[_0.set(\"mtrOpts.protocol\",\"ICMP\")]"
	                                    }
	                                  }],
	                                  f: ["ICMP"]
	                                }]
	                              }]
	                            }]
	                          }]
	                        }, " ", {
	                          t: 7,
	                          e: "c-controlled-input",
	                          m: [{
	                            n: "value",
	                            f: [{
	                              t: 2,
	                              r: "notAppliedOpts.packets"
	                            }],
	                            t: 13
	                          }, {
	                            n: "error",
	                            f: [{
	                              t: 2,
	                              r: "inputErrors.packets"
	                            }],
	                            t: 13
	                          }, {
	                            n: "placeholder",
	                            f: [{
	                              t: 2,
	                              r: "defaultPacketsAmount"
	                            }],
	                            t: 13
	                          }, {
	                            n: "labelText",
	                            f: "Packets",
	                            t: 13,
	                            g: 1
	                          }, {
	                            n: "classList",
	                            f: "gp_input",
	                            t: 13,
	                            g: 1
	                          }],
	                          f: []
	                        }]
	                      }],
	                      n: 50,
	                      x: {
	                        r: ["mainOptions.type"],
	                        s: "_0===\"MTR\""
	                      }
	                    }, " ", {
	                      t: 4,
	                      f: [{
	                        t: 7,
	                        e: "div",
	                        m: [{
	                          t: 13,
	                          n: "class",
	                          f: "typeHTTP",
	                          g: 1
	                        }],
	                        f: [{
	                          t: 7,
	                          e: "c-controlled-input",
	                          m: [{
	                            n: "value",
	                            f: [{
	                              t: 2,
	                              r: "notAppliedOpts.request.host"
	                            }],
	                            t: 13
	                          }, {
	                            n: "error",
	                            f: [{
	                              t: 2,
	                              r: "inputErrors.host"
	                            }],
	                            t: 13
	                          }, {
	                            n: "placeholder",
	                            f: "Host",
	                            t: 13,
	                            g: 1
	                          }, {
	                            n: "labelText",
	                            f: "Host",
	                            t: 13,
	                            g: 1
	                          }, {
	                            n: "classList",
	                            f: "gp_input",
	                            t: 13,
	                            g: 1
	                          }],
	                          f: []
	                        }, " ", {
	                          t: 7,
	                          e: "c-controlled-input",
	                          m: [{
	                            n: "value",
	                            f: [{
	                              t: 2,
	                              r: "notAppliedOpts.request.path"
	                            }],
	                            t: 13
	                          }, {
	                            n: "error",
	                            f: [{
	                              t: 2,
	                              r: "inputErrors.path"
	                            }],
	                            t: 13
	                          }, {
	                            n: "placeholder",
	                            f: "Path",
	                            t: 13,
	                            g: 1
	                          }, {
	                            n: "labelText",
	                            f: "Path",
	                            t: 13,
	                            g: 1
	                          }, {
	                            n: "classList",
	                            f: "gp_input",
	                            t: 13,
	                            g: 1
	                          }],
	                          f: []
	                        }, " ", {
	                          t: 7,
	                          e: "c-controlled-input",
	                          m: [{
	                            n: "value",
	                            f: [{
	                              t: 2,
	                              r: "notAppliedOpts.request.query"
	                            }],
	                            t: 13
	                          }, {
	                            n: "error",
	                            f: [{
	                              t: 2,
	                              r: "inputErrors.query"
	                            }],
	                            t: 13
	                          }, {
	                            n: "placeholder",
	                            f: "Query",
	                            t: 13,
	                            g: 1
	                          }, {
	                            n: "labelText",
	                            f: "Query",
	                            t: 13,
	                            g: 1
	                          }, {
	                            n: "classList",
	                            f: "gp_input",
	                            t: 13,
	                            g: 1
	                          }],
	                          f: []
	                        }, " ", {
	                          t: 7,
	                          e: "div",
	                          m: [{
	                            t: 13,
	                            n: "class",
	                            f: "pair",
	                            g: 1
	                          }],
	                          f: [{
	                            t: 7,
	                            e: "div",
	                            m: [{
	                              t: 13,
	                              n: "class",
	                              f: "gp_dropdown_reg",
	                              g: 1
	                            }],
	                            f: [{
	                              t: 7,
	                              e: "span",
	                              f: ["Protocol"]
	                            }, " ", {
	                              t: 7,
	                              e: "div",
	                              m: [{
	                                t: 13,
	                                n: "class",
	                                f: "btn-group",
	                                g: 1
	                              }],
	                              f: [{
	                                t: 7,
	                                e: "button",
	                                m: [{
	                                  t: 13,
	                                  n: "class",
	                                  f: "dropdown-toggle",
	                                  g: 1
	                                }, {
	                                  n: "type",
	                                  f: "button",
	                                  t: 13,
	                                  g: 1
	                                }, {
	                                  n: "data-toggle",
	                                  f: "dropdown",
	                                  t: 13,
	                                  g: 1
	                                }, {
	                                  n: "aria-haspopup",
	                                  f: "true",
	                                  t: 13,
	                                  g: 1
	                                }, {
	                                  n: "aria-expanded",
	                                  f: "false",
	                                  t: 13,
	                                  g: 1
	                                }],
	                                f: [{
	                                  t: 7,
	                                  e: "span",
	                                  f: [{
	                                    t: 2,
	                                    r: "~/httpOpts.protocol"
	                                  }]
	                                }, " ", {
	                                  t: 7,
	                                  e: "i",
	                                  m: [{
	                                    t: 13,
	                                    n: "class",
	                                    f: "fa fa-angle-down",
	                                    g: 1
	                                  }, {
	                                    n: "aria-hidden",
	                                    f: "true",
	                                    t: 13,
	                                    g: 1
	                                  }]
	                                }]
	                              }, " ", {
	                                t: 7,
	                                e: "div",
	                                m: [{
	                                  t: 13,
	                                  n: "class",
	                                  f: "dropdown-menu",
	                                  g: 1
	                                }],
	                                f: [{
	                                  t: 7,
	                                  e: "div",
	                                  m: [{
	                                    n: ["click"],
	                                    t: 70,
	                                    f: {
	                                      r: ["@this"],
	                                      s: "[_0.set(\"httpOpts.protocol\",\"HTTP\")]"
	                                    }
	                                  }],
	                                  f: ["HTTP"]
	                                }, " ", {
	                                  t: 7,
	                                  e: "div",
	                                  m: [{
	                                    n: ["click"],
	                                    t: 70,
	                                    f: {
	                                      r: ["@this"],
	                                      s: "[_0.set(\"httpOpts.protocol\",\"HTTPS\")]"
	                                    }
	                                  }],
	                                  f: ["HTTPS"]
	                                }, " ", {
	                                  t: 7,
	                                  e: "div",
	                                  m: [{
	                                    n: ["click"],
	                                    t: 70,
	                                    f: {
	                                      r: ["@this"],
	                                      s: "[_0.set(\"httpOpts.protocol\",\"HTTP2\")]"
	                                    }
	                                  }],
	                                  f: ["HTTP2"]
	                                }]
	                              }]
	                            }]
	                          }, " ", {
	                            t: 7,
	                            e: "c-controlled-input",
	                            m: [{
	                              n: "value",
	                              f: [{
	                                t: 2,
	                                r: "notAppliedOpts.port"
	                              }],
	                              t: 13
	                            }, {
	                              n: "error",
	                              f: [{
	                                t: 2,
	                                r: "inputErrors.port"
	                              }],
	                              t: 13
	                            }, {
	                              n: "placeholder",
	                              f: "53",
	                              t: 13,
	                              g: 1
	                            }, {
	                              n: "labelText",
	                              f: "Port",
	                              t: 13,
	                              g: 1
	                            }, {
	                              n: "classList",
	                              f: "port-input gp_input",
	                              t: 13,
	                              g: 1
	                            }],
	                            f: []
	                          }]
	                        }, " ", {
	                          t: 7,
	                          e: "div",
	                          m: [{
	                            t: 13,
	                            n: "class",
	                            f: "pair",
	                            g: 1
	                          }],
	                          f: [{
	                            t: 7,
	                            e: "div",
	                            m: [{
	                              t: 13,
	                              n: "class",
	                              f: "gp_dropdown_reg",
	                              g: 1
	                            }],
	                            f: [{
	                              t: 7,
	                              e: "span",
	                              f: ["Method"]
	                            }, " ", {
	                              t: 7,
	                              e: "div",
	                              m: [{
	                                t: 13,
	                                n: "class",
	                                f: "btn-group",
	                                g: 1
	                              }],
	                              f: [{
	                                t: 7,
	                                e: "button",
	                                m: [{
	                                  t: 13,
	                                  n: "class",
	                                  f: "dropdown-toggle",
	                                  g: 1
	                                }, {
	                                  n: "type",
	                                  f: "button",
	                                  t: 13,
	                                  g: 1
	                                }, {
	                                  n: "data-toggle",
	                                  f: "dropdown",
	                                  t: 13,
	                                  g: 1
	                                }, {
	                                  n: "aria-haspopup",
	                                  f: "true",
	                                  t: 13,
	                                  g: 1
	                                }, {
	                                  n: "aria-expanded",
	                                  f: "false",
	                                  t: 13,
	                                  g: 1
	                                }],
	                                f: [{
	                                  t: 7,
	                                  e: "span",
	                                  f: [{
	                                    t: 2,
	                                    r: "~/httpOpts.request.method"
	                                  }]
	                                }, " ", {
	                                  t: 7,
	                                  e: "i",
	                                  m: [{
	                                    t: 13,
	                                    n: "class",
	                                    f: "fa fa-angle-down",
	                                    g: 1
	                                  }, {
	                                    n: "aria-hidden",
	                                    f: "true",
	                                    t: 13,
	                                    g: 1
	                                  }]
	                                }]
	                              }, " ", {
	                                t: 7,
	                                e: "div",
	                                m: [{
	                                  t: 13,
	                                  n: "class",
	                                  f: "dropdown-menu",
	                                  g: 1
	                                }],
	                                f: [{
	                                  t: 7,
	                                  e: "div",
	                                  m: [{
	                                    n: ["click"],
	                                    t: 70,
	                                    f: {
	                                      r: ["@this"],
	                                      s: "[_0.set(\"httpOpts.request.method\",\"GET\")]"
	                                    }
	                                  }],
	                                  f: ["GET"]
	                                }, " ", {
	                                  t: 7,
	                                  e: "div",
	                                  m: [{
	                                    n: ["click"],
	                                    t: 70,
	                                    f: {
	                                      r: ["@this"],
	                                      s: "[_0.set(\"httpOpts.request.method\",\"HEAD\")]"
	                                    }
	                                  }],
	                                  f: ["HEAD"]
	                                }, " ", {
	                                  t: 7,
	                                  e: "div",
	                                  m: [{
	                                    n: ["click"],
	                                    t: 70,
	                                    f: {
	                                      r: ["@this"],
	                                      s: "[_0.set(\"httpOpts.request.method\",\"OPTIONS\")]"
	                                    }
	                                  }],
	                                  f: ["OPTIONS"]
	                                }]
	                              }]
	                            }]
	                          }, " ", {
	                            t: 7,
	                            e: "c-controlled-input",
	                            m: [{
	                              n: "value",
	                              f: [{
	                                t: 2,
	                                r: "notAppliedOpts.resolver"
	                              }],
	                              t: 13
	                            }, {
	                              n: "error",
	                              f: [{
	                                t: 2,
	                                r: "inputErrors.resolver"
	                              }],
	                              t: 13
	                            }, {
	                              n: "placeholder",
	                              f: "Resolver",
	                              t: 13,
	                              g: 1
	                            }, {
	                              n: "labelText",
	                              f: "Resolver",
	                              t: 13,
	                              g: 1
	                            }, {
	                              n: "classList",
	                              f: "gp_input",
	                              t: 13,
	                              g: 1
	                            }],
	                            f: []
	                          }]
	                        }, " ", {
	                          t: 7,
	                          e: "c-controlled-textarea",
	                          m: [{
	                            n: "value",
	                            f: [{
	                              t: 2,
	                              r: "notAppliedOpts.request.headers"
	                            }],
	                            t: 13
	                          }, {
	                            n: "error",
	                            f: [{
	                              t: 2,
	                              r: "inputErrors.headers"
	                            }],
	                            t: 13
	                          }, {
	                            n: "placeholder",
	                            f: "Header: Value",
	                            t: 13,
	                            g: 1
	                          }, {
	                            n: "labelText",
	                            f: "Headers",
	                            t: 13,
	                            g: 1
	                          }, {
	                            n: "classList",
	                            f: "gp_input",
	                            t: 13,
	                            g: 1
	                          }],
	                          f: []
	                        }]
	                      }],
	                      n: 50,
	                      x: {
	                        r: ["mainOptions.type"],
	                        s: "_0===\"HTTP\""
	                      }
	                    }, " ", {
	                      t: 7,
	                      e: "button",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "gp_btn_green",
	                        g: 1
	                      }, {
	                        n: ["click"],
	                        t: 70,
	                        f: {
	                          r: ["@this"],
	                          s: "[_0.applyOptions()]"
	                        }
	                      }],
	                      f: ["Apply"]
	                    }]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    n: "class",
	                    f: ["gp_map-block_settings-wrapper_settings_subgroup_switch-block ", {
	                      t: 4,
	                      f: ["turned-off"],
	                      n: 51,
	                      x: {
	                        r: ["@this"],
	                        s: "_0.isInfiniteOptsCorrect()"
	                      }
	                    }, " ", {
	                      t: 4,
	                      f: ["disabled"],
	                      n: 50,
	                      r: "testInProgress"
	                    }],
	                    t: 13
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "label",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "gp_switch",
	                      g: 1
	                    }],
	                    f: [{
	                      t: 7,
	                      e: "input",
	                      m: [{
	                        n: "type",
	                        f: "checkbox",
	                        t: 13
	                      }, {
	                        n: "checked",
	                        f: [{
	                          t: 2,
	                          r: "infiniteSwitchEnabled"
	                        }],
	                        t: 13
	                      }, {
	                        n: ["click"],
	                        t: 70,
	                        f: {
	                          r: ["@this"],
	                          s: "[_0.handleInfiniteSwitch()]"
	                        }
	                      }, {
	                        n: ["keydown"],
	                        t: 70,
	                        f: {
	                          r: ["@this", "@event"],
	                          s: "[_0.handleInfiniteSwitchKeyDown(_1)]"
	                        }
	                      }, {
	                        t: 4,
	                        f: [{
	                          n: "disabled",
	                          f: "true",
	                          t: 13
	                        }],
	                        n: 51,
	                        x: {
	                          r: ["@this", "testInProgress"],
	                          s: "_0.isInfiniteOptsCorrect()&&!_1"
	                        }
	                      }]
	                    }, " ", {
	                      t: 7,
	                      e: "span",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "slider round",
	                        g: 1
	                      }]
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "span",
	                    f: ["Infinite"]
	                  }]
	                }]
	              }]
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "btn-group run-test-btn",
	              g: 1
	            }, {
	              n: "id",
	              f: "dd-run-test-btn",
	              t: 13,
	              g: 1
	            }],
	            f: [{
	              t: 4,
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "gp_map-block_settings-wrapper_split-btn",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "gp_map-block_settings-wrapper_split-btn_run gp_btn_green",
	                    g: 1
	                  }, {
	                    n: ["click"],
	                    t: 70,
	                    f: {
	                      r: ["@this"],
	                      s: "[_0.resetMapAndRunTest()]"
	                    }
	                  }],
	                  f: ["Run"]
	                }, " ", {
	                  t: 7,
	                  e: "button",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "dropdown-toggle gp_btn_green",
	                    g: 1
	                  }, {
	                    n: "type",
	                    f: "button",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "data-toggle",
	                    f: "dropdown",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "aria-haspopup",
	                    f: "true",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "aria-expanded",
	                    f: "false",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "div",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "gp_map-block_settings-wrapper_split-btn_icon",
	                      g: 1
	                    }],
	                    f: [{
	                      t: 7,
	                      e: "img",
	                      m: [{
	                        n: "width",
	                        f: "20",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "height",
	                        f: "20",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "src",
	                        f: [{
	                          t: 2,
	                          r: "@shared.assetsHost"
	                        }, "/img/icons/chevron-down.white.svg"],
	                        t: 13
	                      }]
	                    }]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "dropdown-menu gp_map-block_settings-wrapper_split-btn_dropdown",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "span",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "dropdown-item",
	                      g: 1
	                    }, {
	                      n: ["click"],
	                      t: 70,
	                      f: {
	                        r: ["@this"],
	                        s: "[_0.resetMapAndRunTest()]"
	                      }
	                    }],
	                    f: ["Test"]
	                  }, " ", {
	                    t: 7,
	                    e: "span",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "dropdown-item",
	                      g: 1
	                    }, {
	                      n: ["click"],
	                      t: 70,
	                      f: {
	                        r: ["@this"],
	                        s: "[_0.reUseProbesRunTest()]"
	                      }
	                    }],
	                    f: ["Re-use probes"]
	                  }]
	                }]
	              }],
	              n: 50,
	              x: {
	                r: ["prevProbesMeasId", "testInProgress"],
	                s: "_0&&!_1"
	              }
	            }, {
	              t: 4,
	              f: [{
	                t: 7,
	                e: "button",
	                m: [{
	                  n: ["click"],
	                  t: 70,
	                  f: {
	                    r: ["@this"],
	                    s: "[_0.handleInfiniteMeasBtn()]"
	                  }
	                }, {
	                  n: "class",
	                  f: ["gp_map-block_settings-wrapper_btn gp_btn_green ", {
	                    t: 4,
	                    f: ["gp_btn_infinite gp_btn_infinite_loading"],
	                    n: 50,
	                    r: "testInProgress"
	                  }],
	                  t: 13
	                }],
	                f: [{
	                  t: 4,
	                  f: [{
	                    t: 7,
	                    e: "span",
	                    f: [{
	                      t: 2,
	                      r: "runTestBtnText"
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "div",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "spinner",
	                      g: 1
	                    }],
	                    f: [{
	                      t: 7,
	                      e: "div"
	                    }, " ", {
	                      t: 7,
	                      e: "div"
	                    }, " ", {
	                      t: 7,
	                      e: "div"
	                    }, " ", {
	                      t: 7,
	                      e: "div"
	                    }]
	                  }],
	                  n: 50,
	                  r: "testInProgress"
	                }, {
	                  t: 4,
	                  f: [{
	                    t: 2,
	                    r: "runTestBtnText"
	                  }],
	                  n: 51,
	                  l: 1
	                }]
	              }, " "],
	              n: 50,
	              r: "infiniteSwitchEnabled",
	              l: 1
	            }, {
	              t: 4,
	              f: [" ", {
	                t: 7,
	                e: "button",
	                m: [{
	                  n: ["click"],
	                  t: 70,
	                  f: {
	                    r: ["@this"],
	                    s: "[_0.resetMapAndRunTest()]"
	                  }
	                }, {
	                  n: "class",
	                  f: ["gp_map-block_settings-wrapper_btn gp_btn_green ", {
	                    t: 4,
	                    f: ["gp_btn_green_disabled gp_btn_green_loading"],
	                    n: 50,
	                    r: "testInProgress"
	                  }],
	                  t: 13
	                }, {
	                  n: "disabled",
	                  f: [{
	                    t: 2,
	                    r: "testInProgress"
	                  }],
	                  t: 13
	                }],
	                f: [{
	                  t: 4,
	                  f: [{
	                    t: 7,
	                    e: "div"
	                  }, " ", {
	                    t: 7,
	                    e: "div"
	                  }, " ", {
	                    t: 7,
	                    e: "div"
	                  }, " ", {
	                    t: 7,
	                    e: "div"
	                  }],
	                  n: 50,
	                  r: "testInProgress"
	                }, {
	                  t: 4,
	                  f: [{
	                    t: 2,
	                    r: "runTestBtnText"
	                  }],
	                  n: 51,
	                  l: 1
	                }]
	              }],
	              n: 51,
	              l: 1
	            }]
	          }]
	        }, " ", {
	          t: 4,
	          f: [{
	            t: 7,
	            e: "c-gp-credits-message",
	            m: [{
	              n: "rateCreditsData",
	              f: [{
	                t: 2,
	                r: "rateCreditsData"
	              }],
	              t: 13
	            }],
	            f: []
	          }],
	          n: 50,
	          r: "showCreditsError"
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            n: "class",
	            f: ["gp_map-block_map-wrapper ", {
	              t: 4,
	              f: ["transition-none"],
	              n: 51,
	              r: "transitionMap"
	            }, " ", {
	              t: 4,
	              f: ["gp_map-block_map-wrapper_hidden"],
	              n: 51,
	              r: "showMap"
	            }],
	            t: 13
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp_map-block_map-wrapper_map",
	              g: 1
	            }, {
	              n: "id",
	              f: "gp-map",
	              t: 13,
	              g: 1
	            }]
	          }, " ", {
	            t: 4,
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "gp_map-block_map-wrapper_timings-scale",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "span",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "value",
	                  g: 1
	                }],
	                f: [{
	                  t: 2,
	                  r: "probesMaxTiming"
	                }, " ms"]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "gradient",
	                  g: 1
	                }]
	              }, " ", {
	                t: 7,
	                e: "span",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "value",
	                  g: 1
	                }],
	                f: [{
	                  t: 2,
	                  r: "probesMinTiming"
	                }, " ms"]
	              }]
	            }],
	            n: 50,
	            r: "testResults"
	          }]
	        }, " ", {
	          t: 4,
	          f: [{
	            t: 4,
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "gp_map-block_line",
	                g: 1
	              }]
	            }],
	            n: 51,
	            r: "showMap"
	          }, " ", {
	            t: 7,
	            e: "c-gp-credits",
	            m: [{
	              n: "mapOpened",
	              f: [{
	                t: 2,
	                r: "showMap"
	              }],
	              t: 13
	            }, {
	              n: "testInProgress",
	              f: [{
	                t: 2,
	                r: "testInProgress"
	              }],
	              t: 13
	            }, {
	              n: "isInfiniteModeRes",
	              f: [{
	                t: 2,
	                r: "isInfiniteModeRes"
	              }],
	              t: 13
	            }, {
	              n: "rateCreditsData",
	              f: [{
	                t: 2,
	                r: "rateCreditsData"
	              }],
	              t: 13
	            }, {
	              n: "testResults",
	              f: [{
	                t: 2,
	                r: "testResults"
	              }],
	              t: 13
	            }],
	            f: []
	          }, " ", {
	            t: 4,
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "gp_map-block_line",
	                g: 1
	              }]
	            }],
	            n: 50,
	            r: "showMap"
	          }],
	          n: 50,
	          r: "showCreditsData"
	        }, " ", {
	          t: 4,
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp_map-block_line",
	              g: 1
	            }]
	          }],
	          n: 51,
	          r: "showMap"
	        }, " ", {
	          t: 4,
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp_map-block_test-output with-padding",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "gp_map-block_test-output_fail-msg",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "56",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "56",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/globalping/fail-icon-big.svg"],
	                  t: 13
	                }]
	              }, " ", {
	                t: 7,
	                e: "p",
	                f: [{
	                  t: 3,
	                  r: "measurementErrMsg"
	                }]
	              }]
	            }]
	          }],
	          n: 50,
	          r: "measurementErrMsg"
	        }, {
	          t: 4,
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp_map-block_test-output",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "c-gp-results-controls",
	              m: [{
	                n: "showMap",
	                f: [{
	                  t: 2,
	                  r: "showMap"
	                }],
	                t: 13
	              }, {
	                n: "originalShowMap",
	                f: [{
	                  t: 2,
	                  r: "originalShowMap"
	                }],
	                t: 13
	              }, {
	                n: "targets",
	                f: [{
	                  t: 2,
	                  r: "targetsArr"
	                }],
	                t: 13
	              }, {
	                n: "activeTargetIdx",
	                f: [{
	                  t: 2,
	                  r: "activeTargetIdx"
	                }],
	                t: 13
	              }, {
	                n: "rawOutputMode",
	                f: [{
	                  t: 2,
	                  r: "rawOutputMode"
	                }],
	                t: 13
	              }, {
	                n: "testType",
	                f: [{
	                  t: 2,
	                  r: "testReqParams.type"
	                }],
	                t: 13
	              }],
	              f: []
	            }, " ", {
	              t: 4,
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "gp_map-block_test-output_raw-output",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "c-gp-results-raw-output",
	                  m: [{
	                    n: "testReqParams",
	                    f: [{
	                      t: 2,
	                      r: "testReqParams"
	                    }],
	                    t: 13
	                  }, {
	                    n: "preparedTestResults",
	                    f: [{
	                      t: 2,
	                      r: "preparedTestResults"
	                    }],
	                    t: 13
	                  }, {
	                    n: "testInProgress",
	                    f: [{
	                      t: 2,
	                      r: "testInProgress"
	                    }],
	                    t: 13
	                  }, {
	                    n: "scrolledToResIdx",
	                    f: [{
	                      t: 2,
	                      r: "scrolledToResIdx"
	                    }],
	                    t: 13
	                  }, {
	                    n: "currSearchLocation",
	                    f: [{
	                      t: 2,
	                      r: "mainOptions.location"
	                    }],
	                    t: 13
	                  }, {
	                    n: "measurementsMetadata",
	                    f: [{
	                      t: 2,
	                      r: "measurementsMetadata"
	                    }],
	                    t: 13
	                  }, {
	                    n: "activeTargetIdx",
	                    f: [{
	                      t: 2,
	                      r: "activeTargetIdx"
	                    }],
	                    t: 13
	                  }, {
	                    n: "isInfiniteModeRes",
	                    f: [{
	                      t: 2,
	                      r: "isInfiniteModeRes"
	                    }],
	                    t: 13
	                  }, {
	                    n: "screenWidth",
	                    f: [{
	                      t: 2,
	                      r: "screenWidth"
	                    }],
	                    t: 13
	                  }],
	                  f: []
	                }]
	              }],
	              n: 50,
	              r: "rawOutputMode"
	            }, {
	              t: 4,
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "gp_map-block_test-output_table-output",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "c-gp-results-table-output",
	                  m: [{
	                    n: "testReqParams",
	                    f: [{
	                      t: 2,
	                      r: "testReqParams"
	                    }],
	                    t: 13
	                  }, {
	                    n: "testInProgress",
	                    f: [{
	                      t: 2,
	                      r: "testInProgress"
	                    }],
	                    t: 13
	                  }, {
	                    n: "preparedTestResults",
	                    f: [{
	                      t: 2,
	                      r: "preparedTestResults"
	                    }],
	                    t: 13
	                  }, {
	                    n: "targetsCnt",
	                    f: [{
	                      t: 2,
	                      r: "targetsArr.length"
	                    }],
	                    t: 13
	                  }, {
	                    n: "currSearchLocation",
	                    f: [{
	                      t: 2,
	                      r: "mainOptions.location"
	                    }],
	                    t: 13
	                  }, {
	                    n: "measurementsMetadata",
	                    f: [{
	                      t: 2,
	                      r: "measurementsMetadata"
	                    }],
	                    t: 13
	                  }, {
	                    n: "isInfiniteModeRes",
	                    f: [{
	                      t: 2,
	                      r: "isInfiniteModeRes"
	                    }],
	                    t: 13
	                  }],
	                  f: []
	                }]
	              }],
	              n: 51,
	              l: 1
	            }]
	          }, " "],
	          n: 50,
	          r: "testResults",
	          l: 1
	        }, {
	          t: 4,
	          f: [" ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp_map-block_test-output with-padding",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "gp_map-block_test-output_info",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "56",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "56",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/globalping/bulb-icon.svg"],
	                  t: 13
	                }]
	              }, " ", {
	                t: 7,
	                e: "p",
	                f: ["Run a global latency test! Benchmark your CDN provider and understand how the network performs! Compare DNS providers to find the fastest one globally or in your region. Run network tests globally or from specific locations and regions. Debug and troubleshoot your networking problems and share the test results with others!"]
	              }]
	            }]
	          }],
	          n: 51,
	          l: 1
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "gp_detalization",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "gp_detalization_platform",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp_detalization_platform_title",
	              g: 1
	            }],
	            f: ["The Globalping platform"]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp_detalization_platform_descr",
	              g: 1
	            }],
	            f: ["Globalping is a platform that allows anyone to run networking commands such as ping, traceroute, dig, curl and mtr on probes distributed all around the world. Our goal is to provide a free and simple service for everyone out there to make the internet faster. You can use it to optimize your anycast network, monitor your latency, debug routing issues and even check for censorship in different countries."]
	          }, " ", {
	            t: 7,
	            e: "img",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp_detalization_platform_img",
	              g: 1
	            }, {
	              n: "width",
	              f: "363",
	              t: 13,
	              g: 1
	            }, {
	              n: "height",
	              f: "288",
	              t: 13,
	              g: 1
	            }, {
	              n: "src",
	              f: [{
	                t: 2,
	                r: "@shared.assetsHost"
	              }, "/img/globalping/polygons_1.svg"],
	              t: 13
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "gp_detalization_magic",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp_detalization_magic_title",
	              g: 1
	            }],
	            f: ["Test from anywhere with ", {
	              t: 7,
	              e: "span",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "text-magic-color",
	                g: 1
	              }],
	              f: ["magic"]
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp_detalization_magic_descr",
	              g: 1
	            }],
	            f: ["All Globalping integrations and tools including the CLI ", {
	              t: 7,
	              e: "a",
	              m: [{
	                n: "target",
	                f: "_blank",
	                t: 13,
	                g: 1
	              }, {
	                n: "href",
	                f: "https://github.com/jsdelivr/globalping#best-practices-and-tips",
	                t: 13,
	                g: 1
	              }],
	              f: ["use the magic API field"]
	            }, " to set the location of a test. This means that you can write anything that makes sense to you as the input and we will do our best to select the most appropriate probes. Valid inputs include countries, continents, cities, US states, regions (Western Europe), ASNs, ISP names, eyeball or datacenter tags and cloud region names (us-east-2)."]
	          }, " ", {
	            t: 7,
	            e: "img",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp_detalization_magic_img",
	              g: 1
	            }, {
	              n: "width",
	              f: "510",
	              t: 13,
	              g: 1
	            }, {
	              n: "height",
	              f: "289",
	              t: 13,
	              g: 1
	            }, {
	              n: "src",
	              f: [{
	                t: 2,
	                r: "@shared.assetsHost"
	              }, "/img/globalping/polygons_2.svg"],
	              t: 13
	            }]
	          }]
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "gp_features",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "gp_features_item",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "span",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp_features_item_icon",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "img",
	              m: [{
	                n: "width",
	                f: "48",
	                t: 13,
	                g: 1
	              }, {
	                n: "height",
	                f: "48",
	                t: 13,
	                g: 1
	              }, {
	                n: "src",
	                f: [{
	                  t: 2,
	                  r: "@shared.assetsHost"
	                }, "/img/globalping/globalping-opensource-icon.svg"],
	                t: 13
	              }]
	            }]
	          }, " ", {
	            t: 7,
	            e: "span",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp_features_item_name",
	              g: 1
	            }],
	            f: ["Open source and free"]
	          }, " ", {
	            t: 7,
	            e: "span",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp_features_item_descr",
	              g: 1
	            }],
	            f: ["Every component of Globalping is open source and is being actively developed on GitHub with the help of our community and users. We offer generous free limits with higher limits for GitHub Sponsors."]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "gp_features_item",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "span",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp_features_item_icon",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "img",
	              m: [{
	                n: "width",
	                f: "48",
	                t: 13,
	                g: 1
	              }, {
	                n: "height",
	                f: "48",
	                t: 13,
	                g: 1
	              }, {
	                n: "src",
	                f: [{
	                  t: 2,
	                  r: "@shared.assetsHost"
	                }, "/img/globalping/globalping-nonprofit-icon.svg"],
	                t: 13
	              }]
	            }]
	          }, " ", {
	            t: 7,
	            e: "span",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp_features_item_name",
	              g: 1
	            }],
	            f: ["Developed by jsDelivr"]
	          }, " ", {
	            t: 7,
	            e: "span",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp_features_item_descr",
	              g: 1
	            }],
	            f: ["The Globalping platform is developed by the jsDelivr team who has more than 10 years of experience maintaining the jsDelivr CDN which is being used by millions of websites around the globe."]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "gp_features_item",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "span",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp_features_item_icon",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "img",
	              m: [{
	                n: "width",
	                f: "48",
	                t: 13,
	                g: 1
	              }, {
	                n: "height",
	                f: "48",
	                t: 13,
	                g: 1
	              }, {
	                n: "src",
	                f: [{
	                  t: 2,
	                  r: "@shared.assetsHost"
	                }, "/img/globalping/globalping-community-icon.svg"],
	                t: 13
	              }]
	            }]
	          }, " ", {
	            t: 7,
	            e: "span",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp_features_item_name",
	              g: 1
	            }],
	            f: ["Powered by community and sponsors"]
	          }, " ", {
	            t: 7,
	            e: "span",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp_features_item_descr",
	              g: 1
	            }],
	            f: ["The jsDelivr organization and all projects including Globalping rely on our corporate and individual sponsors. Consider joining them to help us release new features even faster!"]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "gp_features_item",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "span",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp_features_item_icon",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "img",
	              m: [{
	                n: "width",
	                f: "48",
	                t: 13,
	                g: 1
	              }, {
	                n: "height",
	                f: "48",
	                t: 13,
	                g: 1
	              }, {
	                n: "src",
	                f: [{
	                  t: 2,
	                  r: "@shared.assetsHost"
	                }, "/img/globalping/globalping-security-icon.svg"],
	                t: 13
	              }]
	            }]
	          }, " ", {
	            t: 7,
	            e: "span",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp_features_item_name",
	              g: 1
	            }],
	            f: ["Secure and private"]
	          }, " ", {
	            t: 7,
	            e: "span",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp_features_item_descr",
	              g: 1
	            }],
	            f: ["The security of our systems and privacy of our users are of the utmost importance for us. We minimize the public information that our probes expose and block harmful and abusive domains and IPs."]
	          }]
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "gp_installation",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "a",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "gp_installation_item",
	            g: 1
	          }, {
	            n: "href",
	            f: "/cli",
	            t: 13,
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "img",
	            m: [{
	              n: "width",
	              f: "61",
	              t: 13,
	              g: 1
	            }, {
	              n: "height",
	              f: "53",
	              t: 13,
	              g: 1
	            }, {
	              n: "src",
	              f: [{
	                t: 2,
	                r: "@shared.assetsHost"
	              }, "/img/globalping/cli-icon.svg"],
	              t: 13
	            }]
	          }, " ", {
	            t: 7,
	            e: "span",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp_installation_item_title",
	              g: 1
	            }],
	            f: ["Install the Globalping CLI"]
	          }, " ", {
	            t: 7,
	            e: "span",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp_installation_item_descr",
	              g: 1
	            }],
	            f: ["Run and script network tests from all over the world without ever leaving your terminal"]
	          }]
	        }, " ", {
	          t: 7,
	          e: "a",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "gp_installation_item router-ignore",
	            g: 1
	          }, {
	            n: "href",
	            f: "/docs/api.globalping.io",
	            t: 13,
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "img",
	            m: [{
	              n: "width",
	              f: "61",
	              t: 13,
	              g: 1
	            }, {
	              n: "height",
	              f: "53",
	              t: 13,
	              g: 1
	            }, {
	              n: "src",
	              f: [{
	                t: 2,
	                r: "@shared.assetsHost"
	              }, "/img/globalping/rest-api-icon.svg"],
	              t: 13
	            }]
	          }, " ", {
	            t: 7,
	            e: "span",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp_installation_item_title",
	              g: 1
	            }],
	            f: ["Integrate the Globalping REST API"]
	          }, " ", {
	            t: 7,
	            e: "span",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp_installation_item_descr",
	              g: 1
	            }],
	            f: ["Use our free API to build your own tools, automated your tests and integrate Globalping into your existing flow"]
	          }]
	        }, " ", {
	          t: 7,
	          e: "a",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "gp_installation_item",
	            g: 1
	          }, {
	            n: "href",
	            f: "/globalping/slack",
	            t: 13,
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "img",
	            m: [{
	              n: "width",
	              f: "61",
	              t: 13,
	              g: 1
	            }, {
	              n: "height",
	              f: "53",
	              t: 13,
	              g: 1
	            }, {
	              n: "src",
	              f: [{
	                t: 2,
	                r: "@shared.assetsHost"
	              }, "/img/globalping/slack-icon.svg"],
	              t: 13
	            }]
	          }, " ", {
	            t: 7,
	            e: "span",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp_installation_item_title",
	              g: 1
	            }],
	            f: ["Install the Globalping Slack App"]
	          }, " ", {
	            t: 7,
	            e: "span",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp_installation_item_descr",
	              g: 1
	            }],
	            f: ["Install the app into your Slack organization to allow all of your members to run global tests in any channel"]
	          }]
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "gp_our-users",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "gp_our-users_title",
	            g: 1
	          }],
	          f: ["Our users:"]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "gp_our-users_list",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp_our-users_list_user",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "a",
	              m: [{
	                n: "target",
	                f: "_blank",
	                t: 13,
	                g: 1
	              }, {
	                n: "rel",
	                f: "noopener noreferrer",
	                t: 13,
	                g: 1
	              }, {
	                n: "href",
	                f: "https://www.fastly.com",
	                t: 13,
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "title",
	                  f: "Used by Fastly",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "48",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/globalping/sponsors/fastly.png"],
	                  t: 13
	                }, {
	                  n: "srcset",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/globalping/sponsors/fastly@2x.png 2x"],
	                  t: 13
	                }, {
	                  n: "loading",
	                  f: "lazy",
	                  t: 13,
	                  g: 1
	                }]
	              }]
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp_our-users_list_user",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "a",
	              m: [{
	                n: "target",
	                f: "_blank",
	                t: 13,
	                g: 1
	              }, {
	                n: "rel",
	                f: "noopener noreferrer",
	                t: 13,
	                g: 1
	              }, {
	                n: "href",
	                f: "https://he.net",
	                t: 13,
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "title",
	                  f: "Used by Hurricane Electric",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "48",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/globalping/sponsors/hurricane_electric.png"],
	                  t: 13
	                }, {
	                  n: "loading",
	                  f: "lazy",
	                  t: 13,
	                  g: 1
	                }]
	              }]
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp_our-users_list_user",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "a",
	              m: [{
	                n: "target",
	                f: "_blank",
	                t: 13,
	                g: 1
	              }, {
	                n: "rel",
	                f: "noopener noreferrer",
	                t: 13,
	                g: 1
	              }, {
	                n: "href",
	                f: "https://www.dnsfilter.com/",
	                t: 13,
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "title",
	                  f: "Used by DNSFilter",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "48",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/globalping/sponsors/dnsfilter.png"],
	                  t: 13
	                }, {
	                  n: "loading",
	                  f: "lazy",
	                  t: 13,
	                  g: 1
	                }]
	              }]
	            }]
	          }]
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "gp_join-network",
	          g: 1
	        }, {
	          n: "id",
	          f: "join-the-network",
	          t: 13,
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "span",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "gp_join-network_title",
	            g: 1
	          }],
	          f: ["Join the network"]
	        }, " ", {
	          t: 7,
	          e: "span",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "gp_join-network_subtitle",
	            g: 1
	          }],
	          f: ["To join the Globalping probe network all you have to do is run our container."]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "gp_join-network_switch-wrapper",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "span",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp_join-network_switch",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "span",
	              m: [{
	                n: "class",
	                f: [{
	                  t: 4,
	                  f: ["active"],
	                  n: 50,
	                  x: {
	                    r: ["joinNetSwitchValue"],
	                    s: "_0===\"docker\""
	                  }
	                }],
	                t: 13
	              }, {
	                n: ["click"],
	                t: 70,
	                f: {
	                  r: ["@this"],
	                  s: "[_0.set(\"joinNetSwitchValue\",\"docker\")]"
	                }
	              }],
	              f: ["Docker"]
	            }, " ", {
	              t: 7,
	              e: "span",
	              m: [{
	                n: "class",
	                f: [{
	                  t: 4,
	                  f: ["active"],
	                  n: 50,
	                  x: {
	                    r: ["joinNetSwitchValue"],
	                    s: "_0===\"podman\""
	                  }
	                }],
	                t: 13
	              }, {
	                n: ["click"],
	                t: 70,
	                f: {
	                  r: ["@this"],
	                  s: "[_0.set(\"joinNetSwitchValue\",\"podman\")]"
	                }
	              }],
	              f: ["Podman"]
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "gp_join-network_cmd-block",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              n: "class",
	              f: ["gp_join-network_cmd-block_command ", {
	                t: 4,
	                f: ["opened"],
	                n: 50,
	                r: "showCommandsBlock"
	              }],
	              t: 13
	            }],
	            f: [{
	              t: 4,
	              f: [{
	                t: 4,
	                f: [{
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "gp_join-network_cmd-block_command_row",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "span",
	                    f: [{
	                      t: 2,
	                      x: {
	                        r: ["idx"],
	                        s: "_0+1"
	                      }
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "span",
	                    f: [{
	                      t: 2,
	                      r: "./cmd"
	                    }]
	                  }, " ", {
	                    t: 4,
	                    f: [{
	                      t: 7,
	                      e: "span",
	                      f: [{
	                        t: 2,
	                        r: "./comment"
	                      }]
	                    }],
	                    n: 50,
	                    r: "./comment"
	                  }]
	                }],
	                n: 52,
	                i: "idx",
	                r: "netCmdTextFull"
	              }],
	              n: 50,
	              r: "showCommandsBlock"
	            }, {
	              t: 4,
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "gp_join-network_cmd-block_command_oneliner",
	                  g: 1
	                }],
	                f: [{
	                  t: 2,
	                  r: "netCmdText"
	                }]
	              }],
	              n: 51,
	              l: 1
	            }]
	          }, " ", {
	            t: 7,
	            e: "button",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp_join-network_cmd-block_btn gp_btn_green",
	              g: 1
	            }, {
	              n: "clipboard",
	              t: 71
	            }, {
	              n: "data-clipboard-text",
	              f: [{
	                t: 2,
	                x: {
	                  r: ["showCommandsBlock", "netCmdTextFullClipboard", "netCmdText"],
	                  s: "_0?_1:_2"
	                }
	              }],
	              t: 13
	            }],
	            f: [{
	              t: 7,
	              e: "img",
	              m: [{
	                n: "width",
	                f: "20",
	                t: 13,
	                g: 1
	              }, {
	                n: "height",
	                f: "20",
	                t: 13,
	                g: 1
	              }, {
	                n: "src",
	                f: [{
	                  t: 2,
	                  r: "@shared.assetsHost"
	                }, "/img/globalping/copy-icon.svg"],
	                t: 13
	              }]
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              n: "class",
	              f: ["gp_join-network_cmd-block_open-btn ", {
	                t: 4,
	                f: ["active"],
	                n: 50,
	                r: "showCommandsBlock"
	              }],
	              t: 13
	            }, {
	              n: ["click"],
	              t: 70,
	              f: {
	                r: ["@this"],
	                s: "[_0.toggle(\"showCommandsBlock\")]"
	              }
	            }],
	            f: [{
	              t: 7,
	              e: "img",
	              m: [{
	                n: "width",
	                f: "9",
	                t: 13,
	                g: 1
	              }, {
	                n: "height",
	                f: "6",
	                t: 13,
	                g: 1
	              }, {
	                n: "src",
	                f: [{
	                  t: 2,
	                  r: "@shared.assetsHost"
	                }, "/img/globalping/chevron.svg"],
	                t: 13
	              }]
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "span",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "gp_join-network_descr",
	            g: 1
	          }],
	          f: ["Once you connect you will become part of the global community that powers the Globalping Platform. The container will work on both x86 and ARM architectures."]
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "gp_join-community",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "gp_join-community_content",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "span",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp_join-community_content_title",
	              g: 1
	            }],
	            f: ["We invite everyone to join our community and help us develop our projects."]
	          }, " ", {
	            t: 7,
	            e: "ul",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp_join-community_content_list",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "li",
	              f: ["We promise a friendly discussion in our issues and code reviews"]
	            }, " ", {
	              t: 7,
	              e: "li",
	              f: ["We appreciate your work and will review your PRs in a timely manner"]
	            }, " ", {
	              t: 7,
	              e: "li",
	              f: ["We are open to new ideas and technologies"]
	            }, " ", {
	              t: 7,
	              e: "li",
	              f: ["You don't have to be a developer to help"]
	            }, " ", {
	              t: 7,
	              e: "li",
	              f: ["Copyrighters, community moderators, dev relations, media relations... are all equally important"]
	            }]
	          }, " ", {
	            t: 7,
	            e: "img",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp_join-community_img",
	              g: 1
	            }, {
	              n: "width",
	              f: "363",
	              t: 13,
	              g: 1
	            }, {
	              n: "height",
	              f: "416",
	              t: 13,
	              g: 1
	            }, {
	              n: "src",
	              f: [{
	                t: 2,
	                r: "@shared.assetsHost"
	              }, "/img/globalping/polygons_3.svg"],
	              t: 13
	            }]
	          }]
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "gp_gh-links",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "gp_gh-links_header",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "span",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp_gh-links_header_title",
	              g: 1
	            }],
	            f: ["Become an open source contributor!"]
	          }, " ", {
	            t: 7,
	            e: "img",
	            m: [{
	              n: "width",
	              f: "64",
	              t: 13,
	              g: 1
	            }, {
	              n: "height",
	              f: "64",
	              t: 13,
	              g: 1
	            }, {
	              n: "src",
	              f: [{
	                t: 2,
	                r: "@shared.assetsHost"
	              }, "/img/globalping/github.svg"],
	              t: 13
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "gp_gh-links_content",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "a",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp_gh-links_content_item",
	              g: 1
	            }, {
	              n: "target",
	              f: "_blank",
	              t: 13,
	              g: 1
	            }, {
	              n: "rel",
	              f: "noopener noreferrer",
	              t: 13,
	              g: 1
	            }, {
	              n: "href",
	              f: "https://github.com/jsdelivr/globalping",
	              t: 13,
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "span",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "gp_gh-links_content_item_title",
	                g: 1
	              }],
	              f: ["Globalping API"]
	            }, " ", {
	              t: 7,
	              e: "span",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "gp_gh-links_content_item_descr",
	                g: 1
	              }],
	              f: ["Learn more about the project, the API, tools and become a contributor"]
	            }]
	          }, " ", {
	            t: 7,
	            e: "a",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp_gh-links_content_item",
	              g: 1
	            }, {
	              n: "target",
	              f: "_blank",
	              t: 13,
	              g: 1
	            }, {
	              n: "rel",
	              f: "noopener noreferrer",
	              t: 13,
	              g: 1
	            }, {
	              n: "href",
	              f: "https://github.com/jsdelivr/globalping-cli",
	              t: 13,
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "span",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "gp_gh-links_content_item_title",
	                g: 1
	              }],
	              f: ["Globalping CLI"]
	            }, " ", {
	              t: 7,
	              e: "span",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "gp_gh-links_content_item_descr",
	                g: 1
	              }],
	              f: ["Our simple to use CLI is also open source and awaits for your feedback."]
	            }]
	          }, " ", {
	            t: 7,
	            e: "a",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp_gh-links_content_item",
	              g: 1
	            }, {
	              n: "target",
	              f: "_blank",
	              t: 13,
	              g: 1
	            }, {
	              n: "rel",
	              f: "noopener noreferrer",
	              t: 13,
	              g: 1
	            }, {
	              n: "href",
	              f: "https://github.com/jsdelivr/globalping-probe",
	              t: 13,
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "span",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "gp_gh-links_content_item_title",
	                g: 1
	              }],
	              f: ["Globalping Probe"]
	            }, " ", {
	              t: 7,
	              e: "span",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "gp_gh-links_content_item_descr",
	                g: 1
	              }],
	              f: ["Explore the codebase of our software probes and firmware for hardware probes as well"]
	            }]
	          }]
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "gp_probe",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "gp_probe_promo",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "img",
	            m: [{
	              n: "width",
	              f: "198",
	              t: 13,
	              g: 1
	            }, {
	              n: "height",
	              f: "198",
	              t: 13,
	              g: 1
	            }, {
	              n: "src",
	              f: [{
	                t: 2,
	                r: "@shared.assetsHost"
	              }, "/img/globalping/probe.png"],
	              t: 13
	            }, {
	              n: "srcset",
	              f: [{
	                t: 2,
	                r: "@shared.assetsHost"
	              }, "/img/globalping/probe@2x.png 2x"],
	              t: 13
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp_probe_promo_content",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "span",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "gp_probe_promo_content_title",
	                g: 1
	              }],
	              f: ["Get a hardware probe"]
	            }, " ", {
	              t: 7,
	              e: "span",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "gp_probe_promo_content_descr",
	                g: 1
	              }],
	              f: ["Become a GitHub sponsor for $10/month or more and get your own hardware probe to install in your home or office network."]
	            }, " ", {
	              t: 7,
	              e: "a",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "gp_probe_promo_content_btn gp_btn_green",
	                g: 1
	              }, {
	                n: "target",
	                f: "_blank",
	                t: 13,
	                g: 1
	              }, {
	                n: "rel",
	                f: "noopener noreferrer",
	                t: 13,
	                g: 1
	              }, {
	                n: "href",
	                f: "https://github.com/sponsors/jsdelivr",
	                t: 13,
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "20",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "20",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/globalping/github.small.svg"],
	                  t: 13
	                }]
	              }, " Become a GitHub Sponsor"]
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "gp_probe_get-probe",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp_probe_get-probe_header",
	              g: 1
	            }],
	            f: ["How to get a probe?"]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp_probe_get-probe_list",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "gp_probe_get-probe_list_item",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "gp_probe_get-probe_list_item_progress",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "img",
	                  m: [{
	                    n: "width",
	                    f: "24",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "24",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "src",
	                    f: [{
	                      t: 2,
	                      r: "@shared.assetsHost"
	                    }, "/img/globalping/circle-icon.svg"],
	                    t: 13
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "span"
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "gp_probe_get-probe_list_item_content",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "span",
	                  f: ["Become a sponsor"]
	                }, " ", {
	                  t: 7,
	                  e: "span",
	                  f: ["Become a GitHub Sponsor for $10+/month."]
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "gp_probe_get-probe_list_item",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "gp_probe_get-probe_list_item_progress",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "img",
	                  m: [{
	                    n: "width",
	                    f: "24",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "24",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "src",
	                    f: [{
	                      t: 2,
	                      r: "@shared.assetsHost"
	                    }, "/img/globalping/circle-icon.svg"],
	                    t: 13
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "span"
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "gp_probe_get-probe_list_item_content",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "span",
	                  f: [{
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      n: "target",
	                      f: "_blank",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "rel",
	                      f: "noopener noreferrer",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "href",
	                      f: "https://forms.gle/9jSzytJpTDYJmS2W8",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: ["Fill the form"]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "span",
	                  f: ["Fill out this form with your details."]
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "gp_probe_get-probe_list_item",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "gp_probe_get-probe_list_item_progress",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "img",
	                  m: [{
	                    n: "width",
	                    f: "24",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "24",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "src",
	                    f: [{
	                      t: 2,
	                      r: "@shared.assetsHost"
	                    }, "/img/globalping/circle-icon.svg"],
	                    t: 13
	                  }]
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "gp_probe_get-probe_list_item_content",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "span",
	                  f: ["Probe arrives"]
	                }, " ", {
	                  t: 7,
	                  e: "span",
	                  f: ["Wait for the probe to arrive."]
	                }]
	              }]
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "gp_probe_how-it-works",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp_probe_how-it-works_header",
	              g: 1
	            }],
	            f: ["How it works?"]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp_probe_how-it-works_text",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "span",
	              f: ["Installing our hardware probe simplifies the whole process and ", {
	                t: 7,
	                e: "b",
	                f: ["removes the need of having a computer running 24/7."]
	              }, " Just connect the probe to your switch or router via an ethernet cable and you are done!"]
	            }, " ", {
	              t: 7,
	              e: "span",
	              f: ["Our hardware probes are fully secure. ", {
	                t: 7,
	                e: "b",
	                f: ["They don't allow any kind of access to your LAN"]
	              }, ", they block all malicious and abusive endpoints, don't open any ports whatsoever and the firmware itself is fully open source."]
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp_probe_how-it-works_btns",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "a",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "gp_probe_how-it-works_btns_learn-more gp_btn_black",
	                g: 1
	              }, {
	                n: "target",
	                f: "_blank",
	                t: 13,
	                g: 1
	              }, {
	                n: "rel",
	                f: "noopener noreferrer",
	                t: 13,
	                g: 1
	              }, {
	                n: "href",
	                f: "https://github.com/jsdelivr/globalping-hwprobe",
	                t: 13,
	                g: 1
	              }],
	              f: ["Learn more"]
	            }, " ", {
	              t: 7,
	              e: "a",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "gp_probe_how-it-works_btns_sponsor gp_btn_green",
	                g: 1
	              }, {
	                n: "target",
	                f: "_blank",
	                t: 13,
	                g: 1
	              }, {
	                n: "rel",
	                f: "noopener noreferrer",
	                t: 13,
	                g: 1
	              }, {
	                n: "href",
	                f: "https://github.com/sponsors/jsdelivr",
	                t: 13,
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "20",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "20",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/globalping/github.small.svg"],
	                  t: 13
	                }]
	              }, " Become a GitHub Sponsor"]
	            }]
	          }]
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "gp_sponsors",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "gp_sponsors_content",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp_sponsors_content_info",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "span",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "gp_sponsors_content_info_title",
	                g: 1
	              }],
	              f: ["Globalping sponsors"]
	            }, " ", {
	              t: 7,
	              e: "span",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "gp_sponsors_content_info_descr",
	                g: 1
	              }],
	              f: ["We thank everyone who decided to help our project by either running multiple globally distributed probes or donating to our cause."]
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp_sponsors_content_list",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "gp_sponsors_content_list_tier-one",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "gp_sponsors_content_list_tier-one_row",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    n: "target",
	                    f: "_blank",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "rel",
	                    f: "noopener noreferrer",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "href",
	                    f: "https://xtom.com",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "title",
	                      f: "Sponsored by xTom",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "width",
	                      f: "101",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "28",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/globalping/sponsors/xtom.svg"],
	                      t: 13
	                    }]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    n: "target",
	                    f: "_blank",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "rel",
	                    f: "noopener noreferrer",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "href",
	                    f: "https://looking.house",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "title",
	                      f: "Sponsored by Looking.house",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "width",
	                      f: "151",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "34",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/globalping/sponsors/looking-house.svg"],
	                      t: 13
	                    }]
	                  }]
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "gp_sponsors_content_list_tier-one_row",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    n: "target",
	                    f: "_blank",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "rel",
	                    f: "noopener noreferrer",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "href",
	                    f: "https://www.starrydns.com",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "title",
	                      f: "Sponsored by StarryDNS",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "width",
	                      f: "160",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "28",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/globalping/sponsors/starry.png"],
	                      t: 13
	                    }]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    n: "target",
	                    f: "_blank",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "rel",
	                    f: "noopener noreferrer",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "href",
	                    f: "https://www.ip2location.io/",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "title",
	                      f: "Sponsored by IP2Location",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "width",
	                      f: "169",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "28",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/globalping/sponsors/ip2location.svg"],
	                      t: 13
	                    }]
	                  }]
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "gp_sponsors_content_list_tier-one_row",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    n: "target",
	                    f: "_blank",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "rel",
	                    f: "noopener noreferrer",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "href",
	                    f: "https://www.exoscale.com",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "title",
	                      f: "Sponsored by Exoscale",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "width",
	                      f: "210",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "28",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/globalping/sponsors/exoscale.svg"],
	                      t: 13
	                    }]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    n: "target",
	                    f: "_blank",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "rel",
	                    f: "noopener noreferrer",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "href",
	                    f: "https://www.fdcservers.net",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "title",
	                      f: "Sponsored by FDCServers",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "width",
	                      f: "95",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "28",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/globalping/sponsors/fdc.svg"],
	                      t: 13
	                    }]
	                  }]
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "gp_sponsors_content_list_tier-one_row",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    n: "target",
	                    f: "_blank",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "rel",
	                    f: "noopener noreferrer",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "href",
	                    f: "https://ipinfo.io/",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "title",
	                      f: "Sponsored by IPInfo",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "width",
	                      f: "93",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "28",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/globalping/sponsors/ipinfo.svg"],
	                      t: 13
	                    }]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    n: "target",
	                    f: "_blank",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "rel",
	                    f: "noopener noreferrer",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "href",
	                    f: "https://www.edisglobal.com/",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "title",
	                      f: "Sponsored by EDIS Global",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "width",
	                      f: "91",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "28",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/globalping/sponsors/edis-global.svg"],
	                      t: 13
	                    }]
	                  }]
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "gp_sponsors_content_list_tier-one_row",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    n: "target",
	                    f: "_blank",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "rel",
	                    f: "noopener noreferrer",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "href",
	                    f: "https://www.misaka.io",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "title",
	                      f: "Sponsored by Misaka Network, Inc.",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "width",
	                      f: "95",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "28",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/globalping/sponsors/misaka.svg"],
	                      t: 13
	                    }]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    n: "target",
	                    f: "_blank",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "rel",
	                    f: "noopener noreferrer",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "href",
	                    f: "https://zappiehost.com",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "title",
	                      f: "Sponsored by Zappie Host",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "width",
	                      f: "97",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "28",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/globalping/sponsors/zappiehost.png"],
	                      t: 13
	                    }]
	                  }]
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "gp_sponsors_content_list_tier-one_row",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    n: "target",
	                    f: "_blank",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "rel",
	                    f: "noopener noreferrer",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "href",
	                    f: "https://www.zenlayer.com/",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "title",
	                      f: "Sponsored by Zenlayer",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "width",
	                      f: "128",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "28",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/globalping/sponsors/zenlayer.svg"],
	                      t: 13
	                    }]
	                  }]
	                }, " ", {
	                  t: 9,
	                  c: " swap images for better look depending on screenWidth "
	                }, " ", {
	                  t: 4,
	                  f: [{
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      n: "target",
	                      f: "_blank",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "rel",
	                      f: "noopener noreferrer",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "href",
	                      f: "https://www.dnsfilter.com/",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: [{
	                      t: 7,
	                      e: "img",
	                      m: [{
	                        n: "title",
	                        f: "Sponsored by DNSFilter",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "width",
	                        f: "120",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "height",
	                        f: "28",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "src",
	                        f: [{
	                          t: 2,
	                          r: "@shared.assetsHost"
	                        }, "/img/globalping/sponsors/dnsfilter.png"],
	                        t: 13
	                      }]
	                    }]
	                  }],
	                  n: 50,
	                  x: {
	                    r: ["screenWidth"],
	                    s: "_0<768"
	                  }
	                }, {
	                  t: 4,
	                  f: [{
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      n: "target",
	                      f: "_blank",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "rel",
	                      f: "noopener noreferrer",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "href",
	                      f: "https://ipgeolocation.io/",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: [{
	                      t: 7,
	                      e: "img",
	                      m: [{
	                        n: "title",
	                        f: "Sponsored by IP Geolocation",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "width",
	                        f: "97",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "height",
	                        f: "56",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "src",
	                        f: [{
	                          t: 2,
	                          r: "@shared.assetsHost"
	                        }, "/img/globalping/sponsors/ipgeolocation.svg"],
	                        t: 13
	                      }]
	                    }]
	                  }],
	                  n: 51,
	                  l: 1
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "gp_sponsors_content_list_tier-one_row",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    n: "target",
	                    f: "_blank",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "rel",
	                    f: "noopener noreferrer",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "href",
	                    f: "https://cloudlooking.glass/",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "title",
	                      f: "Sponsored by Cloud Looking Glass",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "width",
	                      f: "147",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "40",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/globalping/sponsors/cloud-looking-glass.png"],
	                      t: 13
	                    }]
	                  }]
	                }, " ", {
	                  t: 9,
	                  c: " swap images for better look depending on screenWidth "
	                }, " ", {
	                  t: 4,
	                  f: [{
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      n: "target",
	                      f: "_blank",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "rel",
	                      f: "noopener noreferrer",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "href",
	                      f: "https://ipgeolocation.io/",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: [{
	                      t: 7,
	                      e: "img",
	                      m: [{
	                        n: "title",
	                        f: "Sponsored by IP Geolocation",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "width",
	                        f: "97",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "height",
	                        f: "56",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "src",
	                        f: [{
	                          t: 2,
	                          r: "@shared.assetsHost"
	                        }, "/img/globalping/sponsors/ipgeolocation.svg"],
	                        t: 13
	                      }]
	                    }]
	                  }],
	                  n: 50,
	                  x: {
	                    r: ["screenWidth"],
	                    s: "_0<768"
	                  }
	                }, {
	                  t: 4,
	                  f: [{
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      n: "target",
	                      f: "_blank",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "rel",
	                      f: "noopener noreferrer",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "href",
	                      f: "https://www.dnsfilter.com/",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: [{
	                      t: 7,
	                      e: "img",
	                      m: [{
	                        n: "title",
	                        f: "Sponsored by DNSFilter",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "width",
	                        f: "120",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "height",
	                        f: "28",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "src",
	                        f: [{
	                          t: 2,
	                          r: "@shared.assetsHost"
	                        }, "/img/globalping/sponsors/dnsfilter.png"],
	                        t: 13
	                      }]
	                    }]
	                  }],
	                  n: 51,
	                  l: 1
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "gp_sponsors_content_list_tier-one_row",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    n: "target",
	                    f: "_blank",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "rel",
	                    f: "noopener noreferrer",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "href",
	                    f: "https://onidel.com/",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "title",
	                      f: "Sponsored by Onidel",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "width",
	                      f: "130",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "32",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/globalping/sponsors/onidel.svg"],
	                      t: 13
	                    }]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    n: "target",
	                    f: "_blank",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "rel",
	                    f: "noopener noreferrer",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "href",
	                    f: "https://www.kuroit.com/",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "title",
	                      f: "Sponsored by Kuroit",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "width",
	                      f: "128",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "34",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/globalping/sponsors/kuroit.png"],
	                      t: 13
	                    }]
	                  }]
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "gp_sponsors_content_list_tier-one_row",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    n: "target",
	                    f: "_blank",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "rel",
	                    f: "noopener noreferrer",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "href",
	                    f: "https://exservers.net//",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "title",
	                      f: "Sponsored by ExServers",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "width",
	                      f: "156",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "28",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/globalping/sponsors/exservers.png"],
	                      t: 13
	                    }]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    n: "target",
	                    f: "_blank",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "rel",
	                    f: "noopener noreferrer",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "href",
	                    f: "https://netshop-isp.com.cy/",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "title",
	                      f: "Sponsored by NetShop ISP",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "width",
	                      f: "145",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "40",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/globalping/sponsors/netshop-logo-dark.svg"],
	                      t: 13
	                    }]
	                  }]
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "gp_sponsors_content_list_tier-one_row",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    n: "target",
	                    f: "_blank",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "rel",
	                    f: "noopener noreferrer",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "href",
	                    f: "https://www.host-stage.net/",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "title",
	                      f: "Sponsored by HostStage",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "width",
	                      f: "189",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "40",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/globalping/sponsors/host-stage.svg"],
	                      t: 13
	                    }]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    n: "target",
	                    f: "_blank",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "rel",
	                    f: "noopener noreferrer",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "href",
	                    f: "https://www.mvps.net/",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "title",
	                      f: "Sponsored by MVPS",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "width",
	                      f: "158",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "50",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/globalping/sponsors/mvps.svg"],
	                      t: 13
	                    }]
	                  }]
	                }]
	              }, " ", {
	                t: 9,
	                c: " <div class=\"gp_sponsors_content_list_tier-two\">\n\t\t\t\t\t\t\t<div class=\"gp_sponsors_content_list_tier-two_row\">\n\t\t\t\t\t\t\t\t<div class=\"gp_person-sponsor\">Robert  Kowalski</div>\n\n\t\t\t\t\t\t\t\t<img width=\"57\"\n\t\t\t\t\t\t\t\t\theight=\"19\"\n\t\t\t\t\t\t\t\t\tsrc=\"{{@shared.assetsHost}}/img/globalping/sponsors/dell.svg\">\n\n\t\t\t\t\t\t\t\t<div class=\"gp_person-sponsor\">Magdalene Tabhita</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div> "
	              }]
	            }]
	          }, " ", {
	            t: 7,
	            e: "a",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp_sponsors_content_btn gp_btn_green",
	              g: 1
	            }, {
	              n: "href",
	              f: "mailto:d@jsdelivr.com",
	              t: 13,
	              g: 1
	            }],
	            f: ["Get in Contact"]
	          }, " ", {
	            t: 7,
	            e: "img",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp_sponsors_content_img",
	              g: 1
	            }, {
	              n: "width",
	              f: "289",
	              t: 13,
	              g: 1
	            }, {
	              n: "height",
	              f: "288",
	              t: 13,
	              g: 1
	            }, {
	              n: "src",
	              f: [{
	                t: 2,
	                r: "@shared.assetsHost"
	              }, "/img/globalping/polygons_4.svg"],
	              t: 13
	            }]
	          }]
	        }]
	      }]
	    }, " ", {
	      t: 7,
	      e: "c-gp-footer"
	    }]
	  }],
	  e: {
	    "!_0&&!_1": function (_0, _1) {
	      return !_0 && !_1;
	    },
	    "Math.floor(_0)": function (_0) {
	      return Math.floor(_0);
	    },
	    "[_0.setMainOptsTestType(_1)]": function (_0, _1) {
	      return [_0.setMainOptsTestType(_1)];
	    },
	    "!_0": function (_0) {
	      return !_0;
	    },
	    "true": function () {
	      return true;
	    },
	    "_0!==\"DNS\"": function (_0) {
	      return _0 !== "DNS";
	    },
	    "[\"Up to 2 IP addresses or domains\",_0]": function (_0) {
	      return ["Up to 2 IP addresses or domains", _0];
	    },
	    "[_0.resetMapAndRunTest()]": function (_0) {
	      return [_0.resetMapAndRunTest()];
	    },
	    "[[\"This magic field supports names of continents, regions, countries, US states, cities, networks, and our custom tags.\",\"\",\"Use + to combine multiple filters.\",\"Use , to select multiple locations.\"],_0,undefined,undefined,\"multiline\"]": function (_0) {
	      return [["This magic field supports names of continents, regions, countries, US states, cities, networks, and our custom tags.", "", "Use + to combine multiple filters.", "Use , to select multiple locations."], _0, undefined, undefined, "multiline"];
	    },
	    "_0===false": function (_0) {
	      return _0 === false;
	    },
	    "[\"Values up to 5 are supported for infinite measurements\",_0,undefined,undefined,\"gp_tt-limit\"]": function (_0) {
	      return ["Values up to 5 are supported for infinite measurements", _0, undefined, undefined, "gp_tt-limit"];
	    },
	    "[_0.handleToggleMeasOpts()]": function (_0) {
	      return [_0.handleToggleMeasOpts()];
	    },
	    "_0===false&&_1&&_2===false": function (_0, _1, _2) {
	      return _0 === false && _1 && _2 === false;
	    },
	    "_0===\"ping\"": function (_0) {
	      return _0 === "ping";
	    },
	    "[_0.set(\"tracerouteOpts.protocol\",\"TCP\")]": function (_0) {
	      return [_0.set("tracerouteOpts.protocol", "TCP")];
	    },
	    "[_0.set(\"tracerouteOpts.protocol\",\"UDP\")]": function (_0) {
	      return [_0.set("tracerouteOpts.protocol", "UDP")];
	    },
	    "[_0.set(\"tracerouteOpts.protocol\",\"ICMP\")]": function (_0) {
	      return [_0.set("tracerouteOpts.protocol", "ICMP")];
	    },
	    "_0===\"traceroute\"": function (_0) {
	      return _0 === "traceroute";
	    },
	    "[_0.set(\"dnsOpts.protocol\",\"UDP\")]": function (_0) {
	      return [_0.set("dnsOpts.protocol", "UDP")];
	    },
	    "[_0.set(\"dnsOpts.protocol\",\"TCP\")]": function (_0) {
	      return [_0.set("dnsOpts.protocol", "TCP")];
	    },
	    "[_0.set(\"dnsOpts.query.type\",_1)]": function (_0, _1) {
	      return [_0.set("dnsOpts.query.type", _1)];
	    },
	    "[_0.set(\"dnsOpts.trace\",!_1)]": function (_0, _1) {
	      return [_0.set("dnsOpts.trace", !_1)];
	    },
	    "_0===\"DNS\"": function (_0) {
	      return _0 === "DNS";
	    },
	    "[_0.set(\"mtrOpts.protocol\",\"UDP\")]": function (_0) {
	      return [_0.set("mtrOpts.protocol", "UDP")];
	    },
	    "[_0.set(\"mtrOpts.protocol\",\"TCP\")]": function (_0) {
	      return [_0.set("mtrOpts.protocol", "TCP")];
	    },
	    "[_0.set(\"mtrOpts.protocol\",\"ICMP\")]": function (_0) {
	      return [_0.set("mtrOpts.protocol", "ICMP")];
	    },
	    "_0===\"MTR\"": function (_0) {
	      return _0 === "MTR";
	    },
	    "[_0.set(\"httpOpts.protocol\",\"HTTP\")]": function (_0) {
	      return [_0.set("httpOpts.protocol", "HTTP")];
	    },
	    "[_0.set(\"httpOpts.protocol\",\"HTTPS\")]": function (_0) {
	      return [_0.set("httpOpts.protocol", "HTTPS")];
	    },
	    "[_0.set(\"httpOpts.protocol\",\"HTTP2\")]": function (_0) {
	      return [_0.set("httpOpts.protocol", "HTTP2")];
	    },
	    "[_0.set(\"httpOpts.request.method\",\"GET\")]": function (_0) {
	      return [_0.set("httpOpts.request.method", "GET")];
	    },
	    "[_0.set(\"httpOpts.request.method\",\"HEAD\")]": function (_0) {
	      return [_0.set("httpOpts.request.method", "HEAD")];
	    },
	    "[_0.set(\"httpOpts.request.method\",\"OPTIONS\")]": function (_0) {
	      return [_0.set("httpOpts.request.method", "OPTIONS")];
	    },
	    "_0===\"HTTP\"": function (_0) {
	      return _0 === "HTTP";
	    },
	    "[_0.applyOptions()]": function (_0) {
	      return [_0.applyOptions()];
	    },
	    "_0.isInfiniteOptsCorrect()": function (_0) {
	      return _0.isInfiniteOptsCorrect();
	    },
	    "[_0.handleInfiniteSwitch()]": function (_0) {
	      return [_0.handleInfiniteSwitch()];
	    },
	    "[_0.handleInfiniteSwitchKeyDown(_1)]": function (_0, _1) {
	      return [_0.handleInfiniteSwitchKeyDown(_1)];
	    },
	    "_0.isInfiniteOptsCorrect()&&!_1": function (_0, _1) {
	      return _0.isInfiniteOptsCorrect() && !_1;
	    },
	    "[_0.reUseProbesRunTest()]": function (_0) {
	      return [_0.reUseProbesRunTest()];
	    },
	    "_0&&!_1": function (_0, _1) {
	      return _0 && !_1;
	    },
	    "[_0.handleInfiniteMeasBtn()]": function (_0) {
	      return [_0.handleInfiniteMeasBtn()];
	    },
	    "_0===\"docker\"": function (_0) {
	      return _0 === "docker";
	    },
	    "[_0.set(\"joinNetSwitchValue\",\"docker\")]": function (_0) {
	      return [_0.set("joinNetSwitchValue", "docker")];
	    },
	    "_0===\"podman\"": function (_0) {
	      return _0 === "podman";
	    },
	    "[_0.set(\"joinNetSwitchValue\",\"podman\")]": function (_0) {
	      return [_0.set("joinNetSwitchValue", "podman")];
	    },
	    "_0+1": function (_0) {
	      return _0 + 1;
	    },
	    "_0?_1:_2": function (_0, _1, _2) {
	      return _0 ? _1 : _2;
	    },
	    "[_0.toggle(\"showCommandsBlock\")]": function (_0) {
	      return [_0.toggle("showCommandsBlock")];
	    },
	    "_0<768": function (_0) {
	      return _0 < 768;
	    }
	  }
	};
	component$i.exports.components = {
	  "c-gp-jumbotron": gpJumbotron,
	  "c-gp-credits": gpCredits,
	  "c-gp-credits-message": gpCreditsMessage,
	  "c-gp-results-table-output": gpResultsTableOutput,
	  "c-gp-results-raw-output": gpResultsRawOutput,
	  "c-gp-results-controls": gpResultsControls,
	  "c-tags-input": tagsInput,
	  "c-controlled-textarea": controlledTextarea,
	  "c-location-input": locationInput,
	  "c-controlled-input": controlledInput,
	  "c-notification": notification,
	  "c-gp-footer": gpFooter,
	  "c-gp-header": gpHeader,
	  "r-page": rPageGlobalping
	};
	var _index = ractive__default["default"].extend(component$i.exports);

	var component$h = {
	  exports: {}
	};
	const DEB_DATA = {
	  name: 'DEB',
	  descr: 'Debian, UbuntuDEB, Ubuntu',
	  iconName: 'deb-icon.svg',
	  cmd1: {
	    html: 'curl -s https://<wbr>packagecloud.io<wbr>/install<wbr>/repositories<wbr>/jsdelivr<wbr>/globalping<wbr>/script.deb.sh<wbr> | sudo bash',
	    clearText: 'curl -s https://packagecloud.io/install/repositories/jsdelivr/globalping/script.deb.sh | sudo bash'
	  },
	  cmd2: 'apt install globalping',
	  cmd3: 'globalping --help'
	};
	const RPM_DATA = {
	  name: 'RPM',
	  descr: 'CentOS, RHEL, Fedora',
	  iconName: 'rpm-icon.svg',
	  cmd1: {
	    html: 'curl -s https://<wbr>packagecloud.io<wbr>/install<wbr>/repositories<wbr>/jsdelivr<wbr>/globalping<wbr>/script.rpm.sh | sudo bash',
	    clearText: 'curl -s https://packagecloud.io/install/repositories/jsdelivr/globalping/script.rpm.sh | sudo bash'
	  },
	  cmd2: 'dnf install globalping',
	  cmd3: 'globalping --help'
	};
	const HOMEBREW_DATA = {
	  name: 'Homebrew',
	  descr: 'MacOS',
	  iconName: 'homebrew-icon.svg',
	  cmd1: {
	    html: 'brew tap jsdelivr<wbr>/globalping',
	    clearText: 'brew tap jsdelivr/globalping'
	  },
	  cmd2: 'brew install globalping',
	  cmd3: 'globalping --help'
	};
	const QUICK_START_DATA = {
	  ping: {
	    name: 'ping',
	    title: 'ping from Germany',
	    content: `$ globalping ping jsdelivr.com from Germany --limit 2
> EU, DE, Magdeburg, ASN:3209, Vodafone GmbH
PING  (172.67.213.229) 56(84) bytes of data.
64 bytes from 172.67.213.229 (172.67.213.229): icmp_seq=1 ttl=57 time=19.6 ms
64 bytes from 172.67.213.229 (172.67.213.229): icmp_seq=2 ttl=57 time=19.8 ms
64 bytes from 172.67.213.229 (172.67.213.229): icmp_seq=3 ttl=57 time=17.0 ms

---  ping statistics ---
3 packets transmitted, 3 received, 0% packet loss, time 402ms
rtt min/avg/max/mdev = 17.049/18.791/19.774/1.235 ms

> EU, DE, Nuremberg, ASN:51167, Contabo GmbH
PING  (172.67.213.229) 56(84) bytes of data.
64 bytes from 172.67.213.229 (172.67.213.229): icmp_seq=1 ttl=58 time=4.05 ms
64 bytes from 172.67.213.229 (172.67.213.229): icmp_seq=2 ttl=58 time=3.76 ms
64 bytes from 172.67.213.229 (172.67.213.229): icmp_seq=3 ttl=58 time=3.88 ms

---  ping statistics ---
3 packets transmitted, 3 received, 0% packet loss, time 5227ms
rtt min/avg/max/mdev = 3.758/3.894/4.051/0.120 ms`
	  },
	  traceroute: {
	    name: 'traceroute',
	    title: 'traceroute from a US state',
	    content: `$ globalping traceroute jsdelivr.com from "North Carolina"
> NA, US, (NC), Raleigh, ASN:11426, Charter Communications Inc
traceroute to jsdelivr.com (104.21.35.47), 20 hops max, 60 byte packets
 1  192.168.90.1 (192.168.90.1)  2.228 ms  0.154 ms
 2  mta-107-13-96-1.nc.rr.com (107.13.96.1)  10.675 ms  10.643 ms
 3  lag-59.rlghncks01h.netops.charter.com (174.111.105.176)  11.533 ms  11.506 ms
 4  lag-27.drhmncev02r.netops.charter.com (24.25.62.104)  11.542 ms  11.551 ms
 5  lag-31.rcr01drhmncev.netops.charter.com (24.93.64.184)  11.229 ms  11.318 ms
 6  lag-415.asbnva1611w-bcr00.netops.charter.com (107.14.18.106)  17.888 ms  17.941 ms
 7  lag-0.pr2.dca10.netops.charter.com (66.109.5.117)  17.340 ms  17.314 ms
 8  173.245.63.44 (173.245.63.44)  17.842 ms  17.818 ms
 9  172.70.40.3 (172.70.40.3)  43.735 ms  43.685 ms
10  104.21.35.47 (104.21.35.47)  17.378 ms  17.353 ms`
	  },
	  http: {
	    name: 'http',
	    title: 'HTTP GET from AWS',
	    content: `$ globalping http https://example.com from AWS --method GET
> EU, DE, Frankfurt, ASN:16509, Amazon.com, Inc. (aws-eu-central-1)
<!doctype html>
<html>
<head>
    <title>Example Domain</title>

    <meta charset="utf-8" />
    <meta http-equiv="Content-type" content="text/html; charset=utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <style type="text/css">
    body {
        background-color: #f0f0f2;
        margin: 0;
        padding: 0;
        font-family: -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;

    }
    div {
        width: 600px;
        margin: 5em auto;
        padding: 2em;
        background-color: #fdfdff;
        border-radius: 0.5em;
        box-shadow: 2px 3px 7px 2px rgba(0,0,0,0.02);
    }
    a:link, a:visited {
        color: #38488f;
        text-decoration: none;
    }
    @media (max-width: 700px) {
        div {
            margin: 0 auto;
            width: auto;
        }
    }
    </style>
</head>

<body>
<div>
    <h1>Example Domain</h1>
    <p>This domain is for use in illustrative examples in documents. You may use this
    domain in literature without prior coordination or asking for permission.</p>
    <p><a href="https://www.iana.org/domains/example">More information...</a></p>
</div>
</body>
</html>`
	  },
	  dns: {
	    name: 'dns',
	    title: 'resolve from Mumbai',
	    content: `$ globalping dns cdn.jsdelivr.net from Mumbai
> AS, IN, Mumbai, ASN:206216, Advin Services LLC
; <<>> DiG 9.16.27-Debian <<>> cdn.jsdelivr.net -t A -p 53 -4 +timeout=3 +tries=2 +nocookie
;; global options: +cmd
;; Got answer:
;; ->>HEADER<<- opcode: QUERY, status: NOERROR, id: 30928
;; flags: qr rd ra; QUERY: 1, ANSWER: 6, AUTHORITY: 0, ADDITIONAL: 1

;; OPT PSEUDOSECTION:
; EDNS: version: 0, flags:; udp: 512
;; QUESTION SECTION:
;cdn.jsdelivr.net.              IN      A

;; ANSWER SECTION:
cdn.jsdelivr.net.       3161    IN      CNAME   cdn.jsdelivr.net.cdn.cloudflare.net.
cdn.jsdelivr.net.cdn.cloudflare.net. 90 IN A    104.16.88.20
cdn.jsdelivr.net.cdn.cloudflare.net. 90 IN A    104.16.85.20
cdn.jsdelivr.net.cdn.cloudflare.net. 90 IN A    104.16.87.20
cdn.jsdelivr.net.cdn.cloudflare.net. 90 IN A    104.16.86.20
cdn.jsdelivr.net.cdn.cloudflare.net. 90 IN A    104.16.89.20

;; Query time: 4 msec
;; SERVER: 8.8.8.8#53(8.8.8.8)
;; WHEN: Mon Mar 27 15:24:04 UTC 2023
;; MSG SIZE  rcvd: 171`
	  },
	  mtr: {
	    name: 'mtr',
	    title: 'MTR from gcp-europe-west3',
	    content: `$ globalping mtr openai.com from gcp-europe-west3
> EU, DE, Frankfurt, ASN:396982, Google LLC (gcp-europe-west3)
Host                                                             Loss% Drop Rcv Avg  StDev  Javg
 1. AS15169 _gateway (209.85.251.72)                              0.0%    0   3 1.4    0.4   1.0
 2. AS8075  ae65-0.fra-96cbe-1a.ntwk.msn.net (198.200.130.132)    0.0%    0   3 1.7    0.4   0.6
 3. AS8075  ae22-0.icr01.fra23.ntwk.msn.net (104.44.230.16)      33.3%    1   2 4.2    0.1   0.2
 4. AS8075  ae24-0.ier03.fra31.ntwk.msn.net (104.44.235.193)      0.0%    0   3 2.2    0.3   1.2
 5. AS???   (waiting for reply)
 6. AS8075  40.66.0.60 (40.66.0.60)                               0.0%    0   3 2.0    0.3   1.2
 7. AS???   (waiting for reply)
 8. AS???   (waiting for reply)
 9. AS???   (waiting for reply)
10. AS8075  13.107.238.45 (13.107.238.45)                         0.0%    0   3 2.0    0.3   1.3`
	  }
	};
	component$h.exports = {
	  decorators: {
	    clipboard
	  },
	  data() {
	    return {
	      title: 'Globalping CLI - The perfect DevOps tool',
	      description: 'Run network commands from thousands of globally distributed probes without ever leaving your command line. Ping, traceroute, resolve and GET anything you want!',
	      qsTabName: QUICK_START_DATA.ping.name,
	      osDataList: [DEB_DATA, RPM_DATA, HOMEBREW_DATA],
	      selectedOsTab: DEB_DATA.name,
	      quickStartData: QUICK_START_DATA,
	      roundedTotalProbes: 0
	    };
	  },
	  oninit() {
	    if (!ractive__default["default"].isServer) {
	      let handleProbesResponse = isStored => response => {
	        if (!isStored) {
	          sessionStorage.setItem('probesResponse', JSON.stringify(response));
	        } else {
	          response = JSON.parse(response);
	        }
	        let roundedTotalProbes = Math.round(response.length / 100) * 100;
	        this.animate('roundedTotalProbes', roundedTotalProbes, {
	          duration: 2000
	        });
	      };
	      if (has$6.sessionStorage()) {
	        let probesResponse = sessionStorage.getItem('probesResponse');
	        if (probesResponse) {
	          handleProbesResponse(true)(probesResponse);
	        } else {
	          http.fetchGlobalpingProbes().then(handleProbesResponse(false));
	        }
	      } else {
	        http.fetchGlobalpingProbes().then(handleProbesResponse(false));
	      }
	    }
	  }
	};
	component$h.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "r-page",
	    m: [{
	      n: "noYield",
	      f: [{
	        t: 2,
	        r: "noYield"
	      }],
	      t: 13
	    }, {
	      n: "title",
	      f: [{
	        t: 2,
	        r: "title"
	      }],
	      t: 13
	    }, {
	      n: "description",
	      f: [{
	        t: 2,
	        r: "description"
	      }],
	      t: 13
	    }],
	    f: [{
	      t: 7,
	      e: "c-notification"
	    }, " ", {
	      t: 7,
	      e: "c-gp-header",
	      m: [{
	        n: "additionalClasses",
	        f: "header-with-globalping-bg",
	        t: 13,
	        g: 1
	      }]
	    }, " ", {
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "p-globalping-cli",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "c-gp-jumbotron",
	        m: [{
	          n: "className",
	          f: "cli",
	          t: 13,
	          g: 1
	        }, {
	          n: "gridType",
	          f: "type2",
	          t: 13,
	          g: 1
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "gp-cli_main-info",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "h1",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "gp-cli_main-info_title",
	            g: 1
	          }],
	          f: ["Run network commands on a ", {
	            t: 7,
	            e: "span",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp-cli_green-text",
	              g: 1
	            }],
	            f: ["global network of ", {
	              t: 7,
	              e: "span",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "gp-cli_main-info_title_numbers",
	                g: 1
	              }],
	              f: [{
	                t: 2,
	                x: {
	                  r: ["roundedTotalProbes"],
	                  s: "Math.floor(_0)"
	                }
	              }, "+"]
	            }, " probes"]
	          }, " to test, debug and benchmark your infrastructure, routing and web services."]
	        }, " ", {
	          t: 7,
	          e: "span",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "gp-cli_main-info_descr",
	            g: 1
	          }],
	          f: ["All in your command line, simple to use and fully scriptable."]
	        }, " ", {
	          t: 7,
	          e: "a",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "gp-cli_main-info_btn gp_btn_black",
	            g: 1
	          }, {
	            n: "target",
	            f: "_blank",
	            t: 13,
	            g: 1
	          }, {
	            n: "rel",
	            f: "noopener noreferrer",
	            t: 13,
	            g: 1
	          }, {
	            n: "href",
	            f: "https://github.com/jsdelivr/globalping-cli",
	            t: 13,
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "img",
	            m: [{
	              n: "width",
	              f: "20",
	              t: 13,
	              g: 1
	            }, {
	              n: "height",
	              f: "20",
	              t: 13,
	              g: 1
	            }, {
	              n: "src",
	              f: [{
	                t: 2,
	                r: "@shared.assetsHost"
	              }, "/img/globalping/github.small.svg"],
	              t: 13
	            }]
	          }, " GitHub"]
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "gp-cli_how-install",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "span",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "gp-cli_how-install_title",
	            g: 1
	          }],
	          f: ["How to install"]
	        }, " ", {
	          t: 7,
	          e: "span",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "gp-cli_how-install_descr",
	            g: 1
	          }],
	          f: ["Install the correct repo for your OS to make sure you get the latest updated we release."]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "gp-cli_how-install_list",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp-cli_how-install_list_desktop-header",
	              g: 1
	            }],
	            f: [{
	              t: 4,
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "gp-cli_how-install_list_desktop-header_item",
	                  g: 1
	                }, {
	                  n: ["click"],
	                  t: 70,
	                  f: {
	                    r: ["@this", "./name"],
	                    s: "[_0.set(\"selectedOsTab\",_1)]"
	                  }
	                }],
	                f: [{
	                  t: 7,
	                  e: "img",
	                  m: [{
	                    n: "width",
	                    f: "auto",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "32",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "src",
	                    f: [{
	                      t: 2,
	                      r: "@shared.assetsHost"
	                    }, "/img/globalping/gp-cli/", {
	                      t: 2,
	                      r: "./iconName"
	                    }],
	                    t: 13
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "gp-cli_how-install_list_desktop-header_item_text",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "span",
	                    f: [{
	                      t: 2,
	                      r: "./name"
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "span",
	                    f: [{
	                      t: 2,
	                      r: "./descr"
	                    }]
	                  }]
	                }, " ", {
	                  t: 4,
	                  f: [{
	                    t: 7,
	                    e: "div",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "active-tab-line",
	                      g: 1
	                    }]
	                  }],
	                  n: 50,
	                  x: {
	                    r: ["selectedOsTab", "./name"],
	                    s: "_0===_1"
	                  }
	                }]
	              }],
	              n: 52,
	              r: "osDataList"
	            }]
	          }, " ", {
	            t: 4,
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                n: "class",
	                f: ["gp-cli_how-install_list_item ", {
	                  t: 4,
	                  f: ["active"],
	                  n: 50,
	                  x: {
	                    r: ["selectedOsTab", "./name"],
	                    s: "_0===_1"
	                  }
	                }],
	                t: 13
	              }],
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "gp-cli_how-install_list_item_header",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "img",
	                  m: [{
	                    n: "width",
	                    f: "auto",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "32",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "src",
	                    f: [{
	                      t: 2,
	                      r: "@shared.assetsHost"
	                    }, "/img/globalping/gp-cli/", {
	                      t: 2,
	                      r: "./iconName"
	                    }],
	                    t: 13
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "gp-cli_how-install_list_item_header_text",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "span",
	                    f: [{
	                      t: 2,
	                      r: "./name"
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "span",
	                    f: [{
	                      t: 2,
	                      r: "./descr"
	                    }]
	                  }]
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "gp-cli_how-install_list_item_body",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "span",
	                  f: [{
	                    t: 3,
	                    r: "./cmd1.html"
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "br"
	                }, " ", {
	                  t: 7,
	                  e: "span",
	                  f: [{
	                    t: 2,
	                    r: "./cmd2"
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "br"
	                }, " ", {
	                  t: 7,
	                  e: "span",
	                  f: [{
	                    t: 2,
	                    r: "./cmd3"
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "button",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "gp-cli_how-install_list_item_body_btn gp_btn_green",
	                    g: 1
	                  }, {
	                    n: "clipboard",
	                    t: 71
	                  }, {
	                    n: "data-clipboard-text",
	                    f: [{
	                      t: 2,
	                      x: {
	                        r: ["./cmd1.clearText", "./cmd2", "./cmd3"],
	                        s: "_0+\"\\n\"+_1+\"\\n\"+_2"
	                      }
	                    }],
	                    t: 13
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "width",
	                      f: "20",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "20",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/globalping/copy-icon.svg"],
	                      t: 13
	                    }]
	                  }]
	                }]
	              }]
	            }],
	            n: 52,
	            r: "osDataList"
	          }]
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "gp-cli_quick-start",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "gp-cli_quick-start_header",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "span",
	            f: ["Globalping CLI is a must have all-in-one tool for network optimization"]
	          }, " ", {
	            t: 7,
	            e: "span",
	            f: ["Run network commands, write scripts, automate uptime monitoring, do latency checks and make sure your anycast network continues to perform up to your standards, globally! ", {
	              t: 7,
	              e: "a",
	              m: [{
	                n: "target",
	                f: "_blank",
	                t: 13,
	                g: 1
	              }, {
	                n: "href",
	                f: "https://github.com/jsdelivr/globalping#best-practices-and-tips",
	                t: 13,
	                g: 1
	              }],
	              f: ["Learn more about the best practices."]
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "gp-cli_quick-start_content",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp-cli_quick-start_content_header",
	              g: 1
	            }],
	            f: [{
	              t: 4,
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  n: "class",
	                  f: ["gp-cli_quick-start_content_header_item ", {
	                    t: 4,
	                    f: ["active"],
	                    n: 50,
	                    x: {
	                      r: ["qsTabName", "./name"],
	                      s: "_0===_1"
	                    }
	                  }],
	                  t: 13
	                }, {
	                  n: ["click"],
	                  t: 70,
	                  f: {
	                    r: ["@this", "./name"],
	                    s: "[_0.set(\"qsTabName\",_1)]"
	                  }
	                }],
	                f: [{
	                  t: 2,
	                  r: "./title"
	                }]
	              }],
	              n: 52,
	              r: "quickStartData"
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp-cli_quick-start_content_body",
	              g: 1
	            }],
	            f: [{
	              t: 4,
	              f: [{
	                t: 7,
	                e: "pre",
	                m: [{
	                  n: "class",
	                  f: [{
	                    t: 4,
	                    f: ["visible"],
	                    n: 50,
	                    x: {
	                      r: ["qsTabName", "./name"],
	                      s: "_0===_1"
	                    }
	                  }],
	                  t: 13
	                }],
	                f: [{
	                  t: 2,
	                  r: "./content"
	                }]
	              }],
	              n: 52,
	              r: "quickStartData"
	            }]
	          }]
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "gp-cli_command-line",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "gp-cli_command-line_header",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "span",
	            f: ["Globalping CLI - Quick Start"]
	          }, " ", {
	            t: 7,
	            e: "span",
	            f: ["The Globalping command line tool provides a simple and familiar interface that works on Linux, Mac and Windows"]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "gp-cli_command-line_body",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "pre",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp-cli_command-line_body_content",
	              g: 1
	            }],
	            f: ["~$ globalping help\n\nUsage:\n  globalping [command]\n\nMeasurement Commands:\n  dns         Use the native dig command\n  http        Perform a HEAD or GET request to a host\n  mtr         Use the native mtr command\n  ping        Use the native ping command\n  traceroute  Use the native traceroute command\n\nAdditional Commands:\n  completion  Generate the autocompletion script for the specified shell\n  help        Help about any command\n  version     Print the version number of Globalping CLI\n\nFlags:\n  -C, --ci            Disable realtime terminal updates and color suitable for CI (default false)\n  -F, --from string   A continent, region (e.g eastern europe), country, US state or city (default \"world\")\n  -h, --help          help for globalping\n  -J, --json          Output results in JSON format (default false)\n  -L, --limit int     Limit the number of probes to use (default 1)\n\nUse \"globalping [command] --help\" for more information about a command.\n\t\t\t\t"]
	          }]
	        }, " ", {
	          t: 7,
	          e: "a",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "gp-cli_command-line_btn gp_btn_green",
	            g: 1
	          }, {
	            n: "target",
	            f: "_blank",
	            t: 13,
	            g: 1
	          }, {
	            n: "rel",
	            f: "noopener noreferrer",
	            t: 13,
	            g: 1
	          }, {
	            n: "href",
	            f: "https://github.com/jsdelivr/globalping-cli",
	            t: 13,
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "img",
	            m: [{
	              n: "width",
	              f: "20",
	              t: 13,
	              g: 1
	            }, {
	              n: "height",
	              f: "20",
	              t: 13,
	              g: 1
	            }, {
	              n: "src",
	              f: [{
	                t: 2,
	                r: "@shared.assetsHost"
	              }, "/img/globalping/github.small.svg"],
	              t: 13
	            }]
	          }, " Learn more on GitHub"]
	        }]
	      }]
	    }, " ", {
	      t: 7,
	      e: "c-gp-footer"
	    }]
	  }],
	  e: {
	    "Math.floor(_0)": function (_0) {
	      return Math.floor(_0);
	    },
	    "[_0.set(\"selectedOsTab\",_1)]": function (_0, _1) {
	      return [_0.set("selectedOsTab", _1)];
	    },
	    "_0===_1": function (_0, _1) {
	      return _0 === _1;
	    },
	    "_0+\"\\n\"+_1+\"\\n\"+_2": function (_0, _1, _2) {
	      return _0 + "\n" + _1 + "\n" + _2;
	    },
	    "[_0.set(\"qsTabName\",_1)]": function (_0, _1) {
	      return [_0.set("qsTabName", _1)];
	    }
	  }
	};
	component$h.exports.components = {
	  "c-gp-jumbotron": gpJumbotron,
	  "c-notification": notification,
	  "c-gp-footer": gpFooter,
	  "c-gp-header": gpHeader,
	  "r-page": rPageGlobalping
	};
	var cli = ractive__default["default"].extend(component$h.exports);

	var component$g = {
	  exports: {}
	};
	component$g.exports = {
	  data() {
	    return {
	      title: 'Globalping Slack App',
	      description: 'A must have Slack App for devops and support teams, startups and corporations, that allows anyone to run global network tests in any channel and discuss the results.'
	    };
	  }
	};
	component$g.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "r-page",
	    m: [{
	      n: "noYield",
	      f: [{
	        t: 2,
	        r: "noYield"
	      }],
	      t: 13
	    }, {
	      n: "title",
	      f: [{
	        t: 2,
	        r: "title"
	      }],
	      t: 13
	    }, {
	      n: "description",
	      f: [{
	        t: 2,
	        r: "description"
	      }],
	      t: 13
	    }],
	    f: [{
	      t: 7,
	      e: "c-notification"
	    }, " ", {
	      t: 7,
	      e: "c-gp-header",
	      m: [{
	        n: "additionalClasses",
	        f: "header-with-globalping-bg",
	        t: 13,
	        g: 1
	      }]
	    }, " ", {
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "p-globalping-slack",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "c-gp-jumbotron",
	        m: [{
	          n: "className",
	          f: "slack",
	          t: 13,
	          g: 1
	        }, {
	          n: "gridType",
	          f: "type2",
	          t: 13,
	          g: 1
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "gp-slack_main-info",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "h1",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "gp-slack_main-info_title",
	            g: 1
	          }],
	          f: ["With the ", {
	            t: 7,
	            e: "span",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp-slack_green-text",
	              g: 1
	            }],
	            f: ["Globalping App for Slack"]
	          }, " all of your Slack members can run network commands such as ping, traceroute, mtr, http and DNS from a globally distributed network of probes."]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "gp-slack_main-info_ctrls",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "a",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp-slack_main-info_ctrls_btn",
	              g: 1
	            }, {
	              n: "target",
	              f: "_blank",
	              t: 13,
	              g: 1
	            }, {
	              n: "rel",
	              f: "noopener noreferrer",
	              t: 13,
	              g: 1
	            }, {
	              n: "href",
	              f: "https://bots.globalping.io/slack/install",
	              t: 13,
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "img",
	              m: [{
	                n: "width",
	                f: "139",
	                t: 13,
	                g: 1
	              }, {
	                n: "height",
	                f: "40",
	                t: 13,
	                g: 1
	              }, {
	                n: "src",
	                f: [{
	                  t: 2,
	                  r: "@shared.assetsHost"
	                }, "/img/globalping/gp-slack/slack-btn.svg"],
	                t: 13
	              }]
	            }]
	          }, " ", {
	            t: 7,
	            e: "a",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp-slack_main-info_ctrls_btn gp_btn_black",
	              g: 1
	            }, {
	              n: "href",
	              f: "mailto:d@jsdelivr.com",
	              t: 13,
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "img",
	              m: [{
	                n: "width",
	                f: "20",
	                t: 13,
	                g: 1
	              }, {
	                n: "height",
	                f: "20",
	                t: 13,
	                g: 1
	              }, {
	                n: "src",
	                f: [{
	                  t: 2,
	                  r: "@shared.assetsHost"
	                }, "/img/globalping/gp-slack/mail-icon.svg"],
	                t: 13
	              }]
	            }, " Contact us"]
	          }]
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "gp-slack_content",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "gp-slack_content_header",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "span",
	            f: ["Globalping Integration for Slack Quick Start"]
	          }, " ", {
	            t: 7,
	            e: "span",
	            f: ["Simple to use, free and open source."]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "gp-slack_content_steps",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp-slack_content_steps_item",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "gp-slack_content_steps_item_data",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "span",
	                f: ["1"]
	              }, " ", {
	                t: 7,
	                e: "div",
	                f: ["Install the app in your Slack organization"]
	              }, " ", {
	                t: 7,
	                e: "div",
	                f: ["Click to install bellow and select your Slack organization. After installation it will be available to all of your members."]
	              }]
	            }, " ", {
	              t: 7,
	              e: "img",
	              m: [{
	                n: "width",
	                f: "272",
	                t: 13,
	                g: 1
	              }, {
	                n: "height",
	                f: "285",
	                t: 13,
	                g: 1
	              }, {
	                n: "src",
	                f: [{
	                  t: 2,
	                  r: "@shared.assetsHost"
	                }, "/img/globalping/gp-slack/slack-screen-1.svg"],
	                t: 13
	              }]
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp-slack_content_steps_item",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "gp-slack_content_steps_item_data",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "span",
	                f: ["2"]
	              }, " ", {
	                t: 7,
	                e: "div",
	                f: ["Trigger it by calling \"/globalping\""]
	              }, " ", {
	                t: 7,
	                e: "div",
	                f: ["Any user can trigger a test by running the /globalping command. For example \"/globalping ping jsdelivr.com from Germany\"."]
	              }]
	            }, " ", {
	              t: 7,
	              e: "img",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "slack-screen-2",
	                g: 1
	              }, {
	                n: "width",
	                f: "298",
	                t: 13,
	                g: 1
	              }, {
	                n: "height",
	                f: "116",
	                t: 13,
	                g: 1
	              }, {
	                n: "src",
	                f: [{
	                  t: 2,
	                  r: "@shared.assetsHost"
	                }, "/img/globalping/gp-slack/slack-screen-2.svg"],
	                t: 13
	              }]
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp-slack_content_steps_item",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "gp-slack_content_steps_item_data",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "span",
	                f: ["3"]
	              }, " ", {
	                t: 7,
	                e: "div",
	                f: ["Use it to run commands and get results in any channel"]
	              }, " ", {
	                t: 7,
	                e: "div",
	                f: ["The results of the requested test will appear in the same channel or private message where it was triggered"]
	              }]
	            }, " ", {
	              t: 7,
	              e: "img",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "slack-screen-3",
	                g: 1
	              }, {
	                n: "width",
	                f: "286",
	                t: 13,
	                g: 1
	              }, {
	                n: "height",
	                f: "160",
	                t: 13,
	                g: 1
	              }, {
	                n: "src",
	                f: [{
	                  t: 2,
	                  r: "@shared.assetsHost"
	                }, "/img/globalping/gp-slack/slack-screen-3.svg"],
	                t: 13
	              }]
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "a",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "gp-slack_content_btn",
	            g: 1
	          }, {
	            n: "target",
	            f: "_blank",
	            t: 13,
	            g: 1
	          }, {
	            n: "rel",
	            f: "noopener noreferrer",
	            t: 13,
	            g: 1
	          }, {
	            n: "href",
	            f: "https://bots.globalping.io/slack/install",
	            t: 13,
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "img",
	            m: [{
	              n: "width",
	              f: "139",
	              t: 13,
	              g: 1
	            }, {
	              n: "height",
	              f: "40",
	              t: 13,
	              g: 1
	            }, {
	              n: "src",
	              f: [{
	                t: 2,
	                r: "@shared.assetsHost"
	              }, "/img/globalping/gp-slack/slack-btn.svg"],
	              t: 13
	            }]
	          }]
	        }]
	      }]
	    }, " ", {
	      t: 7,
	      e: "c-gp-footer"
	    }]
	  }]
	};
	component$g.exports.components = {
	  "c-gp-jumbotron": gpJumbotron,
	  "c-notification": notification,
	  "c-gp-footer": gpFooter,
	  "c-gp-header": gpHeader,
	  "r-page": rPageGlobalping
	};
	var slack = ractive__default["default"].extend(component$g.exports);

	var component$f = {
	  exports: {}
	};
	const CONTENT_TYPE_HEADER = 'header';
	const CONTENT_TYPE_SUBHEADER = 'subheader';
	const CONTENT_TYPE_DESCR = 'descr';
	const CONTENT_TYPE_LIST = 'list';
	component$f.exports = {
	  computed: {
	    contentPerTestType() {
	      let locationData = this.get('locationData');
	      let locationName = locationData ? locationData.name || locationData.from : 'World';
	      return {
	        ping: [{
	          type: CONTENT_TYPE_HEADER,
	          content: 'What is ping?'
	        }, {
	          type: CONTENT_TYPE_DESCR,
	          content: `Ping is a network testing and troubleshooting utility that helps identify problems when
you can't reach a server or experience slow loading times. It's also often used for simple
network performance monitoring, determining if a website is reachable from the local network, or resolving a hostname's IP address.`
	        }, {
	          type: CONTENT_TYPE_DESCR,
	          content: `Ping sends Internet Control Message Protocol (ICMP) packets from your location to a target
host (a hostname or IP address) to test connectivity. If everything goes well, the target
receives the request and sends back a response to confirm that it's reachable and working.
The response includes the round-trip time (RTT), which tells you how long it took for the
data to travel to the destination and back. This RTT can also indicate the latency, or delay, to the target.`
	        }, {
	          type: CONTENT_TYPE_HEADER,
	          content: 'What are everyday use cases for ping?'
	        }, {
	          type: CONTENT_TYPE_DESCR,
	          content: 'Not sure how ping can help you? Here are some popular use cases:'
	        }, {
	          type: CONTENT_TYPE_SUBHEADER,
	          content: 'Test network connectivity'
	        }, {
	          type: CONTENT_TYPE_DESCR,
	          content: `Ping is the go-to tool when you experience network issues. By sending data packets to a target
host and receiving a response, ping lets you quickly verify if the target is reachable and evaluate
the overall network connectivity.`
	        }, {
	          type: CONTENT_TYPE_SUBHEADER,
	          content: 'Measure latency'
	        }, {
	          type: CONTENT_TYPE_DESCR,
	          content: `You may have a network bottleneck or other performance issues if you spot unusually high RTTs in
your ping results. If you notice high latency but don't know where in the network the problem is,
pinging different hosts and comparing the RTTs helps find the problematic devices.`
	        }, {
	          type: CONTENT_TYPE_SUBHEADER,
	          content: 'Test website reachability'
	        }, {
	          type: CONTENT_TYPE_DESCR,
	          content: `When you can't load a website via your browser, ping the website's hostname to check if it's reachable
from your network. This lets you determine whether you're facing network-related issues or a problem with your browser.`
	        }, {
	          type: CONTENT_TYPE_SUBHEADER,
	          content: 'Diagnose Internet connection problems'
	        }, {
	          type: CONTENT_TYPE_DESCR,
	          content: `Can't connect to the Internet? Ping your router's IP address to verify if your device can reach the
router, helping you find out if the issue lies within your local network or the Internet connection.`
	        }, {
	          type: CONTENT_TYPE_SUBHEADER,
	          content: 'Monitor networks'
	        }, {
	          type: CONTENT_TYPE_DESCR,
	          content: `Create automated scripts that regularly ping one or more hosts and store the result data. Use this
data to identify hosts that frequently cause high response times, packet loss, or other problems so you can take action.`
	        }, {
	          type: CONTENT_TYPE_HEADER,
	          content: `What are common use cases to run ping from ${locationName}?`
	        }, {
	          type: CONTENT_TYPE_DESCR,
	          content: `Sometimes you need to run network tests from locations that aren't accessible to you. That's where Globalping comes
to the rescue. It's a platform that relies on a globally distributed network of probes, allowing you to
perform measurements from any corner of the world.`
	        }, {
	          type: CONTENT_TYPE_DESCR,
	          content: `Running ping from ${locationName} and other places provides many insights and extends the
use cases we explored in the previous section:`
	        }, {
	          type: CONTENT_TYPE_LIST,
	          content: ['Set up global network monitoring', 'Test website availability from various regions', 'Measure latency as experienced by users across the globe']
	        }, {
	          type: CONTENT_TYPE_DESCR,
	          content: 'Here are some additional use cases for geographically distributed ping:'
	        }, {
	          type: CONTENT_TYPE_SUBHEADER,
	          content: 'Optimize content delivery'
	        }, {
	          type: CONTENT_TYPE_DESCR,
	          content: `Run ping from ${locationName} and other locations to test the latency to your website or API. Examine the ping's
RTTs - if they're unusually high, users likely experience delays and long loading times. To reduce latency,
consider using a CDN (Content Delivery Network) for efficient content distribution.`
	        }, {
	          type: CONTENT_TYPE_SUBHEADER,
	          content: `Troubleshoot from your users' perspective`
	        }, {
	          type: CONTENT_TYPE_DESCR,
	          content: `Imagine your website users in ${locationName} are reporting issues, but everything
seems fine from your end. With Globalping, you can run ping from ${locationName} as if you were doing it from your
location to troubleshoot the problem.`
	        }, {
	          type: CONTENT_TYPE_SUBHEADER,
	          content: 'Monitor remote servers'
	        }, {
	          type: CONTENT_TYPE_DESCR,
	          content: `If you manage servers around the globe, running ping from different locations can be of invaluable help for
monitoring performance and connectivity. This allows you to respond faster and more informed when issues in specific regions arise.`
	        }],
	        traceroute: [{
	          type: CONTENT_TYPE_HEADER,
	          content: 'What is traceroute?'
	        }, {
	          type: CONTENT_TYPE_DESCR,
	          content: `Traceroute is a valuable network testing and troubleshooting utility that helps pinpoint potential issues along
the route between your device and the target host, such as when you're unable to reach a website or experience slow load times.`
	        }, {
	          type: CONTENT_TYPE_DESCR,
	          content: `Traceroute sends small data packets to a target hostname or IP address and lists each hop (usually a router) used to get there.
Each packet has a Time to Live (TTL) value, starting at 1, to limit its lifespan. As the data passes through each hop, the TTL value decreases by 1. Once it
reaches 0, the current router stops forwarding the packet and responds with a "TTL exceeded" message. Traceroute then takes note of the router's IP address,
increases the packet's initial TTL by 1, and resends the request.
Thanks to this back and forth, traceroute can compile a list of all the hops the data passes to the target, including the round-trip time (RTT) for each hop.`
	        }, {
	          type: CONTENT_TYPE_HEADER,
	          content: 'What are common use cases for traceroute?'
	        }, {
	          type: CONTENT_TYPE_DESCR,
	          content: `Are you wondering what you can actually achieve by running traceroute? Here're some typical use cases:`
	        }, {
	          type: CONTENT_TYPE_SUBHEADER,
	          content: 'Measure performance'
	        }, {
	          type: CONTENT_TYPE_DESCR,
	          content: `If you notice high latency to a target, run traceroute and look at each hop's round-trip time (RTT) to learn about the time it took for
the data packets to reach the destination and back. If you come across a hop with an unusually high RTT, it could indicate congestion or some other performance
issue at that point.`
	        }, {
	          type: CONTENT_TYPE_SUBHEADER,
	          content: 'Analyze network paths'
	        }, {
	          type: CONTENT_TYPE_DESCR,
	          content: `Traceroute comes in handy when you need to know the path packets take through the network to reach a target host. Listing the IP addresses,
host names, and RTTs for each hop gives you a clearer picture of the network infrastructure. As a result, you may find potential bottlenecks or other problematic
segments, allowing you to take action quickly.`
	        }, {
	          type: CONTENT_TYPE_SUBHEADER,
	          content: 'Troubleshoot network connectivity'
	        }, {
	          type: CONTENT_TYPE_DESCR,
	          content: `When you're experiencing network connectivity issues, traceroute can help pinpoint the problem by collecting data about each hop between
your device and the target. Typically, the issue is with the last hop that sent a response or the one after that hop. Once you know where the problem is, you're a
big step closer to solving it.`
	        }, {
	          type: CONTENT_TYPE_SUBHEADER,
	          content: 'Verify routing changes'
	        }, {
	          type: CONTENT_TYPE_DESCR,
	          content: `Running traceroute before and after making changes to your network infrastructure allows you to verify that the new routing's working as
expected. Compare traceroute results to ensure that data takes the correct path and identify any unexpected behavior you should fix.`
	        }, {
	          type: CONTENT_TYPE_HEADER,
	          content: `What are everyday use cases to run traceroute from ${locationName}?`
	        }, {
	          type: CONTENT_TYPE_DESCR,
	          content: `But how can you use traceroute when users report issues with your infrastructure in places that aren't accessible to you? This is where
Globalping can help you: The platform leverages a globally distributed network of probes, enabling you to send measurement requests from anywhere in the world.`
	        }, {
	          type: CONTENT_TYPE_DESCR,
	          content: `Running traceroute from ${locationName} and any other location provides insights on a global scale, adding to the use cases explored above:`
	        }, {
	          type: CONTENT_TYPE_LIST,
	          content: ['Find network bottlenecks and measure latency globally', 'Analyze and verify the paths data takes from different locations to a website or server', 'Resolve network connectivity issues reported by users all over the world']
	        }, {
	          type: CONTENT_TYPE_DESCR,
	          content: `Let's explore some more use cases for running traceroute globally:`
	        }, {
	          type: CONTENT_TYPE_SUBHEADER,
	          content: 'Global network monitoring'
	        }, {
	          type: CONTENT_TYPE_DESCR,
	          content: `Running traceroute with Globalping regularly from different locations around the world gives you a comprehensive view of your network's
performance and connectivity. This allows you to resolve many network-related issues faster and ensure a consistently high user experience.`
	        }, {
	          type: CONTENT_TYPE_SUBHEADER,
	          content: 'Compare service providers'
	        }, {
	          type: CONTENT_TYPE_DESCR,
	          content: `When choosing the ideal CDN provider, DNS provider, or Cloud hosting company, running traceroute from ${locationName} and other locations
to the provider can help. Examine the number of hops, the round-trip times, and any potential performance spikes encountered along the path. That way, you can
determine which providers offer the best network connectivity and reliability for your desired locations.`
	        }, {
	          type: CONTENT_TYPE_SUBHEADER,
	          content: `Investigate user reports`
	        }, {
	          type: CONTENT_TYPE_DESCR,
	          content: `Are users in remote locations like ${locationName} reporting issues you can't reproduce? Use Globalping to run traceroute from an area near
these users to identify regional problems and determine the proper troubleshooting steps.`
	        }],
	        dns: [{
	          type: CONTENT_TYPE_HEADER,
	          content: 'What is dig, and how to resolve DNS?'
	        }, {
	          type: CONTENT_TYPE_DESCR,
	          content: `Dig is a network testing and troubleshooting tool that allows you to retrieve DNS (Domain Name System) information, such as a
domain's IP address, DNS records, and name server information.`
	        }, {
	          type: CONTENT_TYPE_DESCR,
	          content: `The dig command is quite flexible and lets you add options as needed. For example, you can query specific record types or define
the name server to query instead of your default resolver. When you run the dig command, you get a response divided into sections. The "authority section,"
for instance, lists the authoritative name servers that responded, and the "answer section" contains the response to your DNS query, such as the A record.`
	        }, {
	          type: CONTENT_TYPE_HEADER,
	          content: 'What are typical scenarios for using dig?'
	        }, {
	          type: CONTENT_TYPE_DESCR,
	          content: 'Not sure what you can do with the dig command? Here are some ideas:'
	        }, {
	          type: CONTENT_TYPE_SUBHEADER,
	          content: 'Perform DNS lookups'
	        }, {
	          type: CONTENT_TYPE_DESCR,
	          content: `Probably the most common use case for dig is to perform DNS lookups to provide you with information about the DNS configuration of a domain.
The data retrieved can include A records (IPv4 addresses), AAAA records (IPv6 addresses), MX records (mail server), NS records (name servers), and more.`
	        }, {
	          type: CONTENT_TYPE_SUBHEADER,
	          content: 'Troubleshoot DNS issues'
	        }, {
	          type: CONTENT_TYPE_DESCR,
	          content: `Dig is also the go-to tool for troubleshooting DNS resolution problems. Using the command, you can verify if DNS records are configured
correctly and that DNS servers are responding as they should. Query DNS records and analyze the results to find misconfigurations, DNS propagation problems,
and other DNS issues.`
	        }, {
	          type: CONTENT_TYPE_SUBHEADER,
	          content: 'Measure DNS performance'
	        }, {
	          type: CONTENT_TYPE_DESCR,
	          content: `If you want to measure the performance and reliability of different DNS servers, dig can help you with that too. Examine DNS response times
and query statistics to identify potential bottlenecks or test the efficiency of DNS caching.`
	        }, {
	          type: CONTENT_TYPE_HEADER,
	          content: `What are common use cases to run dig from ${locationName}?`
	        }, {
	          type: CONTENT_TYPE_DESCR,
	          content: `Sometimes you may experience DNS resolution issues or need to check DNS information from locations that aren't accessible to you.
That's where the Globalping platform comes into play. It consists of a network of globally distributed probes that allows you to perform DNS queries similar to dig
from any location.`
	        }, {
	          type: CONTENT_TYPE_DESCR,
	          content: `If you run dig from different places around the world, you can perform DNS-related tasks on a global scale, extending the use cases listed
in the previous section:`
	        }, {
	          type: CONTENT_TYPE_LIST,
	          content: ['Measure regional DNS performance', 'Perform global DNS resolution', 'Monitor and troubleshoot DNS issues globally']
	        }, {
	          type: CONTENT_TYPE_DESCR,
	          content: `But there's more:`
	        }, {
	          type: CONTENT_TYPE_SUBHEADER,
	          content: `Resolve DNS from ${locationName}`
	        }, {
	          type: CONTENT_TYPE_DESCR,
	          content: `Suppose your users in ${locationName} can't reach your website or email services. By running dig from ${locationName} with Globalping, you can
retrieve DNS information specific to that location. Examine the query results and look for misconfigurations that could affect your users' experience.`
	        }, {
	          type: CONTENT_TYPE_SUBHEADER,
	          content: 'Test load balancers'
	        }, {
	          type: CONTENT_TYPE_DESCR,
	          content: `Load balancers help you distribute incoming network traffic, for example, if you run a busy website. You can run dig from ${locationName} and
other locations to test whether your load balancers work as intended. Use Globalping to query your domain's DNS record, which should return IP addresses representing
the used load balancers. Then, run the same dig command repeatedly and see if it returns different IP, showing the load balancer in action. `
	        }, {
	          type: CONTENT_TYPE_SUBHEADER,
	          content: 'Debug CDN and multi-CDN setups'
	        }, {
	          type: CONTENT_TYPE_DESCR,
	          content: `Dig can also help you optimize global content delivery and troubleshoot CDN and multi-CDN setups. For example, use Globalping to perform
DNS queries by running dig from ${locationName} to identify the region's CDN nodes responsible for content delivery. This way, you can verify whether the content
is served to users from the closest nodes and compare DNS response times to find potential performance issues.`
	        }],
	        mtr: [{
	          type: CONTENT_TYPE_HEADER,
	          content: 'What is mtr?'
	        }, {
	          type: CONTENT_TYPE_DESCR,
	          content: `MTR (My Traceroute) is a network testing and troubleshooting utility that combines the functionality of the ping and traceroute commands.
It's designed to help identify issues along the path between your device and a specific destination, including connectivity problems, packet loss, and high latency.`
	        }, {
	          type: CONTENT_TYPE_DESCR,
	          content: `When you run mtr, it sends small data packets to the target host. As the data travels through the network, mtr records information about
each hop (typically a router) passed on the way. For each hop, it notes the IP address and continuously updates the packet loss percentage and the average and
current round-trip time (RTT). While traceroute provides a snapshot of the network path at a specific time, mtr lets you observe what happens as the test progresses.`
	        }, {
	          type: CONTENT_TYPE_HEADER,
	          content: 'What are typical scenarios for using mtr?'
	        }, {
	          type: CONTENT_TYPE_DESCR,
	          content: 'Here are three examples of what you can accomplish with mtr:'
	        }, {
	          type: CONTENT_TYPE_SUBHEADER,
	          content: 'Analyze & troubleshoot network paths'
	        }, {
	          type: CONTENT_TYPE_DESCR,
	          content: `Running mtr gives you real-time data showing the network path between your device and a target host. By providing the IP address, hostname,
RTTs, and packet loss percentage for each hop, you can find bottlenecks and other problematic points and start targeted troubleshooting.`
	        }, {
	          type: CONTENT_TYPE_SUBHEADER,
	          content: 'Plan & optimize network infrastructure'
	        }, {
	          type: CONTENT_TYPE_DESCR,
	          content: `Want to update the routing to improve your network infrastructure? Then run mtr to get data about your network paths before and after the
changes. This helps you determine if you're on the right track and take quick action if the results are not meeting your expectations.`
	        }, {
	          type: CONTENT_TYPE_SUBHEADER,
	          content: 'Measure performance'
	        }, {
	          type: CONTENT_TYPE_DESCR,
	          content: `MTR is also helpful in troubleshooting network issues that impact latency by helping you locate the root cause within the network.
Observe each hop's round-trip time (RTT) as the test progresses, and you can hopefully find the hops contributing to high latency and take measures, such as
moving servers or using a CDN.`
	        }, {
	          type: CONTENT_TYPE_HEADER,
	          content: `What are typical use cases to run mtr from ${locationName}?`
	        }, {
	          type: CONTENT_TYPE_DESCR,
	          content: `When troubleshooting network issues, running mtr from your location or a server you can access is often not enough. Instead, you may
want to perform measurements from various locations worldwide - fortunately, Globalping's global probe network allows you to do just that.`
	        }, {
	          type: CONTENT_TYPE_DESCR,
	          content: 'Running mtr globally expands the previously described usage scenarios:'
	        }, {
	          type: CONTENT_TYPE_LIST,
	          content: ['Analyze, plan, and optimize network paths from various regions', 'Troubleshoot network problems wherever they occur', 'Optimize content delivery for your international users']
	        }, {
	          type: CONTENT_TYPE_DESCR,
	          content: `But there's more you can achieve when you run mtr from different places:`
	        }, {
	          type: CONTENT_TYPE_SUBHEADER,
	          content: 'Investigate regional user issues'
	        }, {
	          type: CONTENT_TYPE_DESCR,
	          content: `If you receive reports from your users about connection problems, use Globalping to run mtr from ${locationName} or just about any
other location. This allows you to find the network segments that aren't working properly and then determine the needed steps to get to the bottom of the problem.`
	        }, {
	          type: CONTENT_TYPE_SUBHEADER,
	          content: 'SLA monitoring'
	        }, {
	          type: CONTENT_TYPE_DESCR,
	          content: `If you have service level agreements with customers worldwide, monitoring your network infrastructure with mtr can help ensure that
performance and reliability meet agreed metrics. Of course, you can also use this in reverse to ensure that your SLAs with service providers are met in
various locations.`
	        }, {
	          type: CONTENT_TYPE_SUBHEADER,
	          content: 'Compare CDN performance and quality'
	        }, {
	          type: CONTENT_TYPE_DESCR,
	          content: `Want to find the best content delivery networks (CDN) in ${locationName} or other locations? Use Globalping to run mtr from different sites
within ${locationName} to compare the performance and reliability of the providers' network infrastructures. Then, compare the results with those from other regions
to find the CDN provider that best meets your needs in your most important locations.`
	        }],
	        http: [{
	          type: CONTENT_TYPE_HEADER,
	          content: 'What is curl?'
	        }, {
	          type: CONTENT_TYPE_DESCR,
	          content: 'Curl is a tool that lets you make HTTP requests and retrieve content or get information from URLs directly from the command line.'
	        }, {
	          type: CONTENT_TYPE_DESCR,
	          content: `You often use curl to make HEAD or GET requests to URLs. For instance, when you make a HEAD request, you get information about the host
and web server associated with the URL. For a GET request, the server responds with the contents of the URL, such as a web page or data from an API GET endpoint.
Each response from the server contains a status code like 404 for "not found" or 200 for successful requests. You can use these codes to determine if the requested
resource is accessible and if there are any server problems.`
	        }, {
	          type: CONTENT_TYPE_HEADER,
	          content: 'What are some everyday use cases for curl to send HTTP requests?'
	        }, {
	          type: CONTENT_TYPE_DESCR,
	          content: `Not sure what you can achieve by sending HTTP GET or HEAD requests?
Here are some ideas:`
	        }, {
	          type: CONTENT_TYPE_SUBHEADER,
	          content: 'Verify service availability'
	        }, {
	          type: CONTENT_TYPE_DESCR,
	          content: `Adding HTTP GET and HEAD requests to your monitoring setup is an effective and simple way to keep an eye on the availability and
response times of your website or servers. Set up alerts to be able to quickly address issues and ensure that everything is back up and running in no time.`
	        }, {
	          type: CONTENT_TYPE_SUBHEADER,
	          content: 'Check HTTP headers'
	        }, {
	          type: CONTENT_TYPE_DESCR,
	          content: `When making an HTTP HEAD request to a website or API using curl, you can fetch the header information without the URL's content.
This allows you to explore and verify cache directives (e.g., ETag or Cache-Control), server information (e.g., software and version), content type, encoding,
and security measures (e.g., Content-Security-Policy or Strict-Transport-Security).`
	        }, {
	          type: CONTENT_TYPE_SUBHEADER,
	          content: 'Debugging and troubleshooting'
	        }, {
	          type: CONTENT_TYPE_DESCR,
	          content: `Curl can also be super helpful in numerous troubleshooting scenarios. For example, you can send requests to your API endpoints using
different parameter values and request headers to test and verify the responses. Or you can use it to evaluate the performance of your service by measuring
the time it takes a GET or HEAD request to your service to send you a response.`
	        }, {
	          type: CONTENT_TYPE_HEADER,
	          content: `What can I achieve by making HTTP requests from ${locationName}?`
	        }, {
	          type: CONTENT_TYPE_DESCR,
	          content: `If you run a website or an API, your users often report problems with your service from different locations that you'd like to investigate
but can't because the location is out of your reach. That's where our Globalping network testing platform comes to the rescue. It consists of a global probe network
that allows you to perform various network commands from anywhere.`
	        }, {
	          type: CONTENT_TYPE_DESCR,
	          content: 'The ability to make HTTP requests using curl from anywhere in the world makes the above scenarios even more interesting:'
	        }, {
	          type: CONTENT_TYPE_LIST,
	          content: ['Debug and troubleshoot regional issues with your website or server', 'Verify the availability and performance of your website or API from all over the world']
	        }, {
	          type: CONTENT_TYPE_DESCR,
	          content: `Let's explore some more use cases:`
	        }, {
	          type: CONTENT_TYPE_SUBHEADER,
	          content: `Test services from your user's perspective`
	        }, {
	          type: CONTENT_TYPE_DESCR,
	          content: `Imagine your users in ${locationName} are reporting unusual behavior from one of your API GET endpoints that you can't reproduce from your
location. To get to the bottom of the problem, you can start troubleshooting by running curl from ${locationName} using Globalping. By making a GET request,
you can retrieve the API response as seen by your users, helping you learn more about the problem and determine your next troubleshooting steps.`
	        }, {
	          type: CONTENT_TYPE_SUBHEADER,
	          content: 'Investigate censorship & content modification'
	        }, {
	          type: CONTENT_TYPE_DESCR,
	          content: `Another interesting way to use Globalping is to run curl from ${locationName} or any other location to learn about censorship or content
modification in that area. For example, you can make a HEAD request to check if a URL is accessible or perform a GET request to compare the content of a URL
with your local version, ensuring that it hasn't been changed.`
	        }, {
	          type: CONTENT_TYPE_DESCR,
	          content: `Globalping also provides performance metrics for each HTTP request, including the response time, content download time, time to first
byte, DNS resolution time, and the time taken to establish the TLS and TCP connection with the server. This allows you to run performance benchmarks and
comparisons from ${locationName}. Measure and understand the local and global latency of your service or the service providers you use, such as CDN, DNS, and
Edge computing companies.`
	        }]
	      };
	    },
	    testType() {
	      let selectedTestType = this.get('selectedTestType');
	      return selectedTestType ? selectedTestType.toLowerCase() : 'ping';
	    },
	    isLocationPresented() {
	      let locationData = this.get('locationData');
	      return locationData !== null && typeof locationData === 'object';
	    }
	  }
	};
	component$f.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "div",
	    m: [{
	      t: 13,
	      n: "class",
	      f: "c-gp-test-depiction",
	      g: 1
	    }],
	    f: [{
	      t: 4,
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "c-gp-test-depiction_test",
	          g: 1
	        }],
	        f: [{
	          t: 4,
	          f: [{
	            t: 4,
	            f: [{
	              t: 4,
	              f: [{
	                t: 7,
	                e: "span",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "c-gp-test-depiction_test_header",
	                  g: 1
	                }],
	                f: [{
	                  t: 2,
	                  r: "./content"
	                }]
	              }],
	              n: 50,
	              r: "isLocationPresented"
	            }, {
	              t: 4,
	              f: [{
	                t: 7,
	                e: "c-placeholder-skeleton",
	                m: [{
	                  n: "type",
	                  f: "header",
	                  t: 13,
	                  g: 1
	                }]
	              }],
	              n: 51,
	              l: 1
	            }],
	            n: 50,
	            x: {
	              r: ["./type"],
	              s: "_0===\"header\""
	            }
	          }, {
	            t: 4,
	            f: [{
	              t: 4,
	              f: [{
	                t: 7,
	                e: "span",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "c-gp-test-depiction_test_subheader",
	                  g: 1
	                }],
	                f: [{
	                  t: 2,
	                  r: "./content"
	                }]
	              }],
	              n: 50,
	              r: "isLocationPresented"
	            }, {
	              t: 4,
	              f: [{
	                t: 7,
	                e: "c-placeholder-skeleton",
	                m: [{
	                  n: "type",
	                  f: "subheader",
	                  t: 13,
	                  g: 1
	                }]
	              }],
	              n: 51,
	              l: 1
	            }, " "],
	            n: 50,
	            x: {
	              r: ["./type"],
	              s: "_0===\"subheader\""
	            },
	            l: 1
	          }, {
	            t: 4,
	            f: [" ", {
	              t: 4,
	              f: [{
	                t: 7,
	                e: "p",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "c-gp-test-depiction_test_descr",
	                  g: 1
	                }],
	                f: [{
	                  t: 2,
	                  r: "./content"
	                }]
	              }],
	              n: 50,
	              r: "isLocationPresented"
	            }, {
	              t: 4,
	              f: [{
	                t: 7,
	                e: "c-placeholder-skeleton",
	                m: [{
	                  n: "type",
	                  f: "descr",
	                  t: 13,
	                  g: 1
	                }]
	              }],
	              n: 51,
	              l: 1
	            }, " "],
	            n: 50,
	            x: {
	              r: ["./type"],
	              s: "_0===\"descr\""
	            },
	            l: 1
	          }, {
	            t: 4,
	            f: [" ", {
	              t: 4,
	              f: [{
	                t: 7,
	                e: "ul",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "c-gp-test-depiction_test_list",
	                  g: 1
	                }],
	                f: [{
	                  t: 4,
	                  f: [{
	                    t: 7,
	                    e: "li",
	                    f: [{
	                      t: 2,
	                      r: "."
	                    }]
	                  }],
	                  n: 52,
	                  r: "./content"
	                }]
	              }],
	              n: 50,
	              r: "isLocationPresented"
	            }, {
	              t: 4,
	              f: [{
	                t: 7,
	                e: "c-placeholder-skeleton",
	                m: [{
	                  n: "type",
	                  f: "list",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "content",
	                  f: [{
	                    t: 2,
	                    r: "./content"
	                  }],
	                  t: 13
	                }]
	              }],
	              n: 51,
	              l: 1
	            }],
	            n: 50,
	            x: {
	              r: ["./type"],
	              s: "_0===\"list\""
	            },
	            l: 1
	          }],
	          n: 52,
	          rx: {
	            r: "contentPerTestType",
	            m: [{
	              t: 30,
	              n: "testType"
	            }]
	          }
	        }]
	      }],
	      n: 50,
	      r: "testType"
	    }]
	  }],
	  e: {
	    "_0===\"header\"": function (_0) {
	      return _0 === "header";
	    },
	    "_0===\"subheader\"": function (_0) {
	      return _0 === "subheader";
	    },
	    "_0===\"descr\"": function (_0) {
	      return _0 === "descr";
	    },
	    "_0===\"list\"": function (_0) {
	      return _0 === "list";
	    }
	  }
	};
	component$f.exports.components = {
	  "c-placeholder-skeleton": placeholderSkeleton
	};
	var gpTestDepiction = ractive__default["default"].extend(component$f.exports);

	var component$e = {
	  exports: {}
	};
	const DEFAULT_LIMIT = 3;
	const INITIAL_OPTS_VALUES = {
	  type: 'Ping',
	  target: 'cdn.jsdelivr.net'
	};
	const CAPITALIZE_EXCLUDE_LIST = ['and', 'or', 'from', 'ltd', 'of'];
	const PROBE_NO_TIMING_VALUE = _.getProbeTimeOutValue();
	const PROBE_STATUS_OFFLINE = _.getProbeStatusOfflineValue();
	component$e.exports = {
	  data() {
	    return {
	      _,
	      title: '',
	      description: '',
	      selectedTestType: null,
	      displayingTestType: INITIAL_OPTS_VALUES.type,
	      btnTestType: INITIAL_OPTS_VALUES.type,
	      testTypesList: [{
	        name: 'Ping',
	        toDisplay: 'Ping'
	      }, {
	        name: 'Traceroute',
	        toDisplay: 'Traceroute'
	      }, {
	        name: 'DNS',
	        toDisplay: 'DNS resolve'
	      }, {
	        name: 'MTR',
	        toDisplay: 'MTR'
	      }, {
	        name: 'HTTP',
	        toDisplay: 'HTTP'
	      }],
	      testOpts: {
	        target: INITIAL_OPTS_VALUES.target,
	        limit: ''
	      },
	      inputErrors: {},
	      testResults: null,
	      testInProgress: false,
	      testReqInterval: null,
	      defaultTestLimit: DEFAULT_LIMIT,
	      probesResponse: null,
	      locationData: null,
	      totalProbesCnt: 0,
	      parsedLocations: {
	        cities: {},
	        asns: {},
	        networks: {},
	        countries: {},
	        continents: {},
	        regions: {}
	      },
	      highLevelLocationHref: null,
	      probesParsed: false,
	      testReqParams: null,
	      rawLocation: null,
	      rawLocationToDisplay: null,
	      allRequiredDataReady: false
	    };
	  },
	  onconfig() {
	    if (!ractive__default["default"].isServer) {
	      let title, description;
	      let {
	        rawTestType,
	        rawLocation,
	        rawLocationToDisplay
	      } = this.getInitialRawDataFromUrl();

	      // create temp title, descr before any checks, required by GA
	      title = this.createMetaTitle(rawTestType, rawLocationToDisplay);
	      description = this.createMetaDescr(rawTestType, rawLocationToDisplay);
	      this.set('title', title);
	      this.set('description', description);
	      this.set('selectedTestType', rawTestType);
	      this.set('rawLocation', rawLocation);
	      this.set('rawLocationToDisplay', rawLocationToDisplay);
	    }
	  },
	  oninit() {
	    if (!ractive__default["default"].isServer) {
	      this.getGlobalpingProbesData();
	      this.observe('selectedTestType', selectedTestType => {
	        if (selectedTestType) {
	          switch (selectedTestType.toLowerCase()) {
	            case 'mtr':
	            case 'http':
	              this.set('displayingTestType', selectedTestType.toUpperCase());
	              this.set('btnTestType', selectedTestType.toUpperCase());
	              break;
	            case 'dns':
	              this.set('displayingTestType', `${selectedTestType.toUpperCase()} resolve`);
	              this.set('btnTestType', selectedTestType.toUpperCase());
	              break;
	            default:
	              this.set('displayingTestType', _.capitalizeStrEveryFirstLetter(selectedTestType));
	              this.set('btnTestType', _.capitalizeStrEveryFirstLetter(selectedTestType));
	          }
	        }
	        this.set('inputErrors', {});
	        this.set('testResults', null);
	      });
	      this.observe('realTimeTestResResponse', realTimeTestResResponse => {
	        if (realTimeTestResResponse.status === 'finished') {
	          clearInterval(this.get('testReqInterval'));
	          this.set('testInProgress', false);
	        }
	        let prevTestResults = this.get('testResults') || [];
	        let updTestResults = realTimeTestResResponse.results.filter(res => {
	          // if it is no in-progress then it is already finished or failed and we could draw a marker
	          if (res.result.status !== 'in-progress') {
	            return true;
	          }
	          return false;
	        });

	        // filter out results that have already been drawn
	        let newTestResults = updTestResults.filter(updRes => {
	          return !prevTestResults.some(prevRes => JSON.stringify(prevRes) === JSON.stringify(updRes));
	        });
	        this.set('testResults', [...prevTestResults, ...newTestResults]);
	      }, {
	        init: false
	      });

	      // check if everything is already set and we can get LocationData etc.
	      this.observe('probesParsed selectedTestType rawLocation', () => {
	        let probesParsed = this.get('probesParsed');
	        let selectedTestType = this.get('selectedTestType');
	        let rawLocation = this.get('rawLocation');
	        if (probesParsed && selectedTestType && rawLocation) {
	          this.set('allRequiredDataReady', true);
	        } else {
	          this.set('allRequiredDataReady', false);
	        }
	      });

	      // create and set meta title, description; locationData, highLevelLocationHref
	      // check if location is correct or presented in the available probes locations
	      this.observe('allRequiredDataReady', allRequiredDataReady => {
	        if (allRequiredDataReady === false) {
	          return;
	        }
	        let selectedTestType = this.get('selectedTestType');
	        let rawLocation = this.get('rawLocation');

	        // handle locationData, highLevelLocationHref
	        if (rawLocation && rawLocation.toLowerCase() !== 'world') {
	          let locationData = this.getLocDataByLocValue(rawLocation);
	          if (locationData) {
	            // if both location and testType are correct and present
	            this.set('locationData', locationData);
	            this.set('highLevelLocationHref', `${commonjsGlobal.location.origin}${this.modifyQueryPart(selectedTestType, locationData.fromAsUrlPart)}`);
	          } else {
	            // when testType correct but location absent at the moment among the probes or incorrect
	            this.moveToNewPageURL(selectedTestType);
	            return;
	          }
	        } else {
	          this.set('locationData', {
	            from: 'World',
	            probesCnt: this.get('totalProbesCnt')
	          });
	          this.set('highLevelLocationHref', `${commonjsGlobal.location.origin}${this.modifyQueryPart(selectedTestType)}`);
	        }

	        // handle meta tag title and description once location is confirmed as presented
	        let locationData = this.getLocDataByLocValue(rawLocation);
	        let title = this.createMetaTitle(selectedTestType, locationData ? locationData.name : 'World');
	        let description = this.createMetaDescr(selectedTestType, locationData ? locationData.name : 'world');
	        this.set('title', title);
	        this.set('description', description);
	      });

	      // set measurementsMetadata for the c-gp-results-share component
	      this.observe('testReqParams', testReqParams => {
	        if (!testReqParams) {
	          return;
	        }
	        let measurementsMetadata = {
	          0: {
	            target: testReqParams.target,
	            measurementId: testReqParams.id
	          }
	        };
	        this.set('measurementsMetadata', measurementsMetadata);
	      });

	      // prepare results for gp-results-raw-output
	      this.observe('testResults', testResults => {
	        if (!testResults) {
	          return;
	        }
	        this.set('preparedTestResults', this.prepareRegularResults(testResults));
	      });
	    }
	  },
	  oncomplete() {
	    if (!ractive__default["default"].isServer) {
	      // run the test if user is pressed Enter inside of any of options inputs
	      let targetInput = this.find('#targetInput');
	      let limitInput = this.find('#limitInput');
	      let handleEnterBtn = event => {
	        if (event.key === 'Enter') {
	          event.preventDefault();
	          this.proceedToTest();
	        }
	      };
	      targetInput.addEventListener('keypress', handleEnterBtn);
	      limitInput.addEventListener('keypress', handleEnterBtn);
	    }
	  },
	  proceedToTest() {
	    let type = this.get('selectedTestType');
	    let testOpts = this.get('testOpts');
	    let {
	      name: magic = 'World'
	    } = this.get('locationData');
	    let reqParams = {
	      type,
	      ...testOpts,
	      locations: [{
	        magic
	      }]
	    };
	    if (!reqParams.limit) {
	      reqParams.limit = DEFAULT_LIMIT;
	    }

	    // clear all data from the previous test, show spinner
	    this.set('testResults', null);
	    this.set('testInProgress', true);
	    this.set('testReqParams', null);
	    http.postGlobalpingMeasurement(reqParams).then(response => {
	      this.getTestMeasurementById(response.id);
	    }).catch(err => {
	      if (err.error.type === 'validation_error') {
	        this.set('testInProgress', false);
	        let inputErrors = Object.keys(err.error.params).reduce((res, key) => {
	          let fieldName = key.split('.')[key.split('.').length - 1];
	          let errMsg = err.error.params[key].replace(/".*"/, fieldName);
	          res[key] = errMsg;
	          return res;
	        }, {});
	        this.set('inputErrors', inputErrors);
	      }
	    });
	  },
	  handleProbesResponse(isStored) {
	    return response => {
	      if (!isStored) {
	        sessionStorage.setItem('probesResponse', JSON.stringify(response));
	      } else {
	        response = JSON.parse(response);
	      }
	      this.set('parsedLocations', this.parseProbesResponse(response));
	      this.set('totalProbesCnt', response.length);
	      this.set('probesParsed', true);
	    };
	  },
	  parseProbesResponse(data) {
	    return data.reduce((res, _ref) => {
	      let {
	        location
	      } = _ref;
	      let cityNameLC = location.city.toLowerCase();
	      let cityNameAsUrlPart = cityNameLC.split(' ').join('-');
	      let countryCodeLC = location.country.toLowerCase();
	      let countryNameLC = countries.find(i => i.code.toLowerCase() === countryCodeLC).name.toLowerCase();
	      let countryNameAsUrlPart = countryNameLC.split(' ').join('-');
	      let asnName = `as${location.asn}`;
	      let networkNameAsKey = location.network.replace(/\./g, '').replace(/[\W]|_/g, ' ').replace(/\s\s+|_/g, ' ').trim().split(' ').join('-').toLowerCase();
	      let continentCodeLC = location.continent.toLowerCase();
	      let continentNameLC = CONTINENTS.find(i => i.code.toLowerCase() === continentCodeLC).name.toLowerCase();
	      let continentNameAsUrlPart = continentNameLC.split(' ').join('-');
	      let regionNameLC = location.region.toLowerCase();
	      let regionNameAsUrlPart = regionNameLC.split(' ').join('-');
	      let stateCodeLC = location.state ? location.state.toLowerCase() : null;
	      let stateNameLC = stateCodeLC ? usaStates.find(i => i.code.toLowerCase() === stateCodeLC).name.toLowerCase() : null;
	      let stateNameAsUrlPart = stateNameLC ? stateNameLC.split(' ').join('-') : null;

	      // collect uniques cities and count amount of probes per city
	      if (!Object.keys(res.cities).includes(cityNameAsUrlPart)) {
	        res.cities[cityNameAsUrlPart] = {
	          name: cityNameLC,
	          from: countries.find(i => i.code.toLowerCase() === countryCodeLC).name.toLowerCase(),
	          probesCnt: 1,
	          fromAsUrlPart: countryNameAsUrlPart
	        };
	      } else {
	        res.cities[cityNameAsUrlPart].probesCnt += 1;
	      }

	      // collect uniques ASNs and count amount of probes per ASN
	      if (!Object.keys(res.asns).includes(asnName)) {
	        res.asns[asnName] = {
	          name: asnName,
	          from: 'world',
	          probesCnt: 1,
	          fromAsUrlPart: 'world'
	        };
	      } else {
	        res.asns[asnName].probesCnt += 1;
	      }

	      // collect uniques Networks and count amount of probes per Network
	      if (!Object.keys(res.networks).includes(networkNameAsKey)) {
	        res.networks[networkNameAsKey] = {
	          name: location.network,
	          from: 'world',
	          probesCnt: 1,
	          fromAsUrlPart: 'world'
	        };
	      } else {
	        res.networks[networkNameAsKey].probesCnt += 1;
	      }

	      // collect uniques Countries and count amount of probes per Country
	      if (!Object.keys(res.countries).includes(countryNameAsUrlPart)) {
	        res.countries[countryNameAsUrlPart] = {
	          name: countryNameLC,
	          from: continentNameLC,
	          probesCnt: 1,
	          fromAsUrlPart: continentNameAsUrlPart
	        };
	      } else {
	        res.countries[countryNameAsUrlPart].probesCnt += 1;
	      }

	      // collect uniques Continents and count amount of probes per Continent
	      if (!Object.keys(res.continents).includes(continentNameAsUrlPart)) {
	        res.continents[continentNameAsUrlPart] = {
	          name: continentNameLC,
	          from: 'world',
	          probesCnt: 1,
	          fromAsUrlPart: 'world'
	        };
	      } else {
	        res.continents[continentNameAsUrlPart].probesCnt += 1;
	      }

	      // collect uniques Regions and count amount of probes per Region
	      if (!Object.keys(res.regions).includes(regionNameAsUrlPart)) {
	        res.regions[regionNameAsUrlPart] = {
	          name: regionNameLC,
	          from: 'world',
	          probesCnt: 1,
	          fromAsUrlPart: 'world'
	        };
	      } else {
	        res.regions[regionNameAsUrlPart].probesCnt += 1;
	      }

	      // collect uniques states (if they are present) and count amount of probes per state
	      if (stateNameAsUrlPart) {
	        if (!Object.keys(res.states).includes(stateNameAsUrlPart)) {
	          res.states[stateNameAsUrlPart] = {
	            name: stateNameLC,
	            from: countries.find(i => i.code.toLowerCase() === countryCodeLC).name.toLowerCase(),
	            probesCnt: 1,
	            fromAsUrlPart: countryNameAsUrlPart
	          };
	        } else {
	          res.states[stateNameAsUrlPart].probesCnt += 1;
	        }
	      }
	      return res;
	    }, {
	      cities: {},
	      asns: {},
	      networks: {},
	      countries: {},
	      continents: {},
	      regions: {},
	      states: {}
	    });
	  },
	  getLocDataByLocValue() {
	    let location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    let locationLC = location.toLowerCase();
	    let parsedLocations = this.get('parsedLocations');

	    // check if the location is a city
	    if (parsedLocations.cities[locationLC]) {
	      let {
	        name,
	        from,
	        probesCnt,
	        fromAsUrlPart
	      } = parsedLocations.cities[locationLC];
	      return {
	        name: _.capitalizeStrEveryFirstLetter(name),
	        from: _.capitalizeStrEveryFirstLetter(from),
	        probesCnt,
	        fromAsUrlPart,
	        type: 'city'
	      };
	    }

	    // check if the location is an ASN
	    if (parsedLocations.asns[locationLC]) {
	      let {
	        name,
	        from,
	        probesCnt,
	        fromAsUrlPart
	      } = parsedLocations.asns[locationLC];
	      return {
	        name: name.toUpperCase(),
	        from: _.capitalizeStrEveryFirstLetter(from),
	        probesCnt,
	        fromAsUrlPart,
	        type: 'asn'
	      };
	    }

	    // check if the location is a Network
	    if (parsedLocations.networks[locationLC]) {
	      let {
	        name,
	        from,
	        probesCnt,
	        fromAsUrlPart
	      } = parsedLocations.networks[locationLC];
	      return {
	        name,
	        from: _.capitalizeStrEveryFirstLetter(from),
	        probesCnt,
	        fromAsUrlPart,
	        type: 'isp'
	      };
	    }

	    // check if the location is a Country
	    if (parsedLocations.countries[locationLC]) {
	      let {
	        name,
	        from,
	        probesCnt,
	        fromAsUrlPart
	      } = parsedLocations.countries[locationLC];
	      return {
	        name: _.capitalizeStrEveryFirstLetter(name),
	        from: _.capitalizeStrEveryFirstLetter(from, CAPITALIZE_EXCLUDE_LIST),
	        probesCnt,
	        fromAsUrlPart,
	        type: 'country'
	      };
	    }

	    // check if the location is a Continent
	    if (parsedLocations.continents[locationLC]) {
	      let {
	        name,
	        from,
	        probesCnt,
	        fromAsUrlPart
	      } = parsedLocations.continents[locationLC];
	      return {
	        name: _.capitalizeStrEveryFirstLetter(name),
	        from: _.capitalizeStrEveryFirstLetter(from),
	        probesCnt,
	        fromAsUrlPart,
	        type: 'continent'
	      };
	    }

	    // check if the location is a Region
	    if (parsedLocations.regions[locationLC]) {
	      let {
	        name,
	        from,
	        probesCnt,
	        fromAsUrlPart
	      } = parsedLocations.regions[locationLC];
	      return {
	        name: _.capitalizeStrEveryFirstLetter(name),
	        from: _.capitalizeStrEveryFirstLetter(from),
	        probesCnt,
	        fromAsUrlPart,
	        type: 'region'
	      };
	    }

	    // check if the location is a State
	    if (parsedLocations.states[locationLC]) {
	      let {
	        name,
	        from,
	        probesCnt,
	        fromAsUrlPart
	      } = parsedLocations.states[locationLC];
	      return {
	        name: _.capitalizeStrEveryFirstLetter(name),
	        from: _.capitalizeStrEveryFirstLetter(from),
	        probesCnt,
	        fromAsUrlPart,
	        type: 'state'
	      };
	    }
	  },
	  getTestMeasurementById(measurementId) {
	    let testReqInterval = setInterval(() => {
	      http.getGlobalpingMeasurement(measurementId).then(testRes => {
	        // prepare and set request params to pass them to gp-test-results
	        let testReqParams = JSON.parse(JSON.stringify(testRes));
	        delete testReqParams.results;
	        delete testReqParams.status;
	        delete testReqParams.updatedAt;
	        delete testReqParams.createdAt;
	        testReqParams = {
	          inProgressUpdates: true,
	          limit: DEFAULT_LIMIT,
	          ...testReqParams,
	          measurementOptions: {
	            trace: false,
	            ...testReqParams.measurementOptions
	          }
	        };

	        // set testReqParams to pass them to c-gp-results-raw-output
	        this.set('testReqParams', testReqParams);

	        // should be after the mainOptions.type was set
	        this.set('realTimeTestResResponse', testRes);
	      }).catch(() => {
	        clearInterval(testReqInterval);
	      });
	    }, 1000);
	    this.set('testReqInterval', testReqInterval);
	  },
	  handleTestTypeSelect(testTypeName) {
	    this.set('selectedTestType', testTypeName);
	    let newPath = this.modifyQueryPart(testTypeName);
	    app.router.dispatch(newPath, {
	      noScroll: true
	    });
	  },
	  moveToNewPageURL(testType) {
	    let newLocation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'world';
	    let newPath = this.modifyQueryPart(testType, newLocation);
	    window.location.replace(newPath);
	  },
	  modifyQueryPart() {
	    let testType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'ping';
	    let newLocation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	    let newQueryTestFromValue = '';
	    if (newLocation) {
	      newQueryTestFromValue = `${testType}-from-${newLocation}`;
	    } else {
	      let splittedQueryTestFrom = app.router.uri.path.split('/');
	      let currQueryTestFromValue = splittedQueryTestFrom[splittedQueryTestFrom.length - 1];
	      newQueryTestFromValue = currQueryTestFromValue.replace(/[A-Za-z]+/, `${testType}`);
	    }
	    return `/network-tools/${newQueryTestFromValue.toLowerCase()}`;
	  },
	  getGlobalpingProbesData() {
	    // get probes from sessionStorage or fetch them
	    if (has$6.sessionStorage()) {
	      let probesResponse = sessionStorage.getItem('probesResponse');
	      if (probesResponse) {
	        this.handleProbesResponse(true)(probesResponse);
	      } else {
	        http.fetchGlobalpingProbes().then(this.handleProbesResponse(false));
	      }
	    } else {
	      http.fetchGlobalpingProbes().then(this.handleProbesResponse(false));
	    }
	  },
	  checkIfTestTypeCorrect(testType) {
	    if (!testType) {
	      return false;
	    }
	    let testTypesList = this.get('testTypesList');
	    return testTypesList.some(i => i.name.toLowerCase() === testType.toLowerCase());
	  },
	  createMetaTitle(testType, location) {
	    switch (testType.toLowerCase()) {
	      case 'dns':
	      case 'mtr':
	      case 'http':
	        testType = testType.toUpperCase();
	        break;
	      default:
	        testType = _.capitalizeFirstLetter(testType);
	    }
	    return `${testType} for free from ${location} - Global ${testType} tests by Globalping`;
	  },
	  createMetaDescr(testType, location) {
	    let description = `Run ${testType} network tests for free from multiple global regions`;
	    if (location.toLowerCase() !== 'world') {
	      description += ` like ${location}`;
	    }
	    description += ' to any endpoint including IP addresses, websites, CDN or cloud providers. Test the network latency and uptime regionally';
	    if (location.toLowerCase() !== 'world') {
	      description += ` in ${location}`;
	    }
	    description += ' or globally.';
	    return description;
	  },
	  prepareRegularResults(testResults) {
	    let dnsTraceEnabled = this.get('testReqParams.measurementOptions.trace');
	    let selectedTestType = this.get('selectedTestType');
	    return testResults.map(res => {
	      let preparedRes = {
	        ...res.probe,
	        statsPerTarget: [{
	          target: res.target
	        }]
	      };
	      if (res.result.status !== 'in-progress') {
	        let {
	          isFailed = false,
	          lastTiming,
	          value: avgTiming,
	          extraValues
	        } = _.calcGpTestResTiming(selectedTestType, res, dnsTraceEnabled);
	        let {
	          packetsTotal
	        } = _.parseGpRawOutputForTimings(res.result.rawOutput);
	        let minTiming = res.result?.stats?.min || PROBE_NO_TIMING_VALUE;
	        let maxTiming = res.result?.stats?.max || PROBE_NO_TIMING_VALUE;
	        let isOffline = res.result.status === PROBE_STATUS_OFFLINE;
	        preparedRes.statsPerTarget = [{
	          ...preparedRes.statsPerTarget[0],
	          avgTiming,
	          isFailed,
	          isOffline,
	          extraValues,
	          rawOutput: res.result.rawOutput,
	          areTimingsReady: this.checkAreTimingsReady(lastTiming, maxTiming, minTiming, avgTiming, packetsTotal)
	        }];
	      }
	      return preparedRes;
	    });
	  },
	  checkAreTimingsReady(lastTiming, maxTiming, minTiming, avgTiming, packetsTotal) {
	    if (!packetsTotal || typeof lastTiming === 'undefined' || typeof maxTiming === 'undefined' || typeof minTiming === 'undefined' || typeof avgTiming === 'undefined') {
	      return false;
	    }
	    return true;
	  },
	  getInitialRawDataFromUrl() {
	    let rawParamsValue = this.get('params');
	    let clearParamsValue = rawParamsValue.replace(/\/network-tools\/?/, '').toLowerCase();
	    let splitPoint = '-from-';
	    let splitPointIdx = clearParamsValue.indexOf(splitPoint);
	    let [rawTestType, rawLocation = 'world'] = splitPointIdx === -1 ? clearParamsValue.split(splitPoint) : [clearParamsValue.slice(0, splitPointIdx), clearParamsValue.slice(splitPointIdx + splitPoint.length)];
	    let rawLocationToDisplay = _.capitalizeStrEveryFirstLetter((rawLocation || 'world').split('-').join(' '), CAPITALIZE_EXCLUDE_LIST);
	    return {
	      rawTestType,
	      rawLocation,
	      rawLocationToDisplay
	    };
	  }
	};
	component$e.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "r-page",
	    m: [{
	      n: "noYield",
	      f: [{
	        t: 2,
	        r: "noYield"
	      }],
	      t: 13
	    }, {
	      n: "title",
	      f: [{
	        t: 2,
	        r: "title"
	      }],
	      t: 13
	    }, {
	      n: "description",
	      f: [{
	        t: 2,
	        r: "description"
	      }],
	      t: 13
	    }],
	    f: [{
	      t: 7,
	      e: "c-notification"
	    }, " ", {
	      t: 7,
	      e: "c-gp-header",
	      m: [{
	        n: "additionalClasses",
	        f: "header-with-globalping-bg",
	        t: 13,
	        g: 1
	      }]
	    }, " ", {
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "p-globalping-network-tools",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "gp-nettools_main-info",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "c-gp-jumbotron",
	          m: [{
	            n: "className",
	            f: "network-tools",
	            t: 13,
	            g: 1
	          }, {
	            n: "gridType",
	            f: "type2",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "gp-nettools_main-info_content",
	            g: 1
	          }],
	          f: [{
	            t: 4,
	            f: [{
	              t: 7,
	              e: "h1",
	              f: [{
	                t: 2,
	                r: "displayingTestType"
	              }, " from ", {
	                t: 4,
	                f: ["multiple locations in"],
	                n: 50,
	                r: "locationData.probesCnt"
	              }]
	            }, " ", {
	              t: 7,
	              e: "span",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "gp-nettools_main-info_content_location",
	                g: 1
	              }],
	              f: [{
	                t: 4,
	                f: [{
	                  t: 7,
	                  e: "span",
	                  f: [{
	                    t: 2,
	                    r: "locationData.name"
	                  }]
	                }],
	                n: 50,
	                r: "locationData.name"
	              }, " ", {
	                t: 4,
	                f: [{
	                  t: 4,
	                  f: [{
	                    t: 7,
	                    e: "span",
	                    f: [", "]
	                  }],
	                  n: 50,
	                  r: "locationData.name"
	                }, " ", {
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "gp-nettools_green-text",
	                    g: 1
	                  }, {
	                    n: "target",
	                    f: "_blank",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "rel",
	                    f: "noopener noreferrer",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "href",
	                    f: [{
	                      t: 2,
	                      r: "highLevelLocationHref"
	                    }],
	                    t: 13
	                  }],
	                  f: [{
	                    t: 2,
	                    r: "locationData.from"
	                  }]
	                }],
	                n: 51,
	                x: {
	                  r: ["locationData.type"],
	                  s: "_0===\"asn\"||_0===\"isp\""
	                }
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "gp-nettools_main-info_content_input-block",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "span",
	                f: ["Run a Free"]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "gp_dropdown_alt",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "btn-group",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "button",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "dropdown-toggle",
	                      g: 1
	                    }, {
	                      n: "type",
	                      f: "button",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "data-toggle",
	                      f: "dropdown",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "aria-haspopup",
	                      f: "true",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "aria-expanded",
	                      f: "false",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: [{
	                      t: 7,
	                      e: "span",
	                      f: [{
	                        t: 2,
	                        r: "~/displayingTestType"
	                      }]
	                    }, " ", {
	                      t: 7,
	                      e: "i",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "fa fa-angle-down",
	                        g: 1
	                      }, {
	                        n: "aria-hidden",
	                        f: "true",
	                        t: 13,
	                        g: 1
	                      }]
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "div",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "dropdown-menu",
	                      g: 1
	                    }],
	                    f: [{
	                      t: 4,
	                      f: [{
	                        t: 4,
	                        f: [{
	                          t: 7,
	                          e: "div",
	                          m: [{
	                            n: ["click"],
	                            t: 70,
	                            f: {
	                              r: ["@this", "./name"],
	                              s: "[_0.handleTestTypeSelect(_1)]"
	                            }
	                          }],
	                          f: [{
	                            t: 2,
	                            r: "./toDisplay"
	                          }]
	                        }],
	                        n: 50,
	                        x: {
	                          r: ["./toDisplay", "displayingTestType"],
	                          s: "_0!==_1"
	                        }
	                      }],
	                      n: 52,
	                      r: "~/testTypesList"
	                    }]
	                  }]
	                }]
	              }, " ", {
	                t: 7,
	                e: "span",
	                f: ["test"]
	              }]
	            }],
	            n: 50,
	            r: "locationData"
	          }, {
	            t: 4,
	            f: [{
	              t: 7,
	              e: "h1",
	              f: [{
	                t: 2,
	                r: "displayingTestType"
	              }, " from multiple locations in"]
	            }, " ", {
	              t: 7,
	              e: "span",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "gp-nettools_main-info_content_temp-location",
	                g: 1
	              }],
	              f: [{
	                t: 4,
	                f: [{
	                  t: 2,
	                  r: "rawLocationToDisplay"
	                }, ","],
	                n: 50,
	                x: {
	                  r: ["rawLocationToDisplay"],
	                  s: "_0.toLowerCase()!==\"world\""
	                }
	              }, " ", {
	                t: 7,
	                e: "a",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "gp-nettools_green-text",
	                  g: 1
	                }, {
	                  n: "target",
	                  f: "_blank",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "rel",
	                  f: "noopener noreferrer",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "href",
	                  f: [{
	                    t: 2,
	                    r: "global.location.origin"
	                  }, "/network-tools/", {
	                    t: 2,
	                    r: "selectedTestType"
	                  }, "-from-world"],
	                  t: 13
	                }],
	                f: ["World"]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "gp-nettools_main-info_content_input-block",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "span",
	                f: ["Run a Free"]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "gp_dropdown_alt",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "btn-group",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "button",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "dropdown-toggle",
	                      g: 1
	                    }, {
	                      n: "type",
	                      f: "button",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "data-toggle",
	                      f: "dropdown",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "aria-haspopup",
	                      f: "true",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "aria-expanded",
	                      f: "false",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: [{
	                      t: 7,
	                      e: "span",
	                      f: [{
	                        t: 2,
	                        r: "~/displayingTestType"
	                      }]
	                    }, " ", {
	                      t: 7,
	                      e: "i",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "fa fa-angle-down",
	                        g: 1
	                      }, {
	                        n: "aria-hidden",
	                        f: "true",
	                        t: 13,
	                        g: 1
	                      }]
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "div",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "dropdown-menu",
	                      g: 1
	                    }],
	                    f: [{
	                      t: 4,
	                      f: [{
	                        t: 4,
	                        f: [{
	                          t: 7,
	                          e: "div",
	                          m: [{
	                            n: ["click"],
	                            t: 70,
	                            f: {
	                              r: ["@this", "./name"],
	                              s: "[_0.handleTestTypeSelect(_1)]"
	                            }
	                          }],
	                          f: [{
	                            t: 2,
	                            r: "./toDisplay"
	                          }]
	                        }],
	                        n: 50,
	                        x: {
	                          r: ["./toDisplay", "displayingTestType"],
	                          s: "_0!==_1"
	                        }
	                      }],
	                      n: 52,
	                      r: "~/testTypesList"
	                    }]
	                  }]
	                }]
	              }, " ", {
	                t: 7,
	                e: "span",
	                f: ["test"]
	              }]
	            }],
	            n: 50,
	            r: "rawLocationToDisplay",
	            l: 1
	          }]
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "gp-nettools_demo-tools",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "gp-nettools_demo-tools_head",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "span"
	          }, " ", {
	            t: 7,
	            e: "span"
	          }, " ", {
	            t: 7,
	            e: "span"
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "gp-nettools_demo-tools_ctrls",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "c-controlled-input",
	            m: [{
	              n: "id",
	              f: "targetInput",
	              t: 13,
	              g: 1
	            }, {
	              n: "value",
	              f: [{
	                t: 2,
	                r: "testOpts.target"
	              }],
	              t: 13
	            }, {
	              n: "error",
	              f: [{
	                t: 2,
	                r: "inputErrors.target"
	              }],
	              t: 13
	            }, {
	              n: "placeholder",
	              f: "IP or host",
	              t: 13,
	              g: 1
	            }, {
	              n: "labelText",
	              f: "Target",
	              t: 13,
	              g: 1
	            }, {
	              n: "classList",
	              f: "gp-nettools_demo-tools_ctrls_target gp_input",
	              t: 13,
	              g: 1
	            }],
	            f: []
	          }, " ", {
	            t: 7,
	            e: "c-controlled-input",
	            m: [{
	              n: "id",
	              f: "limitInput",
	              t: 13,
	              g: 1
	            }, {
	              n: "value",
	              f: [{
	                t: 2,
	                r: "testOpts.limit"
	              }],
	              t: 13
	            }, {
	              n: "error",
	              f: [{
	                t: 2,
	                r: "inputErrors.limit"
	              }],
	              t: 13
	            }, {
	              n: "placeholder",
	              f: [{
	                t: 2,
	                r: "defaultTestLimit"
	              }],
	              t: 13
	            }, {
	              n: "labelText",
	              f: "Probes",
	              t: 13,
	              g: 1
	            }, {
	              n: "classList",
	              f: "gp-nettools_demo-tools_ctrls_probes gp_input",
	              t: 13,
	              g: 1
	            }],
	            f: []
	          }, " ", {
	            t: 7,
	            e: "button",
	            m: [{
	              n: ["click"],
	              t: 70,
	              f: {
	                r: ["@this"],
	                s: "[_0.proceedToTest()]"
	              }
	            }, {
	              n: "class",
	              f: ["gp-nettools_demo-tools_ctrls_btn gp_btn_green ", {
	                t: 4,
	                f: ["gp_btn_green_disabled gp_btn_green_loading"],
	                n: 50,
	                r: "testInProgress"
	              }],
	              t: 13
	            }, {
	              n: "disabled",
	              f: [{
	                t: 2,
	                r: "testInProgress"
	              }],
	              t: 13
	            }],
	            f: [{
	              t: 4,
	              f: [{
	                t: 7,
	                e: "div"
	              }, " ", {
	                t: 7,
	                e: "div"
	              }, " ", {
	                t: 7,
	                e: "div"
	              }, " ", {
	                t: 7,
	                e: "div"
	              }],
	              n: 50,
	              r: "testInProgress"
	            }, {
	              t: 4,
	              f: ["Run ", {
	                t: 2,
	                r: "btnTestType"
	              }, " Test"],
	              n: 51,
	              l: 1
	            }]
	          }]
	        }, " ", {
	          t: 4,
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp_map-block_demo-tools_fail-msg",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "img",
	              m: [{
	                n: "width",
	                f: "56",
	                t: 13,
	                g: 1
	              }, {
	                n: "height",
	                f: "56",
	                t: 13,
	                g: 1
	              }, {
	                n: "src",
	                f: [{
	                  t: 2,
	                  r: "@shared.assetsHost"
	                }, "/img/globalping/fail-icon-big.svg"],
	                t: 13
	              }]
	            }, " ", {
	              t: 7,
	              e: "p",
	              f: ["All tests failed. Maybe you specified a non existing endpoint?"]
	            }]
	          }],
	          n: 50,
	          r: "testFailed"
	        }, {
	          t: 4,
	          f: [{
	            t: 7,
	            e: "c-gp-results-raw-output",
	            m: [{
	              n: "testReqParams",
	              f: [{
	                t: 2,
	                r: "testReqParams"
	              }],
	              t: 13
	            }, {
	              n: "testInProgress",
	              f: [{
	                t: 2,
	                r: "testInProgress"
	              }],
	              t: 13
	            }, {
	              n: "measurementsMetadata",
	              f: [{
	                t: 2,
	                r: "measurementsMetadata"
	              }],
	              t: 13
	            }, {
	              n: "preparedTestResults",
	              f: [{
	                t: 2,
	                r: "preparedTestResults"
	              }],
	              t: 13
	            }, {
	              n: "activeTargetIdx",
	              f: "0",
	              t: 13,
	              g: 1
	            }],
	            f: []
	          }, " "],
	          n: 50,
	          r: "testResults",
	          l: 1
	        }, {
	          t: 4,
	          f: [" ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp-nettools_demo-tools_descr",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "img",
	              m: [{
	                n: "width",
	                f: "56",
	                t: 13,
	                g: 1
	              }, {
	                n: "height",
	                f: "56",
	                t: 13,
	                g: 1
	              }, {
	                n: "src",
	                f: [{
	                  t: 2,
	                  r: "@shared.assetsHost"
	                }, "/img/globalping/bulb-icon.svg"],
	                t: 13
	              }]
	            }, " ", {
	              t: 4,
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "gp-nettools_demo-tools_descr_text",
	                  g: 1
	                }],
	                f: ["Run a free global ", {
	                  t: 2,
	                  r: "displayingTestType"
	                }, " test! Benchmark and compare CDN and DNS providers to understand how their networks performs. Compare hosting and cloud providers to find the fastest one globally or in your region. Run ", {
	                  t: 2,
	                  r: "displayingTestType"
	                }, " tests from ", {
	                  t: 2,
	                  x: {
	                    r: ["locationData.name", "locationData.from"],
	                    s: "_0||_1"
	                  }
	                }, ", globally or from other locations or even cloud regions. Test, measure and troubleshoot your network for free using Globalping!"]
	              }],
	              n: 50,
	              r: "locationData"
	            }, {
	              t: 4,
	              f: [{
	                t: 7,
	                e: "c-placeholder-skeleton",
	                m: [{
	                  n: "type",
	                  f: "descr",
	                  t: 13,
	                  g: 1
	                }]
	              }],
	              n: 51,
	              l: 1
	            }]
	          }],
	          n: 51,
	          l: 1
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "gp-nettools_learn-how",
	          g: 1
	        }],
	        f: [{
	          t: 4,
	          f: [{
	            t: 7,
	            e: "span",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp-nettools_learn-how_title",
	              g: 1
	            }],
	            f: ["Explore how Globalping makes global network tests and benchmarking possible and free for all."]
	          }, " ", {
	            t: 7,
	            e: "span",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp-nettools_learn-how_descr",
	              g: 1
	            }],
	            f: ["Debug your web services and servers and understand and fix your routing by running network commands like ping from ", {
	              t: 2,
	              x: {
	                r: ["locationData.name", "locationData.from"],
	                s: "_0||_1"
	              }
	            }, " or any other location like a country or city."]
	          }],
	          n: 50,
	          r: "locationData"
	        }, {
	          t: 4,
	          f: [{
	            t: 7,
	            e: "c-placeholder-skeleton",
	            m: [{
	              n: "type",
	              f: "header",
	              t: 13,
	              g: 1
	            }]
	          }, " ", {
	            t: 7,
	            e: "c-placeholder-skeleton",
	            m: [{
	              n: "type",
	              f: "descr",
	              t: 13,
	              g: 1
	            }]
	          }],
	          n: 51,
	          l: 1
	        }, " ", {
	          t: 7,
	          e: "a",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "gp-nettools_learn-how_btn gp_btn_green",
	            g: 1
	          }, {
	            n: "href",
	            f: "/",
	            t: 13,
	            g: 1
	          }],
	          f: ["Learn more"]
	        }]
	      }, " ", {
	        t: 7,
	        e: "c-gp-test-depiction",
	        m: [{
	          n: "locationData",
	          f: [{
	            t: 2,
	            r: "locationData"
	          }],
	          t: 13
	        }, {
	          n: "selectedTestType",
	          f: [{
	            t: 2,
	            r: "selectedTestType"
	          }],
	          t: 13
	        }]
	      }]
	    }, " ", {
	      t: 7,
	      e: "c-gp-footer"
	    }]
	  }],
	  e: {
	    "_0===\"asn\"||_0===\"isp\"": function (_0) {
	      return _0 === "asn" || _0 === "isp";
	    },
	    "[_0.handleTestTypeSelect(_1)]": function (_0, _1) {
	      return [_0.handleTestTypeSelect(_1)];
	    },
	    "_0!==_1": function (_0, _1) {
	      return _0 !== _1;
	    },
	    "_0.toLowerCase()!==\"world\"": function (_0) {
	      return _0.toLowerCase() !== "world";
	    },
	    "[_0.proceedToTest()]": function (_0) {
	      return [_0.proceedToTest()];
	    },
	    "_0||_1": function (_0, _1) {
	      return _0 || _1;
	    }
	  }
	};
	component$e.exports.components = {
	  "c-placeholder-skeleton": placeholderSkeleton,
	  "c-gp-test-depiction": gpTestDepiction,
	  "c-gp-jumbotron": gpJumbotron,
	  "c-gp-results-raw-output": gpResultsRawOutput,
	  "c-controlled-input": controlledInput,
	  "c-notification": notification,
	  "c-gp-footer": gpFooter,
	  "c-gp-header": gpHeader,
	  "r-page": rPageGlobalping
	};
	var networkTools = ractive__default["default"].extend(component$e.exports);

	var component$d = {
	  exports: {}
	};
	component$d.exports = {
	  data() {
	    return {
	      defaultLinkText: 'Learn more',
	      defaultImgW: '24',
	      defaultImgH: '24'
	    };
	  }
	};
	component$d.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "div",
	    m: [{
	      t: 13,
	      n: "class",
	      f: "c-tiles c-tiles-community",
	      g: 1
	    }],
	    f: [{
	      t: 4,
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          n: "class",
	          f: ["c-tiles_tile ", {
	            t: 4,
	            f: ["disabled"],
	            n: 50,
	            r: "status"
	          }],
	          t: 13
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "c-tiles_tile_header",
	            g: 1
	          }],
	          f: [{
	            t: 2,
	            r: "header"
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            n: "class",
	            f: ["c-tiles_tile_img ", {
	              t: 2,
	              r: "imgClass"
	            }],
	            t: 13
	          }],
	          f: [{
	            t: 7,
	            e: "img",
	            m: [{
	              n: "width",
	              f: [{
	                t: 2,
	                x: {
	                  r: ["imgW", "defaultImgW"],
	                  s: "_0||_1"
	                }
	              }],
	              t: 13
	            }, {
	              n: "height",
	              f: [{
	                t: 2,
	                x: {
	                  r: ["imgH", "defaultImgH"],
	                  s: "_0||_1"
	                }
	              }],
	              t: 13
	            }, {
	              n: "src",
	              f: [{
	                t: 2,
	                r: "@shared.assetsHost"
	              }, {
	                t: 2,
	                r: "baseImgSrc"
	              }, "/", {
	                t: 2,
	                r: "imgName"
	              }, {
	                t: 2,
	                r: "imgExt"
	              }],
	              t: 13
	            }]
	          }, " ", {
	            t: 7,
	            e: "span",
	            f: [{
	              t: 2,
	              r: "authorName"
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "c-tiles_tile_descr",
	            g: 1
	          }],
	          f: [{
	            t: 2,
	            r: "descr"
	          }]
	        }, " ", {
	          t: 7,
	          e: "a",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "c-tiles_tile_link",
	            g: 1
	          }, {
	            n: "href",
	            f: [{
	              t: 2,
	              r: "href"
	            }],
	            t: 13
	          }, {
	            t: 4,
	            f: [{
	              n: "target",
	              f: "_blank",
	              t: 13
	            }, {
	              n: "rel",
	              f: "noopener noreferrer",
	              t: 13
	            }],
	            n: 50,
	            r: "externalLink"
	          }],
	          f: [{
	            t: 2,
	            r: "defaultLinkText"
	          }]
	        }]
	      }],
	      n: 52,
	      r: "tilesData"
	    }]
	  }],
	  e: {
	    "_0||_1": function (_0, _1) {
	      return _0 || _1;
	    }
	  }
	};
	var tilesCommunity = ractive__default["default"].extend(component$d.exports);

	var component$c = {
	  exports: {}
	};
	component$c.exports = {
	  data() {
	    return {
	      defaultLinkText: 'Learn more',
	      defaultImgW: '48',
	      defaultImgH: '48'
	    };
	  }
	};
	component$c.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "div",
	    m: [{
	      t: 13,
	      n: "class",
	      f: "c-tiles",
	      g: 1
	    }],
	    f: [{
	      t: 4,
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          n: "class",
	          f: ["c-tiles_tile ", {
	            t: 4,
	            f: ["disabled"],
	            n: 50,
	            r: "status"
	          }],
	          t: 13
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "c-tiles_tile_img",
	            g: 1
	          }, {
	            n: "class",
	            f: [{
	              t: 2,
	              r: "imgClass"
	            }],
	            t: 13
	          }],
	          f: [{
	            t: 7,
	            e: "img",
	            m: [{
	              n: "width",
	              f: [{
	                t: 2,
	                x: {
	                  r: ["imgW", "defaultImgW"],
	                  s: "_0||_1"
	                }
	              }],
	              t: 13
	            }, {
	              n: "height",
	              f: [{
	                t: 2,
	                x: {
	                  r: ["imgH", "defaultImgH"],
	                  s: "_0||_1"
	                }
	              }],
	              t: 13
	            }, {
	              n: "src",
	              f: [{
	                t: 2,
	                r: "@shared.assetsHost"
	              }, {
	                t: 2,
	                r: "baseImgSrc"
	              }, "/", {
	                t: 2,
	                r: "imgName"
	              }, {
	                t: 2,
	                r: "imgExt"
	              }],
	              t: 13
	            }, {
	              t: 4,
	              f: [{
	                n: "srcset",
	                f: [{
	                  t: 2,
	                  r: "@shared.assetsHost"
	                }, {
	                  t: 2,
	                  r: "baseImgSrc"
	                }, "/", {
	                  t: 2,
	                  r: "imgName"
	                }, "@2x", {
	                  t: 2,
	                  r: "imgExt"
	                }, " 2x"],
	                t: 13
	              }],
	              n: 50,
	              x: {
	                r: ["imgExt"],
	                s: "_0===\".png\""
	              }
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "c-tiles_tile_header",
	            g: 1
	          }],
	          f: [{
	            t: 2,
	            r: "header"
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "c-tiles_tile_descr",
	            g: 1
	          }],
	          f: [{
	            t: 2,
	            r: "descr"
	          }]
	        }, " ", {
	          t: 4,
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "c-tiles_tile_status",
	              g: 1
	            }],
	            f: [{
	              t: 2,
	              r: "status"
	            }]
	          }],
	          n: 50,
	          r: "status"
	        }, {
	          t: 4,
	          f: [{
	            t: 7,
	            e: "a",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "c-tiles_tile_link",
	              g: 1
	            }, {
	              n: "href",
	              f: [{
	                t: 2,
	                r: "href"
	              }],
	              t: 13
	            }, {
	              t: 4,
	              f: [{
	                n: "target",
	                f: "_blank",
	                t: 13
	              }, {
	                n: "rel",
	                f: "noopener noreferrer",
	                t: 13
	              }],
	              n: 50,
	              r: "externalLink"
	            }],
	            f: [{
	              t: 2,
	              r: "defaultLinkText"
	            }]
	          }],
	          n: 51,
	          l: 1
	        }]
	      }],
	      n: 52,
	      r: "tilesData"
	    }]
	  }],
	  e: {
	    "_0||_1": function (_0, _1) {
	      return _0 || _1;
	    },
	    "_0===\".png\"": function (_0) {
	      return _0 === ".png";
	    }
	  }
	};
	var tiles = ractive__default["default"].extend(component$c.exports);

	var component$b = {
	  exports: {}
	};
	component$b.exports = {
	  data() {
	    return {
	      title: 'Globalping Integrations - Power up your tools and apps by giving them access to Globalping',
	      description: 'Learn how to interact with our global network of probes and add network testing functionality to your tools and apps.',
	      gpTiles: [{
	        header: 'REST API',
	        descr: 'Build your own free and commercial tools and services using our flexible and powerful API.',
	        href: '/docs/api.globalping.io',
	        baseImgSrc: '/img/globalping/integrations',
	        imgName: 'rest',
	        imgExt: '.png',
	        imgClass: 'img-rounded'
	      }, {
	        header: 'CLI/Scripting',
	        descr: 'Our CLI tool makes it simple to script and automate any kind of actions and tests.',
	        href: '/cli',
	        baseImgSrc: '/img/globalping/integrations',
	        imgName: 'bash',
	        imgExt: '.svg',
	        imgClass: 'img-with-border'
	      }, {
	        header: 'Slack',
	        descr: 'Our official Slack app allows your whole team to collaborate and run network tests in any channel and thread.',
	        href: '/slack',
	        baseImgSrc: '/img/globalping/integrations',
	        imgName: 'slack',
	        imgExt: '.png'
	      }, {
	        header: 'Zapier',
	        descr: 'Build advanced automations without writing any code with our Zapier app.',
	        href: 'https://zapier.com/apps/globalping/integrations',
	        baseImgSrc: '/img/globalping/integrations',
	        imgName: 'zapier',
	        imgExt: '.png',
	        externalLink: true
	      }, {
	        header: 'n8n node',
	        descr: 'Add Globalping to your n8n workflows and get access to thousands of probes',
	        href: 'https://www.npmjs.com/package/@globalping/n8n-nodes-globalping',
	        baseImgSrc: '/img/globalping/integrations',
	        imgName: 'n8n',
	        imgExt: '.svg',
	        imgW: 40,
	        imgH: 40,
	        imgClass: 'img-with-border',
	        externalLink: true
	      }, {
	        header: 'GitHub Bot',
	        descr: 'Interact with the Globalping network in GitHub comments for quick and simple tests.',
	        href: 'https://github.com/globalping',
	        baseImgSrc: '/img/globalping/integrations',
	        imgName: 'gh-bot',
	        imgExt: '.png',
	        externalLink: true
	      }, {
	        header: 'ChatGPT',
	        descr: 'Let ChatGPT do the testing for you.',
	        href: '/',
	        baseImgSrc: '/img/globalping/integrations',
	        imgName: 'chatgpt',
	        imgExt: '.png',
	        status: 'Coming soon'
	      }, {
	        header: 'IFTTT',
	        descr: 'Make Globalping part of your flow with our IFTTT integration.',
	        href: '/',
	        baseImgSrc: '/img/globalping/integrations',
	        imgName: 'ifttt',
	        imgExt: '.png',
	        status: 'Coming soon'
	      }, {
	        header: 'GitHub Action',
	        descr: 'Automate tests and make Globalping part of your CI to ensure your network is available and fast.',
	        href: '/',
	        baseImgSrc: '/img/globalping/integrations',
	        imgName: 'gh-action',
	        imgExt: '.png',
	        status: 'Coming soon'
	      }, {
	        header: 'NetBox',
	        descr: 'Interact with Globalping without ever leaving NetBox',
	        href: '/',
	        baseImgSrc: '/img/globalping/integrations',
	        imgName: 'netbox',
	        imgExt: '.png',
	        status: 'Coming soon'
	      }],
	      communityTiles: [{
	        header: 'Home Assistant Addon',
	        descr: 'Run a Globalping probe with Home Assistant',
	        authorName: 'Erwin Willems',
	        href: 'https://github.com/erwin-willems/hassio-addons',
	        baseImgSrc: '/img/globalping/integrations',
	        imgName: 'community/home-assistant',
	        imgExt: '.jpeg',
	        imgClass: 'img-rounded-with-author',
	        externalLink: true
	      }, {
	        header: 'Globalping TS/JS Library',
	        descr: 'Typescript and JavaScript API wrapper',
	        authorName: 'eyepokes',
	        href: 'https://github.com/eyepokes/globalping-ts',
	        baseImgSrc: '/img/globalping/integrations',
	        imgName: 'community/globalping-ts',
	        imgExt: '.jpeg',
	        imgClass: 'img-rounded-with-author',
	        externalLink: true
	      }, {
	        header: 'Globalping Java Client Library',
	        descr: 'Java library with Maven and Gradle',
	        authorName: 'nick9822',
	        href: 'https://github.com/nick9822/globalping-java',
	        baseImgSrc: '/img/globalping/integrations',
	        imgName: 'community/gp-java-cli-lib',
	        imgExt: '.jpeg',
	        imgClass: 'img-rounded-with-author',
	        externalLink: true
	      }, {
	        header: 'Globalping Python Library',
	        descr: 'Globalping Python library for easy scripting',
	        authorName: 'HackedServer',
	        href: 'https://github.com/HackedServer/libglobalping-unofficial',
	        baseImgSrc: '/img/globalping/integrations',
	        imgName: 'community/unofficial-gp-python-lib',
	        imgExt: '.png',
	        imgClass: 'img-rounded-with-author',
	        externalLink: true
	      }]
	    };
	  }
	};
	component$b.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "r-page",
	    m: [{
	      n: "noYield",
	      f: [{
	        t: 2,
	        r: "noYield"
	      }],
	      t: 13
	    }, {
	      n: "title",
	      f: [{
	        t: 2,
	        r: "title"
	      }],
	      t: 13
	    }, {
	      n: "description",
	      f: [{
	        t: 2,
	        r: "description"
	      }],
	      t: 13
	    }],
	    f: [{
	      t: 7,
	      e: "c-notification"
	    }, " ", {
	      t: 7,
	      e: "c-gp-header",
	      m: [{
	        n: "additionalClasses",
	        f: "header-with-globalping-bg",
	        t: 13,
	        g: 1
	      }]
	    }, " ", {
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "p-globalping-integrations",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "p-globalping-integrations_header",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "h1",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "p-globalping-integrations_header_title",
	            g: 1
	          }],
	          f: ["Globalping Integrations"]
	        }, " ", {
	          t: 7,
	          e: "h2",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "p-globalping-integrations_header_descr",
	            g: 1
	          }],
	          f: ["A fully-featured REST API for your own app, easy-to-use CLI for scripting, or a no-code chatbot – we have it all. Integrate Globalping into anything!"]
	        }]
	      }, " ", {
	        t: 7,
	        e: "c-tiles",
	        m: [{
	          n: "tilesData",
	          f: [{
	            t: 2,
	            r: "gpTiles"
	          }],
	          t: 13
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "p-globalping-integrations_header",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "h1",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "p-globalping-integrations_header_title",
	            g: 1
	          }],
	          f: ["Community Integrations"]
	        }, " ", {
	          t: 7,
	          e: "h2",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "p-globalping-integrations_header_descr",
	            g: 1
	          }],
	          f: ["Unofficial integrations built and supported by the amazing Globalping community!"]
	        }]
	      }, " ", {
	        t: 7,
	        e: "c-tiles-community",
	        m: [{
	          n: "tilesData",
	          f: [{
	            t: 2,
	            r: "communityTiles"
	          }],
	          t: 13
	        }]
	      }]
	    }, " ", {
	      t: 7,
	      e: "c-gp-footer"
	    }]
	  }]
	};
	component$b.exports.components = {
	  "c-tiles-community": tilesCommunity,
	  "c-tiles": tiles,
	  "c-notification": notification,
	  "c-gp-footer": gpFooter,
	  "c-gp-header": gpHeader,
	  "r-page": rPageGlobalping
	};
	var integrations = ractive__default["default"].extend(component$b.exports);

	var component$a = {
	  exports: {}
	};
	component$a.exports = {
	  data() {
	    return {
	      title: 'About - Globalping',
	      description: 'Globalping is a free, open-source platform for network testing and monitoring. Run network-related commands in real-time from any location in the world. Test your web services, APIs, CDNs, DNS and edge compute services.',
	      totalProbes: 0,
	      totalCities: 0,
	      totalCountries: 0,
	      totalMeasurements: 0,
	      totalASNs: 0,
	      responseTime: 0,
	      collaborators: [{
	        title: 'Core Team',
	        data: [{
	          name: 'Dmitriy Akulov',
	          position: 'Founder',
	          imgSrc: '/img/about/dmitriy-akulov.png',
	          imgSrc2: '/img/about/dmitriy-akulov@2x.png 2x',
	          social: {
	            url: 'https://twitter.com/jimaek',
	            imgSrc: '/img/about/twitter-icon.svg'
	          }
	        }, {
	          name: 'Martin Kolarik',
	          position: 'Core Developer',
	          imgSrc: '/img/about/martin-kolarik.png',
	          imgSrc2: '/img/about/martin-kolarik@2x.png 2x',
	          social: {
	            url: 'https://twitter.com/makolarik',
	            imgSrc: '/img/about/twitter-icon.svg'
	          }
	        }, {
	          name: 'Alexey Yarmosh',
	          position: 'Software Engineer',
	          imgSrc: '/img/globalping/about/alexey-yarmosh.jpeg',
	          social: {
	            url: 'https://www.linkedin.com/in/alexey-yarmosh/',
	            imgSrc: '/img/about/linkedin-icon.svg'
	          }
	        }]
	      }, {
	        title: 'Frequent Contributors',
	        data: [{
	          name: 'Artem Stoianov',
	          position: 'Developer',
	          imgSrc: '/img/about/artem-stoianov.png',
	          imgSrc2: '/img/about/artem-stoianov@2x.png 2x',
	          social: {
	            url: 'https://twitter.com/zarianec',
	            imgSrc: '/img/about/twitter-icon.svg'
	          }
	        }, {
	          name: 'Kyrylo Chyzhov',
	          position: 'Developer',
	          imgSrc: '/img/globalping/about/kyrylo-chyzhov.jpeg',
	          social: {
	            url: 'https://www.linkedin.com/in/kyrylo-chyzhov-092ab7107',
	            imgSrc: '/img/about/linkedin-icon.svg'
	          }
	        }, {
	          name: 'Robert Zygmuntowski',
	          position: 'UI/UX Designer',
	          imgSrc: '/img/globalping/about/robert-zygmuntowski.jpeg',
	          social: {
	            url: 'https://www.linkedin.com/in/robert-zygmuntowski-144865a9',
	            imgSrc: '/img/about/linkedin-icon.svg'
	          }
	        }]
	      }]
	    };
	  },
	  oninit() {
	    if (!ractive__default["default"].isServer) {
	      this.getProbesData();
	    }
	  },
	  handleProbesResponse(isStored) {
	    return response => {
	      if (!isStored) {
	        sessionStorage.setItem('probesResponse', JSON.stringify(response));
	      } else {
	        response = JSON.parse(response);
	      }
	      let {
	        totalCities,
	        totalCountries,
	        totalASNs
	      } = response.reduce((res, item) => {
	        if (!res.citiesList.includes(item.location.city)) {
	          res.citiesList.push(item.location.city);
	        }
	        if (!res.countriesList.includes(item.location.country)) {
	          res.countriesList.push(item.location.country);
	        }
	        if (!res.ASNsList.includes(item.location.asn)) {
	          res.ASNsList.push(item.location.asn);
	        }
	        res.totalCities = res.citiesList.length;
	        res.totalCountries = res.countriesList.length;
	        res.totalASNs = res.ASNsList.length;
	        return res;
	      }, {
	        citiesList: [],
	        countriesList: [],
	        ASNsList: [],
	        totalCities: 0,
	        totalCountries: 0,
	        totalASNs: 0
	      });
	      this.animate('totalProbes', response.length, {
	        duration: 2000
	      });
	      this.animate('totalCities', totalCities, {
	        duration: 2000
	      });
	      this.animate('totalCountries', totalCountries, {
	        duration: 2000
	      });
	      this.animate('totalASNs', totalASNs, {
	        duration: 2000
	      });

	      // TODO: 670 temp as static values
	      this.animate('totalMeasurements', 300, {
	        duration: 2000
	      });
	      this.animate('responseTime', 14, {
	        duration: 2000
	      });
	    };
	  },
	  getProbesData() {
	    if (has$6.sessionStorage()) {
	      let probesResponse = sessionStorage.getItem('probesResponse');
	      if (probesResponse) {
	        this.handleProbesResponse(true)(probesResponse);
	      } else {
	        http.fetchGlobalpingProbes().then(this.handleProbesResponse(false));
	      }
	    } else {
	      http.fetchGlobalpingProbes().then(this.handleProbesResponse(false));
	    }
	  }
	};
	component$a.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "r-page",
	    m: [{
	      n: "noYield",
	      f: [{
	        t: 2,
	        r: "noYield"
	      }],
	      t: 13
	    }, {
	      n: "title",
	      f: [{
	        t: 2,
	        r: "title"
	      }],
	      t: 13
	    }, {
	      n: "description",
	      f: [{
	        t: 2,
	        r: "description"
	      }],
	      t: 13
	    }],
	    f: [{
	      t: 7,
	      e: "c-notification"
	    }, " ", {
	      t: 7,
	      e: "c-gp-header",
	      m: [{
	        n: "additionalClasses",
	        f: "gp-about-us-header",
	        t: 13,
	        g: 1
	      }, {
	        n: "mainLogoName",
	        f: "globalping-full-white.svg",
	        t: 13,
	        g: 1
	      }]
	    }, " ", {
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "p-globalping-about",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "c-gp-jumbotron",
	        m: [{
	          n: "className",
	          f: "about-us",
	          t: 13,
	          g: 1
	        }, {
	          n: "gridType",
	          f: "type3",
	          t: 13,
	          g: 1
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "gp-about",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "gp-about_info",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp-about_info_title",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "span",
	              f: ["Globalping"]
	            }, " ", {
	              t: 7,
	              e: "span",
	              f: ["A globally distributed network of probes or network vantage points"]
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp-about_info_descr",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "span",
	              f: ["Globalping is a free, open-source platform for network testing and monitoring. At its core is a robust API that can schedule and run network-related commands in real-time from any location in the world."]
	            }, " ", {
	              t: 7,
	              e: "span",
	              f: ["It's a simple and secure way to test your web services, APIs, CDNs, DNS and edge compute services, to ensure their global availability, and understand their latency and performance on a global scale."]
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp-about_info_focus",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "span",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "gp-about_info_focus_title",
	                g: 1
	              }],
	              f: ["We’re focused on:"]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "gp-about_info_focus_list",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "gp-about_info_focus_list_item",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "img",
	                  m: [{
	                    n: "width",
	                    f: "58",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "58",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "src",
	                    f: [{
	                      t: 2,
	                      r: "@shared.assetsHost"
	                    }, "/img/globalping/globalping-performance-icon.svg"],
	                    t: 13
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "span",
	                  f: ["Performance"]
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "gp-about_info_focus_list_item",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "img",
	                  m: [{
	                    n: "width",
	                    f: "58",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "58",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "src",
	                    f: [{
	                      t: 2,
	                      r: "@shared.assetsHost"
	                    }, "/img/globalping/globalping-ux-icon.svg"],
	                    t: 13
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "span",
	                  f: ["User Experience"]
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "gp-about_info_focus_list_item",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "img",
	                  m: [{
	                    n: "width",
	                    f: "58",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "58",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "src",
	                    f: [{
	                      t: 2,
	                      r: "@shared.assetsHost"
	                    }, "/img/globalping/globalping-security-icon.svg"],
	                    t: 13
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "span",
	                  f: ["Security"]
	                }]
	              }]
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "gp-about_in-numbers",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "h2",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp-about_title",
	              g: 1
	            }],
	            f: ["Globalping in numbers"]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp-about_in-numbers_list",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "gp-about_in-numbers_list_block",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "gp-about_in-numbers_list_block_item",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "span",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "gp-about_in-numbers_list_block_item_name",
	                    g: 1
	                  }],
	                  f: ["Eyeball and DC"]
	                }, " ", {
	                  t: 7,
	                  e: "span",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "gp-about_in-numbers_list_block_item_value",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 2,
	                    x: {
	                      r: ["totalProbes"],
	                      s: "Math.floor(_0)"
	                    }
	                  }, {
	                    t: 4,
	                    f: ["+"],
	                    n: 50,
	                    r: "totalProbes"
	                  }, " probes"]
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "gp-about_in-numbers_list_block_item",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "span",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "gp-about_in-numbers_list_block_item_name",
	                    g: 1
	                  }],
	                  f: ["Unique and global"]
	                }, " ", {
	                  t: 7,
	                  e: "span",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "gp-about_in-numbers_list_block_item_value",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 2,
	                    x: {
	                      r: ["totalCities"],
	                      s: "Math.floor(_0)"
	                    }
	                  }, {
	                    t: 4,
	                    f: ["+"],
	                    n: 50,
	                    r: "totalCities"
	                  }, " cities"]
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "gp-about_in-numbers_list_block_item",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "span",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "gp-about_in-numbers_list_block_item_name",
	                    g: 1
	                  }],
	                  f: ["Every day"]
	                }, " ", {
	                  t: 7,
	                  e: "span",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "gp-about_in-numbers_list_block_item_value",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 2,
	                    x: {
	                      r: ["totalMeasurements"],
	                      s: "Math.floor(_0)"
	                    }
	                  }, {
	                    t: 4,
	                    f: ["k+"],
	                    n: 50,
	                    r: "totalMeasurements"
	                  }, " measurements"]
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "gp-about_in-numbers_list_block",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "gp-about_in-numbers_list_block_item",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "span",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "gp-about_in-numbers_list_block_item_name",
	                    g: 1
	                  }],
	                  f: ["Global ISP reach"]
	                }, " ", {
	                  t: 7,
	                  e: "span",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "gp-about_in-numbers_list_block_item_value",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 2,
	                    x: {
	                      r: ["totalASNs"],
	                      s: "Math.floor(_0)"
	                    }
	                  }, {
	                    t: 4,
	                    f: ["+"],
	                    n: 50,
	                    r: "totalASNs"
	                  }, " ASNs"]
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "gp-about_in-numbers_list_block_item",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "span",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "gp-about_in-numbers_list_block_item_name",
	                    g: 1
	                  }],
	                  f: ["And growing"]
	                }, " ", {
	                  t: 7,
	                  e: "span",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "gp-about_in-numbers_list_block_item_value",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 2,
	                    x: {
	                      r: ["totalCountries"],
	                      s: "Math.floor(_0)"
	                    }
	                  }, {
	                    t: 4,
	                    f: ["+"],
	                    n: 50,
	                    r: "totalCountries"
	                  }, " countries"]
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "gp-about_in-numbers_list_block_item",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "span",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "gp-about_in-numbers_list_block_item_name",
	                    g: 1
	                  }],
	                  f: ["Low latency API"]
	                }, " ", {
	                  t: 7,
	                  e: "span",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "gp-about_in-numbers_list_block_item_value",
	                    g: 1
	                  }],
	                  f: ["<", {
	                    t: 2,
	                    x: {
	                      r: ["responseTime"],
	                      s: "Math.floor(_0)"
	                    }
	                  }, {
	                    t: 4,
	                    f: ["ms"],
	                    n: 50,
	                    r: "totalCountries"
	                  }, " response time"]
	                }]
	              }]
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "gp-about_prod-ready",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "h2",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp-about_title",
	              g: 1
	            }],
	            f: ["Ready for production"]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp-about_prod-ready_list",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "span",
	              f: ["From solo developers to enterprises - our platform is designed as one-size-fits-all."]
	            }, " ", {
	              t: 7,
	              e: "span",
	              f: ["We aim to ensure the service remains useful to the majority of users for free, while heavier users and enterprise companies pay their fair share and help us develop a high quality service."]
	            }, " ", {
	              t: 7,
	              e: "span",
	              f: ["Volentio Group proudly supports Globalping by funding the core team and providing governance to ensure the project's success for the public good."]
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "gp-about_people-behind",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "h2",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp-about_title",
	              g: 1
	            }],
	            f: ["The people behind"]
	          }, " ", {
	            t: 7,
	            e: "p",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp-about_people-behind_descr",
	              g: 1
	            }],
	            f: ["These people currently run or previously helped with running this project. Want to join them? We are always looking for help!"]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp-about_people-behind_wrapper",
	              g: 1
	            }],
	            f: [{
	              t: 4,
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "gp-about_people-behind_wrapper_collaborators",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "h3",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "gp-about_people-behind_wrapper_collaborators_title",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 2,
	                    r: "./title"
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "gp-about_people-behind_wrapper_collaborators_list",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 4,
	                    f: [{
	                      t: 7,
	                      e: "div",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "gp-about_people-behind_wrapper_collaborators_list_item",
	                        g: 1
	                      }],
	                      f: [{
	                        t: 7,
	                        e: "div",
	                        m: [{
	                          t: 13,
	                          n: "class",
	                          f: "gp-about_people-behind_wrapper_collaborators_list_item_img-wrapper",
	                          g: 1
	                        }],
	                        f: [{
	                          t: 7,
	                          e: "img",
	                          m: [{
	                            n: "width",
	                            f: "48",
	                            t: 13,
	                            g: 1
	                          }, {
	                            n: "height",
	                            f: "48",
	                            t: 13,
	                            g: 1
	                          }, {
	                            n: "src",
	                            f: [{
	                              t: 2,
	                              r: "@shared.assetsHost"
	                            }, {
	                              t: 2,
	                              r: "./imgSrc"
	                            }],
	                            t: 13
	                          }, {
	                            t: 4,
	                            f: [{
	                              n: "srcset",
	                              f: [{
	                                t: 2,
	                                r: "@shared.assetsHost"
	                              }, {
	                                t: 2,
	                                r: "./imgSrc2"
	                              }],
	                              t: 13
	                            }],
	                            n: 50,
	                            r: "./imgSrc2"
	                          }, {
	                            n: "loading",
	                            f: "lazy",
	                            t: 13,
	                            g: 1
	                          }]
	                        }]
	                      }, " ", {
	                        t: 7,
	                        e: "div",
	                        m: [{
	                          t: 13,
	                          n: "class",
	                          f: "gp-about_people-behind_wrapper_collaborators_list_item_info",
	                          g: 1
	                        }],
	                        f: [{
	                          t: 7,
	                          e: "span",
	                          m: [{
	                            t: 13,
	                            n: "class",
	                            f: "gp-about_people-behind_wrapper_collaborators_list_item_info_name",
	                            g: 1
	                          }],
	                          f: [{
	                            t: 2,
	                            r: "./name"
	                          }]
	                        }, " ", {
	                          t: 7,
	                          e: "span",
	                          m: [{
	                            t: 13,
	                            n: "class",
	                            f: "gp-about_people-behind_wrapper_collaborators_list_item_info_position",
	                            g: 1
	                          }],
	                          f: [{
	                            t: 2,
	                            r: "./position"
	                          }]
	                        }, " ", {
	                          t: 7,
	                          e: "span",
	                          m: [{
	                            t: 13,
	                            n: "class",
	                            f: "gp-about_people-behind_wrapper_collaborators_list_item_info_social",
	                            g: 1
	                          }],
	                          f: [{
	                            t: 7,
	                            e: "a",
	                            m: [{
	                              n: "target",
	                              f: "_blank",
	                              t: 13,
	                              g: 1
	                            }, {
	                              n: "rel",
	                              f: "noopener noreferrer",
	                              t: 13,
	                              g: 1
	                            }, {
	                              n: "href",
	                              f: [{
	                                t: 2,
	                                r: "./social.url"
	                              }],
	                              t: 13
	                            }],
	                            f: [{
	                              t: 7,
	                              e: "img",
	                              m: [{
	                                n: "width",
	                                f: "24",
	                                t: 13,
	                                g: 1
	                              }, {
	                                n: "height",
	                                f: "24",
	                                t: 13,
	                                g: 1
	                              }, {
	                                n: "src",
	                                f: [{
	                                  t: 2,
	                                  r: "@shared.assetsHost"
	                                }, {
	                                  t: 2,
	                                  r: "./social.imgSrc"
	                                }],
	                                t: 13
	                              }]
	                            }]
	                          }]
	                        }]
	                      }]
	                    }],
	                    n: 52,
	                    r: "./data"
	                  }]
	                }]
	              }],
	              n: 52,
	              r: "collaborators"
	            }]
	          }]
	        }]
	      }]
	    }, " ", {
	      t: 7,
	      e: "c-gp-footer"
	    }]
	  }],
	  e: {
	    "Math.floor(_0)": function (_0) {
	      return Math.floor(_0);
	    }
	  }
	};
	component$a.exports.components = {
	  "c-gp-jumbotron": gpJumbotron,
	  "c-notification": notification,
	  "c-gp-footer": gpFooter,
	  "c-gp-header": gpHeader,
	  "r-page": rPageGlobalping
	};
	var aboutUs = ractive__default["default"].extend(component$a.exports);

	var component$9 = {
	  exports: {}
	};
	component$9.exports = {
	  data() {
	    return {
	      title: 'Our Sponsors - Globalping',
	      description: 'Globalping is sponsored by Zenlayer, xTom, and other awesome companies.',
	      platinumSponsors: [
	        // {
	        // 	href: 'https://www.sponsor-example.domain/',
	        // 	linkDisplayed: 'www.sponsor-example.domain',
	        // 	imgTitle: 'Title example',
	        // 	imgWidth: 0,
	        // 	imgHeight: 0,
	        // 	imgSrc: [ '/path/to/img.ext' ],
	        // 	spDescr: 'Sponsor description',
	        // },
	      ],
	      goldSponsors: [{
	        href: 'https://www.zenlayer.com/',
	        linkDisplayed: 'www.zenlayer.com',
	        imgTitle: 'Sponsored by Zenlayer',
	        imgWidth: 228,
	        imgHeight: 50,
	        imgSrc: ['/img/globalping/sponsors/zenlayer.svg'],
	        spDescr: 'Deploy and run your applications on the #1 hyperconnected cloud for emerging markets.'
	      }],
	      bronzeSponsors: [{
	        href: 'https://xtom.com',
	        imgTitle: 'Sponsored by xTom',
	        imgWidth: 216,
	        imgHeight: 60,
	        imgSrc: ['/img/globalping/sponsors/xtom.svg']
	      }, {
	        href: 'https://looking.house',
	        imgTitle: 'Sponsored by Looking.house',
	        imgWidth: 222,
	        imgHeight: 50,
	        imgSrc: ['/img/globalping/sponsors/looking-house.svg']
	      }, {
	        href: 'https://www.starrydns.com',
	        imgTitle: 'Sponsored by StarryDNS',
	        imgWidth: 229,
	        imgHeight: 40,
	        imgSrc: ['/img/globalping/sponsors/starry.png']
	      }, {
	        href: 'https://www.ip2location.io/',
	        imgTitle: 'Sponsored by IP2Location',
	        imgWidth: 241,
	        imgHeight: 40,
	        imgSrc: ['/img/globalping/sponsors/ip2location.svg']
	      }, {
	        href: 'https://www.exoscale.com',
	        imgTitle: 'Sponsored by Exoscale',
	        imgWidth: 262,
	        imgHeight: 35,
	        imgSrc: ['/img/globalping/sponsors/exoscale.svg']
	      }, {
	        href: 'https://www.fdcservers.net',
	        imgTitle: 'Sponsored by FDCServers',
	        imgWidth: 205,
	        imgHeight: 60,
	        imgSrc: ['/img/globalping/sponsors/fdc.svg']
	      }, {
	        href: 'https://ipinfo.io/',
	        imgTitle: 'Sponsored by IPInfo',
	        imgWidth: 200,
	        imgHeight: 60,
	        imgSrc: ['/img/globalping/sponsors/ipinfo.svg']
	      }, {
	        href: 'https://www.edisglobal.com/',
	        imgTitle: 'Sponsored by EDIS Global',
	        imgWidth: 196,
	        imgHeight: 60,
	        imgSrc: ['/img/globalping/sponsors/edis-global.svg']
	      }, {
	        href: 'https://www.misaka.io',
	        imgTitle: 'Sponsored by Misaka Network, Inc.',
	        imgWidth: 203,
	        imgHeight: 60,
	        imgSrc: ['/img/globalping/sponsors/misaka.svg']
	      }, {
	        href: 'https://zappiehost.com',
	        imgTitle: 'Sponsored by Zappie Host',
	        imgWidth: 208,
	        imgHeight: 60,
	        imgSrc: ['/img/globalping/sponsors/zappiehost.png']
	      }, {
	        href: 'https://www.dnsfilter.com/',
	        imgTitle: 'Sponsored by DNSFilter',
	        imgWidth: 214,
	        imgHeight: 50,
	        imgSrc: ['/img/globalping/sponsors/dnsfilter.png']
	      }, {
	        href: 'https://ipgeolocation.io/',
	        imgTitle: 'Sponsored by IP Geolocation',
	        imgWidth: 121,
	        imgHeight: 70,
	        imgSrc: ['/img/globalping/sponsors/ipgeolocation.svg']
	      }, {
	        href: 'https://cloudlooking.glass/',
	        imgTitle: 'Sponsored by Cloud Looking Glass',
	        imgWidth: 221,
	        imgHeight: 60,
	        imgSrc: ['/img/globalping/sponsors/cloud-looking-glass.png']
	      }, {
	        href: 'https://onidel.com/',
	        imgTitle: 'Sponsored by Onidel',
	        imgWidth: 244,
	        imgHeight: 60,
	        imgSrc: ['/img/globalping/sponsors/onidel.svg']
	      }, {
	        href: 'https://www.kuroit.com/',
	        imgTitle: 'Sponsored by Kuroit',
	        imgWidth: 226,
	        imgHeight: 60,
	        imgSrc: ['/img/globalping/sponsors/kuroit.png']
	      }, {
	        href: 'https://exservers.net/',
	        imgTitle: 'Sponsored by ExServers',
	        imgWidth: 250,
	        imgHeight: 45,
	        imgSrc: ['/img/globalping/sponsors/exservers.png']
	      }, {
	        href: 'https://netshop-isp.com.cy/',
	        imgTitle: 'Sponsored by NetShop ISP',
	        imgWidth: 217,
	        imgHeight: 60,
	        imgSrc: ['/img/globalping/sponsors/netshop-logo-dark.svg']
	      }, {
	        href: 'https://www.host-stage.net/',
	        imgTitle: 'Sponsored by HostStage',
	        imgWidth: 259,
	        imgHeight: 55,
	        imgSrc: ['/img/globalping/sponsors/host-stage.svg']
	      }, {
	        href: 'https://www.mvps.net/',
	        imgTitle: 'Sponsored by MVPS',
	        imgWidth: 253,
	        imgHeight: 80,
	        imgSrc: ['/img/globalping/sponsors/mvps.svg']
	      }]
	    };
	  }
	};
	component$9.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "r-page",
	    m: [{
	      n: "noYield",
	      f: [{
	        t: 2,
	        r: "noYield"
	      }],
	      t: 13
	    }, {
	      n: "title",
	      f: [{
	        t: 2,
	        r: "title"
	      }],
	      t: 13
	    }, {
	      n: "description",
	      f: [{
	        t: 2,
	        r: "description"
	      }],
	      t: 13
	    }],
	    f: [{
	      t: 7,
	      e: "c-notification"
	    }, " ", {
	      t: 7,
	      e: "c-gp-header",
	      m: [{
	        n: "additionalClasses",
	        f: "header-with-gp-translucent-bg",
	        t: 13,
	        g: 1
	      }]
	    }, " ", {
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "p-globalping-sponsors",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "c-gp-jumbotron",
	        m: [{
	          n: "className",
	          f: "sponsors",
	          t: 13,
	          g: 1
	        }, {
	          n: "gridType",
	          f: "type4",
	          t: 13,
	          g: 1
	        }]
	      }, " ", {
	        t: 7,
	        e: "h1",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "gp-sponsors_header",
	          g: 1
	        }],
	        f: ["Our Sponsors"]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "gp-sponsors_main-info",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "gp-sponsors_main-info_descr",
	            g: 1
	          }],
	          f: ["As an open-source project that relies on the community to operate, we are also highly appreciative of larger organizations that support our work."]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "gp-sponsors_main-info_list-wrapper",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "span",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp-sponsors_main-info_list-wrapper_title",
	              g: 1
	            }],
	            f: ["Globalping sponsors can be listed here for considerable and ongoing contributions to the project in the form of:"]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp-sponsors_main-info_list-wrapper_list",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "span",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "gp-sponsors_main-info_list-wrapper_list_item",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/globalping/check.svg"],
	                  t: 13
	                }, {
	                  n: "width",
	                  f: "20",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "20",
	                  t: 13,
	                  g: 1
	                }]
	              }, " ", {
	                t: 7,
	                e: "span",
	                f: ["Infrastructure, like servers and services"]
	              }]
	            }, " ", {
	              t: 7,
	              e: "span",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "gp-sponsors_main-info_list-wrapper_list_item",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/globalping/check.svg"],
	                  t: 13
	                }, {
	                  n: "width",
	                  f: "20",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "20",
	                  t: 13,
	                  g: 1
	                }]
	              }, " ", {
	                t: 7,
	                e: "span",
	                f: ["Mass hosting of probes managed by us"]
	              }]
	            }, " ", {
	              t: 7,
	              e: "span",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "gp-sponsors_main-info_list-wrapper_list_item",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/globalping/check.svg"],
	                  t: 13
	                }, {
	                  n: "width",
	                  f: "20",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "20",
	                  t: 13,
	                  g: 1
	                }]
	              }, " ", {
	                t: 7,
	                e: "span",
	                f: ["Grants and ongoing sponsorships"]
	              }]
	            }, " ", {
	              t: 7,
	              e: "span",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "gp-sponsors_main-info_list-wrapper_list_item",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/globalping/check.svg"],
	                  t: 13
	                }, {
	                  n: "width",
	                  f: "20",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "20",
	                  t: 13,
	                  g: 1
	                }]
	              }, " ", {
	                t: 7,
	                e: "span",
	                f: ["Developer hours and code contributions"]
	              }]
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "gp-sponsors_main-info_contact-us",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "span",
	            f: ["Contact us at"]
	          }, " ", {
	            t: 7,
	            e: "a",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp-sponsors_main-info_contact-us_mail",
	              g: 1
	            }, {
	              n: "href",
	              f: "mailto:d@globalping.io",
	              t: 13,
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "img",
	              m: [{
	                n: "src",
	                f: [{
	                  t: 2,
	                  r: "@shared.assetsHost"
	                }, "/img/globalping/mail-icon.svg"],
	                t: 13
	              }, {
	                n: "width",
	                f: "20",
	                t: 13,
	                g: 1
	              }, {
	                n: "height",
	                f: "20",
	                t: 13,
	                g: 1
	              }]
	            }, " ", {
	              t: 7,
	              e: "span",
	              f: ["d@globalping.io"]
	            }]
	          }]
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "gp-sponsors_sponsors-list",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "gp-sponsors_sponsors-list_platinum",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp-sponsors_sponsors-list_platinum_title",
	              g: 1
	            }],
	            f: ["PLATINUM"]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp-sponsors_sponsors-list_platinum_list",
	              g: 1
	            }],
	            f: [{
	              t: 4,
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "gp-sponsors_sponsors-list_platinum_list_item",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "gp-sponsors_sponsors-list_platinum_list_item_logo",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "title",
	                      f: [{
	                        t: 2,
	                        r: "./imgTitle"
	                      }],
	                      t: 13
	                    }, {
	                      n: "width",
	                      f: [{
	                        t: 2,
	                        r: "./imgWidth"
	                      }],
	                      t: 13
	                    }, {
	                      n: "height",
	                      f: [{
	                        t: 2,
	                        r: "./imgHeight"
	                      }],
	                      t: 13
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, {
	                        t: 2,
	                        r: "./imgSrc.0"
	                      }],
	                      t: 13
	                    }, {
	                      t: 4,
	                      f: [{
	                        n: "srcset",
	                        f: [{
	                          t: 2,
	                          r: "@shared.assetsHost"
	                        }, {
	                          t: 2,
	                          r: "./imgSrc.1"
	                        }],
	                        t: 13
	                      }],
	                      n: 50,
	                      r: "./imgSrc.1"
	                    }, {
	                      n: "loading",
	                      f: "lazy",
	                      t: 13,
	                      g: 1
	                    }]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "p",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "gp-sponsors_sponsors-list_platinum_list_item_descr",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 2,
	                    r: "./spDescr"
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "span",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "gp-sponsors_sponsors-list_platinum_list_item_link",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/globalping/link-icon.svg"],
	                      t: 13
	                    }, {
	                      n: "width",
	                      f: "20",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "20",
	                      t: 13,
	                      g: 1
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      n: "href",
	                      f: [{
	                        t: 2,
	                        r: "./href"
	                      }],
	                      t: 13
	                    }],
	                    f: [{
	                      t: 2,
	                      r: "./linkDisplayed"
	                    }]
	                  }]
	                }]
	              }],
	              n: 52,
	              r: "platinumSponsors"
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "gp-sponsors_sponsors-list_platinum_list_item become-a-sponsor",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "span",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "gp-sponsors_sponsors-list_platinum_list_item_title",
	                  g: 1
	                }],
	                f: ["Become a sponsor"]
	              }, " ", {
	                t: 7,
	                e: "span",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "gp-sponsors_sponsors-list_platinum_list_item_descr",
	                  g: 1
	                }],
	                f: ["Developer hours, donations, servers, and partnerships."]
	              }]
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "gp-sponsors_sponsors-list_gold",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp-sponsors_sponsors-list_gold_title",
	              g: 1
	            }],
	            f: ["GOLD"]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp-sponsors_sponsors-list_gold_list",
	              g: 1
	            }],
	            f: [{
	              t: 4,
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "gp-sponsors_sponsors-list_gold_list_item",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "gp-sponsors_sponsors-list_gold_list_item_logo",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "title",
	                      f: [{
	                        t: 2,
	                        r: "./imgTitle"
	                      }],
	                      t: 13
	                    }, {
	                      n: "width",
	                      f: [{
	                        t: 2,
	                        r: "./imgWidth"
	                      }],
	                      t: 13
	                    }, {
	                      n: "height",
	                      f: [{
	                        t: 2,
	                        r: "./imgHeight"
	                      }],
	                      t: 13
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, {
	                        t: 2,
	                        r: "./imgSrc.0"
	                      }],
	                      t: 13
	                    }, {
	                      t: 4,
	                      f: [{
	                        n: "srcset",
	                        f: [{
	                          t: 2,
	                          r: "@shared.assetsHost"
	                        }, {
	                          t: 2,
	                          r: "./imgSrc.1"
	                        }],
	                        t: 13
	                      }],
	                      n: 50,
	                      r: "./imgSrc.1"
	                    }, {
	                      n: "loading",
	                      f: "lazy",
	                      t: 13,
	                      g: 1
	                    }]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "p",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "gp-sponsors_sponsors-list_gold_list_item_descr",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 2,
	                    r: "./spDescr"
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "span",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "gp-sponsors_sponsors-list_gold_list_item_link",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/globalping/link-icon.svg"],
	                      t: 13
	                    }, {
	                      n: "width",
	                      f: "20",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "20",
	                      t: 13,
	                      g: 1
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      n: "href",
	                      f: [{
	                        t: 2,
	                        r: "./href"
	                      }],
	                      t: 13
	                    }],
	                    f: [{
	                      t: 2,
	                      r: "./linkDisplayed"
	                    }]
	                  }]
	                }]
	              }],
	              n: 52,
	              r: "goldSponsors"
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "gp-sponsors_sponsors-list_gold_list_item become-a-sponsor",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "span",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "gp-sponsors_sponsors-list_gold_list_item_title",
	                  g: 1
	                }],
	                f: ["Become a sponsor"]
	              }, " ", {
	                t: 7,
	                e: "span",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "gp-sponsors_sponsors-list_gold_list_item_descr",
	                  g: 1
	                }],
	                f: ["Developer hours, donations, servers, and partnerships."]
	              }]
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "gp-sponsors_sponsors-list_bronze",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp-sponsors_sponsors-list_bronze_title",
	              g: 1
	            }],
	            f: ["BRONZE"]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp-sponsors_sponsors-list_bronze_list",
	              g: 1
	            }],
	            f: [{
	              t: 4,
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "gp-sponsors_sponsors-list_bronze_list_item",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "gp-sponsors_sponsors-list_bronze_list_item_logo",
	                    g: 1
	                  }, {
	                    n: "target",
	                    f: "_blank",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "rel",
	                    f: "noopener noreferrer",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "href",
	                    f: [{
	                      t: 2,
	                      r: "./href"
	                    }],
	                    t: 13
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "title",
	                      f: [{
	                        t: 2,
	                        r: "./imgTitle"
	                      }],
	                      t: 13
	                    }, {
	                      n: "width",
	                      f: [{
	                        t: 2,
	                        r: "./imgWidth"
	                      }],
	                      t: 13
	                    }, {
	                      n: "height",
	                      f: [{
	                        t: 2,
	                        r: "./imgHeight"
	                      }],
	                      t: 13
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, {
	                        t: 2,
	                        r: "./imgSrc.0"
	                      }],
	                      t: 13
	                    }, {
	                      t: 4,
	                      f: [{
	                        n: "srcset",
	                        f: [{
	                          t: 2,
	                          r: "@shared.assetsHost"
	                        }, {
	                          t: 2,
	                          r: "./imgSrc.1"
	                        }],
	                        t: 13
	                      }],
	                      n: 50,
	                      r: "./imgSrc.1"
	                    }, {
	                      n: "loading",
	                      f: "lazy",
	                      t: 13,
	                      g: 1
	                    }]
	                  }]
	                }]
	              }],
	              n: 52,
	              r: "bronzeSponsors"
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "gp-sponsors_sponsors-list_bronze_list_item become-a-sponsor",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "span",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "gp-sponsors_sponsors-list_bronze_list_item_title",
	                  g: 1
	                }],
	                f: ["Become a sponsor"]
	              }, " ", {
	                t: 7,
	                e: "span",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "gp-sponsors_sponsors-list_bronze_list_item_descr",
	                  g: 1
	                }],
	                f: ["Developer hours, donations, servers, and partnerships."]
	              }]
	            }]
	          }]
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "gp-sponsors_help-us",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "img",
	          m: [{
	            n: "width",
	            f: "40",
	            t: 13,
	            g: 1
	          }, {
	            n: "height",
	            f: "40",
	            t: 13,
	            g: 1
	          }, {
	            n: "src",
	            f: [{
	              t: 2,
	              r: "@shared.assetsHost"
	            }, "/img/globalping/heart.svg"],
	            t: 13
	          }, {
	            n: "loading",
	            f: "lazy",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "span",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "gp-sponsors_help-us_text",
	            g: 1
	          }],
	          f: ["Help us make jsDelivr even better"]
	        }, " ", {
	          t: 7,
	          e: "a",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "gp_btn_green",
	            g: 1
	          }, {
	            n: "href",
	            f: "https://github.com/sponsors/jsdelivr",
	            t: 13,
	            g: 1
	          }, {
	            n: "target",
	            f: "_blank",
	            t: 13,
	            g: 1
	          }],
	          f: ["Become our sponsor"]
	        }]
	      }]
	    }, " ", {
	      t: 7,
	      e: "c-gp-footer"
	    }]
	  }]
	};
	component$9.exports.components = {
	  "c-gp-jumbotron": gpJumbotron,
	  "c-notification": notification,
	  "c-gp-footer": gpFooter,
	  "c-gp-header": gpHeader,
	  "r-page": rPageGlobalping
	};
	var sponsors = ractive__default["default"].extend(component$9.exports);

	var component$8 = {
	  exports: {}
	};
	const CUSTOM_DONATION_VALUE = 'custom';
	const NO_DONATION = {
	  value: 'free',
	  displayed: 'Free',
	  msg: '250 free tests/hour'
	};
	component$8.exports = {
	  data() {
	    return {
	      _,
	      useDefaultHeader: true,
	      creditsPerDollar: 2000,
	      donationValue: null,
	      defaultHeaderNumber: null,
	      defaultHeaderText: null,
	      defaultHeaderAdditional: null,
	      partsGap: 2,
	      sliderPosition: 1,
	      partsElements: [],
	      partWidth: null,
	      partClassname: 'range-slider_line_part',
	      gapClassname: 'range-slider_line_gap',
	      partLabelClassname: 'range-slider-labels_label',
	      partsLabelsData: [{
	        displayed: '$1',
	        value: 1
	      }, {
	        displayed: '$2',
	        value: 2
	      }, {
	        displayed: '$4',
	        value: 4
	      }, {
	        displayed: '$8',
	        value: 8
	      }, {
	        displayed: '$16',
	        value: 16
	      }, {
	        displayed: '$32',
	        value: 32
	      }, {
	        displayed: '$64',
	        value: 64
	      }, {
	        displayed: '$128',
	        value: 128
	      }, {
	        displayed: 'Custom',
	        value: CUSTOM_DONATION_VALUE
	      }]
	    };
	  },
	  oninit() {
	    if (!ractive__default["default"].isServer) {
	      this.set('screenWidth', window.innerWidth);
	    }
	  },
	  onrender() {
	    if (!ractive__default["default"].isServer) {
	      let isSliderDragging = false;
	      let partsLabelsData = this.get('partsLabelsData');
	      let partsCount = partsLabelsData.length;
	      let sliderContainer = document.getElementById('slider-container');
	      let sliderKnob = document.getElementById('slider-knob');

	      // create Slider line and labels
	      this.createSliderLine();
	      this.createSliderLabels();

	      // handle mouse click on the slider line
	      sliderContainer.addEventListener('click', event => {
	        if (isSliderDragging) {
	          // while dragging we need to prevent the click event from being triggered
	          event.stopPropagation();
	          event.preventDefault();
	          isSliderDragging = false;
	          return;
	        }
	        let rect = sliderContainer.getBoundingClientRect();
	        let x = event.clientX - rect.left;
	        this.moveSliderToClosestPart(x);
	      });

	      // handle the sliderKnob dragging with a mouse move
	      sliderKnob.addEventListener('mousedown', event => {
	        event.preventDefault();
	        isSliderDragging = false;
	        let onMouseMove = event => {
	          isSliderDragging = true;
	          let rect = sliderContainer.getBoundingClientRect();
	          let x = event.clientX - rect.left;
	          this.handleSliderOnMouseDown(x);
	        };
	        let onMouseUp = () => {
	          document.removeEventListener('mousemove', onMouseMove);
	          document.removeEventListener('mouseup', onMouseUp);

	          // reset isSliderDragging with a next tick to avoid conflicts with an occasional click event
	          setTimeout(() => {
	            isSliderDragging = false;
	          }, 0);
	        };
	        document.addEventListener('mousemove', onMouseMove);
	        document.addEventListener('mouseup', onMouseUp);
	      });

	      // handle the sliderKnob dragging with a touch move
	      sliderKnob.addEventListener('touchstart', event => {
	        event.preventDefault();
	        isSliderDragging = false;
	        let onTouchMove = event => {
	          isSliderDragging = true;
	          let rect = sliderContainer.getBoundingClientRect();
	          let x = event.touches[0].clientX - rect.left;
	          this.handleSliderOnMouseDown(x);
	        };
	        let onTouchEnd = () => {
	          document.removeEventListener('touchmove', onTouchMove);
	          document.removeEventListener('touchend', onTouchEnd);

	          // reset isSliderDragging with a next tick to avoid conflicts with an occasional tap
	          setTimeout(() => {
	            isSliderDragging = false;
	          }, 0);
	        };
	        document.addEventListener('touchmove', onTouchMove);
	        document.addEventListener('touchend', onTouchEnd);
	      });

	      // handle keyboard controls
	      let handleSliderKeyboardNavigation = event => {
	        let sliderPosition = this.get('sliderPosition');
	        if (event.key === 'ArrowLeft') {
	          sliderPosition = sliderPosition - 1 < 0 ? 0 : sliderPosition - 1;
	        } else if (event.key === 'ArrowRight') {
	          let newPos = sliderPosition + 1;
	          sliderPosition = newPos > partsCount ? partsCount : newPos;
	        }
	        this.set('sliderPosition', sliderPosition);
	        this.updateSliderPosition();
	      };
	      listeners.addManagedListener(this, document, 'keydown', handleSliderKeyboardNavigation);

	      // initiate the slider
	      this.updateSliderPosition();

	      // handle slider position
	      this.observe('sliderPosition', sliderPosition => {
	        let partsLabelsData = this.get('partsLabelsData');
	        let donationValue;
	        if (sliderPosition - 1 < 0) {
	          donationValue = NO_DONATION.value;
	        } else {
	          donationValue = partsLabelsData[sliderPosition - 1].value;
	        }
	        this.set('donationValue', donationValue);
	        this.updateSliderSelectedValue();
	      });

	      // create default header based on the Slider value
	      this.observe('donationValue', donationValue => {
	        let creditsPerDollar = this.get('creditsPerDollar');
	        let defaultHeaderNumber = null;
	        let defaultHeaderText = null;
	        let defaultHeaderAdditional = null;
	        if (donationValue === CUSTOM_DONATION_VALUE) {
	          defaultHeaderText = 'Customizable';
	        } else if (donationValue === NO_DONATION.value) {
	          defaultHeaderText = NO_DONATION.msg;
	        } else if (donationValue) {
	          defaultHeaderNumber = creditsPerDollar * donationValue;
	          defaultHeaderAdditional = ' credits/donation';
	        }
	        this.animate('defaultHeaderNumber', defaultHeaderNumber);
	        this.set('defaultHeaderText', defaultHeaderText);
	        this.set('defaultHeaderAdditional', defaultHeaderAdditional);
	      });

	      // detect window resize and update partWidth and slider knob posision
	      let handleSliderResize = debounce(throttle(() => {
	        let partsGap = this.get('partsGap');
	        let sliderPosition = this.get('sliderPosition');
	        let updPartWidth = this.get('partsElements')[0].offsetWidth + partsGap;
	        let sliderKnobEl = document.getElementById('slider-knob');
	        sliderKnobEl.style.left = `${sliderPosition * updPartWidth}px`;
	        this.set('partWidth', updPartWidth);
	        this.set('screenWidth', window.innerWidth);
	        this.createSliderLabels();
	      }, 200));
	      listeners.addManagedListener(this, document, 'resize', handleSliderResize);
	    }
	  },
	  updateSliderPosition() {
	    let sliderPosition = this.get('sliderPosition');
	    let partsElements = this.get('partsElements');
	    let partWidth = this.get('partWidth');
	    let sliderKnobEl = document.getElementById('slider-knob');
	    sliderKnobEl.style.left = `${sliderPosition * partWidth}px`;

	    // highlight parts to the left of the sliderKnobEl
	    partsElements.forEach((partEl, idx) => {
	      if (idx < sliderPosition) {
	        partEl.style.backgroundColor = '#17d4a7';
	      } else {
	        partEl.style.backgroundColor = '#e7e7ee';
	      }
	    });
	  },
	  moveSliderToClosestPart(x) {
	    let partWidth = this.get('partWidth');
	    let partsCount = this.get('partsLabelsData').length;
	    let newSliderPos = Math.round((x < 0 ? 0 : x) / partWidth);
	    let updSliderPos;
	    if (newSliderPos <= 0) {
	      updSliderPos = 0;
	    } else if (newSliderPos > partsCount) {
	      updSliderPos = partsCount;
	    } else {
	      updSliderPos = newSliderPos;
	    }
	    this.set('sliderPosition', updSliderPos);
	    this.updateSliderPosition();
	  },
	  handleSliderOnMouseDown(x) {
	    let currentSliderPos = this.get('sliderPosition');
	    let partsElements = this.get('partsElements');
	    let partWidth = this.get('partWidth');
	    let sliderKnobEl = document.getElementById('slider-knob');
	    let quotient = Math.round((x < 0 ? 0 : x) / partWidth);
	    let updSliderPos = quotient > partsElements.length ? partsElements.length : quotient;
	    let shiftLeft = `${updSliderPos * partWidth}px`;
	    sliderKnobEl.style.left = shiftLeft;
	    if (updSliderPos !== currentSliderPos) {
	      this.set('sliderPosition', updSliderPos);
	    }

	    // highlight parts to the left of the sliderKnobEl
	    partsElements.forEach((partEl, idx) => {
	      if (idx < quotient) {
	        partEl.style.backgroundColor = '#17d4a7';
	      } else {
	        partEl.style.backgroundColor = '#e7e7ee';
	      }
	    });
	  },
	  createSliderLine() {
	    let sliderLine = document.getElementById('slider-line');
	    let partsGap = this.get('partsGap');
	    let partsLabelsData = this.get('partsLabelsData');
	    let partsCount = partsLabelsData.length;
	    let parts = [];

	    // divide the line with parts and gaps, create parts labels
	    for (let i = 0; i < partsCount; i++) {
	      // create slider line
	      let partEl = document.createElement('div');
	      partEl.className = this.get('partClassname');
	      parts.push(partEl);
	      sliderLine.appendChild(partEl);

	      // add gap between slider parts, except after the last part
	      if (i < partsCount - 1) {
	        let gapEl = document.createElement('div');
	        gapEl.className = this.get('gapClassname');
	        sliderLine.appendChild(gapEl);
	      }
	    }

	    // collect parts elements of the slider line
	    this.set('partsElements', parts);

	    // calculate and set slider part width
	    this.set('partWidth', parts[0].offsetWidth + partsGap);
	  },
	  createSliderLabels() {
	    let sliderLabels = document.getElementById('slider-labels');
	    let partsLabelsData = this.get('partsLabelsData');
	    let screenWidth = this.get('screenWidth');
	    let partWidth = this.get('partWidth');
	    let partLabelClassname = this.get('partLabelClassname');
	    let partsCount = partsLabelsData.length;

	    // if there are labels - remove them
	    let labels = sliderLabels.querySelectorAll('div');
	    if (labels.length > 0) {
	      labels.forEach(label => sliderLabels.removeChild(label));
	    }

	    // create labels line
	    if (screenWidth < 768) {
	      let firstLabelEl = document.createElement('div');
	      let middleLabelEl = document.createElement('div');
	      let lastLabelEl = document.createElement('div');
	      firstLabelEl.className = `${partLabelClassname} m-first-label`;
	      middleLabelEl.className = `${partLabelClassname} m-middle-label`;
	      lastLabelEl.className = `${partLabelClassname} m-last-label`;
	      firstLabelEl.textContent = NO_DONATION.displayed;
	      middleLabelEl.textContent = this.getMiddleLabelText();
	      lastLabelEl.textContent = partsLabelsData[partsCount - 1].displayed;
	      sliderLabels.appendChild(firstLabelEl);
	      sliderLabels.appendChild(middleLabelEl);
	      sliderLabels.appendChild(lastLabelEl);
	    } else {
	      for (let i = 0; i < partsCount; i++) {
	        if (i === 0) {
	          let firstLabelEl = document.createElement('div');
	          firstLabelEl.className = partLabelClassname;
	          firstLabelEl.textContent = NO_DONATION.displayed;
	          sliderLabels.appendChild(firstLabelEl);
	        }
	        let partLabelEl = document.createElement('div');
	        partLabelEl.className = partLabelClassname;
	        partLabelEl.textContent = partsLabelsData[i].displayed;
	        partLabelEl.style.position = 'absolute';
	        if (i === partsCount - 1) {
	          partLabelEl.className = partLabelClassname;
	          partLabelEl.style.right = 0;
	        } else {
	          partLabelEl.style.left = `${(i + 1) * partWidth - 1}px`;
	          partLabelEl.style.transform = 'translateX(-50%)';
	        }
	        sliderLabels.appendChild(partLabelEl);
	      }
	    }
	  },
	  updateSliderSelectedValue() {
	    let middleLabel = document.querySelector('.m-middle-label');
	    if (middleLabel) {
	      middleLabel.textContent = this.getMiddleLabelText();
	    }
	  },
	  getMiddleLabelText() {
	    let sliderPosition = this.get('sliderPosition');
	    let partsLabelsData = this.get('partsLabelsData');
	    let newLabelData = partsLabelsData[sliderPosition - 1] ? partsLabelsData[sliderPosition - 1] : null;
	    return newLabelData === null ? '' : newLabelData.value === CUSTOM_DONATION_VALUE ? '' : newLabelData.displayed;
	  }
	};
	component$8.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "div",
	    m: [{
	      t: 13,
	      n: "class",
	      f: "c-range-slider",
	      g: 1
	    }],
	    f: [{
	      t: 4,
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "range-slider-header",
	          g: 1
	        }],
	        f: [{
	          t: 4,
	          f: [{
	            t: 2,
	            x: {
	              r: ["_", "defaultHeaderNumber"],
	              s: "_0.formatNumber(Math.round(_1))"
	            }
	          }],
	          n: 50,
	          r: "defaultHeaderNumber"
	        }, {
	          t: 4,
	          f: [{
	            t: 2,
	            r: "defaultHeaderText"
	          }],
	          n: 50,
	          r: "defaultHeaderText",
	          l: 1
	        }, " ", {
	          t: 2,
	          r: "defaultHeaderAdditional"
	        }]
	      }],
	      n: 50,
	      r: "useDefaultHeader"
	    }, {
	      t: 4,
	      f: [{
	        t: 8,
	        r: "customHeader"
	      }],
	      n: 50,
	      r: "@this.partials.customHeader",
	      l: 1
	    }, " ", {
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "range-slider",
	        g: 1
	      }, {
	        n: "id",
	        f: "slider-container",
	        t: 13,
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "range-slider_line",
	          g: 1
	        }, {
	          n: "id",
	          f: "slider-line",
	          t: 13,
	          g: 1
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "range-slider_knob",
	          g: 1
	        }, {
	          n: "id",
	          f: "slider-knob",
	          t: 13,
	          g: 1
	        }]
	      }]
	    }, " ", {
	      t: 4,
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "range-slider-labels",
	          g: 1
	        }, {
	          n: "id",
	          f: "slider-labels",
	          t: 13,
	          g: 1
	        }]
	      }],
	      n: 50,
	      r: "partsLabelsData"
	    }]
	  }],
	  e: {
	    "_0.formatNumber(Math.round(_1))": function (_0, _1) {
	      return _0.formatNumber(Math.round(_1));
	    }
	  }
	};
	var rangeSlider = ractive__default["default"].extend(component$8.exports);

	var component$7 = {
	  exports: {}
	};
	component$7.exports = {
	  decorators: {
	    tooltip
	  },
	  data() {
	    return {
	      title: 'Credits - Globalping',
	      description: 'Start using Globalping for free - no registration needed! Get higher limits by creating an account, hosting probes, or sponsoring the project.',
	      userBenefits: {
	        unregistered: {
	          probesPerMeas: 50,
	          freeTestsPerHour: 250
	        },
	        registered: {
	          probesPerMeas: 500,
	          freeTestsPerHour: 500
	        }
	      },
	      faq: [{
	        question: 'How to generate free credits?',
	        answer: 'Simply login to the <a href="https://dash.globalping.io" target="_blank">Globalping Dashboard</a> and follow the instructions. You will need to host a probe using a Docker container or by ordering our hardware probe.'
	      }, {
	        question: 'What is a credit and what does it do?',
	        answer: 'A single credit equals to one test. For example if you request a ping measurement from 5 locations, it will use 5 credits. A single measurement can request up to 500 probes, which effectively means a maximum of 500 credits being used per measurement.'
	      }, {
	        question: 'How to buy more credits?',
	        answer: 'You will need to register an account first and then donate your chosen amount using GitHub Sponsors. Our system will pick up the donation and credit your account automatically.'
	      }, {
	        question: 'Can I use credits to power a commercial tool or product?',
	        answer: 'Yes, we support commercial use of Globalping within the limits of our terms of service.'
	      }, {
	        question: 'Do you support non-profits with free credits?',
	        answer: 'Yes, we can provide large amounts of free credits to all kinds of organizations and projects after a manual review. Please contact us via email.'
	      }, {
	        question: 'How to get in contact?',
	        answer: 'To report issues with the API or our tools it is best to open a GitHub issue. But if for any reason you prefer to contact us privately via email you can do so at <a href="mailto:d@globalping.io">d@globalping.io</a>'
	      }]
	    };
	  },
	  openLink(url) {
	    event.preventDefault();
	    window.open(url, '_blank');
	  }
	};
	component$7.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "r-page",
	    m: [{
	      n: "noYield",
	      f: [{
	        t: 2,
	        r: "noYield"
	      }],
	      t: 13
	    }, {
	      n: "title",
	      f: [{
	        t: 2,
	        r: "title"
	      }],
	      t: 13
	    }, {
	      n: "description",
	      f: [{
	        t: 2,
	        r: "description"
	      }],
	      t: 13
	    }],
	    f: [{
	      t: 7,
	      e: "c-notification"
	    }, " ", {
	      t: 7,
	      e: "c-gp-header",
	      m: [{
	        n: "additionalClasses",
	        f: "header-with-gp-translucent-bg",
	        t: 13,
	        g: 1
	      }]
	    }, " ", {
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "p-globalping-credits",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "c-gp-jumbotron",
	        m: [{
	          n: "className",
	          f: "credits",
	          t: 13,
	          g: 1
	        }, {
	          n: "gridType",
	          f: "type4",
	          t: 13,
	          g: 1
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "gp-credits",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "gp-credits_info",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "h1",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp-credits_info_title",
	              g: 1
	            }],
	            f: ["Globalping limits and credits"]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp-credits_info_descr",
	              g: 1
	            }],
	            f: ["Start using Globalping for free - no registration needed!"]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp-credits_info_user-benefits",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "gp-credits_info_user-benefits_block",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "span",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "gp-credits_info_user-benefits_block_title",
	                  g: 1
	                }],
	                f: ["Unregistered User"]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "gp-credits_info_user-benefits_block_list",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "span",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "gp-credits_info_user-benefits_block_list_item",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "width",
	                      f: "20",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "20",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/globalping/check.svg"],
	                      t: 13
	                    }, {
	                      n: "loading",
	                      f: "lazy",
	                      t: 13,
	                      g: 1
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "span",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "gp-credits_info_user-benefits_block_list_item_numbers",
	                      g: 1
	                    }],
	                    f: [{
	                      t: 2,
	                      r: "./userBenefits.unregistered.probesPerMeas"
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "span",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "gp-credits_info_user-benefits_block_list_item_text",
	                      g: 1
	                    }],
	                    f: ["Probes per measurement"]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "span",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "gp-credits_info_user-benefits_block_list_item",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "width",
	                      f: "20",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "20",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/globalping/check.svg"],
	                      t: 13
	                    }, {
	                      n: "loading",
	                      f: "lazy",
	                      t: 13,
	                      g: 1
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "span",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "gp-credits_info_user-benefits_block_list_item_numbers",
	                      g: 1
	                    }],
	                    f: [{
	                      t: 2,
	                      r: "./userBenefits.unregistered.freeTestsPerHour"
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "span",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "gp-credits_info_user-benefits_block_list_item_text",
	                      g: 1
	                    }],
	                    f: ["Free tests per hour"]
	                  }]
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "gp-credits_info_user-benefits_block registered",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "span",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "gp-credits_info_user-benefits_block_title",
	                  g: 1
	                }],
	                f: ["Registered User"]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "gp-credits_info_user-benefits_block_list",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "span",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "gp-credits_info_user-benefits_block_list_item",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "width",
	                      f: "20",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "20",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/globalping/check.svg"],
	                      t: 13
	                    }, {
	                      n: "loading",
	                      f: "lazy",
	                      t: 13,
	                      g: 1
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "span",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "gp-credits_info_user-benefits_block_list_item_numbers",
	                      g: 1
	                    }],
	                    f: [{
	                      t: 2,
	                      r: "./userBenefits.registered.probesPerMeas"
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "span",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "gp-credits_info_user-benefits_block_list_item_text",
	                      g: 1
	                    }],
	                    f: ["Probes per measurement"]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "span",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "gp-credits_info_user-benefits_block_list_item",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "width",
	                      f: "20",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "20",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/globalping/check.svg"],
	                      t: 13
	                    }, {
	                      n: "loading",
	                      f: "lazy",
	                      t: 13,
	                      g: 1
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "span",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "gp-credits_info_user-benefits_block_list_item_numbers",
	                      g: 1
	                    }],
	                    f: [{
	                      t: 2,
	                      r: "./userBenefits.registered.freeTestsPerHour"
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "span",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "gp-credits_info_user-benefits_block_list_item_text",
	                      g: 1
	                    }],
	                    f: ["Free tests per hour"]
	                  }]
	                }]
	              }, " ", {
	                t: 7,
	                e: "span",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "gp-credits_info_user-benefits_block_hint",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "span",
	                  f: ["Higher limits for members!"]
	                }, " ", {
	                  t: 7,
	                  e: "img",
	                  m: [{
	                    n: "tooltip",
	                    t: 71,
	                    f: {
	                      r: [],
	                      s: "[[\"By creating a free account you help us fight abuse while getting access to higher limits and additional features.\"],\"top\",undefined,undefined,\"multiline gp-credits_tooltip\"]"
	                    }
	                  }, {
	                    n: "width",
	                    f: "14",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "14",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "src",
	                    f: [{
	                      t: 2,
	                      r: "@shared.assetsHost"
	                    }, "/img/globalping/help-icon.svg"],
	                    t: 13
	                  }]
	                }]
	              }]
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp-credits_info_credits-donations",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "c-range-slider"
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "gp-credits_become-a-sponsor",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "img",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp-credits_become-a-sponsor_polygons left",
	              g: 1
	            }, {
	              n: "width",
	              f: "510",
	              t: 13,
	              g: 1
	            }, {
	              n: "height",
	              f: "289",
	              t: 13,
	              g: 1
	            }, {
	              n: "src",
	              f: [{
	                t: 2,
	                r: "@shared.assetsHost"
	              }, "/img/globalping/credits/polygons_1.svg"],
	              t: 13
	            }, {
	              n: "loading",
	              f: "lazy",
	              t: 13,
	              g: 1
	            }]
	          }, " ", {
	            t: 7,
	            e: "img",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp-credits_become-a-sponsor_polygons right",
	              g: 1
	            }, {
	              n: "width",
	              f: "362",
	              t: 13,
	              g: 1
	            }, {
	              n: "height",
	              f: "288",
	              t: 13,
	              g: 1
	            }, {
	              n: "src",
	              f: [{
	                t: 2,
	                r: "@shared.assetsHost"
	              }, "/img/globalping/credits/polygons_2.svg"],
	              t: 13
	            }, {
	              n: "loading",
	              f: "lazy",
	              t: 13,
	              g: 1
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp-credits_become-a-sponsor_block left",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "h2",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "gp-credits_become-a-sponsor_block_title",
	                g: 1
	              }],
	              f: ["Become a sponsor"]
	            }, " ", {
	              t: 7,
	              e: "h3",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "gp-credits_become-a-sponsor_block_subtitle",
	                g: 1
	              }],
	              f: ["+2000 tests per $1 donated"]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "gp-credits_become-a-sponsor_block_content",
	                g: 1
	              }],
	              f: ["We aim to offer a reliable service to everyone, from home users and solo developers to startups, corporations, and large enterprises. We're doing our best to keep things fair. Everyone gets a number of free requests every hour, while larger users may pay for additional requests, and help support the active development of the project."]
	            }, " ", {
	              t: 7,
	              e: "a",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "gp_btn_green gp-credits_become-a-sponsor_block_btn",
	                g: 1
	              }, {
	                n: "target",
	                f: "_blank",
	                t: 13,
	                g: 1
	              }, {
	                n: "href",
	                f: "https://github.com/sponsors/jsdelivr",
	                t: 13,
	                g: 1
	              }],
	              f: ["Become a GitHub sponsor"]
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp-credits_become-a-sponsor_block right",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "h2",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "gp-credits_become-a-sponsor_block_title",
	                g: 1
	              }],
	              f: ["Host a probe"]
	            }, " ", {
	              t: 7,
	              e: "h3",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "gp-credits_become-a-sponsor_block_subtitle",
	                g: 1
	              }],
	              f: ["+150 tests/probe/day"]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "gp-credits_become-a-sponsor_block_content",
	                g: 1
	              }],
	              f: ["Generate free credits passively! Become a member of the community by hosting a probe and adopting it under your account. For each day your probe stays online, you will get additional free credits."]
	            }, " ", {
	              t: 7,
	              e: "a",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "gp_btn_green gp-credits_become-a-sponsor_block_btn",
	                g: 1
	              }, {
	                n: ["click"],
	                t: 70,
	                f: {
	                  r: ["@this", "@shared.serverHost"],
	                  s: "[_0.openLink(_1+\"/#join-the-network\")]"
	                }
	              }],
	              f: ["Host a probe"]
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "gp-credits_faq",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "h2",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp-credits_faq_title",
	              g: 1
	            }],
	            f: ["Frequently Asked Questions"]
	          }, " ", {
	            t: 7,
	            e: "span",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp-credits_faq_descr",
	              g: 1
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp-credits_faq_list",
	              g: 1
	            }],
	            f: [{
	              t: 4,
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "gp-credits_faq_list_item",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "span",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "gp-credits_faq_list_item_question",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 2,
	                    r: "./question"
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "span",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "gp-credits_faq_list_item_answer",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 3,
	                    r: "./answer"
	                  }]
	                }]
	              }],
	              n: 52,
	              r: "faq"
	            }]
	          }]
	        }]
	      }]
	    }, " ", {
	      t: 7,
	      e: "c-gp-footer"
	    }]
	  }],
	  e: {
	    "[[\"By creating a free account you help us fight abuse while getting access to higher limits and additional features.\"],\"top\",undefined,undefined,\"multiline gp-credits_tooltip\"]": function () {
	      return [["By creating a free account you help us fight abuse while getting access to higher limits and additional features."], "top", undefined, undefined, "multiline gp-credits_tooltip"];
	    },
	    "[_0.openLink(_1+\"/#join-the-network\")]": function (_0, _1) {
	      return [_0.openLink(_1 + "/#join-the-network")];
	    }
	  }
	};
	component$7.exports.components = {
	  "c-range-slider": rangeSlider,
	  "c-gp-jumbotron": gpJumbotron,
	  "c-notification": notification,
	  "c-gp-footer": gpFooter,
	  "c-gp-header": gpHeader,
	  "r-page": rPageGlobalping
	};
	var credits = ractive__default["default"].extend(component$7.exports);

	var component$6 = {
	  exports: {}
	};
	const MAP_MIN_ZOOM = 2;
	const MAP_MAX_ZOOM = 22;
	const MAP_ZOOM_REG = 3.74;
	const MAP_ZOOM_ALT = 2.14;
	const MAP_CENTER_REG = {
	  lat: 48,
	  lng: 16
	};
	const MAP_CENTER_ALT = {
	  lat: 30,
	  lng: 18
	};
	const getMarkerSize = (probeCount, zoom) => {
	  let size = {
	    svgWidth: 16,
	    svgHeight: 16,
	    circleRadius: 4.5,
	    strokeWidth: 1.5
	  };
	  if (probeCount > 1) {
	    let scalingFactor = probeCount.toString().length;
	    size.svgWidth += 4 * scalingFactor + 4;
	    size.svgHeight += 4 * scalingFactor + 4;
	    size.circleRadius += 2 * scalingFactor + 1.5;
	    size.strokeWidth += .5;
	  }
	  if (zoom >= 5) {
	    size.svgWidth *= 1.1;
	    size.svgHeight *= 1.1;
	  }
	  if (zoom >= 10) {
	    size.svgWidth *= 1.1;
	    size.svgHeight *= 1.1;
	  }
	  return size;
	};
	let map;
	let infoWindows = [];
	let mapMarkers = [];
	let markerCluster;
	component$6.exports = {
	  data() {
	    return {
	      class: '',
	      iwClass: '',
	      probesByCoords: null,
	      onProbesByCoordsChange: null
	    };
	  },
	  onrender() {
	    if (!ractive__default["default"].isServer) {
	      app.initMap = this.initMap.bind(this);
	      if (app.loaded) {
	        this.initMap();
	      }
	    }
	  },
	  onteardown() {
	    if (!ractive__default["default"].isServer) {
	      map = null;
	      markerCluster = null;
	      infoWindows = [];
	      mapMarkers = [];
	    }
	  },
	  initMap() {
	    let mq = window.matchMedia('(min-width: 768px)');
	    map = new google.maps.Map(this.find('#gp-map'), {
	      zoom: MAP_ZOOM_REG,
	      center: MAP_CENTER_REG,
	      mapTypeId: 'roadmap',
	      draggableCursor: 'default',
	      mapTypeControl: false,
	      streetViewControl: false,
	      fullscreenControl: false,
	      minZoom: MAP_MIN_ZOOM,
	      maxZoom: MAP_MAX_ZOOM,
	      mapId: 'ce04bbf9d49b6f34'
	    });
	    if (mq.matches) {
	      map.setCenter(MAP_CENTER_ALT);
	      map.setZoom(MAP_ZOOM_ALT);
	    }
	    map.addListener('zoom_changed', () => {
	      markerCluster?.clusters.forEach(c => {
	        let m = c.marker;
	        let {
	          svgWidth,
	          svgHeight
	        } = getMarkerSize(Number(m.content.getAttribute('data-probe-count')), map.zoom);
	        m.content.style.width = `${svgWidth}px`;
	        m.content.style.height = `${svgHeight}px`;
	      });
	      mapMarkers.forEach(m => {
	        let {
	          svgWidth,
	          svgHeight
	        } = getMarkerSize(Number(m.content.getAttribute('data-probe-count')), map.zoom);
	        m.content.style.width = `${svgWidth}px`;
	        m.content.style.height = `${svgHeight}px`;
	        m.content.setAttribute('data-zoom', map.zoom);
	      });
	      infoWindows.forEach(iw => iw.close());
	    });
	    this.observe('probesByCoords', (markersData, prevMarkersData) => {
	      if (markersData && JSON.stringify(markersData) !== JSON.stringify(prevMarkersData)) {
	        // hide all existing markers from the map
	        mapMarkers.forEach(mm => mm.map = null);

	        // show the marker or create one if it is missing
	        let filteredMarkers = Object.keys(markersData).map(key => {
	          let [lat, lng] = key.split(', ');
	          let marker = mapMarkers.find(mm => mm.position.lat === lat && mm.position.lng === lng);
	          if (!marker) {
	            marker = this.createMapMarkerWithIW(key, markersData[key]);
	            mapMarkers.push(marker);
	          }
	          marker.map = map;
	          return marker;
	        });
	        let createClusterMarkerSVG = this.createClusterMarkerSVG;
	        if (markerCluster) {
	          markerCluster.clearMarkers();
	          markerCluster.addMarkers(filteredMarkers);
	        } else {
	          // eslint-disable-next-line no-undef
	          markerCluster = new markerClusterer.MarkerClusterer({
	            map,
	            markers: filteredMarkers,
	            renderer: {
	              render(_ref) {
	                let {
	                  markers,
	                  position
	                } = _ref;
	                let totalCustomNumber = markers.reduce((sum, marker) => sum + (marker.markersCount || 0), 0);
	                let svg = createClusterMarkerSVG(totalCustomNumber);
	                let clusterDiv = document.createElement('div');
	                clusterDiv.setAttribute('data-probe-count', totalCustomNumber);
	                clusterDiv.setAttribute('data-zoom', map.zoom);
	                clusterDiv.style.position = 'relative';
	                clusterDiv.style.backgroundImage = `url('data:image/svg+xml;base64,${svg}')`;
	                clusterDiv.style.backgroundRepeat = 'no-repeat';
	                clusterDiv.style.backgroundPosition = 'center';
	                clusterDiv.style.backgroundSize = 'contain';
	                let {
	                  svgWidth,
	                  svgHeight
	                } = getMarkerSize(totalCustomNumber, map.zoom);
	                clusterDiv.style.width = `${svgWidth}px`;
	                clusterDiv.style.height = `${svgHeight}px`;
	                return new google.maps.marker.AdvancedMarkerElement({
	                  position,
	                  content: clusterDiv,
	                  zIndex: totalCustomNumber
	                });
	              }
	            },
	            // eslint-disable-next-line no-undef
	            algorithm: new markerClusterer.SuperClusterAlgorithm({
	              radius: 40
	            })
	          });
	        }
	        if (this.get('onProbesByCoordsChange') && this.get('onProbesByCoordsChange')()) {
	          this.focusMapOnMarkers(markersData);
	        } else {
	          if (!mq.matches) {
	            map.setCenter(MAP_CENTER_REG);
	            map.setZoom(MAP_ZOOM_REG);
	          } else {
	            map.setCenter(MAP_CENTER_ALT);
	            map.setZoom(MAP_ZOOM_ALT);
	          }
	        }
	      }
	    });

	    // close IWs on click on Map
	    google.maps.event.addListener(map, 'click', () => {
	      infoWindows.forEach(iw => iw.close());
	    });
	  },
	  createMapMarkerWithIW(key, markerData) {
	    let infoWindow = new google.maps.InfoWindow();
	    let svg = this.createMapMarkerSvg(markerData);
	    let [lat, lng] = key.split(', ');

	    // Collect InfoWindows
	    infoWindows.push(infoWindow);
	    infoWindow.setContent(this.createInfoWindowContent(markerData));
	    let markerContent = document.createElement('div');
	    markerContent.style.backgroundImage = `url('data:image/svg+xml;base64,${svg}')`;
	    markerContent.style.backgroundRepeat = 'no-repeat';
	    markerContent.style.backgroundPosition = 'center';
	    markerContent.style.backgroundSize = 'contain';
	    markerContent.setAttribute('data-probe-count', markerData.length);
	    let {
	      svgWidth,
	      svgHeight
	    } = getMarkerSize(markerData.length, map.zoom);
	    markerContent.style.width = `${svgWidth}px`;
	    markerContent.style.height = `${svgHeight}px`;

	    // Create a new AdvancedMarkerView
	    let marker = new google.maps.marker.AdvancedMarkerElement({
	      map,
	      content: markerContent,
	      position: {
	        lat: Number(lat),
	        lng: Number(lng)
	      },
	      zIndex: 1
	    });
	    marker.markersCount = markerData.length || 0;

	    // Handle closing of all InfoWindows on a click on a marker
	    marker.addListener('click', () => {
	      infoWindows.forEach(iw => iw.close());
	      infoWindow.open({
	        map,
	        anchor: marker
	      });
	    });
	    return marker;
	  },
	  createMapMarkerSvg(markerData) {
	    return this.createClusterMarkerSVG(markerData.length);
	  },
	  createInfoWindowContent(markersByCoords) {
	    let markersCnt = markersByCoords.length;
	    let groupedNetworks = markersByCoords.reduce((res, m) => {
	      let marker = res.find(i => i.location.network === m.location.network);
	      if (marker) {
	        marker.cnt += 1;
	      } else {
	        res.push({
	          ...m,
	          cnt: 1,
	          sortKey: m.location.network.toLowerCase()
	        });
	      }
	      return res;
	    }, []).sort((a, b) => a.sortKey < b.sortKey ? -1 : a.sortKey > b.sortKey);
	    let infoWindowContent = `<div class="${this.get('iwClass')}">`;
	    if (markersCnt === 1) {
	      let {
	        network,
	        city,
	        country
	      } = markersByCoords[0].location;
	      infoWindowContent += `<span>${network} (${city}, ${country})</span>`;
	    } else {
	      // in this case we should render a list of probes
	      groupedNetworks.forEach((m, mIdx) => {
	        if (mIdx === 0) {
	          // add header content
	          infoWindowContent += `<span class="${this.get('iwClass')}_header">`;
	          infoWindowContent += `<img width="16" height="16" src="${this.get('@shared.assetsHost')}/img/globalping/location-icon.svg">`;
	          infoWindowContent += `<span class="${this.get('iwClass')}_header_location">${m.location.city}, ${m.location.country}</span>`;
	          infoWindowContent += `<span class="${this.get('iwClass')}_header_cnt">${markersByCoords.length}</span>`;
	          infoWindowContent += '</span>';
	        }

	        // render the list of the probes, grouped by the same network
	        infoWindowContent += `<span class="${this.get('iwClass')}_row">${m.location.network} ${m.cnt > 1 ? `<span class="${this.get('iwClass')}_row_network-cnt">${m.cnt}</span>` : ''}</span>`;
	      });
	    }
	    infoWindowContent += '</div>';
	    return infoWindowContent;
	  },
	  createClusterMarkerSVG(elementsCnt) {
	    let {
	      svgWidth,
	      svgHeight,
	      circleRadius,
	      strokeWidth
	    } = getMarkerSize(elementsCnt, 1); // here zoom must always be 1

	    return window.btoa(`
				<svg width="${svgWidth}" height="${svgHeight}" viewBox="0 0 ${svgWidth} ${svgHeight}" fill="none" xmlns="http://www.w3.org/2000/svg">
					<g filter="url(#filter0_d_6106_3045)">
						<circle cx="${svgWidth / 2}" cy="${svgHeight / 2}" r="${circleRadius}" fill="#17D4A7"/>
						<circle cx="${svgWidth / 2}" cy="${svgHeight / 2}" r="${circleRadius + 1}" stroke="white" stroke-width="${strokeWidth}"/>
					</g>
					${elementsCnt !== 1 ? `<text x="${svgWidth / 2}" y="${svgHeight / 2}" text-anchor="middle" dy=".35em" font-family="Arial" font-size="10" font-weight="bold" fill="#fff">${elementsCnt}</text>` : ''}
					<defs>
						<filter id="filter0_d_6106_3045" x="0" y="0" width="${svgWidth}" height="${svgHeight}" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
							<feFlood flood-opacity="0" result="BackgroundImageFix"/>
							<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
							<feOffset dy="1"/>
							<feGaussianBlur stdDeviation="1"/>
							<feComposite in2="hardAlpha" operator="out"/>
							<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/>
							<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_6106_3045"/>
							<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_6106_3045" result="shape"/>
						</filter>
					</defs>
				</svg>
			`);
	  },
	  focusMapOnMarkers(markersData) {
	    let locationStrings = Object.keys(markersData);
	    if (locationStrings.length === 0) {
	      return;
	    }
	    let positions = locationStrings.map(str => {
	      let [lat, lng] = str.split(', ');
	      return {
	        lat: Number(lat),
	        lng: Number(lng)
	      };
	    });
	    let bounds = new google.maps.LatLngBounds();
	    positions.forEach(position => bounds.extend(position));

	    // temp limit for zooming
	    map.setOptions({
	      maxZoom: 12
	    });
	    map.fitBounds(bounds);
	    google.maps.event.addListenerOnce(map, 'idle', () => {
	      // resore zooming to inital
	      map.setOptions({
	        maxZoom: MAP_MAX_ZOOM
	      });
	    });
	  }
	};
	component$6.exports.template = {
	  v: 4,
	  t: [{
	    t: 4,
	    f: [{
	      t: 7,
	      e: "script",
	      f: ["\t\tfunction onDocumentReady (fn) {\n\t\t\tif (document.readyState !== 'loading') {\n\t\t\t\tfn();\n\t\t\t} else {\n\t\t\t\tdocument.addEventListener('DOMContentLoaded', fn);\n\t\t\t}\n\t\t}\n\t\t/* eslint-disable */\n\t\tfunction initMap () {\n\t\t\tonDocumentReady(function () {\n\t\t\t\tapp.loaded = true;\n\n\t\t\t\tif (app.initMap && app.router.route.view) {\n\t\t\t\t\tapp.initMap();\n\t\t\t\t}\n\t\t\t});\n\t\t}\n\t"]
	    }, " ", {
	      t: 7,
	      e: "script",
	      m: [{
	        n: "src",
	        f: "https://maps.googleapis.com/maps/api/js?key=AIzaSyBTICLY5LgWNJ0Uly61Q1sNXz_1KZIECwg&language=en&callback=initMap&libraries=marker&loading=async",
	        t: 13,
	        g: 1
	      }, {
	        n: "async",
	        f: 0,
	        t: 13
	      }]
	    }, " ", {
	      t: 4,
	      f: [{
	        t: 7,
	        e: "script",
	        m: [{
	          n: "src",
	          f: "https://cdn.jsdelivr.net/npm/@googlemaps/markerclusterer@2.5.3/dist/index.umd.min.js",
	          t: 13,
	          g: 1
	        }]
	      }],
	      n: 50,
	      r: "probesByCoords"
	    }],
	    n: 50,
	    x: {
	      r: ["@shared.isServer", "@shared.googleMapsLoaded"],
	      s: "!_0&&!_1"
	    }
	  }, {
	    t: 7,
	    e: "div",
	    m: [{
	      n: "id",
	      f: "gp-map",
	      t: 13,
	      g: 1
	    }, {
	      n: "class",
	      f: [{
	        t: 2,
	        r: "class"
	      }],
	      t: 13
	    }]
	  }],
	  e: {
	    "!_0&&!_1": function (_0, _1) {
	      return !_0 && !_1;
	    }
	  }
	};
	var googleMaps = ractive__default["default"].extend(component$6.exports);

	var component$5 = {
	  exports: {}
	};
	const FILTER_TYPE_BY_CONTINENT = 'byContinent';
	const FILTER_TYPE_BY_NETWORK = 'byNetwork';
	const FILTER_TYPE_BY_CLOUD = 'byCloud';
	component$5.exports = {
	  data() {
	    return {
	      title: 'Network - Globalping',
	      description: 'Explore the global network map of Globalping probes.',
	      availableFilters: [{
	        name: 'Europe',
	        value: 'EU',
	        type: FILTER_TYPE_BY_CONTINENT
	      }, {
	        name: 'North America',
	        value: 'NA',
	        type: FILTER_TYPE_BY_CONTINENT
	      }, {
	        name: 'South America',
	        value: 'SA',
	        type: FILTER_TYPE_BY_CONTINENT
	      }, {
	        name: 'Africa',
	        value: 'AF',
	        type: FILTER_TYPE_BY_CONTINENT
	      }, {
	        name: 'Asia',
	        value: 'AS',
	        type: FILTER_TYPE_BY_CONTINENT
	      }, {
	        name: 'Oceania',
	        value: 'OC',
	        type: FILTER_TYPE_BY_CONTINENT
	      }, {
	        name: 'eyeball network',
	        value: 'eyeball-network',
	        type: FILTER_TYPE_BY_NETWORK
	      }, {
	        name: 'datacenter',
	        value: 'datacenter-network',
	        type: FILTER_TYPE_BY_NETWORK
	      }, {
	        name: 'Google Cloud',
	        value: 'gcp',
	        type: FILTER_TYPE_BY_CLOUD
	      }, {
	        name: 'AWS Cloud',
	        value: 'aws',
	        type: FILTER_TYPE_BY_CLOUD
	      }],
	      filtersSet: null,
	      probesResponse: null,
	      probesByContinents: null,
	      probesByCoords: null,
	      filteredProbes: null,
	      preparedProbesColumns: null,
	      filteredMarkersData: null
	    };
	  },
	  computed: {
	    filter: {
	      get() {
	        return this.get('filtersSet') ? this.get('filtersSet').map(f => f.value).join(',').toLowerCase() : [];
	      },
	      set(filters) {
	        let availableFilters = this.get('availableFilters');
	        (filters || '').split(',').forEach(f => {
	          let idx = availableFilters.findIndex(af => af.value.toLowerCase() === f.toLowerCase());
	          if (idx > -1) {
	            this.setFilterRule(idx);
	          }
	        });
	      }
	    }
	  },
	  oninit() {
	    if (!ractive__default["default"].isServer) {
	      // get probes from sessionStorage or fetch them and handle
	      this.getProbesData();

	      // set initial screenWidth value
	      this.observe('screenWidth', screenWidth => {
	        if (!screenWidth) {
	          this.set('screenWidth', window.innerWidth);
	        } else {
	          let columnsAmount = this.getLayoutColumnsAmount(screenWidth);
	          let filteredProbes = this.get('filteredProbes');
	          let sorted = this.sortProbesByCountriesAndCities(filteredProbes);
	          let preparedProbesColumns = this.splitDataIntoColumns(sorted, columnsAmount);
	          this.set('preparedProbesColumns', preparedProbesColumns);
	        }
	      });

	      // sort probes by continents, and each list by country name
	      this.observe('probesResponse', probesResponse => {
	        if (probesResponse) {
	          let {
	            groupedByContinents,
	            groupedByCoords
	          } = this.groupProbes(probesResponse);
	          this.set('probesByContinents', groupedByContinents);
	          this.set('probesByCoords', groupedByCoords);

	          // set initial probes and marker data values
	          let filtersSet = this.get('filtersSet');
	          this.set('filteredProbes', this.getFilteredProbesList(filtersSet));
	          this.set('filteredMarkersData', this.getFilteredMarkersData(filtersSet));
	        }
	      });

	      // use filters for the probesByContinents before render
	      this.observe('filtersSet', filtersSet => {
	        this.set('filteredProbes', this.getFilteredProbesList(filtersSet));
	        this.set('filteredMarkersData', this.getFilteredMarkersData(filtersSet));
	      });

	      // prepare probes data for rendering
	      this.observe('filteredProbes', filteredProbes => {
	        if (!filteredProbes) {
	          return;
	        }
	        let screenWidth = this.get('screenWidth');
	        let columnsAmount = this.getLayoutColumnsAmount(screenWidth);
	        let sorted = this.sortProbesByCountriesAndCities(filteredProbes);
	        let preparedProbesColumns = this.splitDataIntoColumns(sorted, columnsAmount);
	        this.set('preparedProbesColumns', preparedProbesColumns);
	      });
	    }
	  },
	  onrender() {
	    if (!ractive__default["default"].isServer) {
	      this.set('@shared.googleMapsLoaded', true);
	      listeners.screenWidthListener(this);
	    }
	  },
	  handleProbesByCoordsChange() {
	    let filtersSet = this.get('filtersSet');
	    let byContinentFilerRule = filtersSet ? filtersSet.find(fR => fR.type === FILTER_TYPE_BY_CONTINENT) : null;
	    return byContinentFilerRule;
	  },
	  getProbesData() {
	    if (has$6.sessionStorage()) {
	      let probesResponse = sessionStorage.getItem('probesResponse');
	      if (probesResponse) {
	        this.handleProbesResponse(true)(probesResponse);
	      } else {
	        http.fetchGlobalpingProbes().then(this.handleProbesResponse(false));
	      }
	    } else {
	      http.fetchGlobalpingProbes().then(this.handleProbesResponse(false));
	    }
	  },
	  handleProbesResponse(isStored) {
	    return response => {
	      if (!isStored) {
	        sessionStorage.setItem('probesResponse', JSON.stringify(response));
	      } else {
	        response = JSON.parse(response);
	      }
	      this.set('probesResponse', response);
	    };
	  },
	  groupProbes(probes) {
	    // group probes by Continents and Coordinates
	    let groups = probes.reduce((res, probe) => {
	      let coords = `${probe.location.latitude}, ${probe.location.longitude}`;
	      let location = `${probe.location.country}, ${probe.location.city}`;

	      // group by Continents
	      if (!Object.hasOwn(res.groupedByContinents, probe.location.continent)) {
	        res.groupedByContinents[probe.location.continent] = {};
	      }
	      if (!Object.hasOwn(res.groupedByContinents[probe.location.continent], location)) {
	        res.groupedByContinents[probe.location.continent][location] = [];
	      }
	      res.groupedByContinents[probe.location.continent][location].push(probe);

	      // group by Coordinates
	      if (!Object.hasOwn(res.groupedByCoords, coords)) {
	        res.groupedByCoords[coords] = [];
	      }
	      res.groupedByCoords[coords].push(probe);
	      return res;
	    }, {
	      groupedByContinents: {},
	      groupedByCoords: {}
	    });
	    let byContinentSorted = Object.entries(groups.groupedByContinents).sort((a, b) => Object.keys(b[1]).length - Object.keys(a[1]).length);
	    groups.groupedByContinents = Object.fromEntries(byContinentSorted);
	    return groups;
	  },
	  getContinentName(code) {
	    let cData = CONTINENTS.find(c => c.code === code);
	    return cData ? cData.name : null;
	  },
	  setFilterRule(fIdx) {
	    let filtersSet = this.get('filtersSet');
	    let availableFilters = this.get('availableFilters');
	    let newFilterRule = availableFilters[fIdx];
	    let updFiltersSet;
	    newFilterRule.selected = true;
	    newFilterRule.avFiltersIdx = fIdx;
	    if (filtersSet) {
	      // if user sets the Eyeball filter we should deselect any byCloud filters and replace the previous byNetwork filter
	      if (newFilterRule.value === 'eyeball-network') {
	        let {
	          filtered,
	          filteredOut
	        } = filtersSet.reduce((acc, f) => {
	          if (f.type !== FILTER_TYPE_BY_CLOUD) {
	            acc.filtered.push(f);
	          } else {
	            acc.filteredOut.push(f);
	          }
	          return acc;
	        }, {
	          filtered: [],
	          filteredOut: []
	        });
	        let index = filtered.findIndex(i => i.type === FILTER_TYPE_BY_NETWORK);
	        if (index !== -1) {
	          availableFilters[filtered[index].avFiltersIdx].selected = false;
	          filtered[index] = newFilterRule;
	        } else {
	          filtered.push(newFilterRule);
	        }
	        updFiltersSet = filtered;
	        filteredOut.forEach(fO => availableFilters[fO.avFiltersIdx].selected = false);
	        // if user sets the byCloud filter we should deselect Eyeball filter and replace the previous byCloud filter
	      } else if (newFilterRule.type === FILTER_TYPE_BY_CLOUD) {
	        let {
	          filtered,
	          filteredOut
	        } = filtersSet.reduce((acc, f) => {
	          if (f.value !== 'eyeball-network') {
	            acc.filtered.push(f);
	          } else {
	            acc.filteredOut.push(f);
	          }
	          return acc;
	        }, {
	          filtered: [],
	          filteredOut: []
	        });
	        let index = filtered.findIndex(i => i.type === FILTER_TYPE_BY_CLOUD);
	        if (index !== -1) {
	          availableFilters[filtered[index].avFiltersIdx].selected = false;
	          filtered[index] = newFilterRule;
	        } else {
	          filtered.push(newFilterRule);
	        }
	        updFiltersSet = filtered;
	        filteredOut.forEach(fO => availableFilters[fO.avFiltersIdx].selected = false);
	      } else if (filtersSet.find(f => f.type === newFilterRule.type)) {
	        updFiltersSet = filtersSet.map(f => {
	          if (f.type === newFilterRule.type) {
	            availableFilters[f.avFiltersIdx].selected = false;
	            return newFilterRule;
	          }
	          return f;
	        });
	      } else {
	        updFiltersSet = [...filtersSet, newFilterRule];
	      }
	    } else {
	      updFiltersSet = [newFilterRule];
	    }
	    this.set('filtersSet', updFiltersSet);
	    this.set('availableFilters', availableFilters);
	  },
	  rmFilterRule(fIdx) {
	    let filtersSet = this.get('filtersSet');
	    let availableFilters = this.get('availableFilters');
	    let setFilterRule = filtersSet[fIdx];
	    let avFiltersRule = availableFilters.find(af => af.value === setFilterRule.value);
	    avFiltersRule.selected = false;
	    filtersSet.splice(fIdx, 1);
	    this.set('filtersSet', filtersSet.length ? filtersSet : []);
	    this.set('availableFilters', availableFilters);
	  },
	  getFilteredProbesList(filtersSet) {
	    let probesByContinents = this.get('probesByContinents');
	    return this.applyFiltersToData(probesByContinents, filtersSet, true);
	  },
	  getFilteredMarkersData(filtersSet) {
	    let probesByCoords = this.get('probesByCoords');
	    return this.applyFiltersToData(probesByCoords, filtersSet);
	  },
	  applyFiltersToData(data, filtersSet) {
	    let forProbes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	    let filteredProbes = {};
	    if (filtersSet === null || filtersSet.length === 0) {
	      return data;
	    }

	    // get the filter rules
	    let byContinentFilerRule = filtersSet.find(fR => fR.type === FILTER_TYPE_BY_CONTINENT);
	    let byNetworkFilerRule = filtersSet.find(fR => fR.type === FILTER_TYPE_BY_NETWORK);
	    let byCloudFilerRule = filtersSet.find(fR => fR.type === FILTER_TYPE_BY_CLOUD);

	    // filter by Continent
	    if (byContinentFilerRule) {
	      if (forProbes) {
	        filteredProbes[byContinentFilerRule.value] = data[byContinentFilerRule.value];
	      } else {
	        let toFilter = Object.keys(filteredProbes).length ? filteredProbes : data;
	        filteredProbes = Object.keys(toFilter).reduce((res, key) => {
	          let filtered = toFilter[key].filter(p => p.location.continent === byContinentFilerRule.value);
	          if (filtered.length) {
	            res[key] = filtered;
	          } else {
	            delete res[key];
	          }
	          return res;
	        }, filteredProbes);
	      }
	    }

	    // filter by Network
	    if (byNetworkFilerRule) {
	      let toFilter = Object.keys(filteredProbes).length ? filteredProbes : data;
	      if (forProbes) {
	        filteredProbes = Object.keys(toFilter).reduce((res, key) => {
	          let continentProbes = Object.keys(toFilter[key]).reduce((cRes, loc) => {
	            let locFiltered = toFilter[key][loc].filter(p => p.tags.includes(byNetworkFilerRule.value));
	            if (locFiltered.length) {
	              cRes[loc] = locFiltered;
	            }
	            return cRes;
	          }, {});
	          if (Object.keys(continentProbes).length) {
	            res[key] = continentProbes;
	          } else {
	            delete res[key];
	          }
	          return res;
	        }, {});
	      } else {
	        filteredProbes = Object.keys(toFilter).reduce((res, key) => {
	          let filtered = toFilter[key].filter(p => p.tags.includes(byNetworkFilerRule.value));
	          if (filtered.length) {
	            res[key] = filtered;
	          } else {
	            delete res[key];
	          }
	          return res;
	        }, filteredProbes);
	      }
	    }

	    // filter by Cloud provider
	    if (byCloudFilerRule) {
	      let toFilter = Object.keys(filteredProbes).length ? filteredProbes : data;
	      if (forProbes) {
	        filteredProbes = Object.keys(toFilter).reduce((res, key) => {
	          let continentProbes = Object.keys(toFilter[key]).reduce((cRes, loc) => {
	            let locFiltered = toFilter[key][loc].filter(p => p.tags.some(v => v.startsWith(byCloudFilerRule.value)));
	            if (locFiltered.length) {
	              cRes[loc] = locFiltered;
	            }
	            return cRes;
	          }, {});
	          if (Object.keys(continentProbes).length) {
	            res[key] = continentProbes;
	          } else {
	            delete res[key];
	          }
	          return res;
	        }, {});
	      } else {
	        filteredProbes = Object.keys(toFilter).reduce((res, key) => {
	          let filtered = toFilter[key].filter(p => p.tags.some(v => v.startsWith(byCloudFilerRule.value)));
	          if (filtered.length) {
	            res[key] = filtered;
	          } else {
	            delete res[key];
	          }
	          return res;
	        }, filteredProbes);
	      }
	    }
	    return filteredProbes;
	  },
	  sortProbesByCountriesAndCities(obj) {
	    let sortedArray = [];
	    Object.keys(obj).forEach(continent => {
	      let sortedLocations = Object.keys(obj[continent]).sort((a, b) => {
	        let [countryA, cityA] = a.split(', ');
	        let [countryB, cityB] = b.split(', ');
	        return countryA.localeCompare(countryB) || cityA.localeCompare(cityB);
	      });
	      sortedArray.push(...sortedLocations.map(location => ({
	        continent,
	        location,
	        probes: obj[continent][location]
	      })));
	    });
	    return sortedArray;
	  },
	  splitDataIntoColumns(data) {
	    let columnsCnt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 4;
	    let minItemsPerColumn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 30;
	    let totalItems = data.length;
	    let itemsPerColumn = Math.max(minItemsPerColumn, Math.ceil(totalItems / columnsCnt));
	    let columnNumber = 0;
	    let columnMax = Math.max(minItemsPerColumn, itemsPerColumn);
	    return data.reduce((res, item) => {
	      if (!res[columnNumber]) {
	        res[columnNumber] = [];
	      }
	      let currCont = item.continent;
	      if (res[columnNumber].length < columnMax) {
	        let isPresent = res.some(i => i.some(k => k.continent === currCont));
	        if (isPresent) {
	          res[columnNumber].push({
	            ...item,
	            continent: null
	          });
	        } else {
	          if (res[columnNumber].length + 1 !== columnMax) {
	            res[columnNumber].push(item);
	          } else {
	            columnNumber += 1;
	          }
	        }
	      } else {
	        columnNumber += 1;
	      }
	      return res;
	    }, []);
	  },
	  getLayoutColumnsAmount(screenWidth) {
	    let columnsAmount = 1;
	    if (screenWidth >= 576 && screenWidth < 768) {
	      columnsAmount = 2;
	    } else if (screenWidth >= 768 && screenWidth < 992) {
	      columnsAmount = 3;
	    } else if (screenWidth >= 992) {
	      columnsAmount = 4;
	    }
	    return columnsAmount;
	  }
	};
	component$5.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "r-page",
	    m: [{
	      n: "noYield",
	      f: [{
	        t: 2,
	        r: "noYield"
	      }],
	      t: 13
	    }, {
	      n: "title",
	      f: [{
	        t: 2,
	        r: "title"
	      }],
	      t: 13
	    }, {
	      n: "description",
	      f: [{
	        t: 2,
	        r: "description"
	      }],
	      t: 13
	    }],
	    f: [{
	      t: 7,
	      e: "c-notification"
	    }, " ", {
	      t: 7,
	      e: "c-gp-header",
	      m: [{
	        n: "additionalClasses",
	        f: "header-with-globalping-bg",
	        t: 13,
	        g: 1
	      }]
	    }, " ", {
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "p-globalping-network",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "gp-network",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "gp-network_map-wrapper",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "c-google-maps",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp-network_map-wrapper_map",
	              g: 1
	            }, {
	              n: "iwClass",
	              f: "gp-network_iw",
	              t: 13,
	              g: 1
	            }, {
	              n: "probesByCoords",
	              f: [{
	                t: 2,
	                r: "filteredMarkersData"
	              }],
	              t: 13
	            }, {
	              n: "onProbesByCoordsChange",
	              f: [{
	                t: 2,
	                r: "@this.handleProbesByCoordsChange"
	              }],
	              t: 13
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "gp-network_filters",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "span",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp-network_filters_title",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "img",
	              m: [{
	                n: "width",
	                f: "20",
	                t: 13,
	                g: 1
	              }, {
	                n: "height",
	                f: "20",
	                t: 13,
	                g: 1
	              }, {
	                n: "src",
	                f: [{
	                  t: 2,
	                  r: "@shared.assetsHost"
	                }, "/img/globalping/filter-icon.svg"],
	                t: 13
	              }]
	            }, " ", {
	              t: 7,
	              e: "span",
	              f: ["Filters:"]
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "gp-network_filters_list",
	              g: 1
	            }],
	            f: [{
	              t: 4,
	              f: [{
	                t: 7,
	                e: "span",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "gp-network_filters_list_selected",
	                  g: 1
	                }],
	                f: [{
	                  t: 2,
	                  r: "./name"
	                }, " ", {
	                  t: 7,
	                  e: "img",
	                  m: [{
	                    n: ["click"],
	                    t: 70,
	                    f: {
	                      r: ["@this", "@key"],
	                      s: "[_0.rmFilterRule(_1)]"
	                    }
	                  }, {
	                    n: "width",
	                    f: "16",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "16",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "src",
	                    f: [{
	                      t: 2,
	                      r: "@shared.assetsHost"
	                    }, "/img/globalping/tag-input-close-icon.svg"],
	                    t: 13
	                  }]
	                }]
	              }],
	              n: 52,
	              r: "filtersSet"
	            }, " ", {
	              t: 4,
	              f: [{
	                t: 4,
	                f: [{
	                  t: 7,
	                  e: "span",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "gp-network_filters_list_item",
	                    g: 1
	                  }, {
	                    n: ["click"],
	                    t: 70,
	                    f: {
	                      r: ["@this", "@key"],
	                      s: "[_0.setFilterRule(_1)]"
	                    }
	                  }],
	                  f: [{
	                    t: 2,
	                    r: "./name"
	                  }]
	                }],
	                n: 51,
	                r: "./selected"
	              }],
	              n: 52,
	              r: "availableFilters"
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "gp-network_list",
	            g: 1
	          }],
	          f: [{
	            t: 4,
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "gp-network_list_column",
	                g: 1
	              }],
	              f: [{
	                t: 4,
	                f: [{
	                  t: 4,
	                  f: [{
	                    t: 7,
	                    e: "span",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "gp-network_list_column_item cont-header",
	                      g: 1
	                    }],
	                    f: [{
	                      t: 2,
	                      x: {
	                        r: ["@this", "item.continent"],
	                        s: "_0.getContinentName(_1)"
	                      }
	                    }]
	                  }],
	                  n: 50,
	                  x: {
	                    r: ["item.continent"],
	                    s: "_0!==null"
	                  }
	                }, " ", {
	                  t: 7,
	                  e: "span",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "gp-network_list_column_item",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "span",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "gp-network_list_column_item_img",
	                      g: 1
	                    }],
	                    f: [{
	                      t: 7,
	                      e: "img",
	                      m: [{
	                        n: "width",
	                        f: "17",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "height",
	                        f: "12",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "src",
	                        f: ["https://cdn.jsdelivr.net/npm/country-flag-icons@1.5.5/3x2/", {
	                          t: 2,
	                          x: {
	                            r: ["item.location"],
	                            s: "_0.split(\", \")[0]"
	                          }
	                        }, ".svg"],
	                        t: 13
	                      }]
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "span",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "gp-network_list_column_item_location",
	                      g: 1
	                    }],
	                    f: [{
	                      t: 2,
	                      r: "item.location"
	                    }, " ", {
	                      t: 4,
	                      f: [{
	                        t: 7,
	                        e: "span",
	                        f: ["(x", {
	                          t: 2,
	                          r: "item.probes.length"
	                        }, ")"]
	                      }],
	                      n: 50,
	                      x: {
	                        r: ["item.probes.length"],
	                        s: "_0!==1"
	                      }
	                    }]
	                  }]
	                }],
	                n: 52,
	                z: [{
	                  n: "item",
	                  x: {
	                    r: "."
	                  }
	                }],
	                r: "column"
	              }]
	            }],
	            n: 52,
	            z: [{
	              n: "column",
	              x: {
	                r: "."
	              }
	            }],
	            r: "preparedProbesColumns"
	          }, " ", {
	            t: 4,
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "gp-network_list_no-result",
	                g: 1
	              }],
	              f: ["No results found. Try adjusting your filters."]
	            }],
	            n: 50,
	            x: {
	              r: ["preparedProbesColumns", "preparedProbesColumns.length"],
	              s: "_0&&_1===0"
	            }
	          }]
	        }]
	      }]
	    }, " ", {
	      t: 7,
	      e: "c-gp-footer"
	    }]
	  }],
	  e: {
	    "[_0.rmFilterRule(_1)]": function (_0, _1) {
	      return [_0.rmFilterRule(_1)];
	    },
	    "[_0.setFilterRule(_1)]": function (_0, _1) {
	      return [_0.setFilterRule(_1)];
	    },
	    "_0.getContinentName(_1)": function (_0, _1) {
	      return _0.getContinentName(_1);
	    },
	    "_0!==null": function (_0) {
	      return _0 !== null;
	    },
	    "_0.split(\", \")[0]": function (_0) {
	      return _0.split(", ")[0];
	    },
	    "_0!==1": function (_0) {
	      return _0 !== 1;
	    },
	    "_0&&_1===0": function (_0, _1) {
	      return _0 && _1 === 0;
	    }
	  }
	};
	component$5.exports.components = {
	  "c-notification": notification,
	  "c-gp-footer": gpFooter,
	  "c-google-maps": googleMaps,
	  "c-gp-header": gpHeader,
	  "r-page": rPageGlobalping
	};
	var network = ractive__default["default"].extend(component$5.exports);

	// eslint-disable-next-line es/no-set -- safe
	var SetPrototype$1 = Set.prototype;
	var setHelpers = {
	  // eslint-disable-next-line es/no-set -- safe
	  Set: Set,
	  add: functionUncurryThis(SetPrototype$1.add),
	  has: functionUncurryThis(SetPrototype$1.has),
	  remove: functionUncurryThis(SetPrototype$1['delete']),
	  proto: SetPrototype$1
	};

	var has$5 = setHelpers.has;

	// Perform ? RequireInternalSlot(M, [[SetData]])
	var aSet = function (it) {
	  has$5(it);
	  return it;
	};

	var iterateSimple = function (record, fn, ITERATOR_INSTEAD_OF_RECORD) {
	  var iterator = ITERATOR_INSTEAD_OF_RECORD ? record : record.iterator;
	  var next = record.next;
	  var step, result;
	  while (!(step = functionCall(next, iterator)).done) {
	    result = fn(step.value);
	    if (result !== undefined) return result;
	  }
	};

	var Set$3 = setHelpers.Set;
	var SetPrototype = setHelpers.proto;
	var forEach = functionUncurryThis(SetPrototype.forEach);
	var keys = functionUncurryThis(SetPrototype.keys);
	var next = keys(new Set$3()).next;
	var setIterate = function (set, fn, interruptible) {
	  return interruptible ? iterateSimple({
	    iterator: keys(set),
	    next: next
	  }, fn) : forEach(set, fn);
	};

	var Set$2 = setHelpers.Set;
	var add$3 = setHelpers.add;
	var setClone = function (set) {
	  var result = new Set$2();
	  setIterate(set, function (it) {
	    add$3(result, it);
	  });
	  return result;
	};

	var setSize = functionUncurryThisAccessor(setHelpers.proto, 'size', 'get') || function (set) {
	  return set.size;
	};

	var INVALID_SIZE = 'Invalid size';
	var $RangeError = RangeError;
	var $TypeError = TypeError;
	var max = Math.max;
	var SetRecord = function (set, intSize) {
	  this.set = set;
	  this.size = max(intSize, 0);
	  this.has = aCallable(set.has);
	  this.keys = aCallable(set.keys);
	};
	SetRecord.prototype = {
	  getIterator: function () {
	    return getIteratorDirect(anObject(functionCall(this.keys, this.set)));
	  },
	  includes: function (it) {
	    return functionCall(this.has, this.set, it);
	  }
	};

	// `GetSetRecord` abstract operation
	// https://tc39.es/proposal-set-methods/#sec-getsetrecord
	var getSetRecord = function (obj) {
	  anObject(obj);
	  var numSize = +obj.size;
	  // NOTE: If size is undefined, then numSize will be NaN
	  // eslint-disable-next-line no-self-compare -- NaN check
	  if (numSize !== numSize) throw new $TypeError(INVALID_SIZE);
	  var intSize = toIntegerOrInfinity(numSize);
	  if (intSize < 0) throw new $RangeError(INVALID_SIZE);
	  return new SetRecord(obj, intSize);
	};

	var has$4 = setHelpers.has;
	var remove$1 = setHelpers.remove;

	// `Set.prototype.difference` method
	// https://github.com/tc39/proposal-set-methods
	var setDifference = function difference(other) {
	  var O = aSet(this);
	  var otherRec = getSetRecord(other);
	  var result = setClone(O);
	  if (setSize(O) <= otherRec.size) setIterate(O, function (e) {
	    if (otherRec.includes(e)) remove$1(result, e);
	  });else iterateSimple(otherRec.getIterator(), function (e) {
	    if (has$4(O, e)) remove$1(result, e);
	  });
	  return result;
	};

	var createSetLike = function (size) {
	  return {
	    size: size,
	    has: function () {
	      return false;
	    },
	    keys: function () {
	      return {
	        next: function () {
	          return {
	            done: true
	          };
	        }
	      };
	    }
	  };
	};
	var setMethodAcceptSetLike = function (name) {
	  var Set = getBuiltIn('Set');
	  try {
	    new Set()[name](createSetLike(0));
	    try {
	      // late spec change, early WebKit ~ Safari 17.0 beta implementation does not pass it
	      // https://github.com/tc39/proposal-set-methods/pull/88
	      new Set()[name](createSetLike(-1));
	      return false;
	    } catch (error2) {
	      return true;
	    }
	  } catch (error) {
	    return false;
	  }
	};

	// `Set.prototype.difference` method
	// https://tc39.es/ecma262/#sec-set.prototype.difference
	_export({
	  target: 'Set',
	  proto: true,
	  real: true,
	  forced: !setMethodAcceptSetLike('difference')
	}, {
	  difference: setDifference
	});

	var Set$1 = setHelpers.Set;
	var add$2 = setHelpers.add;
	var has$3 = setHelpers.has;

	// `Set.prototype.intersection` method
	// https://github.com/tc39/proposal-set-methods
	var setIntersection = function intersection(other) {
	  var O = aSet(this);
	  var otherRec = getSetRecord(other);
	  var result = new Set$1();
	  if (setSize(O) > otherRec.size) {
	    iterateSimple(otherRec.getIterator(), function (e) {
	      if (has$3(O, e)) add$2(result, e);
	    });
	  } else {
	    setIterate(O, function (e) {
	      if (otherRec.includes(e)) add$2(result, e);
	    });
	  }
	  return result;
	};

	var INCORRECT = !setMethodAcceptSetLike('intersection') || fails(function () {
	  // eslint-disable-next-line es/no-array-from, es/no-set -- testing
	  return String(Array.from(new Set([1, 2, 3]).intersection(new Set([3, 2])))) !== '3,2';
	});

	// `Set.prototype.intersection` method
	// https://tc39.es/ecma262/#sec-set.prototype.intersection
	_export({
	  target: 'Set',
	  proto: true,
	  real: true,
	  forced: INCORRECT
	}, {
	  intersection: setIntersection
	});

	var has$2 = setHelpers.has;

	// `Set.prototype.isDisjointFrom` method
	// https://tc39.github.io/proposal-set-methods/#Set.prototype.isDisjointFrom
	var setIsDisjointFrom = function isDisjointFrom(other) {
	  var O = aSet(this);
	  var otherRec = getSetRecord(other);
	  if (setSize(O) <= otherRec.size) return setIterate(O, function (e) {
	    if (otherRec.includes(e)) return false;
	  }, true) !== false;
	  var iterator = otherRec.getIterator();
	  return iterateSimple(iterator, function (e) {
	    if (has$2(O, e)) return iteratorClose(iterator, 'normal', false);
	  }) !== false;
	};

	// `Set.prototype.isDisjointFrom` method
	// https://tc39.es/ecma262/#sec-set.prototype.isdisjointfrom
	_export({
	  target: 'Set',
	  proto: true,
	  real: true,
	  forced: !setMethodAcceptSetLike('isDisjointFrom')
	}, {
	  isDisjointFrom: setIsDisjointFrom
	});

	// `Set.prototype.isSubsetOf` method
	// https://tc39.github.io/proposal-set-methods/#Set.prototype.isSubsetOf
	var setIsSubsetOf = function isSubsetOf(other) {
	  var O = aSet(this);
	  var otherRec = getSetRecord(other);
	  if (setSize(O) > otherRec.size) return false;
	  return setIterate(O, function (e) {
	    if (!otherRec.includes(e)) return false;
	  }, true) !== false;
	};

	// `Set.prototype.isSubsetOf` method
	// https://tc39.es/ecma262/#sec-set.prototype.issubsetof
	_export({
	  target: 'Set',
	  proto: true,
	  real: true,
	  forced: !setMethodAcceptSetLike('isSubsetOf')
	}, {
	  isSubsetOf: setIsSubsetOf
	});

	var has$1 = setHelpers.has;

	// `Set.prototype.isSupersetOf` method
	// https://tc39.github.io/proposal-set-methods/#Set.prototype.isSupersetOf
	var setIsSupersetOf = function isSupersetOf(other) {
	  var O = aSet(this);
	  var otherRec = getSetRecord(other);
	  if (setSize(O) < otherRec.size) return false;
	  var iterator = otherRec.getIterator();
	  return iterateSimple(iterator, function (e) {
	    if (!has$1(O, e)) return iteratorClose(iterator, 'normal', false);
	  }) !== false;
	};

	// `Set.prototype.isSupersetOf` method
	// https://tc39.es/ecma262/#sec-set.prototype.issupersetof
	_export({
	  target: 'Set',
	  proto: true,
	  real: true,
	  forced: !setMethodAcceptSetLike('isSupersetOf')
	}, {
	  isSupersetOf: setIsSupersetOf
	});

	var add$1 = setHelpers.add;
	var has = setHelpers.has;
	var remove = setHelpers.remove;

	// `Set.prototype.symmetricDifference` method
	// https://github.com/tc39/proposal-set-methods
	var setSymmetricDifference = function symmetricDifference(other) {
	  var O = aSet(this);
	  var keysIter = getSetRecord(other).getIterator();
	  var result = setClone(O);
	  iterateSimple(keysIter, function (e) {
	    if (has(O, e)) remove(result, e);else add$1(result, e);
	  });
	  return result;
	};

	// `Set.prototype.symmetricDifference` method
	// https://tc39.es/ecma262/#sec-set.prototype.symmetricdifference
	_export({
	  target: 'Set',
	  proto: true,
	  real: true,
	  forced: !setMethodAcceptSetLike('symmetricDifference')
	}, {
	  symmetricDifference: setSymmetricDifference
	});

	var add = setHelpers.add;

	// `Set.prototype.union` method
	// https://github.com/tc39/proposal-set-methods
	var setUnion = function union(other) {
	  var O = aSet(this);
	  var keysIter = getSetRecord(other).getIterator();
	  var result = setClone(O);
	  iterateSimple(keysIter, function (it) {
	    add(result, it);
	  });
	  return result;
	};

	// `Set.prototype.union` method
	// https://tc39.es/ecma262/#sec-set.prototype.union
	_export({
	  target: 'Set',
	  proto: true,
	  real: true,
	  forced: !setMethodAcceptSetLike('union')
	}, {
	  union: setUnion
	});

	var getCache = (key, ttl, getDefaultValue) => {
	  if (!has$6.sessionStorage()) {
	    return getDefaultValue().then(value => {
	      sessionStorage.setItem(key, JSON.stringify({
	        data: value,
	        ttl: Date.now() + ttl
	      }));
	      return value;
	    });
	  }
	  let value;
	  try {
	    value = JSON.parse(sessionStorage.getItem(key) || '{}');
	  } catch {}
	  if (value && value.ttl && value.ttl > Date.now()) {
	    return Promise.resolve(value.data);
	  }
	  return getDefaultValue().then(value => {
	    sessionStorage.setItem(key, JSON.stringify({
	      data: value,
	      ttl: Date.now() + ttl
	    }));
	    return value;
	  });
	};
	var dataCache = {
	  getCache: getCache
	};

	var component$4 = {
	  exports: {}
	};
	component$4.exports = {
	  decorators: {
	    tooltip
	  },
	  data() {
	    return {
	      _,
	      username: '',
	      userProbes: null,
	      probesByCoords: null,
	      maxTagCount: 2,
	      userStats: {
	        asn: {
	          name: ['ASN'],
	          icon: 'file-text.svg',
	          count: 0
	        },
	        city: {
	          name: ['city', 'cities'],
	          icon: 'city.svg',
	          count: 0
	        },
	        country: {
	          name: ['country', 'countries'],
	          icon: 'country.svg',
	          count: 0
	        }
	      }
	    };
	  },
	  computed: {
	    title() {
	      return `${this.get('username')}'s Probes - Globalping`;
	    },
	    description() {
	      return `Find ${this.get('username')}'s Globalping probes.`;
	    }
	  },
	  oninit() {
	    if (!ractive__default["default"].isServer) {
	      this.getProbesData();
	      this.observe('userProbes', probes => {
	        if (probes) {
	          let {
	            groupedByCoords
	          } = this.groupProbes(probes);
	          this.set('probesByCoords', groupedByCoords);
	        }
	      });
	    }
	  },
	  onrender() {
	    if (!ractive__default["default"].isServer) {
	      let handleResize = debounce(throttle(() => this.calculateMaxTagCount(), 200));
	      listeners.addManagedListener(this, window, 'resize', handleResize);
	      this.observe('userProbes', () => this.calculateMaxTagCount(), {
	        defer: true
	      });
	    }
	  },
	  calculateMaxTagCount() {
	    let tagContainer = $('.page-content_main_section_probe_tag').get(0);
	    let tagContainerWidth = tagContainer ? tagContainer.offsetWidth : 0;
	    let maxTagCount = Math.max(2, Math.floor(tagContainerWidth / 100));
	    this.set('maxTagCount', maxTagCount);
	  },
	  handleProbesResponse(response) {
	    let user = `u-${this.get('username')}`.toLowerCase();
	    let userProbes = response.filter(probe => probe.tags.some(tag => tag.toLowerCase() === user)).sort((a, b) => {
	      let aLocation = `${a.location.country}${a.location.city}`;
	      let bLocation = `${b.location.country}${b.location.city}`;
	      return aLocation < bLocation ? -1 : aLocation > bLocation ? 1 : 0;
	    });
	    this.set('userProbes', userProbes);
	    let entries = Object.entries(this.get('userStats')).map(_ref => {
	      let [key, value] = _ref;
	      if (key === 'probe') {
	        return [key, {
	          ...value,
	          count: userProbes.length
	        }];
	      }
	      return [key, {
	        ...value,
	        count: [...new Set(userProbes.map(probe => probe.location[key]))].length
	      }];
	    }).sort((a, b) => b[1].count - a[1].count);
	    this.set('userStats', {}); // force reordering
	    this.set('userStats', Object.fromEntries(entries));
	  },
	  getProbesData() {
	    dataCache.getCache('probesResponse@2', 60 * 1000, http.fetchGlobalpingProbes).then(value => this.handleProbesResponse(value));
	  },
	  groupProbes(probes) {
	    // group probes by Coordinates
	    let groups = probes.reduce((res, probe) => {
	      let coords = `${probe.location.latitude}, ${probe.location.longitude}`;
	      if (!Object.hasOwn(res.groupedByCoords, coords)) {
	        res.groupedByCoords[coords] = [];
	      }
	      res.groupedByCoords[coords].push(probe);
	      return res;
	    }, {
	      groupedByCoords: {}
	    });
	    return groups;
	  }
	};
	component$4.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "r-page",
	    m: [{
	      n: "noYield",
	      f: [{
	        t: 2,
	        r: "noYield"
	      }],
	      t: 13
	    }, {
	      n: "title",
	      f: [{
	        t: 2,
	        r: "title"
	      }],
	      t: 13
	    }, {
	      n: "description",
	      f: [{
	        t: 2,
	        r: "description"
	      }],
	      t: 13
	    }],
	    f: [" ", {
	      t: 7,
	      e: "c-notification"
	    }, " ", {
	      t: 7,
	      e: "c-gp-header",
	      m: [{
	        n: "additionalClasses",
	        f: "header-with-gp-translucent-bg",
	        t: 13,
	        g: 1
	      }]
	    }, " ", {
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "p-users",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "page-content",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "page-content_side-menu",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "menu-section",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "section-list",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "user-section user-info",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "img",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "user-avatar",
	                    g: 1
	                  }, {
	                    n: "width",
	                    f: "124",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "124",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "src",
	                    f: ["https://github.com/", {
	                      t: 2,
	                      r: "username"
	                    }, ".png"],
	                    t: 13
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "span",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "user-data",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "width",
	                      f: "20",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "20",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/icons/github-outline.svg"],
	                      t: 13
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      n: "rel",
	                      f: "noopener noreferrer",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "href",
	                      f: ["https://github.com/", {
	                        t: 2,
	                        r: "username"
	                      }],
	                      t: 13
	                    }],
	                    f: [{
	                      t: 2,
	                      r: "username"
	                    }]
	                  }]
	                }]
	              }, " ", {
	                t: 4,
	                f: [{
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "user-section",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "span",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "user-data",
	                      g: 1
	                    }],
	                    f: [{
	                      t: 7,
	                      e: "img",
	                      m: [{
	                        n: "width",
	                        f: "20",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "height",
	                        f: "20",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "src",
	                        f: [{
	                          t: 2,
	                          r: "@shared.assetsHost"
	                        }, "/img/icons/radio.svg"],
	                        t: 13
	                      }]
	                    }, " ", {
	                      t: 2,
	                      r: "userProbes.length"
	                    }, " ", {
	                      t: 2,
	                      x: {
	                        r: ["_", "userProbes.length"],
	                        s: "_0.pluralize(\"probe\",_1)"
	                      }
	                    }]
	                  }, " ", {
	                    t: 4,
	                    f: [{
	                      t: 4,
	                      f: [{
	                        t: 7,
	                        e: "span",
	                        m: [{
	                          t: 13,
	                          n: "class",
	                          f: "user-data",
	                          g: 1
	                        }],
	                        f: [{
	                          t: 7,
	                          e: "img",
	                          m: [{
	                            n: "width",
	                            f: "20",
	                            t: 13,
	                            g: 1
	                          }, {
	                            n: "height",
	                            f: "20",
	                            t: 13,
	                            g: 1
	                          }, {
	                            n: "src",
	                            f: [{
	                              t: 2,
	                              r: "@shared.assetsHost"
	                            }, "/img/icons/", {
	                              t: 2,
	                              r: "icon"
	                            }],
	                            t: 13
	                          }]
	                        }, " ", {
	                          t: 2,
	                          r: "count"
	                        }, " ", {
	                          t: 2,
	                          x: {
	                            r: ["~/_", "name", "count"],
	                            s: "(function(){var x$0;return((x$0=_0.pluralize).apply(x$0,[].concat(_1,[_2])));})()"
	                          }
	                        }]
	                      }],
	                      n: 50,
	                      r: "count"
	                    }],
	                    n: 52,
	                    r: "userStats"
	                  }]
	                }],
	                n: 50,
	                r: "userProbes"
	              }]
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "page-content_main",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "page-content_main_section",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "p-users_map-wrapper",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "c-google-maps",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "p-users_map-wrapper_map",
	                  g: 1
	                }, {
	                  n: "iwClass",
	                  f: "p-users_iw",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "probesByCoords",
	                  f: [{
	                    t: 2,
	                    r: "probesByCoords"
	                  }],
	                  t: 13
	                }]
	              }]
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "page-content_main_section",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "h2",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "page-content_main_section_title",
	                g: 1
	              }],
	              f: ["List of probes"]
	            }, " ", {
	              t: 4,
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "text-center",
	                  g: 1
	                }],
	                f: ["Please wait while user data loads."]
	              }],
	              n: 50,
	              x: {
	                r: ["userProbes"],
	                s: "_0===null"
	              }
	            }, " ", {
	              t: 4,
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "text-center",
	                  g: 1
	                }],
	                f: [{
	                  t: 2,
	                  r: "username"
	                }, " seems to have no probes."]
	              }],
	              n: 50,
	              x: {
	                r: ["userProbes.length"],
	                s: "_0===0"
	              }
	            }, " ", {
	              t: 4,
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "page-content_main_section_probe",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "page-content_main_section_probe_details",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "div",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "page-content_main_section_probe_details_icon",
	                      g: 1
	                    }],
	                    f: [{
	                      t: 7,
	                      e: "img",
	                      m: [{
	                        n: "width",
	                        f: "24",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "height",
	                        f: "24",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "src",
	                        f: [{
	                          t: 2,
	                          r: "@shared.assetsHost"
	                        }, "/img/globalping/globalping-probe.svg"],
	                        t: 13
	                      }]
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "div",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "page-content_main_section_probe_details_info",
	                      g: 1
	                    }],
	                    f: [{
	                      t: 7,
	                      e: "div",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "page-content_main_section_probe_details_info_city",
	                        g: 1
	                      }],
	                      f: [{
	                        t: 7,
	                        e: "img",
	                        m: [{
	                          n: "width",
	                          f: "16.8",
	                          t: 13,
	                          g: 1
	                        }, {
	                          n: "height",
	                          f: "12",
	                          t: 13,
	                          g: 1
	                        }, {
	                          n: "src",
	                          f: ["https://cdn.jsdelivr.net/npm/country-flag-icons@1.5.5/3x2/", {
	                            t: 2,
	                            r: "location.country"
	                          }, ".svg"],
	                          t: 13
	                        }]
	                      }, " ", {
	                        t: 7,
	                        e: "span",
	                        m: [{
	                          t: 13,
	                          n: "class",
	                          f: "page-content_main_section_probe_details_info_city_name",
	                          g: 1
	                        }],
	                        f: [{
	                          t: 2,
	                          r: "location.city"
	                        }, ", ", {
	                          t: 2,
	                          r: "location.country"
	                        }]
	                      }]
	                    }, " ", {
	                      t: 7,
	                      e: "span",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "page-content_main_section_probe_details_info_location",
	                        g: 1
	                      }],
	                      f: [{
	                        t: 2,
	                        r: "location.network"
	                      }]
	                    }]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "page-content_main_section_probe_tag",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 4,
	                    f: [{
	                      t: 4,
	                      f: [{
	                        t: 7,
	                        e: "span",
	                        m: [{
	                          t: 13,
	                          n: "class",
	                          f: "page-content_main_section_probe_tag_item",
	                          g: 1
	                        }, {
	                          n: "tooltip",
	                          t: 71,
	                          f: {
	                            r: ["."],
	                            s: "[_0]"
	                          }
	                        }],
	                        f: [{
	                          t: 2,
	                          r: "."
	                        }]
	                      }],
	                      n: 50,
	                      x: {
	                        r: ["index", "maxTagCount"],
	                        s: "_0<_1"
	                      }
	                    }],
	                    n: 52,
	                    i: "index",
	                    r: "tags"
	                  }, " ", {
	                    t: 4,
	                    f: [{
	                      t: 7,
	                      e: "span",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "page-content_main_section_probe_tag_item",
	                        g: 1
	                      }, {
	                        n: "tooltip",
	                        t: 71,
	                        f: {
	                          r: ["tags", "maxTagCount"],
	                          s: "[_0.slice(_1).join(\", \")]"
	                        }
	                      }],
	                      f: ["+", {
	                        t: 2,
	                        x: {
	                          r: ["tags.length", "maxTagCount"],
	                          s: "_0-_1"
	                        }
	                      }]
	                    }],
	                    n: 50,
	                    x: {
	                      r: ["tags.length", "maxTagCount"],
	                      s: "_0>_1"
	                    }
	                  }]
	                }]
	              }],
	              n: 52,
	              r: "userProbes"
	            }]
	          }]
	        }]
	      }]
	    }, " ", {
	      t: 7,
	      e: "c-gp-footer"
	    }],
	    p: {
	      seo: [{
	        t: 7,
	        e: "meta",
	        m: [{
	          n: "name",
	          f: "canonical",
	          t: 13,
	          g: 1
	        }, {
	          n: "content",
	          f: ["/users/", {
	            t: 2,
	            r: "username"
	          }],
	          t: 13
	        }]
	      }]
	    }
	  }],
	  e: {
	    "_0.pluralize(\"probe\",_1)": function (_0, _1) {
	      return _0.pluralize("probe", _1);
	    },
	    "(function(){var x$0;return((x$0=_0.pluralize).apply(x$0,[].concat(_1,[_2])));})()": function (_0, _1, _2) {
	      return function () {
	        var x$0;
	        return (x$0 = _0.pluralize).apply(x$0, [].concat(_1, [_2]));
	      }();
	    },
	    "_0===null": function (_0) {
	      return _0 === null;
	    },
	    "_0===0": function (_0) {
	      return _0 === 0;
	    },
	    "[_0]": function (_0) {
	      return [_0];
	    },
	    "_0<_1": function (_0, _1) {
	      return _0 < _1;
	    },
	    "[_0.slice(_1).join(\", \")]": function (_0, _1) {
	      return [_0.slice(_1).join(", ")];
	    },
	    "_0-_1": function (_0, _1) {
	      return _0 - _1;
	    },
	    "_0>_1": function (_0, _1) {
	      return _0 > _1;
	    }
	  }
	};
	component$4.exports.components = {
	  "c-notification": notification,
	  "c-gp-footer": gpFooter,
	  "c-google-maps": googleMaps,
	  "c-gp-header": gpHeader,
	  "r-page": rPageGlobalping
	};
	var _users = ractive__default["default"].extend(component$4.exports);

	var component$3 = {
	  exports: {}
	};
	const ID_PREFIX$1 = 'id-';
	component$3.exports = {
	  data() {
	    return {
	      _,
	      html: '',
	      safeHtmlToRender: ''
	    };
	  },
	  oninit() {
	    if (!ractive__default["default"].isServer) {
	      app.injectGlobalStyle('https://cdn.jsdelivr.net/gh/highlightjs/cdn-release@11.7.0/build/styles/github.min.css');
	      Promise.all([
	      // eslint-disable-next-line n/no-missing-import
	      import('https://cdn.jsdelivr.net/npm/dompurify@2.4.3/+esm')]).then(_ref => {
	        let [{
	          default: DOMPurify
	        }] = _ref;
	        let _this = this;
	        DOMPurify.removeAllHooks();
	        DOMPurify.addHook('afterSanitizeAttributes', node => {
	          if (node.hasAttribute('href')) {
	            node.setAttribute('href', _.normalizeHref(node.getAttribute('href'), ID_PREFIX$1));
	          }
	          if (node.hasAttribute('src')) {
	            node.setAttribute('src', _.optimizeSrc(node.getAttribute('src'), _this.get('github')));
	            node.setAttribute('loading', 'lazy');
	          }
	          if ('target' in node) {
	            if (_.isExternalLink(node.getAttribute('href'))) {
	              node.setAttribute('target', '_blank');
	            }
	            node.setAttribute('rel', 'nofollow noopener noreferrer');
	            node.classList.add('router-ignore');
	          }
	        });

	        // if page URL has a hash then scroll page to the anchor
	        this.observe('safeHtmlToRender', () => {
	          // it appears the observer sometimes executes too soon despite defer: true, so we delay by one cycle here
	          setTimeout(() => {
	            let anchor = app.router.uri.hash;
	            let el = anchor ? this.find(anchor) : null;
	            if (el) {
	              if (document.visibilityState === 'visible') {
	                el.scrollIntoView({
	                  behavior: 'smooth'
	                });
	              } else {
	                document.addEventListener('visibilitychange', function listener() {
	                  el.scrollIntoView({
	                    behavior: 'smooth'
	                  });
	                  document.removeEventListener('visibilitychange', listener);
	                });
	              }
	            }
	          });
	        }, {
	          init: false,
	          defer: true
	        });
	        this.observe('html', html => {
	          this.set('safeHtmlToRender', DOMPurify.sanitize(html));
	        });
	      });
	    }
	  }
	};
	component$3.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "div",
	    m: [{
	      t: 13,
	      n: "class",
	      f: "c-html",
	      g: 1
	    }],
	    f: [{
	      t: 3,
	      r: "safeHtmlToRender"
	    }]
	  }]
	};
	var html = ractive__default["default"].extend(component$3.exports);

	var component$2 = {
	  exports: {}
	};
	const ID_PREFIX = 'id-';
	component$2.exports = {
	  data() {
	    return {
	      _,
	      html: '',
	      markdown: ''
	    };
	  },
	  oninit() {
	    if (!ractive__default["default"].isServer) {
	      app.injectGlobalStyle('https://cdn.jsdelivr.net/gh/highlightjs/cdn-release@11.7.0/build/styles/github.min.css');
	      Promise.all([
	      // eslint-disable-next-line n/no-missing-import
	      import('https://cdn.jsdelivr.net/npm/marked@4.2.12/+esm'),
	      // eslint-disable-next-line n/no-missing-import
	      import('https://cdn.jsdelivr.net/npm/@highlightjs/cdn-assets@11.7.0/es/highlight.min.js')]).then(_ref => {
	        let [{
	          marked
	        }, {
	          default: hljs
	        }] = _ref;
	        marked.use({
	          renderer: {
	            table() {
	              for (var _len = arguments.length, rows = new Array(_len), _key = 0; _key < _len; _key++) {
	                rows[_key] = arguments[_key];
	              }
	              return `<div class="table-responsive"><table class="table table-striped">${rows.join('')}</table></div>`;
	            }
	          }
	        });
	        marked.setOptions({
	          langPrefix: 'hljs language-',
	          headerIds: true,
	          headerPrefix: ID_PREFIX,
	          highlight(code, language) {
	            return hljs.getLanguage(language) ? hljs.highlightAuto(code, ['html', 'javascript', 'sh', 'bash']).value : code;
	          }
	        });
	        this.observe('markdown', md => {
	          this.set('html', marked.parse(md));
	        });
	      });
	    }
	  }
	};
	component$2.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "div",
	    m: [{
	      t: 13,
	      n: "class",
	      f: "c-markdown",
	      g: 1
	    }],
	    f: [{
	      t: 7,
	      e: "c-html",
	      m: [{
	        n: "html",
	        f: [{
	          t: 2,
	          r: "html"
	        }],
	        t: 13
	      }]
	    }]
	  }]
	};
	component$2.exports.components = {
	  "c-html": html
	};
	var markdown = ractive__default["default"].extend(component$2.exports);

	var component$1 = {
	  exports: {}
	};
	component$1.exports = {
	  data() {
	    return {};
	  },
	  oninit() {
	    if (!ractive__default["default"].isServer && !this.get('@shared.tuText')) {
	      _.makeHTTPRequest({
	        url: 'https://raw.githubusercontent.com/jsdelivr/globalping/master/docs/terms/Terms%20of%20Use.md',
	        rawResponse: true
	      }).then(response => {
	        this.set('@shared.tuText', response);
	      }).catch(() => {
	        this.set('@shared.tuText', `Failed to load the document. Please view it directly at:<br>https://github.com/jsdelivr/globalping/blob/master/docs/terms/Terms%20of%20Use.md`);
	      });
	      _.makeHTTPRequest({
	        url: 'https://raw.githubusercontent.com/jsdelivr/globalping/master/docs/terms/Privacy%20Policy.md',
	        rawResponse: true
	      }).then(response => {
	        this.set('@shared.ppText', response);
	      }).catch(() => {
	        this.set('@shared.ppText', `Failed to load the document. Please view it directly at:<br>https://github.com/jsdelivr/globalping/blob/master/docs/terms/Privacy%20Policy.md`);
	      });
	      _.makeHTTPRequest({
	        url: 'https://raw.githubusercontent.com/jsdelivr/globalping/master/docs/terms/Cookie%20Policy.md',
	        rawResponse: true
	      }).then(response => {
	        this.set('@shared.cpText', response);
	      }).catch(() => {
	        this.set('@shared.cpText', `Failed to load the document. Please view it directly at:<br>https://github.com/jsdelivr/globalping/blob/master/docs/terms/Cookie%20Policy.md`);
	      });
	    }
	  }
	};
	component$1.exports.template = {
	  v: 4,
	  t: []
	};
	var gpGithubMdDocumentsPrefetch = ractive__default["default"].extend(component$1.exports);

	var component = {
	  exports: {}
	};
	component.exports = {
	  data() {
	    return {
	      title: 'Terms & Policies - Globalping',
	      description: 'Learn about the terms of usage of the global network testing platform Globalping.',
	      currentPolicy: 'terms-of-use'
	    };
	  },
	  onrender() {
	    if (!ractive__default["default"].isServer) {
	      listeners.stickySidebarScrollListener(this);
	    }
	  }
	};
	component.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "r-page",
	    m: [{
	      n: "noYield",
	      f: [{
	        t: 2,
	        r: "noYield"
	      }],
	      t: 13
	    }, {
	      n: "title",
	      f: [{
	        t: 2,
	        r: "title"
	      }],
	      t: 13
	    }, {
	      n: "description",
	      f: [{
	        t: 2,
	        r: "description"
	      }],
	      t: 13
	    }],
	    f: [{
	      t: 7,
	      e: "c-gp-github-md-documents-prefetch"
	    }, " ", {
	      t: 7,
	      e: "c-notification"
	    }, " ", {
	      t: 7,
	      e: "c-gp-header",
	      m: [{
	        n: "additionalClasses",
	        f: "header-with-gp-translucent-bg",
	        t: 13,
	        g: 1
	      }]
	    }, " ", {
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "p-privacy-policy",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          n: "class",
	          f: ["please-wait-sign ", {
	            t: 4,
	            f: ["not-displayed"],
	            n: 50,
	            x: {
	              r: ["@shared.tuText", "@shared.ppText", "@shared.cpText"],
	              s: "_0&&_1&&_2"
	            }
	          }],
	          t: 13
	        }],
	        f: ["Please wait while the document loads."]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          n: "class",
	          f: ["dropdown ", {
	            t: 4,
	            f: ["not-displayed"],
	            n: 51,
	            x: {
	              r: ["@shared.tuText", "@shared.ppText", "@shared.cpText"],
	              s: "_0&&_1&&_2"
	            }
	          }],
	          t: 13
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "dropdown-toggle",
	            g: 1
	          }, {
	            n: "data-toggle",
	            f: "dropdown",
	            t: 13,
	            g: 1
	          }, {
	            n: "aria-haspopup",
	            f: "true",
	            t: 13,
	            g: 1
	          }, {
	            n: "aria-expanded",
	            f: "false",
	            t: 13,
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "span",
	            f: ["Navigation"]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "toggle-icon",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "toggle-bar",
	                g: 1
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "toggle-bar",
	                g: 1
	              }]
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "ul",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "dropdown-menu",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "li",
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "dropdown-subtitle",
	                g: 1
	              }],
	              f: ["Documents:"]
	            }]
	          }, " ", {
	            t: 7,
	            e: "li",
	            f: [{
	              t: 7,
	              e: "a",
	              m: [{
	                n: "href",
	                f: "/terms/terms-of-use",
	                t: 13,
	                g: 1
	              }, {
	                n: "class",
	                f: ["dropdown-item ", {
	                  t: 4,
	                  f: ["active"],
	                  n: 50,
	                  x: {
	                    r: ["currentPolicy"],
	                    s: "_0===\"terms-of-use\""
	                  }
	                }],
	                t: 13
	              }],
	              f: ["Terms of Use"]
	            }]
	          }, " ", {
	            t: 7,
	            e: "li",
	            f: [{
	              t: 7,
	              e: "a",
	              m: [{
	                n: "href",
	                f: "/terms/privacy-policy",
	                t: 13,
	                g: 1
	              }, {
	                n: "class",
	                f: ["dropdown-item ", {
	                  t: 4,
	                  f: ["active"],
	                  n: 50,
	                  x: {
	                    r: ["currentPolicy"],
	                    s: "_0===\"privacy-policy\""
	                  }
	                }],
	                t: 13
	              }],
	              f: ["Privacy Policy"]
	            }]
	          }, " ", {
	            t: 7,
	            e: "li",
	            f: [{
	              t: 7,
	              e: "a",
	              m: [{
	                n: "href",
	                f: "/terms/cookie-policy",
	                t: 13,
	                g: 1
	              }, {
	                n: "class",
	                f: ["dropdown-item ", {
	                  t: 4,
	                  f: ["active"],
	                  n: 50,
	                  x: {
	                    r: ["currentPolicy"],
	                    s: "_0===\"cookie-policy\""
	                  }
	                }],
	                t: 13
	              }],
	              f: ["Cookie Policy"]
	            }]
	          }]
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          n: "class",
	          f: ["page-content ", {
	            t: 4,
	            f: ["not-displayed"],
	            n: 51,
	            x: {
	              r: ["@shared.tuText", "@shared.ppText", "@shared.cpText"],
	              s: "_0&&_1&&_2"
	            }
	          }],
	          t: 13
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "page-content_side-menu",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "menu-section",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "strong",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "section-title",
	                g: 1
	              }],
	              f: ["Documents:"]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "section-list",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "div",
	                f: [{
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    n: "href",
	                    f: "/terms/terms-of-use",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "class",
	                    f: [{
	                      t: 4,
	                      f: ["active"],
	                      n: 50,
	                      x: {
	                        r: ["currentPolicy"],
	                        s: "_0===\"terms-of-use\""
	                      }
	                    }],
	                    t: 13
	                  }],
	                  f: ["Terms of Use"]
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                f: [{
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    n: "href",
	                    f: "/terms/privacy-policy",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "class",
	                    f: [{
	                      t: 4,
	                      f: ["active"],
	                      n: 50,
	                      x: {
	                        r: ["currentPolicy"],
	                        s: "_0===\"privacy-policy\""
	                      }
	                    }],
	                    t: 13
	                  }],
	                  f: ["Privacy Policy"]
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                f: [{
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    n: "href",
	                    f: "/terms/cookie-policy",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "class",
	                    f: [{
	                      t: 4,
	                      f: ["active"],
	                      n: 50,
	                      x: {
	                        r: ["currentPolicy"],
	                        s: "_0===\"cookie-policy\""
	                      }
	                    }],
	                    t: 13
	                  }],
	                  f: ["Cookie Policy"]
	                }]
	              }]
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "page-content_main",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "h1",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "page-content_main_title",
	              g: 1
	            }],
	            f: ["Terms & Policies"]
	          }, " ", {
	            t: 4,
	            f: [{
	              t: 7,
	              e: "c-markdown",
	              m: [{
	                n: "markdown",
	                f: [{
	                  t: 2,
	                  r: "@shared.ppText"
	                }],
	                t: 13
	              }]
	            }],
	            n: 50,
	            x: {
	              r: ["currentPolicy"],
	              s: "_0===\"privacy-policy\""
	            }
	          }, {
	            t: 4,
	            f: [{
	              t: 7,
	              e: "c-markdown",
	              m: [{
	                n: "markdown",
	                f: [{
	                  t: 2,
	                  r: "@shared.cpText"
	                }],
	                t: 13
	              }]
	            }, " "],
	            n: 50,
	            x: {
	              r: ["currentPolicy"],
	              s: "_0===\"cookie-policy\""
	            },
	            l: 1
	          }, {
	            t: 4,
	            f: [" ", {
	              t: 7,
	              e: "c-markdown",
	              m: [{
	                n: "markdown",
	                f: [{
	                  t: 2,
	                  r: "@shared.tuText"
	                }],
	                t: 13
	              }]
	            }],
	            n: 51,
	            l: 1
	          }]
	        }]
	      }]
	    }, " ", {
	      t: 7,
	      e: "c-gp-footer"
	    }]
	  }],
	  e: {
	    "_0&&_1&&_2": function (_0, _1, _2) {
	      return _0 && _1 && _2;
	    },
	    "_0===\"terms-of-use\"": function (_0) {
	      return _0 === "terms-of-use";
	    },
	    "_0===\"privacy-policy\"": function (_0) {
	      return _0 === "privacy-policy";
	    },
	    "_0===\"cookie-policy\"": function (_0) {
	      return _0 === "cookie-policy";
	    }
	  }
	};
	component.exports.components = {
	  "c-markdown": markdown,
	  "c-gp-github-md-documents-prefetch": gpGithubMdDocumentsPrefetch,
	  "c-notification": notification,
	  "c-gp-footer": gpFooter,
	  "c-gp-header": gpHeader,
	  "r-page": rPageGlobalping
	};
	var terms = ractive__default["default"].extend(component.exports);

	const {
	  getGlobalpingUser
	} = http;
	Ractive.DEBUG = location.hostname === 'localhost';
	let app$1 = {
	  config: {}
	};
	app$1.router = new Ractive.Router({
	  el: '#page',
	  data() {
	    return {
	      app: app$1
	    };
	  },
	  globals: ['query', 'collection']
	});
	app$1.router.addRoute('/', _index, {
	  qs: ['measurement']
	});
	app$1.router.addRoute('/cli', cli);
	app$1.router.addRoute('/slack', slack);
	app$1.router.addRoute('/network-tools/:params?', networkTools);
	app$1.router.addRoute('/integrations', integrations);
	app$1.router.addRoute('/about-us', aboutUs);
	app$1.router.addRoute('/sponsors', sponsors);
	app$1.router.addRoute('/credits', credits);
	app$1.router.addRoute('/network', network, {
	  qs: ['filter']
	});
	app$1.router.addRoute('/terms', terms);
	app$1.router.addRoute('/terms/:currentPolicy', terms);
	app$1.router.addRoute('/users/:username', _users);
	app$1.router.replaceQueryParam = function (name, newValue) {
	  history.replaceState(history.state, null, location.href.replace(new RegExp(`${name}=[^&]+|$`), `${name}=${encodeURIComponent(newValue)}`));
	  this.route.view.set(name, newValue);
	  return this;
	};
	_.onDocumentReady(() => {
	  let state = {};
	  let ractive = new Ractive();
	  ractive.set('@shared.app', app$1);
	  ractive.set('@shared.escape', escape);
	  function escape(string) {
	    string.replace(/</g, '\\u003c').replace(/>/g, '\\u003e').replace(/\u2028/g, '\\u2028').replace(/\u2029/g, '\\u2029');
	  }
	  getGlobalpingUser().then(user => {
	    ractive.set('@shared.user', user);
	  });
	  try {
	    let shared = JSON.parse(document.querySelector('#ractive-shared').innerHTML.trim());
	    if (shared) {
	      Object.keys(shared).forEach(key => {
	        ractive.set(`@shared.${key}`, shared[key]);
	      });
	    }
	    http.fetchListStatPeriods().then(response => {
	      ractive.set('@shared.rawListStatPeriods', response);
	    });
	  } catch (e) {}
	  try {
	    state = JSON.parse(document.querySelector('#ractive-data').innerHTML.trim());
	  } catch (e) {}
	  if (!document.title.includes('not found')) {
	    app$1.router.init({
	      noScroll: true,
	      state: {
	        ...state,
	        ...app$1.router.data()
	      }
	    }).watchLinks().watchState();
	  }
	});
	app$1.injectGlobalStyle = href => {
	  for (let link of document.getElementsByTagName('link')) {
	    if (link.href === href) {
	      return;
	    }
	  }
	  let link = document.createElement('link');
	  link.rel = 'stylesheet';
	  link.href = href;
	  document.head.appendChild(link);
	};
	var appGlobalping = app$1;

	return appGlobalping;

}));
